// @ts-nocheck
// Generated by scripts/work-settings.mjs. Do not edit.
import createPrecompiledValidator from '@rjsf/validator-ajv8/lib/createPrecompiledValidator.js';
import type { ValidatorType } from '@rjsf/utils';
import type { WorkSettingsData, WorkSettingsVariant } from '../../../../../../shared/work-settings';
"use strict";
var compiled0 = (() => {
  var __getOwnPropNames = Object.getOwnPropertyNames;
  var __commonJS = (cb, mod) => function __require() {
    return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
  };

  // src/web/node_modules/ajv/dist/runtime/ucs2length.js
  var require_ucs2length = __commonJS({
    "src/web/node_modules/ajv/dist/runtime/ucs2length.js"(exports) {
      "use strict";
      Object.defineProperty(exports, "__esModule", { value: true });
      function ucs2length(str) {
        const len = str.length;
        let length = 0;
        let pos = 0;
        let value;
        while (pos < len) {
          length++;
          value = str.charCodeAt(pos++);
          if (value >= 55296 && value <= 56319 && pos < len) {
            value = str.charCodeAt(pos);
            if ((value & 64512) === 56320)
              pos++;
          }
        }
        return length;
      }
      exports.default = ucs2length;
      ucs2length.code = 'require("ajv/dist/runtime/ucs2length").default';
    }
  });

  // src/web/validator-0.cjs
  var require_validator_0 = __commonJS({
    "src/web/validator-0.cjs"(exports) {
      exports["394164df"] = validate10;
      var schema11 = { "$schema": "http://json-schema.org/draft-07/schema#", "type": "object", "additionalProperties": false, "required": ["cobieFile"], "properties": { "toolCallLimit": { "type": "integer", "title": "Tool call limit per execution", "default": 40, "minimum": 1, "maximum": 80, "description": "Set 1\u201380 calls; default 40. Each execution or continuation has its own allowance. The final report is excluded. Estimates vary with model size and the size of the delivery; they are neither a completion guarantee nor a timeout." }, "cobieFile": { "type": "string", "title": "COBie Excel", "minLength": 1, "maxLength": 4096, "description": "The COBie workbook (.xlsx) to check. Use the folder button to pick it, or paste its full path. The check report is saved in the same folder." }, "formFile": { "type": "string", "title": "Input form Excel", "default": "", "maxLength": 4096, "description": `The input form (.xlsx) this COBie was made from: the same one COBie-maker used. What the form supplies in the delivery (contacts, the facility's name and units, each type's manufacturer, model number and warranty, and the installation and warranty dates) is compared with it row by row. Leave blank to skip verification against it. If there is none yet, "Get a blank form" saves one; it must list the delivered types and be filled in before it can be compared, and is normally made from the model by COBie-maker.` }, "categories": { "type": "array", "title": "Categories to check", "description": "The categories this COBie delivery covers. Only the selected categories are compared with the model; an unselected category is not reported as missing from the delivery even when the model flags it for COBie. All are selected by default. Adjust to the delivery scope and keep at least one.", "default": ["OST_MechanicalEquipment", "OST_DuctTerminal", "OST_DuctAccessory", "OST_PlumbingFixtures", "OST_PlumbingEquipment", "OST_PipeAccessory", "OST_Sprinklers", "OST_FireAlarmDevices", "OST_ElectricalEquipment", "OST_ElectricalFixtures", "OST_LightingFixtures", "OST_LightingDevices", "OST_CommunicationDevices", "OST_DataDevices", "OST_SecurityDevices", "OST_NurseCallDevices", "OST_TelephoneDevices", "OST_AudioVisualDevices", "OST_SpecialityEquipment", "OST_MedicalEquipment", "OST_FoodServiceEquipment", "OST_Furniture", "OST_FurnitureSystems", "OST_Casework", "OST_Doors", "OST_Windows"], "uniqueItems": true, "minItems": 1, "items": { "type": "string", "oneOf": [{ "const": "OST_MechanicalEquipment", "title": "Mechanical equipment" }, { "const": "OST_DuctTerminal", "title": "Air terminals" }, { "const": "OST_DuctAccessory", "title": "Duct accessories" }, { "const": "OST_PlumbingFixtures", "title": "Plumbing fixtures" }, { "const": "OST_PlumbingEquipment", "title": "Plumbing equipment" }, { "const": "OST_PipeAccessory", "title": "Pipe accessories" }, { "const": "OST_Sprinklers", "title": "Sprinklers" }, { "const": "OST_FireAlarmDevices", "title": "Fire alarm devices" }, { "const": "OST_ElectricalEquipment", "title": "Electrical equipment" }, { "const": "OST_ElectricalFixtures", "title": "Electrical fixtures" }, { "const": "OST_LightingFixtures", "title": "Lighting fixtures" }, { "const": "OST_LightingDevices", "title": "Lighting devices" }, { "const": "OST_CommunicationDevices", "title": "Communication devices" }, { "const": "OST_DataDevices", "title": "Data devices" }, { "const": "OST_SecurityDevices", "title": "Security devices" }, { "const": "OST_NurseCallDevices", "title": "Nurse call devices" }, { "const": "OST_TelephoneDevices", "title": "Telephone devices" }, { "const": "OST_AudioVisualDevices", "title": "Audio visual devices" }, { "const": "OST_SpecialityEquipment", "title": "Specialty equipment" }, { "const": "OST_MedicalEquipment", "title": "Medical equipment" }, { "const": "OST_FoodServiceEquipment", "title": "Food service equipment" }, { "const": "OST_Furniture", "title": "Furniture" }, { "const": "OST_FurnitureSystems", "title": "Furniture systems" }, { "const": "OST_Casework", "title": "Casework" }, { "const": "OST_Doors", "title": "Doors" }, { "const": "OST_Windows", "title": "Windows" }] } }, "notes": { "type": "string", "title": "Requests and notes for this run", "default": "", "maxLength": 1e4, "description": "Optional. The model is the project currently open in Revit." } }, "$id": "394164df" };
      var func2 = require_ucs2length().default;
      function validate10(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
        ;
        let vErrors = null;
        let errors = 0;
        if (data && typeof data == "object" && !Array.isArray(data)) {
          if (data.cobieFile === void 0) {
            const err0 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "cobieFile" }, message: "must have required property 'cobieFile'", schema: schema11.required, parentSchema: schema11, data };
            if (vErrors === null) {
              vErrors = [err0];
            } else {
              vErrors.push(err0);
            }
            errors++;
          }
          for (const key0 in data) {
            if (!(key0 === "toolCallLimit" || key0 === "cobieFile" || key0 === "formFile" || key0 === "categories" || key0 === "notes")) {
              const err1 = { instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties", schema: false, parentSchema: schema11, data };
              if (vErrors === null) {
                vErrors = [err1];
              } else {
                vErrors.push(err1);
              }
              errors++;
            }
          }
          if (data.toolCallLimit !== void 0) {
            let data0 = data.toolCallLimit;
            if (!(typeof data0 == "number" && (!(data0 % 1) && !isNaN(data0)) && isFinite(data0))) {
              const err2 = { instancePath: instancePath + "/toolCallLimit", schemaPath: "#/properties/toolCallLimit/type", keyword: "type", params: { type: "integer" }, message: "must be integer", schema: schema11.properties.toolCallLimit.type, parentSchema: schema11.properties.toolCallLimit, data: data0 };
              if (vErrors === null) {
                vErrors = [err2];
              } else {
                vErrors.push(err2);
              }
              errors++;
            }
            if (typeof data0 == "number" && isFinite(data0)) {
              if (data0 > 80 || isNaN(data0)) {
                const err3 = { instancePath: instancePath + "/toolCallLimit", schemaPath: "#/properties/toolCallLimit/maximum", keyword: "maximum", params: { comparison: "<=", limit: 80 }, message: "must be <= 80", schema: 80, parentSchema: schema11.properties.toolCallLimit, data: data0 };
                if (vErrors === null) {
                  vErrors = [err3];
                } else {
                  vErrors.push(err3);
                }
                errors++;
              }
              if (data0 < 1 || isNaN(data0)) {
                const err4 = { instancePath: instancePath + "/toolCallLimit", schemaPath: "#/properties/toolCallLimit/minimum", keyword: "minimum", params: { comparison: ">=", limit: 1 }, message: "must be >= 1", schema: 1, parentSchema: schema11.properties.toolCallLimit, data: data0 };
                if (vErrors === null) {
                  vErrors = [err4];
                } else {
                  vErrors.push(err4);
                }
                errors++;
              }
            }
          }
          if (data.cobieFile !== void 0) {
            let data1 = data.cobieFile;
            if (typeof data1 === "string") {
              if (func2(data1) > 4096) {
                const err5 = { instancePath: instancePath + "/cobieFile", schemaPath: "#/properties/cobieFile/maxLength", keyword: "maxLength", params: { limit: 4096 }, message: "must NOT have more than 4096 characters", schema: 4096, parentSchema: schema11.properties.cobieFile, data: data1 };
                if (vErrors === null) {
                  vErrors = [err5];
                } else {
                  vErrors.push(err5);
                }
                errors++;
              }
              if (func2(data1) < 1) {
                const err6 = { instancePath: instancePath + "/cobieFile", schemaPath: "#/properties/cobieFile/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters", schema: 1, parentSchema: schema11.properties.cobieFile, data: data1 };
                if (vErrors === null) {
                  vErrors = [err6];
                } else {
                  vErrors.push(err6);
                }
                errors++;
              }
            } else {
              const err7 = { instancePath: instancePath + "/cobieFile", schemaPath: "#/properties/cobieFile/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: schema11.properties.cobieFile.type, parentSchema: schema11.properties.cobieFile, data: data1 };
              if (vErrors === null) {
                vErrors = [err7];
              } else {
                vErrors.push(err7);
              }
              errors++;
            }
          }
          if (data.formFile !== void 0) {
            let data2 = data.formFile;
            if (typeof data2 === "string") {
              if (func2(data2) > 4096) {
                const err8 = { instancePath: instancePath + "/formFile", schemaPath: "#/properties/formFile/maxLength", keyword: "maxLength", params: { limit: 4096 }, message: "must NOT have more than 4096 characters", schema: 4096, parentSchema: schema11.properties.formFile, data: data2 };
                if (vErrors === null) {
                  vErrors = [err8];
                } else {
                  vErrors.push(err8);
                }
                errors++;
              }
            } else {
              const err9 = { instancePath: instancePath + "/formFile", schemaPath: "#/properties/formFile/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: schema11.properties.formFile.type, parentSchema: schema11.properties.formFile, data: data2 };
              if (vErrors === null) {
                vErrors = [err9];
              } else {
                vErrors.push(err9);
              }
              errors++;
            }
          }
          if (data.categories !== void 0) {
            let data3 = data.categories;
            if (Array.isArray(data3)) {
              if (data3.length < 1) {
                const err10 = { instancePath: instancePath + "/categories", schemaPath: "#/properties/categories/minItems", keyword: "minItems", params: { limit: 1 }, message: "must NOT have fewer than 1 items", schema: 1, parentSchema: schema11.properties.categories, data: data3 };
                if (vErrors === null) {
                  vErrors = [err10];
                } else {
                  vErrors.push(err10);
                }
                errors++;
              }
              const len0 = data3.length;
              for (let i0 = 0; i0 < len0; i0++) {
                let data4 = data3[i0];
                if (typeof data4 !== "string") {
                  const err11 = { instancePath: instancePath + "/categories/" + i0, schemaPath: "#/properties/categories/items/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: schema11.properties.categories.items.type, parentSchema: schema11.properties.categories.items, data: data4 };
                  if (vErrors === null) {
                    vErrors = [err11];
                  } else {
                    vErrors.push(err11);
                  }
                  errors++;
                }
                const _errs12 = errors;
                let valid3 = false;
                let passing0 = null;
                const _errs13 = errors;
                if ("OST_MechanicalEquipment" !== data4) {
                  const err12 = { instancePath: instancePath + "/categories/" + i0, schemaPath: "#/properties/categories/items/oneOf/0/const", keyword: "const", params: { allowedValue: "OST_MechanicalEquipment" }, message: "must be equal to constant", schema: "OST_MechanicalEquipment", parentSchema: schema11.properties.categories.items.oneOf[0], data: data4 };
                  if (vErrors === null) {
                    vErrors = [err12];
                  } else {
                    vErrors.push(err12);
                  }
                  errors++;
                }
                var _valid0 = _errs13 === errors;
                if (_valid0) {
                  valid3 = true;
                  passing0 = 0;
                }
                const _errs14 = errors;
                if ("OST_DuctTerminal" !== data4) {
                  const err13 = { instancePath: instancePath + "/categories/" + i0, schemaPath: "#/properties/categories/items/oneOf/1/const", keyword: "const", params: { allowedValue: "OST_DuctTerminal" }, message: "must be equal to constant", schema: "OST_DuctTerminal", parentSchema: schema11.properties.categories.items.oneOf[1], data: data4 };
                  if (vErrors === null) {
                    vErrors = [err13];
                  } else {
                    vErrors.push(err13);
                  }
                  errors++;
                }
                var _valid0 = _errs14 === errors;
                if (_valid0 && valid3) {
                  valid3 = false;
                  passing0 = [passing0, 1];
                } else {
                  if (_valid0) {
                    valid3 = true;
                    passing0 = 1;
                  }
                  const _errs15 = errors;
                  if ("OST_DuctAccessory" !== data4) {
                    const err14 = { instancePath: instancePath + "/categories/" + i0, schemaPath: "#/properties/categories/items/oneOf/2/const", keyword: "const", params: { allowedValue: "OST_DuctAccessory" }, message: "must be equal to constant", schema: "OST_DuctAccessory", parentSchema: schema11.properties.categories.items.oneOf[2], data: data4 };
                    if (vErrors === null) {
                      vErrors = [err14];
                    } else {
                      vErrors.push(err14);
                    }
                    errors++;
                  }
                  var _valid0 = _errs15 === errors;
                  if (_valid0 && valid3) {
                    valid3 = false;
                    passing0 = [passing0, 2];
                  } else {
                    if (_valid0) {
                      valid3 = true;
                      passing0 = 2;
                    }
                    const _errs16 = errors;
                    if ("OST_PlumbingFixtures" !== data4) {
                      const err15 = { instancePath: instancePath + "/categories/" + i0, schemaPath: "#/properties/categories/items/oneOf/3/const", keyword: "const", params: { allowedValue: "OST_PlumbingFixtures" }, message: "must be equal to constant", schema: "OST_PlumbingFixtures", parentSchema: schema11.properties.categories.items.oneOf[3], data: data4 };
                      if (vErrors === null) {
                        vErrors = [err15];
                      } else {
                        vErrors.push(err15);
                      }
                      errors++;
                    }
                    var _valid0 = _errs16 === errors;
                    if (_valid0 && valid3) {
                      valid3 = false;
                      passing0 = [passing0, 3];
                    } else {
                      if (_valid0) {
                        valid3 = true;
                        passing0 = 3;
                      }
                      const _errs17 = errors;
                      if ("OST_PlumbingEquipment" !== data4) {
                        const err16 = { instancePath: instancePath + "/categories/" + i0, schemaPath: "#/properties/categories/items/oneOf/4/const", keyword: "const", params: { allowedValue: "OST_PlumbingEquipment" }, message: "must be equal to constant", schema: "OST_PlumbingEquipment", parentSchema: schema11.properties.categories.items.oneOf[4], data: data4 };
                        if (vErrors === null) {
                          vErrors = [err16];
                        } else {
                          vErrors.push(err16);
                        }
                        errors++;
                      }
                      var _valid0 = _errs17 === errors;
                      if (_valid0 && valid3) {
                        valid3 = false;
                        passing0 = [passing0, 4];
                      } else {
                        if (_valid0) {
                          valid3 = true;
                          passing0 = 4;
                        }
                        const _errs18 = errors;
                        if ("OST_PipeAccessory" !== data4) {
                          const err17 = { instancePath: instancePath + "/categories/" + i0, schemaPath: "#/properties/categories/items/oneOf/5/const", keyword: "const", params: { allowedValue: "OST_PipeAccessory" }, message: "must be equal to constant", schema: "OST_PipeAccessory", parentSchema: schema11.properties.categories.items.oneOf[5], data: data4 };
                          if (vErrors === null) {
                            vErrors = [err17];
                          } else {
                            vErrors.push(err17);
                          }
                          errors++;
                        }
                        var _valid0 = _errs18 === errors;
                        if (_valid0 && valid3) {
                          valid3 = false;
                          passing0 = [passing0, 5];
                        } else {
                          if (_valid0) {
                            valid3 = true;
                            passing0 = 5;
                          }
                          const _errs19 = errors;
                          if ("OST_Sprinklers" !== data4) {
                            const err18 = { instancePath: instancePath + "/categories/" + i0, schemaPath: "#/properties/categories/items/oneOf/6/const", keyword: "const", params: { allowedValue: "OST_Sprinklers" }, message: "must be equal to constant", schema: "OST_Sprinklers", parentSchema: schema11.properties.categories.items.oneOf[6], data: data4 };
                            if (vErrors === null) {
                              vErrors = [err18];
                            } else {
                              vErrors.push(err18);
                            }
                            errors++;
                          }
                          var _valid0 = _errs19 === errors;
                          if (_valid0 && valid3) {
                            valid3 = false;
                            passing0 = [passing0, 6];
                          } else {
                            if (_valid0) {
                              valid3 = true;
                              passing0 = 6;
                            }
                            const _errs20 = errors;
                            if ("OST_FireAlarmDevices" !== data4) {
                              const err19 = { instancePath: instancePath + "/categories/" + i0, schemaPath: "#/properties/categories/items/oneOf/7/const", keyword: "const", params: { allowedValue: "OST_FireAlarmDevices" }, message: "must be equal to constant", schema: "OST_FireAlarmDevices", parentSchema: schema11.properties.categories.items.oneOf[7], data: data4 };
                              if (vErrors === null) {
                                vErrors = [err19];
                              } else {
                                vErrors.push(err19);
                              }
                              errors++;
                            }
                            var _valid0 = _errs20 === errors;
                            if (_valid0 && valid3) {
                              valid3 = false;
                              passing0 = [passing0, 7];
                            } else {
                              if (_valid0) {
                                valid3 = true;
                                passing0 = 7;
                              }
                              const _errs21 = errors;
                              if ("OST_ElectricalEquipment" !== data4) {
                                const err20 = { instancePath: instancePath + "/categories/" + i0, schemaPath: "#/properties/categories/items/oneOf/8/const", keyword: "const", params: { allowedValue: "OST_ElectricalEquipment" }, message: "must be equal to constant", schema: "OST_ElectricalEquipment", parentSchema: schema11.properties.categories.items.oneOf[8], data: data4 };
                                if (vErrors === null) {
                                  vErrors = [err20];
                                } else {
                                  vErrors.push(err20);
                                }
                                errors++;
                              }
                              var _valid0 = _errs21 === errors;
                              if (_valid0 && valid3) {
                                valid3 = false;
                                passing0 = [passing0, 8];
                              } else {
                                if (_valid0) {
                                  valid3 = true;
                                  passing0 = 8;
                                }
                                const _errs22 = errors;
                                if ("OST_ElectricalFixtures" !== data4) {
                                  const err21 = { instancePath: instancePath + "/categories/" + i0, schemaPath: "#/properties/categories/items/oneOf/9/const", keyword: "const", params: { allowedValue: "OST_ElectricalFixtures" }, message: "must be equal to constant", schema: "OST_ElectricalFixtures", parentSchema: schema11.properties.categories.items.oneOf[9], data: data4 };
                                  if (vErrors === null) {
                                    vErrors = [err21];
                                  } else {
                                    vErrors.push(err21);
                                  }
                                  errors++;
                                }
                                var _valid0 = _errs22 === errors;
                                if (_valid0 && valid3) {
                                  valid3 = false;
                                  passing0 = [passing0, 9];
                                } else {
                                  if (_valid0) {
                                    valid3 = true;
                                    passing0 = 9;
                                  }
                                  const _errs23 = errors;
                                  if ("OST_LightingFixtures" !== data4) {
                                    const err22 = { instancePath: instancePath + "/categories/" + i0, schemaPath: "#/properties/categories/items/oneOf/10/const", keyword: "const", params: { allowedValue: "OST_LightingFixtures" }, message: "must be equal to constant", schema: "OST_LightingFixtures", parentSchema: schema11.properties.categories.items.oneOf[10], data: data4 };
                                    if (vErrors === null) {
                                      vErrors = [err22];
                                    } else {
                                      vErrors.push(err22);
                                    }
                                    errors++;
                                  }
                                  var _valid0 = _errs23 === errors;
                                  if (_valid0 && valid3) {
                                    valid3 = false;
                                    passing0 = [passing0, 10];
                                  } else {
                                    if (_valid0) {
                                      valid3 = true;
                                      passing0 = 10;
                                    }
                                    const _errs24 = errors;
                                    if ("OST_LightingDevices" !== data4) {
                                      const err23 = { instancePath: instancePath + "/categories/" + i0, schemaPath: "#/properties/categories/items/oneOf/11/const", keyword: "const", params: { allowedValue: "OST_LightingDevices" }, message: "must be equal to constant", schema: "OST_LightingDevices", parentSchema: schema11.properties.categories.items.oneOf[11], data: data4 };
                                      if (vErrors === null) {
                                        vErrors = [err23];
                                      } else {
                                        vErrors.push(err23);
                                      }
                                      errors++;
                                    }
                                    var _valid0 = _errs24 === errors;
                                    if (_valid0 && valid3) {
                                      valid3 = false;
                                      passing0 = [passing0, 11];
                                    } else {
                                      if (_valid0) {
                                        valid3 = true;
                                        passing0 = 11;
                                      }
                                      const _errs25 = errors;
                                      if ("OST_CommunicationDevices" !== data4) {
                                        const err24 = { instancePath: instancePath + "/categories/" + i0, schemaPath: "#/properties/categories/items/oneOf/12/const", keyword: "const", params: { allowedValue: "OST_CommunicationDevices" }, message: "must be equal to constant", schema: "OST_CommunicationDevices", parentSchema: schema11.properties.categories.items.oneOf[12], data: data4 };
                                        if (vErrors === null) {
                                          vErrors = [err24];
                                        } else {
                                          vErrors.push(err24);
                                        }
                                        errors++;
                                      }
                                      var _valid0 = _errs25 === errors;
                                      if (_valid0 && valid3) {
                                        valid3 = false;
                                        passing0 = [passing0, 12];
                                      } else {
                                        if (_valid0) {
                                          valid3 = true;
                                          passing0 = 12;
                                        }
                                        const _errs26 = errors;
                                        if ("OST_DataDevices" !== data4) {
                                          const err25 = { instancePath: instancePath + "/categories/" + i0, schemaPath: "#/properties/categories/items/oneOf/13/const", keyword: "const", params: { allowedValue: "OST_DataDevices" }, message: "must be equal to constant", schema: "OST_DataDevices", parentSchema: schema11.properties.categories.items.oneOf[13], data: data4 };
                                          if (vErrors === null) {
                                            vErrors = [err25];
                                          } else {
                                            vErrors.push(err25);
                                          }
                                          errors++;
                                        }
                                        var _valid0 = _errs26 === errors;
                                        if (_valid0 && valid3) {
                                          valid3 = false;
                                          passing0 = [passing0, 13];
                                        } else {
                                          if (_valid0) {
                                            valid3 = true;
                                            passing0 = 13;
                                          }
                                          const _errs27 = errors;
                                          if ("OST_SecurityDevices" !== data4) {
                                            const err26 = { instancePath: instancePath + "/categories/" + i0, schemaPath: "#/properties/categories/items/oneOf/14/const", keyword: "const", params: { allowedValue: "OST_SecurityDevices" }, message: "must be equal to constant", schema: "OST_SecurityDevices", parentSchema: schema11.properties.categories.items.oneOf[14], data: data4 };
                                            if (vErrors === null) {
                                              vErrors = [err26];
                                            } else {
                                              vErrors.push(err26);
                                            }
                                            errors++;
                                          }
                                          var _valid0 = _errs27 === errors;
                                          if (_valid0 && valid3) {
                                            valid3 = false;
                                            passing0 = [passing0, 14];
                                          } else {
                                            if (_valid0) {
                                              valid3 = true;
                                              passing0 = 14;
                                            }
                                            const _errs28 = errors;
                                            if ("OST_NurseCallDevices" !== data4) {
                                              const err27 = { instancePath: instancePath + "/categories/" + i0, schemaPath: "#/properties/categories/items/oneOf/15/const", keyword: "const", params: { allowedValue: "OST_NurseCallDevices" }, message: "must be equal to constant", schema: "OST_NurseCallDevices", parentSchema: schema11.properties.categories.items.oneOf[15], data: data4 };
                                              if (vErrors === null) {
                                                vErrors = [err27];
                                              } else {
                                                vErrors.push(err27);
                                              }
                                              errors++;
                                            }
                                            var _valid0 = _errs28 === errors;
                                            if (_valid0 && valid3) {
                                              valid3 = false;
                                              passing0 = [passing0, 15];
                                            } else {
                                              if (_valid0) {
                                                valid3 = true;
                                                passing0 = 15;
                                              }
                                              const _errs29 = errors;
                                              if ("OST_TelephoneDevices" !== data4) {
                                                const err28 = { instancePath: instancePath + "/categories/" + i0, schemaPath: "#/properties/categories/items/oneOf/16/const", keyword: "const", params: { allowedValue: "OST_TelephoneDevices" }, message: "must be equal to constant", schema: "OST_TelephoneDevices", parentSchema: schema11.properties.categories.items.oneOf[16], data: data4 };
                                                if (vErrors === null) {
                                                  vErrors = [err28];
                                                } else {
                                                  vErrors.push(err28);
                                                }
                                                errors++;
                                              }
                                              var _valid0 = _errs29 === errors;
                                              if (_valid0 && valid3) {
                                                valid3 = false;
                                                passing0 = [passing0, 16];
                                              } else {
                                                if (_valid0) {
                                                  valid3 = true;
                                                  passing0 = 16;
                                                }
                                                const _errs30 = errors;
                                                if ("OST_AudioVisualDevices" !== data4) {
                                                  const err29 = { instancePath: instancePath + "/categories/" + i0, schemaPath: "#/properties/categories/items/oneOf/17/const", keyword: "const", params: { allowedValue: "OST_AudioVisualDevices" }, message: "must be equal to constant", schema: "OST_AudioVisualDevices", parentSchema: schema11.properties.categories.items.oneOf[17], data: data4 };
                                                  if (vErrors === null) {
                                                    vErrors = [err29];
                                                  } else {
                                                    vErrors.push(err29);
                                                  }
                                                  errors++;
                                                }
                                                var _valid0 = _errs30 === errors;
                                                if (_valid0 && valid3) {
                                                  valid3 = false;
                                                  passing0 = [passing0, 17];
                                                } else {
                                                  if (_valid0) {
                                                    valid3 = true;
                                                    passing0 = 17;
                                                  }
                                                  const _errs31 = errors;
                                                  if ("OST_SpecialityEquipment" !== data4) {
                                                    const err30 = { instancePath: instancePath + "/categories/" + i0, schemaPath: "#/properties/categories/items/oneOf/18/const", keyword: "const", params: { allowedValue: "OST_SpecialityEquipment" }, message: "must be equal to constant", schema: "OST_SpecialityEquipment", parentSchema: schema11.properties.categories.items.oneOf[18], data: data4 };
                                                    if (vErrors === null) {
                                                      vErrors = [err30];
                                                    } else {
                                                      vErrors.push(err30);
                                                    }
                                                    errors++;
                                                  }
                                                  var _valid0 = _errs31 === errors;
                                                  if (_valid0 && valid3) {
                                                    valid3 = false;
                                                    passing0 = [passing0, 18];
                                                  } else {
                                                    if (_valid0) {
                                                      valid3 = true;
                                                      passing0 = 18;
                                                    }
                                                    const _errs32 = errors;
                                                    if ("OST_MedicalEquipment" !== data4) {
                                                      const err31 = { instancePath: instancePath + "/categories/" + i0, schemaPath: "#/properties/categories/items/oneOf/19/const", keyword: "const", params: { allowedValue: "OST_MedicalEquipment" }, message: "must be equal to constant", schema: "OST_MedicalEquipment", parentSchema: schema11.properties.categories.items.oneOf[19], data: data4 };
                                                      if (vErrors === null) {
                                                        vErrors = [err31];
                                                      } else {
                                                        vErrors.push(err31);
                                                      }
                                                      errors++;
                                                    }
                                                    var _valid0 = _errs32 === errors;
                                                    if (_valid0 && valid3) {
                                                      valid3 = false;
                                                      passing0 = [passing0, 19];
                                                    } else {
                                                      if (_valid0) {
                                                        valid3 = true;
                                                        passing0 = 19;
                                                      }
                                                      const _errs33 = errors;
                                                      if ("OST_FoodServiceEquipment" !== data4) {
                                                        const err32 = { instancePath: instancePath + "/categories/" + i0, schemaPath: "#/properties/categories/items/oneOf/20/const", keyword: "const", params: { allowedValue: "OST_FoodServiceEquipment" }, message: "must be equal to constant", schema: "OST_FoodServiceEquipment", parentSchema: schema11.properties.categories.items.oneOf[20], data: data4 };
                                                        if (vErrors === null) {
                                                          vErrors = [err32];
                                                        } else {
                                                          vErrors.push(err32);
                                                        }
                                                        errors++;
                                                      }
                                                      var _valid0 = _errs33 === errors;
                                                      if (_valid0 && valid3) {
                                                        valid3 = false;
                                                        passing0 = [passing0, 20];
                                                      } else {
                                                        if (_valid0) {
                                                          valid3 = true;
                                                          passing0 = 20;
                                                        }
                                                        const _errs34 = errors;
                                                        if ("OST_Furniture" !== data4) {
                                                          const err33 = { instancePath: instancePath + "/categories/" + i0, schemaPath: "#/properties/categories/items/oneOf/21/const", keyword: "const", params: { allowedValue: "OST_Furniture" }, message: "must be equal to constant", schema: "OST_Furniture", parentSchema: schema11.properties.categories.items.oneOf[21], data: data4 };
                                                          if (vErrors === null) {
                                                            vErrors = [err33];
                                                          } else {
                                                            vErrors.push(err33);
                                                          }
                                                          errors++;
                                                        }
                                                        var _valid0 = _errs34 === errors;
                                                        if (_valid0 && valid3) {
                                                          valid3 = false;
                                                          passing0 = [passing0, 21];
                                                        } else {
                                                          if (_valid0) {
                                                            valid3 = true;
                                                            passing0 = 21;
                                                          }
                                                          const _errs35 = errors;
                                                          if ("OST_FurnitureSystems" !== data4) {
                                                            const err34 = { instancePath: instancePath + "/categories/" + i0, schemaPath: "#/properties/categories/items/oneOf/22/const", keyword: "const", params: { allowedValue: "OST_FurnitureSystems" }, message: "must be equal to constant", schema: "OST_FurnitureSystems", parentSchema: schema11.properties.categories.items.oneOf[22], data: data4 };
                                                            if (vErrors === null) {
                                                              vErrors = [err34];
                                                            } else {
                                                              vErrors.push(err34);
                                                            }
                                                            errors++;
                                                          }
                                                          var _valid0 = _errs35 === errors;
                                                          if (_valid0 && valid3) {
                                                            valid3 = false;
                                                            passing0 = [passing0, 22];
                                                          } else {
                                                            if (_valid0) {
                                                              valid3 = true;
                                                              passing0 = 22;
                                                            }
                                                            const _errs36 = errors;
                                                            if ("OST_Casework" !== data4) {
                                                              const err35 = { instancePath: instancePath + "/categories/" + i0, schemaPath: "#/properties/categories/items/oneOf/23/const", keyword: "const", params: { allowedValue: "OST_Casework" }, message: "must be equal to constant", schema: "OST_Casework", parentSchema: schema11.properties.categories.items.oneOf[23], data: data4 };
                                                              if (vErrors === null) {
                                                                vErrors = [err35];
                                                              } else {
                                                                vErrors.push(err35);
                                                              }
                                                              errors++;
                                                            }
                                                            var _valid0 = _errs36 === errors;
                                                            if (_valid0 && valid3) {
                                                              valid3 = false;
                                                              passing0 = [passing0, 23];
                                                            } else {
                                                              if (_valid0) {
                                                                valid3 = true;
                                                                passing0 = 23;
                                                              }
                                                              const _errs37 = errors;
                                                              if ("OST_Doors" !== data4) {
                                                                const err36 = { instancePath: instancePath + "/categories/" + i0, schemaPath: "#/properties/categories/items/oneOf/24/const", keyword: "const", params: { allowedValue: "OST_Doors" }, message: "must be equal to constant", schema: "OST_Doors", parentSchema: schema11.properties.categories.items.oneOf[24], data: data4 };
                                                                if (vErrors === null) {
                                                                  vErrors = [err36];
                                                                } else {
                                                                  vErrors.push(err36);
                                                                }
                                                                errors++;
                                                              }
                                                              var _valid0 = _errs37 === errors;
                                                              if (_valid0 && valid3) {
                                                                valid3 = false;
                                                                passing0 = [passing0, 24];
                                                              } else {
                                                                if (_valid0) {
                                                                  valid3 = true;
                                                                  passing0 = 24;
                                                                }
                                                                const _errs38 = errors;
                                                                if ("OST_Windows" !== data4) {
                                                                  const err37 = { instancePath: instancePath + "/categories/" + i0, schemaPath: "#/properties/categories/items/oneOf/25/const", keyword: "const", params: { allowedValue: "OST_Windows" }, message: "must be equal to constant", schema: "OST_Windows", parentSchema: schema11.properties.categories.items.oneOf[25], data: data4 };
                                                                  if (vErrors === null) {
                                                                    vErrors = [err37];
                                                                  } else {
                                                                    vErrors.push(err37);
                                                                  }
                                                                  errors++;
                                                                }
                                                                var _valid0 = _errs38 === errors;
                                                                if (_valid0 && valid3) {
                                                                  valid3 = false;
                                                                  passing0 = [passing0, 25];
                                                                } else {
                                                                  if (_valid0) {
                                                                    valid3 = true;
                                                                    passing0 = 25;
                                                                  }
                                                                }
                                                              }
                                                            }
                                                          }
                                                        }
                                                      }
                                                    }
                                                  }
                                                }
                                              }
                                            }
                                          }
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
                if (!valid3) {
                  const err38 = { instancePath: instancePath + "/categories/" + i0, schemaPath: "#/properties/categories/items/oneOf", keyword: "oneOf", params: { passingSchemas: passing0 }, message: "must match exactly one schema in oneOf", schema: schema11.properties.categories.items.oneOf, parentSchema: schema11.properties.categories.items, data: data4 };
                  if (vErrors === null) {
                    vErrors = [err38];
                  } else {
                    vErrors.push(err38);
                  }
                  errors++;
                } else {
                  errors = _errs12;
                  if (vErrors !== null) {
                    if (_errs12) {
                      vErrors.length = _errs12;
                    } else {
                      vErrors = null;
                    }
                  }
                }
              }
              let i1 = data3.length;
              let j0;
              if (i1 > 1) {
                const indices0 = {};
                for (; i1--; ) {
                  let item0 = data3[i1];
                  if (typeof item0 !== "string") {
                    continue;
                  }
                  if (typeof indices0[item0] == "number") {
                    j0 = indices0[item0];
                    const err39 = { instancePath: instancePath + "/categories", schemaPath: "#/properties/categories/uniqueItems", keyword: "uniqueItems", params: { i: i1, j: j0 }, message: "must NOT have duplicate items (items ## " + j0 + " and " + i1 + " are identical)", schema: true, parentSchema: schema11.properties.categories, data: data3 };
                    if (vErrors === null) {
                      vErrors = [err39];
                    } else {
                      vErrors.push(err39);
                    }
                    errors++;
                    break;
                  }
                  indices0[item0] = i1;
                }
              }
            } else {
              const err40 = { instancePath: instancePath + "/categories", schemaPath: "#/properties/categories/type", keyword: "type", params: { type: "array" }, message: "must be array", schema: schema11.properties.categories.type, parentSchema: schema11.properties.categories, data: data3 };
              if (vErrors === null) {
                vErrors = [err40];
              } else {
                vErrors.push(err40);
              }
              errors++;
            }
          }
          if (data.notes !== void 0) {
            let data5 = data.notes;
            if (typeof data5 === "string") {
              if (func2(data5) > 1e4) {
                const err41 = { instancePath: instancePath + "/notes", schemaPath: "#/properties/notes/maxLength", keyword: "maxLength", params: { limit: 1e4 }, message: "must NOT have more than 10000 characters", schema: 1e4, parentSchema: schema11.properties.notes, data: data5 };
                if (vErrors === null) {
                  vErrors = [err41];
                } else {
                  vErrors.push(err41);
                }
                errors++;
              }
            } else {
              const err42 = { instancePath: instancePath + "/notes", schemaPath: "#/properties/notes/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: schema11.properties.notes.type, parentSchema: schema11.properties.notes, data: data5 };
              if (vErrors === null) {
                vErrors = [err42];
              } else {
                vErrors.push(err42);
              }
              errors++;
            }
          }
        } else {
          const err43 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object", schema: schema11.type, parentSchema: schema11, data };
          if (vErrors === null) {
            vErrors = [err43];
          } else {
            vErrors.push(err43);
          }
          errors++;
        }
        validate10.errors = vErrors;
        return errors === 0;
      }
      exports["19a4bec0"] = validate11;
      var schema12 = { "const": "OST_MechanicalEquipment", "title": "Mechanical equipment", "$id": "19a4bec0" };
      function validate11(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
        ;
        let vErrors = null;
        let errors = 0;
        if ("OST_MechanicalEquipment" !== data) {
          const err0 = { instancePath, schemaPath: "#/const", keyword: "const", params: { allowedValue: "OST_MechanicalEquipment" }, message: "must be equal to constant", schema: "OST_MechanicalEquipment", parentSchema: schema12, data };
          if (vErrors === null) {
            vErrors = [err0];
          } else {
            vErrors.push(err0);
          }
          errors++;
        }
        validate11.errors = vErrors;
        return errors === 0;
      }
      exports["-7a870233"] = validate12;
      var schema13 = { "const": "OST_DuctTerminal", "title": "Air terminals", "$id": "-7a870233" };
      function validate12(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
        ;
        let vErrors = null;
        let errors = 0;
        if ("OST_DuctTerminal" !== data) {
          const err0 = { instancePath, schemaPath: "#/const", keyword: "const", params: { allowedValue: "OST_DuctTerminal" }, message: "must be equal to constant", schema: "OST_DuctTerminal", parentSchema: schema13, data };
          if (vErrors === null) {
            vErrors = [err0];
          } else {
            vErrors.push(err0);
          }
          errors++;
        }
        validate12.errors = vErrors;
        return errors === 0;
      }
      exports["-5d12407c"] = validate13;
      var schema14 = { "const": "OST_DuctAccessory", "title": "Duct accessories", "$id": "-5d12407c" };
      function validate13(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
        ;
        let vErrors = null;
        let errors = 0;
        if ("OST_DuctAccessory" !== data) {
          const err0 = { instancePath, schemaPath: "#/const", keyword: "const", params: { allowedValue: "OST_DuctAccessory" }, message: "must be equal to constant", schema: "OST_DuctAccessory", parentSchema: schema14, data };
          if (vErrors === null) {
            vErrors = [err0];
          } else {
            vErrors.push(err0);
          }
          errors++;
        }
        validate13.errors = vErrors;
        return errors === 0;
      }
      exports["5064bfe2"] = validate14;
      var schema15 = { "const": "OST_PlumbingFixtures", "title": "Plumbing fixtures", "$id": "5064bfe2" };
      function validate14(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
        ;
        let vErrors = null;
        let errors = 0;
        if ("OST_PlumbingFixtures" !== data) {
          const err0 = { instancePath, schemaPath: "#/const", keyword: "const", params: { allowedValue: "OST_PlumbingFixtures" }, message: "must be equal to constant", schema: "OST_PlumbingFixtures", parentSchema: schema15, data };
          if (vErrors === null) {
            vErrors = [err0];
          } else {
            vErrors.push(err0);
          }
          errors++;
        }
        validate14.errors = vErrors;
        return errors === 0;
      }
      exports["324315ca"] = validate15;
      var schema16 = { "const": "OST_PlumbingEquipment", "title": "Plumbing equipment", "$id": "324315ca" };
      function validate15(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
        ;
        let vErrors = null;
        let errors = 0;
        if ("OST_PlumbingEquipment" !== data) {
          const err0 = { instancePath, schemaPath: "#/const", keyword: "const", params: { allowedValue: "OST_PlumbingEquipment" }, message: "must be equal to constant", schema: "OST_PlumbingEquipment", parentSchema: schema16, data };
          if (vErrors === null) {
            vErrors = [err0];
          } else {
            vErrors.push(err0);
          }
          errors++;
        }
        validate15.errors = vErrors;
        return errors === 0;
      }
      exports["-56f1cca4"] = validate16;
      var schema17 = { "const": "OST_PipeAccessory", "title": "Pipe accessories", "$id": "-56f1cca4" };
      function validate16(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
        ;
        let vErrors = null;
        let errors = 0;
        if ("OST_PipeAccessory" !== data) {
          const err0 = { instancePath, schemaPath: "#/const", keyword: "const", params: { allowedValue: "OST_PipeAccessory" }, message: "must be equal to constant", schema: "OST_PipeAccessory", parentSchema: schema17, data };
          if (vErrors === null) {
            vErrors = [err0];
          } else {
            vErrors.push(err0);
          }
          errors++;
        }
        validate16.errors = vErrors;
        return errors === 0;
      }
      exports["14d3afa8"] = validate17;
      var schema18 = { "const": "OST_Sprinklers", "title": "Sprinklers", "$id": "14d3afa8" };
      function validate17(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
        ;
        let vErrors = null;
        let errors = 0;
        if ("OST_Sprinklers" !== data) {
          const err0 = { instancePath, schemaPath: "#/const", keyword: "const", params: { allowedValue: "OST_Sprinklers" }, message: "must be equal to constant", schema: "OST_Sprinklers", parentSchema: schema18, data };
          if (vErrors === null) {
            vErrors = [err0];
          } else {
            vErrors.push(err0);
          }
          errors++;
        }
        validate17.errors = vErrors;
        return errors === 0;
      }
      exports["-70a286b6"] = validate18;
      var schema19 = { "const": "OST_FireAlarmDevices", "title": "Fire alarm devices", "$id": "-70a286b6" };
      function validate18(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
        ;
        let vErrors = null;
        let errors = 0;
        if ("OST_FireAlarmDevices" !== data) {
          const err0 = { instancePath, schemaPath: "#/const", keyword: "const", params: { allowedValue: "OST_FireAlarmDevices" }, message: "must be equal to constant", schema: "OST_FireAlarmDevices", parentSchema: schema19, data };
          if (vErrors === null) {
            vErrors = [err0];
          } else {
            vErrors.push(err0);
          }
          errors++;
        }
        validate18.errors = vErrors;
        return errors === 0;
      }
      exports["51af88b2"] = validate19;
      var schema20 = { "const": "OST_ElectricalEquipment", "title": "Electrical equipment", "$id": "51af88b2" };
      function validate19(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
        ;
        let vErrors = null;
        let errors = 0;
        if ("OST_ElectricalEquipment" !== data) {
          const err0 = { instancePath, schemaPath: "#/const", keyword: "const", params: { allowedValue: "OST_ElectricalEquipment" }, message: "must be equal to constant", schema: "OST_ElectricalEquipment", parentSchema: schema20, data };
          if (vErrors === null) {
            vErrors = [err0];
          } else {
            vErrors.push(err0);
          }
          errors++;
        }
        validate19.errors = vErrors;
        return errors === 0;
      }
      exports["-4ba7d81e"] = validate20;
      var schema21 = { "const": "OST_ElectricalFixtures", "title": "Electrical fixtures", "$id": "-4ba7d81e" };
      function validate20(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
        ;
        let vErrors = null;
        let errors = 0;
        if ("OST_ElectricalFixtures" !== data) {
          const err0 = { instancePath, schemaPath: "#/const", keyword: "const", params: { allowedValue: "OST_ElectricalFixtures" }, message: "must be equal to constant", schema: "OST_ElectricalFixtures", parentSchema: schema21, data };
          if (vErrors === null) {
            vErrors = [err0];
          } else {
            vErrors.push(err0);
          }
          errors++;
        }
        validate20.errors = vErrors;
        return errors === 0;
      }
      exports["-7881d1e"] = validate21;
      var schema22 = { "const": "OST_LightingFixtures", "title": "Lighting fixtures", "$id": "-7881d1e" };
      function validate21(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
        ;
        let vErrors = null;
        let errors = 0;
        if ("OST_LightingFixtures" !== data) {
          const err0 = { instancePath, schemaPath: "#/const", keyword: "const", params: { allowedValue: "OST_LightingFixtures" }, message: "must be equal to constant", schema: "OST_LightingFixtures", parentSchema: schema22, data };
          if (vErrors === null) {
            vErrors = [err0];
          } else {
            vErrors.push(err0);
          }
          errors++;
        }
        validate21.errors = vErrors;
        return errors === 0;
      }
      exports["-565a22a6"] = validate22;
      var schema23 = { "const": "OST_LightingDevices", "title": "Lighting devices", "$id": "-565a22a6" };
      function validate22(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
        ;
        let vErrors = null;
        let errors = 0;
        if ("OST_LightingDevices" !== data) {
          const err0 = { instancePath, schemaPath: "#/const", keyword: "const", params: { allowedValue: "OST_LightingDevices" }, message: "must be equal to constant", schema: "OST_LightingDevices", parentSchema: schema23, data };
          if (vErrors === null) {
            vErrors = [err0];
          } else {
            vErrors.push(err0);
          }
          errors++;
        }
        validate22.errors = vErrors;
        return errors === 0;
      }
      exports["15a81048"] = validate23;
      var schema24 = { "const": "OST_CommunicationDevices", "title": "Communication devices", "$id": "15a81048" };
      function validate23(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
        ;
        let vErrors = null;
        let errors = 0;
        if ("OST_CommunicationDevices" !== data) {
          const err0 = { instancePath, schemaPath: "#/const", keyword: "const", params: { allowedValue: "OST_CommunicationDevices" }, message: "must be equal to constant", schema: "OST_CommunicationDevices", parentSchema: schema24, data };
          if (vErrors === null) {
            vErrors = [err0];
          } else {
            vErrors.push(err0);
          }
          errors++;
        }
        validate23.errors = vErrors;
        return errors === 0;
      }
      exports["10af3296"] = validate24;
      var schema25 = { "const": "OST_DataDevices", "title": "Data devices", "$id": "10af3296" };
      function validate24(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
        ;
        let vErrors = null;
        let errors = 0;
        if ("OST_DataDevices" !== data) {
          const err0 = { instancePath, schemaPath: "#/const", keyword: "const", params: { allowedValue: "OST_DataDevices" }, message: "must be equal to constant", schema: "OST_DataDevices", parentSchema: schema25, data };
          if (vErrors === null) {
            vErrors = [err0];
          } else {
            vErrors.push(err0);
          }
          errors++;
        }
        validate24.errors = vErrors;
        return errors === 0;
      }
      exports["74da8ac2"] = validate25;
      var schema26 = { "const": "OST_SecurityDevices", "title": "Security devices", "$id": "74da8ac2" };
      function validate25(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
        ;
        let vErrors = null;
        let errors = 0;
        if ("OST_SecurityDevices" !== data) {
          const err0 = { instancePath, schemaPath: "#/const", keyword: "const", params: { allowedValue: "OST_SecurityDevices" }, message: "must be equal to constant", schema: "OST_SecurityDevices", parentSchema: schema26, data };
          if (vErrors === null) {
            vErrors = [err0];
          } else {
            vErrors.push(err0);
          }
          errors++;
        }
        validate25.errors = vErrors;
        return errors === 0;
      }
      exports["62161bc4"] = validate26;
      var schema27 = { "const": "OST_NurseCallDevices", "title": "Nurse call devices", "$id": "62161bc4" };
      function validate26(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
        ;
        let vErrors = null;
        let errors = 0;
        if ("OST_NurseCallDevices" !== data) {
          const err0 = { instancePath, schemaPath: "#/const", keyword: "const", params: { allowedValue: "OST_NurseCallDevices" }, message: "must be equal to constant", schema: "OST_NurseCallDevices", parentSchema: schema27, data };
          if (vErrors === null) {
            vErrors = [err0];
          } else {
            vErrors.push(err0);
          }
          errors++;
        }
        validate26.errors = vErrors;
        return errors === 0;
      }
      exports["-462ab8f8"] = validate27;
      var schema28 = { "const": "OST_TelephoneDevices", "title": "Telephone devices", "$id": "-462ab8f8" };
      function validate27(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
        ;
        let vErrors = null;
        let errors = 0;
        if ("OST_TelephoneDevices" !== data) {
          const err0 = { instancePath, schemaPath: "#/const", keyword: "const", params: { allowedValue: "OST_TelephoneDevices" }, message: "must be equal to constant", schema: "OST_TelephoneDevices", parentSchema: schema28, data };
          if (vErrors === null) {
            vErrors = [err0];
          } else {
            vErrors.push(err0);
          }
          errors++;
        }
        validate27.errors = vErrors;
        return errors === 0;
      }
      exports["-1c430518"] = validate28;
      var schema29 = { "const": "OST_AudioVisualDevices", "title": "Audio visual devices", "$id": "-1c430518" };
      function validate28(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
        ;
        let vErrors = null;
        let errors = 0;
        if ("OST_AudioVisualDevices" !== data) {
          const err0 = { instancePath, schemaPath: "#/const", keyword: "const", params: { allowedValue: "OST_AudioVisualDevices" }, message: "must be equal to constant", schema: "OST_AudioVisualDevices", parentSchema: schema29, data };
          if (vErrors === null) {
            vErrors = [err0];
          } else {
            vErrors.push(err0);
          }
          errors++;
        }
        validate28.errors = vErrors;
        return errors === 0;
      }
      exports["1b6c3599"] = validate29;
      var schema30 = { "const": "OST_SpecialityEquipment", "title": "Specialty equipment", "$id": "1b6c3599" };
      function validate29(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
        ;
        let vErrors = null;
        let errors = 0;
        if ("OST_SpecialityEquipment" !== data) {
          const err0 = { instancePath, schemaPath: "#/const", keyword: "const", params: { allowedValue: "OST_SpecialityEquipment" }, message: "must be equal to constant", schema: "OST_SpecialityEquipment", parentSchema: schema30, data };
          if (vErrors === null) {
            vErrors = [err0];
          } else {
            vErrors.push(err0);
          }
          errors++;
        }
        validate29.errors = vErrors;
        return errors === 0;
      }
      exports["4d29f44a"] = validate30;
      var schema31 = { "const": "OST_MedicalEquipment", "title": "Medical equipment", "$id": "4d29f44a" };
      function validate30(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
        ;
        let vErrors = null;
        let errors = 0;
        if ("OST_MedicalEquipment" !== data) {
          const err0 = { instancePath, schemaPath: "#/const", keyword: "const", params: { allowedValue: "OST_MedicalEquipment" }, message: "must be equal to constant", schema: "OST_MedicalEquipment", parentSchema: schema31, data };
          if (vErrors === null) {
            vErrors = [err0];
          } else {
            vErrors.push(err0);
          }
          errors++;
        }
        validate30.errors = vErrors;
        return errors === 0;
      }
      exports["-4770344e"] = validate31;
      var schema32 = { "const": "OST_FoodServiceEquipment", "title": "Food service equipment", "$id": "-4770344e" };
      function validate31(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
        ;
        let vErrors = null;
        let errors = 0;
        if ("OST_FoodServiceEquipment" !== data) {
          const err0 = { instancePath, schemaPath: "#/const", keyword: "const", params: { allowedValue: "OST_FoodServiceEquipment" }, message: "must be equal to constant", schema: "OST_FoodServiceEquipment", parentSchema: schema32, data };
          if (vErrors === null) {
            vErrors = [err0];
          } else {
            vErrors.push(err0);
          }
          errors++;
        }
        validate31.errors = vErrors;
        return errors === 0;
      }
      exports["6493f4d8"] = validate32;
      var schema33 = { "const": "OST_Furniture", "title": "Furniture", "$id": "6493f4d8" };
      function validate32(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
        ;
        let vErrors = null;
        let errors = 0;
        if ("OST_Furniture" !== data) {
          const err0 = { instancePath, schemaPath: "#/const", keyword: "const", params: { allowedValue: "OST_Furniture" }, message: "must be equal to constant", schema: "OST_Furniture", parentSchema: schema33, data };
          if (vErrors === null) {
            vErrors = [err0];
          } else {
            vErrors.push(err0);
          }
          errors++;
        }
        validate32.errors = vErrors;
        return errors === 0;
      }
      exports["4c6214d6"] = validate33;
      var schema34 = { "const": "OST_FurnitureSystems", "title": "Furniture systems", "$id": "4c6214d6" };
      function validate33(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
        ;
        let vErrors = null;
        let errors = 0;
        if ("OST_FurnitureSystems" !== data) {
          const err0 = { instancePath, schemaPath: "#/const", keyword: "const", params: { allowedValue: "OST_FurnitureSystems" }, message: "must be equal to constant", schema: "OST_FurnitureSystems", parentSchema: schema34, data };
          if (vErrors === null) {
            vErrors = [err0];
          } else {
            vErrors.push(err0);
          }
          errors++;
        }
        validate33.errors = vErrors;
        return errors === 0;
      }
      exports["-649acad8"] = validate34;
      var schema35 = { "const": "OST_Casework", "title": "Casework", "$id": "-649acad8" };
      function validate34(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
        ;
        let vErrors = null;
        let errors = 0;
        if ("OST_Casework" !== data) {
          const err0 = { instancePath, schemaPath: "#/const", keyword: "const", params: { allowedValue: "OST_Casework" }, message: "must be equal to constant", schema: "OST_Casework", parentSchema: schema35, data };
          if (vErrors === null) {
            vErrors = [err0];
          } else {
            vErrors.push(err0);
          }
          errors++;
        }
        validate34.errors = vErrors;
        return errors === 0;
      }
      exports["-77cdd682"] = validate35;
      var schema36 = { "const": "OST_Doors", "title": "Doors", "$id": "-77cdd682" };
      function validate35(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
        ;
        let vErrors = null;
        let errors = 0;
        if ("OST_Doors" !== data) {
          const err0 = { instancePath, schemaPath: "#/const", keyword: "const", params: { allowedValue: "OST_Doors" }, message: "must be equal to constant", schema: "OST_Doors", parentSchema: schema36, data };
          if (vErrors === null) {
            vErrors = [err0];
          } else {
            vErrors.push(err0);
          }
          errors++;
        }
        validate35.errors = vErrors;
        return errors === 0;
      }
      exports["7db312ba"] = validate36;
      var schema37 = { "const": "OST_Windows", "title": "Windows", "$id": "7db312ba" };
      function validate36(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
        ;
        let vErrors = null;
        let errors = 0;
        if ("OST_Windows" !== data) {
          const err0 = { instancePath, schemaPath: "#/const", keyword: "const", params: { allowedValue: "OST_Windows" }, message: "must be equal to constant", schema: "OST_Windows", parentSchema: schema37, data };
          if (vErrors === null) {
            vErrors = [err0];
          } else {
            vErrors.push(err0);
          }
          errors++;
        }
        validate36.errors = vErrors;
        return errors === 0;
      }
    }
  });
  return require_validator_0();
})();

"use strict";
var compiled1 = (() => {
  var __getOwnPropNames = Object.getOwnPropertyNames;
  var __commonJS = (cb, mod) => function __require() {
    return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
  };

  // src/web/node_modules/ajv/dist/runtime/ucs2length.js
  var require_ucs2length = __commonJS({
    "src/web/node_modules/ajv/dist/runtime/ucs2length.js"(exports) {
      "use strict";
      Object.defineProperty(exports, "__esModule", { value: true });
      function ucs2length(str) {
        const len = str.length;
        let length = 0;
        let pos = 0;
        let value;
        while (pos < len) {
          length++;
          value = str.charCodeAt(pos++);
          if (value >= 55296 && value <= 56319 && pos < len) {
            value = str.charCodeAt(pos);
            if ((value & 64512) === 56320)
              pos++;
          }
        }
        return length;
      }
      exports.default = ucs2length;
      ucs2length.code = 'require("ajv/dist/runtime/ucs2length").default';
    }
  });

  // src/web/validator-1.cjs
  var require_validator_1 = __commonJS({
    "src/web/validator-1.cjs"(exports) {
      exports["106430"] = validate10;
      var schema11 = { "const": "OST_DuctTerminal", "title": "\u98A8\u7BA1\u7D42\u7AEF", "$id": "106430" };
      function validate10(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
        ;
        let vErrors = null;
        let errors = 0;
        if ("OST_DuctTerminal" !== data) {
          const err0 = { instancePath, schemaPath: "#/const", keyword: "const", params: { allowedValue: "OST_DuctTerminal" }, message: "must be equal to constant", schema: "OST_DuctTerminal", parentSchema: schema11, data };
          if (vErrors === null) {
            vErrors = [err0];
          } else {
            vErrors.push(err0);
          }
          errors++;
        }
        validate10.errors = vErrors;
        return errors === 0;
      }
      exports["49941251"] = validate11;
      var schema12 = { "const": "OST_Furniture", "title": "\u5BB6\u5177", "$id": "49941251" };
      function validate11(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
        ;
        let vErrors = null;
        let errors = 0;
        if ("OST_Furniture" !== data) {
          const err0 = { instancePath, schemaPath: "#/const", keyword: "const", params: { allowedValue: "OST_Furniture" }, message: "must be equal to constant", schema: "OST_Furniture", parentSchema: schema12, data };
          if (vErrors === null) {
            vErrors = [err0];
          } else {
            vErrors.push(err0);
          }
          errors++;
        }
        validate11.errors = vErrors;
        return errors === 0;
      }
      exports["-36d18649"] = validate12;
      var schema13 = { "$schema": "http://json-schema.org/draft-07/schema#", "type": "object", "additionalProperties": false, "required": ["cobieFile"], "properties": { "toolCallLimit": { "type": "integer", "title": "\u6BCF\u6B21\u57F7\u884C\u5DE5\u5177\u4E0A\u9650\uFF08\u6B21\uFF09", "default": 40, "minimum": 1, "maximum": 80, "description": "\u53EF\u8A2D\u5B9A 1\u201380 \u6B21\uFF0C\u9810\u8A2D 40 \u6B21\u3002\u57F7\u884C\u6216\u7E8C\u8DD1\u5404\u81EA\u8A08\u7B97\uFF1B\u7D50\u6848\u5831\u544A\u4E0D\u8A08\u5165\u3002\u9810\u4F30\u6703\u96A8\u6A21\u578B\u898F\u6A21\u8207\u4EA4\u4ED8\u6A94\u5927\u5C0F\u8B8A\u52D5\uFF0C\u4E26\u975E\u5B8C\u6210\u4FDD\u8B49\u6216\u903E\u6642\u9650\u5236\u3002" }, "cobieFile": { "type": "string", "title": "COBie Excel", "minLength": 1, "maxLength": 4096, "description": "\u8981\u6AA2\u6838\u7684 COBie \u6D3B\u9801\u7C3F\uFF08.xlsx\uFF09\u3002\u6309\u53F3\u5074\u7684\u8CC7\u6599\u593E\u5716\u793A\u9078\u6A94\uFF0C\u6216\u76F4\u63A5\u8CBC\u4E0A\u5B8C\u6574\u8DEF\u5F91\u3002\u6AA2\u6838\u5831\u8868\u6703\u653E\u5728\u540C\u4E00\u500B\u8CC7\u6599\u593E\u3002" }, "formFile": { "type": "string", "title": "\u586B\u5BEB\u8868 Excel", "default": "", "maxLength": 4096, "description": "\u88FD\u4F5C\u9019\u4EFD COBie \u6642\u7528\u7684\u586B\u5BEB\u8868\uFF08.xlsx\uFF09\uFF0C\u4E5F\u5C31\u662F COBie \u88FD\u4F5C\u7684\u90A3\u4E00\u5F35\u3002\u4EA4\u4ED8\u8CC7\u6599\u4E2D\u7531\u586B\u5BEB\u8868\u63D0\u4F9B\u7684\u5167\u5BB9\uFF08\u806F\u7D61\u4EBA\u3001\u8A2D\u65BD\u540D\u7A31\u8207\u55AE\u4F4D\u3001\u5404\u8A2D\u5099\u578B\u5F0F\u7684\u88FD\u9020\u5546\u3001\u578B\u865F\u3001\u4FDD\u56FA\uFF0C\u4EE5\u53CA\u5B89\u88DD\u8207\u4FDD\u56FA\u65E5\u671F\uFF09\u6703\u9010\u7B46\u8207\u5B83\u6BD4\u5C0D\u3002\u9084\u6C92\u6709\u586B\u5BEB\u8868\u6642\uFF0C\u6309\u300C\u53D6\u5F97\u7A7A\u767D\u8868\u55AE\u300D\u53EF\u62FF\u5230\u4E00\u4EFD\uFF1B\u5B83\u8981\u5217\u51FA\u4EA4\u4ED8\u7684\u8A2D\u5099\u578B\u5F0F\u4E26\u586B\u597D\u5167\u5BB9\u624D\u80FD\u7528\u4F86\u6BD4\u5C0D\uFF0C\u4E00\u822C\u7531 COBie \u88FD\u4F5C\u4F9D\u6A21\u578B\u7522\u751F\u3002\u7559\u7A7A\u5247\u4E0D\u505A\u8207\u586B\u5BEB\u8868\u7684\u8CC7\u6599\u9A57\u8B49\u3002" }, "categories": { "type": "array", "title": "\u6AA2\u6838\u54C1\u985E", "description": "\u9019\u4EFD COBie \u4EA4\u4ED8\u6DB5\u84CB\u54EA\u4E9B\u54C1\u985E\u3002\u8207\u6A21\u578B\u6BD4\u5C0D\u6642\u53EA\u770B\u52FE\u9078\u7684\u54C1\u985E\uFF1B\u6C92\u52FE\u9078\u7684\u54C1\u985E\u5373\u4F7F\u6A21\u578B\u4E2D\u6709\u6A19\u8A18 COBie\uFF0C\u4E5F\u4E0D\u6703\u88AB\u5217\u70BA\u4EA4\u4ED8\u6A94\u7F3A\u6F0F\u3002\u9810\u8A2D\u5168\u9078\uFF0C\u8ACB\u4F9D\u4EA4\u4ED8\u7BC4\u570D\u8ABF\u6574\uFF0C\u81F3\u5C11\u4FDD\u7559\u4E00\u9805\u3002", "default": ["OST_MechanicalEquipment", "OST_DuctTerminal", "OST_DuctAccessory", "OST_PlumbingFixtures", "OST_PlumbingEquipment", "OST_PipeAccessory", "OST_Sprinklers", "OST_FireAlarmDevices", "OST_ElectricalEquipment", "OST_ElectricalFixtures", "OST_LightingFixtures", "OST_LightingDevices", "OST_CommunicationDevices", "OST_DataDevices", "OST_SecurityDevices", "OST_NurseCallDevices", "OST_TelephoneDevices", "OST_AudioVisualDevices", "OST_SpecialityEquipment", "OST_MedicalEquipment", "OST_FoodServiceEquipment", "OST_Furniture", "OST_FurnitureSystems", "OST_Casework", "OST_Doors", "OST_Windows"], "uniqueItems": true, "minItems": 1, "items": { "type": "string", "oneOf": [{ "const": "OST_MechanicalEquipment", "title": "\u6A5F\u68B0\u8A2D\u5099" }, { "const": "OST_DuctTerminal", "title": "\u98A8\u7BA1\u7D42\u7AEF" }, { "const": "OST_DuctAccessory", "title": "\u98A8\u7BA1\u9644\u4EF6" }, { "const": "OST_PlumbingFixtures", "title": "\u885B\u5DE5\u8A2D\u5099" }, { "const": "OST_PlumbingEquipment", "title": "\u7D66\u6392\u6C34\u8A2D\u5099" }, { "const": "OST_PipeAccessory", "title": "\u7BA1\u9644\u4EF6" }, { "const": "OST_Sprinklers", "title": "\u7051\u6C34\u982D" }, { "const": "OST_FireAlarmDevices", "title": "\u706B\u8B66\u88DD\u7F6E" }, { "const": "OST_ElectricalEquipment", "title": "\u96FB\u6C23\u8A2D\u5099" }, { "const": "OST_ElectricalFixtures", "title": "\u96FB\u6C23\u88DD\u7F6E" }, { "const": "OST_LightingFixtures", "title": "\u7167\u660E\u8A2D\u5099" }, { "const": "OST_LightingDevices", "title": "\u7167\u660E\u88DD\u7F6E" }, { "const": "OST_CommunicationDevices", "title": "\u901A\u8A0A\u88DD\u7F6E" }, { "const": "OST_DataDevices", "title": "\u8CC7\u6599\u88DD\u7F6E" }, { "const": "OST_SecurityDevices", "title": "\u4FDD\u5168\u88DD\u7F6E" }, { "const": "OST_NurseCallDevices", "title": "\u8B77\u7406\u547C\u53EB\u88DD\u7F6E" }, { "const": "OST_TelephoneDevices", "title": "\u96FB\u8A71\u88DD\u7F6E" }, { "const": "OST_AudioVisualDevices", "title": "\u8996\u807D\u8A2D\u5099" }, { "const": "OST_SpecialityEquipment", "title": "\u5C08\u7528\u8A2D\u5099" }, { "const": "OST_MedicalEquipment", "title": "\u91AB\u7642\u8A2D\u5099" }, { "const": "OST_FoodServiceEquipment", "title": "\u9910\u98F2\u8A2D\u5099" }, { "const": "OST_Furniture", "title": "\u5BB6\u5177" }, { "const": "OST_FurnitureSystems", "title": "\u5BB6\u5177\u7CFB\u7D71" }, { "const": "OST_Casework", "title": "\u6AE5\u6AC3" }, { "const": "OST_Doors", "title": "\u9580" }, { "const": "OST_Windows", "title": "\u7A97" }] } }, "notes": { "type": "string", "title": "\u672C\u6B21\u8981\u6C42\u8207\u8AAA\u660E", "default": "", "maxLength": 1e4, "description": "\u53EF\u7559\u7A7A\u3002\u6A21\u578B\u4EE5\u76EE\u524D\u5728 Revit \u958B\u555F\u7684\u5C08\u6848\u70BA\u6E96\u3002" } }, "$id": "-36d18649" };
      var func2 = require_ucs2length().default;
      function validate12(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
        ;
        let vErrors = null;
        let errors = 0;
        if (data && typeof data == "object" && !Array.isArray(data)) {
          if (data.cobieFile === void 0) {
            const err0 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "cobieFile" }, message: "must have required property 'cobieFile'", schema: schema13.required, parentSchema: schema13, data };
            if (vErrors === null) {
              vErrors = [err0];
            } else {
              vErrors.push(err0);
            }
            errors++;
          }
          for (const key0 in data) {
            if (!(key0 === "toolCallLimit" || key0 === "cobieFile" || key0 === "formFile" || key0 === "categories" || key0 === "notes")) {
              const err1 = { instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties", schema: false, parentSchema: schema13, data };
              if (vErrors === null) {
                vErrors = [err1];
              } else {
                vErrors.push(err1);
              }
              errors++;
            }
          }
          if (data.toolCallLimit !== void 0) {
            let data0 = data.toolCallLimit;
            if (!(typeof data0 == "number" && (!(data0 % 1) && !isNaN(data0)) && isFinite(data0))) {
              const err2 = { instancePath: instancePath + "/toolCallLimit", schemaPath: "#/properties/toolCallLimit/type", keyword: "type", params: { type: "integer" }, message: "must be integer", schema: schema13.properties.toolCallLimit.type, parentSchema: schema13.properties.toolCallLimit, data: data0 };
              if (vErrors === null) {
                vErrors = [err2];
              } else {
                vErrors.push(err2);
              }
              errors++;
            }
            if (typeof data0 == "number" && isFinite(data0)) {
              if (data0 > 80 || isNaN(data0)) {
                const err3 = { instancePath: instancePath + "/toolCallLimit", schemaPath: "#/properties/toolCallLimit/maximum", keyword: "maximum", params: { comparison: "<=", limit: 80 }, message: "must be <= 80", schema: 80, parentSchema: schema13.properties.toolCallLimit, data: data0 };
                if (vErrors === null) {
                  vErrors = [err3];
                } else {
                  vErrors.push(err3);
                }
                errors++;
              }
              if (data0 < 1 || isNaN(data0)) {
                const err4 = { instancePath: instancePath + "/toolCallLimit", schemaPath: "#/properties/toolCallLimit/minimum", keyword: "minimum", params: { comparison: ">=", limit: 1 }, message: "must be >= 1", schema: 1, parentSchema: schema13.properties.toolCallLimit, data: data0 };
                if (vErrors === null) {
                  vErrors = [err4];
                } else {
                  vErrors.push(err4);
                }
                errors++;
              }
            }
          }
          if (data.cobieFile !== void 0) {
            let data1 = data.cobieFile;
            if (typeof data1 === "string") {
              if (func2(data1) > 4096) {
                const err5 = { instancePath: instancePath + "/cobieFile", schemaPath: "#/properties/cobieFile/maxLength", keyword: "maxLength", params: { limit: 4096 }, message: "must NOT have more than 4096 characters", schema: 4096, parentSchema: schema13.properties.cobieFile, data: data1 };
                if (vErrors === null) {
                  vErrors = [err5];
                } else {
                  vErrors.push(err5);
                }
                errors++;
              }
              if (func2(data1) < 1) {
                const err6 = { instancePath: instancePath + "/cobieFile", schemaPath: "#/properties/cobieFile/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters", schema: 1, parentSchema: schema13.properties.cobieFile, data: data1 };
                if (vErrors === null) {
                  vErrors = [err6];
                } else {
                  vErrors.push(err6);
                }
                errors++;
              }
            } else {
              const err7 = { instancePath: instancePath + "/cobieFile", schemaPath: "#/properties/cobieFile/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: schema13.properties.cobieFile.type, parentSchema: schema13.properties.cobieFile, data: data1 };
              if (vErrors === null) {
                vErrors = [err7];
              } else {
                vErrors.push(err7);
              }
              errors++;
            }
          }
          if (data.formFile !== void 0) {
            let data2 = data.formFile;
            if (typeof data2 === "string") {
              if (func2(data2) > 4096) {
                const err8 = { instancePath: instancePath + "/formFile", schemaPath: "#/properties/formFile/maxLength", keyword: "maxLength", params: { limit: 4096 }, message: "must NOT have more than 4096 characters", schema: 4096, parentSchema: schema13.properties.formFile, data: data2 };
                if (vErrors === null) {
                  vErrors = [err8];
                } else {
                  vErrors.push(err8);
                }
                errors++;
              }
            } else {
              const err9 = { instancePath: instancePath + "/formFile", schemaPath: "#/properties/formFile/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: schema13.properties.formFile.type, parentSchema: schema13.properties.formFile, data: data2 };
              if (vErrors === null) {
                vErrors = [err9];
              } else {
                vErrors.push(err9);
              }
              errors++;
            }
          }
          if (data.categories !== void 0) {
            let data3 = data.categories;
            if (Array.isArray(data3)) {
              if (data3.length < 1) {
                const err10 = { instancePath: instancePath + "/categories", schemaPath: "#/properties/categories/minItems", keyword: "minItems", params: { limit: 1 }, message: "must NOT have fewer than 1 items", schema: 1, parentSchema: schema13.properties.categories, data: data3 };
                if (vErrors === null) {
                  vErrors = [err10];
                } else {
                  vErrors.push(err10);
                }
                errors++;
              }
              const len0 = data3.length;
              for (let i0 = 0; i0 < len0; i0++) {
                let data4 = data3[i0];
                if (typeof data4 !== "string") {
                  const err11 = { instancePath: instancePath + "/categories/" + i0, schemaPath: "#/properties/categories/items/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: schema13.properties.categories.items.type, parentSchema: schema13.properties.categories.items, data: data4 };
                  if (vErrors === null) {
                    vErrors = [err11];
                  } else {
                    vErrors.push(err11);
                  }
                  errors++;
                }
                const _errs12 = errors;
                let valid3 = false;
                let passing0 = null;
                const _errs13 = errors;
                if ("OST_MechanicalEquipment" !== data4) {
                  const err12 = { instancePath: instancePath + "/categories/" + i0, schemaPath: "#/properties/categories/items/oneOf/0/const", keyword: "const", params: { allowedValue: "OST_MechanicalEquipment" }, message: "must be equal to constant", schema: "OST_MechanicalEquipment", parentSchema: schema13.properties.categories.items.oneOf[0], data: data4 };
                  if (vErrors === null) {
                    vErrors = [err12];
                  } else {
                    vErrors.push(err12);
                  }
                  errors++;
                }
                var _valid0 = _errs13 === errors;
                if (_valid0) {
                  valid3 = true;
                  passing0 = 0;
                }
                const _errs14 = errors;
                if ("OST_DuctTerminal" !== data4) {
                  const err13 = { instancePath: instancePath + "/categories/" + i0, schemaPath: "#/properties/categories/items/oneOf/1/const", keyword: "const", params: { allowedValue: "OST_DuctTerminal" }, message: "must be equal to constant", schema: "OST_DuctTerminal", parentSchema: schema13.properties.categories.items.oneOf[1], data: data4 };
                  if (vErrors === null) {
                    vErrors = [err13];
                  } else {
                    vErrors.push(err13);
                  }
                  errors++;
                }
                var _valid0 = _errs14 === errors;
                if (_valid0 && valid3) {
                  valid3 = false;
                  passing0 = [passing0, 1];
                } else {
                  if (_valid0) {
                    valid3 = true;
                    passing0 = 1;
                  }
                  const _errs15 = errors;
                  if ("OST_DuctAccessory" !== data4) {
                    const err14 = { instancePath: instancePath + "/categories/" + i0, schemaPath: "#/properties/categories/items/oneOf/2/const", keyword: "const", params: { allowedValue: "OST_DuctAccessory" }, message: "must be equal to constant", schema: "OST_DuctAccessory", parentSchema: schema13.properties.categories.items.oneOf[2], data: data4 };
                    if (vErrors === null) {
                      vErrors = [err14];
                    } else {
                      vErrors.push(err14);
                    }
                    errors++;
                  }
                  var _valid0 = _errs15 === errors;
                  if (_valid0 && valid3) {
                    valid3 = false;
                    passing0 = [passing0, 2];
                  } else {
                    if (_valid0) {
                      valid3 = true;
                      passing0 = 2;
                    }
                    const _errs16 = errors;
                    if ("OST_PlumbingFixtures" !== data4) {
                      const err15 = { instancePath: instancePath + "/categories/" + i0, schemaPath: "#/properties/categories/items/oneOf/3/const", keyword: "const", params: { allowedValue: "OST_PlumbingFixtures" }, message: "must be equal to constant", schema: "OST_PlumbingFixtures", parentSchema: schema13.properties.categories.items.oneOf[3], data: data4 };
                      if (vErrors === null) {
                        vErrors = [err15];
                      } else {
                        vErrors.push(err15);
                      }
                      errors++;
                    }
                    var _valid0 = _errs16 === errors;
                    if (_valid0 && valid3) {
                      valid3 = false;
                      passing0 = [passing0, 3];
                    } else {
                      if (_valid0) {
                        valid3 = true;
                        passing0 = 3;
                      }
                      const _errs17 = errors;
                      if ("OST_PlumbingEquipment" !== data4) {
                        const err16 = { instancePath: instancePath + "/categories/" + i0, schemaPath: "#/properties/categories/items/oneOf/4/const", keyword: "const", params: { allowedValue: "OST_PlumbingEquipment" }, message: "must be equal to constant", schema: "OST_PlumbingEquipment", parentSchema: schema13.properties.categories.items.oneOf[4], data: data4 };
                        if (vErrors === null) {
                          vErrors = [err16];
                        } else {
                          vErrors.push(err16);
                        }
                        errors++;
                      }
                      var _valid0 = _errs17 === errors;
                      if (_valid0 && valid3) {
                        valid3 = false;
                        passing0 = [passing0, 4];
                      } else {
                        if (_valid0) {
                          valid3 = true;
                          passing0 = 4;
                        }
                        const _errs18 = errors;
                        if ("OST_PipeAccessory" !== data4) {
                          const err17 = { instancePath: instancePath + "/categories/" + i0, schemaPath: "#/properties/categories/items/oneOf/5/const", keyword: "const", params: { allowedValue: "OST_PipeAccessory" }, message: "must be equal to constant", schema: "OST_PipeAccessory", parentSchema: schema13.properties.categories.items.oneOf[5], data: data4 };
                          if (vErrors === null) {
                            vErrors = [err17];
                          } else {
                            vErrors.push(err17);
                          }
                          errors++;
                        }
                        var _valid0 = _errs18 === errors;
                        if (_valid0 && valid3) {
                          valid3 = false;
                          passing0 = [passing0, 5];
                        } else {
                          if (_valid0) {
                            valid3 = true;
                            passing0 = 5;
                          }
                          const _errs19 = errors;
                          if ("OST_Sprinklers" !== data4) {
                            const err18 = { instancePath: instancePath + "/categories/" + i0, schemaPath: "#/properties/categories/items/oneOf/6/const", keyword: "const", params: { allowedValue: "OST_Sprinklers" }, message: "must be equal to constant", schema: "OST_Sprinklers", parentSchema: schema13.properties.categories.items.oneOf[6], data: data4 };
                            if (vErrors === null) {
                              vErrors = [err18];
                            } else {
                              vErrors.push(err18);
                            }
                            errors++;
                          }
                          var _valid0 = _errs19 === errors;
                          if (_valid0 && valid3) {
                            valid3 = false;
                            passing0 = [passing0, 6];
                          } else {
                            if (_valid0) {
                              valid3 = true;
                              passing0 = 6;
                            }
                            const _errs20 = errors;
                            if ("OST_FireAlarmDevices" !== data4) {
                              const err19 = { instancePath: instancePath + "/categories/" + i0, schemaPath: "#/properties/categories/items/oneOf/7/const", keyword: "const", params: { allowedValue: "OST_FireAlarmDevices" }, message: "must be equal to constant", schema: "OST_FireAlarmDevices", parentSchema: schema13.properties.categories.items.oneOf[7], data: data4 };
                              if (vErrors === null) {
                                vErrors = [err19];
                              } else {
                                vErrors.push(err19);
                              }
                              errors++;
                            }
                            var _valid0 = _errs20 === errors;
                            if (_valid0 && valid3) {
                              valid3 = false;
                              passing0 = [passing0, 7];
                            } else {
                              if (_valid0) {
                                valid3 = true;
                                passing0 = 7;
                              }
                              const _errs21 = errors;
                              if ("OST_ElectricalEquipment" !== data4) {
                                const err20 = { instancePath: instancePath + "/categories/" + i0, schemaPath: "#/properties/categories/items/oneOf/8/const", keyword: "const", params: { allowedValue: "OST_ElectricalEquipment" }, message: "must be equal to constant", schema: "OST_ElectricalEquipment", parentSchema: schema13.properties.categories.items.oneOf[8], data: data4 };
                                if (vErrors === null) {
                                  vErrors = [err20];
                                } else {
                                  vErrors.push(err20);
                                }
                                errors++;
                              }
                              var _valid0 = _errs21 === errors;
                              if (_valid0 && valid3) {
                                valid3 = false;
                                passing0 = [passing0, 8];
                              } else {
                                if (_valid0) {
                                  valid3 = true;
                                  passing0 = 8;
                                }
                                const _errs22 = errors;
                                if ("OST_ElectricalFixtures" !== data4) {
                                  const err21 = { instancePath: instancePath + "/categories/" + i0, schemaPath: "#/properties/categories/items/oneOf/9/const", keyword: "const", params: { allowedValue: "OST_ElectricalFixtures" }, message: "must be equal to constant", schema: "OST_ElectricalFixtures", parentSchema: schema13.properties.categories.items.oneOf[9], data: data4 };
                                  if (vErrors === null) {
                                    vErrors = [err21];
                                  } else {
                                    vErrors.push(err21);
                                  }
                                  errors++;
                                }
                                var _valid0 = _errs22 === errors;
                                if (_valid0 && valid3) {
                                  valid3 = false;
                                  passing0 = [passing0, 9];
                                } else {
                                  if (_valid0) {
                                    valid3 = true;
                                    passing0 = 9;
                                  }
                                  const _errs23 = errors;
                                  if ("OST_LightingFixtures" !== data4) {
                                    const err22 = { instancePath: instancePath + "/categories/" + i0, schemaPath: "#/properties/categories/items/oneOf/10/const", keyword: "const", params: { allowedValue: "OST_LightingFixtures" }, message: "must be equal to constant", schema: "OST_LightingFixtures", parentSchema: schema13.properties.categories.items.oneOf[10], data: data4 };
                                    if (vErrors === null) {
                                      vErrors = [err22];
                                    } else {
                                      vErrors.push(err22);
                                    }
                                    errors++;
                                  }
                                  var _valid0 = _errs23 === errors;
                                  if (_valid0 && valid3) {
                                    valid3 = false;
                                    passing0 = [passing0, 10];
                                  } else {
                                    if (_valid0) {
                                      valid3 = true;
                                      passing0 = 10;
                                    }
                                    const _errs24 = errors;
                                    if ("OST_LightingDevices" !== data4) {
                                      const err23 = { instancePath: instancePath + "/categories/" + i0, schemaPath: "#/properties/categories/items/oneOf/11/const", keyword: "const", params: { allowedValue: "OST_LightingDevices" }, message: "must be equal to constant", schema: "OST_LightingDevices", parentSchema: schema13.properties.categories.items.oneOf[11], data: data4 };
                                      if (vErrors === null) {
                                        vErrors = [err23];
                                      } else {
                                        vErrors.push(err23);
                                      }
                                      errors++;
                                    }
                                    var _valid0 = _errs24 === errors;
                                    if (_valid0 && valid3) {
                                      valid3 = false;
                                      passing0 = [passing0, 11];
                                    } else {
                                      if (_valid0) {
                                        valid3 = true;
                                        passing0 = 11;
                                      }
                                      const _errs25 = errors;
                                      if ("OST_CommunicationDevices" !== data4) {
                                        const err24 = { instancePath: instancePath + "/categories/" + i0, schemaPath: "#/properties/categories/items/oneOf/12/const", keyword: "const", params: { allowedValue: "OST_CommunicationDevices" }, message: "must be equal to constant", schema: "OST_CommunicationDevices", parentSchema: schema13.properties.categories.items.oneOf[12], data: data4 };
                                        if (vErrors === null) {
                                          vErrors = [err24];
                                        } else {
                                          vErrors.push(err24);
                                        }
                                        errors++;
                                      }
                                      var _valid0 = _errs25 === errors;
                                      if (_valid0 && valid3) {
                                        valid3 = false;
                                        passing0 = [passing0, 12];
                                      } else {
                                        if (_valid0) {
                                          valid3 = true;
                                          passing0 = 12;
                                        }
                                        const _errs26 = errors;
                                        if ("OST_DataDevices" !== data4) {
                                          const err25 = { instancePath: instancePath + "/categories/" + i0, schemaPath: "#/properties/categories/items/oneOf/13/const", keyword: "const", params: { allowedValue: "OST_DataDevices" }, message: "must be equal to constant", schema: "OST_DataDevices", parentSchema: schema13.properties.categories.items.oneOf[13], data: data4 };
                                          if (vErrors === null) {
                                            vErrors = [err25];
                                          } else {
                                            vErrors.push(err25);
                                          }
                                          errors++;
                                        }
                                        var _valid0 = _errs26 === errors;
                                        if (_valid0 && valid3) {
                                          valid3 = false;
                                          passing0 = [passing0, 13];
                                        } else {
                                          if (_valid0) {
                                            valid3 = true;
                                            passing0 = 13;
                                          }
                                          const _errs27 = errors;
                                          if ("OST_SecurityDevices" !== data4) {
                                            const err26 = { instancePath: instancePath + "/categories/" + i0, schemaPath: "#/properties/categories/items/oneOf/14/const", keyword: "const", params: { allowedValue: "OST_SecurityDevices" }, message: "must be equal to constant", schema: "OST_SecurityDevices", parentSchema: schema13.properties.categories.items.oneOf[14], data: data4 };
                                            if (vErrors === null) {
                                              vErrors = [err26];
                                            } else {
                                              vErrors.push(err26);
                                            }
                                            errors++;
                                          }
                                          var _valid0 = _errs27 === errors;
                                          if (_valid0 && valid3) {
                                            valid3 = false;
                                            passing0 = [passing0, 14];
                                          } else {
                                            if (_valid0) {
                                              valid3 = true;
                                              passing0 = 14;
                                            }
                                            const _errs28 = errors;
                                            if ("OST_NurseCallDevices" !== data4) {
                                              const err27 = { instancePath: instancePath + "/categories/" + i0, schemaPath: "#/properties/categories/items/oneOf/15/const", keyword: "const", params: { allowedValue: "OST_NurseCallDevices" }, message: "must be equal to constant", schema: "OST_NurseCallDevices", parentSchema: schema13.properties.categories.items.oneOf[15], data: data4 };
                                              if (vErrors === null) {
                                                vErrors = [err27];
                                              } else {
                                                vErrors.push(err27);
                                              }
                                              errors++;
                                            }
                                            var _valid0 = _errs28 === errors;
                                            if (_valid0 && valid3) {
                                              valid3 = false;
                                              passing0 = [passing0, 15];
                                            } else {
                                              if (_valid0) {
                                                valid3 = true;
                                                passing0 = 15;
                                              }
                                              const _errs29 = errors;
                                              if ("OST_TelephoneDevices" !== data4) {
                                                const err28 = { instancePath: instancePath + "/categories/" + i0, schemaPath: "#/properties/categories/items/oneOf/16/const", keyword: "const", params: { allowedValue: "OST_TelephoneDevices" }, message: "must be equal to constant", schema: "OST_TelephoneDevices", parentSchema: schema13.properties.categories.items.oneOf[16], data: data4 };
                                                if (vErrors === null) {
                                                  vErrors = [err28];
                                                } else {
                                                  vErrors.push(err28);
                                                }
                                                errors++;
                                              }
                                              var _valid0 = _errs29 === errors;
                                              if (_valid0 && valid3) {
                                                valid3 = false;
                                                passing0 = [passing0, 16];
                                              } else {
                                                if (_valid0) {
                                                  valid3 = true;
                                                  passing0 = 16;
                                                }
                                                const _errs30 = errors;
                                                if ("OST_AudioVisualDevices" !== data4) {
                                                  const err29 = { instancePath: instancePath + "/categories/" + i0, schemaPath: "#/properties/categories/items/oneOf/17/const", keyword: "const", params: { allowedValue: "OST_AudioVisualDevices" }, message: "must be equal to constant", schema: "OST_AudioVisualDevices", parentSchema: schema13.properties.categories.items.oneOf[17], data: data4 };
                                                  if (vErrors === null) {
                                                    vErrors = [err29];
                                                  } else {
                                                    vErrors.push(err29);
                                                  }
                                                  errors++;
                                                }
                                                var _valid0 = _errs30 === errors;
                                                if (_valid0 && valid3) {
                                                  valid3 = false;
                                                  passing0 = [passing0, 17];
                                                } else {
                                                  if (_valid0) {
                                                    valid3 = true;
                                                    passing0 = 17;
                                                  }
                                                  const _errs31 = errors;
                                                  if ("OST_SpecialityEquipment" !== data4) {
                                                    const err30 = { instancePath: instancePath + "/categories/" + i0, schemaPath: "#/properties/categories/items/oneOf/18/const", keyword: "const", params: { allowedValue: "OST_SpecialityEquipment" }, message: "must be equal to constant", schema: "OST_SpecialityEquipment", parentSchema: schema13.properties.categories.items.oneOf[18], data: data4 };
                                                    if (vErrors === null) {
                                                      vErrors = [err30];
                                                    } else {
                                                      vErrors.push(err30);
                                                    }
                                                    errors++;
                                                  }
                                                  var _valid0 = _errs31 === errors;
                                                  if (_valid0 && valid3) {
                                                    valid3 = false;
                                                    passing0 = [passing0, 18];
                                                  } else {
                                                    if (_valid0) {
                                                      valid3 = true;
                                                      passing0 = 18;
                                                    }
                                                    const _errs32 = errors;
                                                    if ("OST_MedicalEquipment" !== data4) {
                                                      const err31 = { instancePath: instancePath + "/categories/" + i0, schemaPath: "#/properties/categories/items/oneOf/19/const", keyword: "const", params: { allowedValue: "OST_MedicalEquipment" }, message: "must be equal to constant", schema: "OST_MedicalEquipment", parentSchema: schema13.properties.categories.items.oneOf[19], data: data4 };
                                                      if (vErrors === null) {
                                                        vErrors = [err31];
                                                      } else {
                                                        vErrors.push(err31);
                                                      }
                                                      errors++;
                                                    }
                                                    var _valid0 = _errs32 === errors;
                                                    if (_valid0 && valid3) {
                                                      valid3 = false;
                                                      passing0 = [passing0, 19];
                                                    } else {
                                                      if (_valid0) {
                                                        valid3 = true;
                                                        passing0 = 19;
                                                      }
                                                      const _errs33 = errors;
                                                      if ("OST_FoodServiceEquipment" !== data4) {
                                                        const err32 = { instancePath: instancePath + "/categories/" + i0, schemaPath: "#/properties/categories/items/oneOf/20/const", keyword: "const", params: { allowedValue: "OST_FoodServiceEquipment" }, message: "must be equal to constant", schema: "OST_FoodServiceEquipment", parentSchema: schema13.properties.categories.items.oneOf[20], data: data4 };
                                                        if (vErrors === null) {
                                                          vErrors = [err32];
                                                        } else {
                                                          vErrors.push(err32);
                                                        }
                                                        errors++;
                                                      }
                                                      var _valid0 = _errs33 === errors;
                                                      if (_valid0 && valid3) {
                                                        valid3 = false;
                                                        passing0 = [passing0, 20];
                                                      } else {
                                                        if (_valid0) {
                                                          valid3 = true;
                                                          passing0 = 20;
                                                        }
                                                        const _errs34 = errors;
                                                        if ("OST_Furniture" !== data4) {
                                                          const err33 = { instancePath: instancePath + "/categories/" + i0, schemaPath: "#/properties/categories/items/oneOf/21/const", keyword: "const", params: { allowedValue: "OST_Furniture" }, message: "must be equal to constant", schema: "OST_Furniture", parentSchema: schema13.properties.categories.items.oneOf[21], data: data4 };
                                                          if (vErrors === null) {
                                                            vErrors = [err33];
                                                          } else {
                                                            vErrors.push(err33);
                                                          }
                                                          errors++;
                                                        }
                                                        var _valid0 = _errs34 === errors;
                                                        if (_valid0 && valid3) {
                                                          valid3 = false;
                                                          passing0 = [passing0, 21];
                                                        } else {
                                                          if (_valid0) {
                                                            valid3 = true;
                                                            passing0 = 21;
                                                          }
                                                          const _errs35 = errors;
                                                          if ("OST_FurnitureSystems" !== data4) {
                                                            const err34 = { instancePath: instancePath + "/categories/" + i0, schemaPath: "#/properties/categories/items/oneOf/22/const", keyword: "const", params: { allowedValue: "OST_FurnitureSystems" }, message: "must be equal to constant", schema: "OST_FurnitureSystems", parentSchema: schema13.properties.categories.items.oneOf[22], data: data4 };
                                                            if (vErrors === null) {
                                                              vErrors = [err34];
                                                            } else {
                                                              vErrors.push(err34);
                                                            }
                                                            errors++;
                                                          }
                                                          var _valid0 = _errs35 === errors;
                                                          if (_valid0 && valid3) {
                                                            valid3 = false;
                                                            passing0 = [passing0, 22];
                                                          } else {
                                                            if (_valid0) {
                                                              valid3 = true;
                                                              passing0 = 22;
                                                            }
                                                            const _errs36 = errors;
                                                            if ("OST_Casework" !== data4) {
                                                              const err35 = { instancePath: instancePath + "/categories/" + i0, schemaPath: "#/properties/categories/items/oneOf/23/const", keyword: "const", params: { allowedValue: "OST_Casework" }, message: "must be equal to constant", schema: "OST_Casework", parentSchema: schema13.properties.categories.items.oneOf[23], data: data4 };
                                                              if (vErrors === null) {
                                                                vErrors = [err35];
                                                              } else {
                                                                vErrors.push(err35);
                                                              }
                                                              errors++;
                                                            }
                                                            var _valid0 = _errs36 === errors;
                                                            if (_valid0 && valid3) {
                                                              valid3 = false;
                                                              passing0 = [passing0, 23];
                                                            } else {
                                                              if (_valid0) {
                                                                valid3 = true;
                                                                passing0 = 23;
                                                              }
                                                              const _errs37 = errors;
                                                              if ("OST_Doors" !== data4) {
                                                                const err36 = { instancePath: instancePath + "/categories/" + i0, schemaPath: "#/properties/categories/items/oneOf/24/const", keyword: "const", params: { allowedValue: "OST_Doors" }, message: "must be equal to constant", schema: "OST_Doors", parentSchema: schema13.properties.categories.items.oneOf[24], data: data4 };
                                                                if (vErrors === null) {
                                                                  vErrors = [err36];
                                                                } else {
                                                                  vErrors.push(err36);
                                                                }
                                                                errors++;
                                                              }
                                                              var _valid0 = _errs37 === errors;
                                                              if (_valid0 && valid3) {
                                                                valid3 = false;
                                                                passing0 = [passing0, 24];
                                                              } else {
                                                                if (_valid0) {
                                                                  valid3 = true;
                                                                  passing0 = 24;
                                                                }
                                                                const _errs38 = errors;
                                                                if ("OST_Windows" !== data4) {
                                                                  const err37 = { instancePath: instancePath + "/categories/" + i0, schemaPath: "#/properties/categories/items/oneOf/25/const", keyword: "const", params: { allowedValue: "OST_Windows" }, message: "must be equal to constant", schema: "OST_Windows", parentSchema: schema13.properties.categories.items.oneOf[25], data: data4 };
                                                                  if (vErrors === null) {
                                                                    vErrors = [err37];
                                                                  } else {
                                                                    vErrors.push(err37);
                                                                  }
                                                                  errors++;
                                                                }
                                                                var _valid0 = _errs38 === errors;
                                                                if (_valid0 && valid3) {
                                                                  valid3 = false;
                                                                  passing0 = [passing0, 25];
                                                                } else {
                                                                  if (_valid0) {
                                                                    valid3 = true;
                                                                    passing0 = 25;
                                                                  }
                                                                }
                                                              }
                                                            }
                                                          }
                                                        }
                                                      }
                                                    }
                                                  }
                                                }
                                              }
                                            }
                                          }
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
                if (!valid3) {
                  const err38 = { instancePath: instancePath + "/categories/" + i0, schemaPath: "#/properties/categories/items/oneOf", keyword: "oneOf", params: { passingSchemas: passing0 }, message: "must match exactly one schema in oneOf", schema: schema13.properties.categories.items.oneOf, parentSchema: schema13.properties.categories.items, data: data4 };
                  if (vErrors === null) {
                    vErrors = [err38];
                  } else {
                    vErrors.push(err38);
                  }
                  errors++;
                } else {
                  errors = _errs12;
                  if (vErrors !== null) {
                    if (_errs12) {
                      vErrors.length = _errs12;
                    } else {
                      vErrors = null;
                    }
                  }
                }
              }
              let i1 = data3.length;
              let j0;
              if (i1 > 1) {
                const indices0 = {};
                for (; i1--; ) {
                  let item0 = data3[i1];
                  if (typeof item0 !== "string") {
                    continue;
                  }
                  if (typeof indices0[item0] == "number") {
                    j0 = indices0[item0];
                    const err39 = { instancePath: instancePath + "/categories", schemaPath: "#/properties/categories/uniqueItems", keyword: "uniqueItems", params: { i: i1, j: j0 }, message: "must NOT have duplicate items (items ## " + j0 + " and " + i1 + " are identical)", schema: true, parentSchema: schema13.properties.categories, data: data3 };
                    if (vErrors === null) {
                      vErrors = [err39];
                    } else {
                      vErrors.push(err39);
                    }
                    errors++;
                    break;
                  }
                  indices0[item0] = i1;
                }
              }
            } else {
              const err40 = { instancePath: instancePath + "/categories", schemaPath: "#/properties/categories/type", keyword: "type", params: { type: "array" }, message: "must be array", schema: schema13.properties.categories.type, parentSchema: schema13.properties.categories, data: data3 };
              if (vErrors === null) {
                vErrors = [err40];
              } else {
                vErrors.push(err40);
              }
              errors++;
            }
          }
          if (data.notes !== void 0) {
            let data5 = data.notes;
            if (typeof data5 === "string") {
              if (func2(data5) > 1e4) {
                const err41 = { instancePath: instancePath + "/notes", schemaPath: "#/properties/notes/maxLength", keyword: "maxLength", params: { limit: 1e4 }, message: "must NOT have more than 10000 characters", schema: 1e4, parentSchema: schema13.properties.notes, data: data5 };
                if (vErrors === null) {
                  vErrors = [err41];
                } else {
                  vErrors.push(err41);
                }
                errors++;
              }
            } else {
              const err42 = { instancePath: instancePath + "/notes", schemaPath: "#/properties/notes/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: schema13.properties.notes.type, parentSchema: schema13.properties.notes, data: data5 };
              if (vErrors === null) {
                vErrors = [err42];
              } else {
                vErrors.push(err42);
              }
              errors++;
            }
          }
        } else {
          const err43 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object", schema: schema13.type, parentSchema: schema13, data };
          if (vErrors === null) {
            vErrors = [err43];
          } else {
            vErrors.push(err43);
          }
          errors++;
        }
        validate12.errors = vErrors;
        return errors === 0;
      }
      exports["3f74340"] = validate13;
      var schema14 = { "const": "OST_MechanicalEquipment", "title": "\u6A5F\u68B0\u8A2D\u5099", "$id": "3f74340" };
      function validate13(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
        ;
        let vErrors = null;
        let errors = 0;
        if ("OST_MechanicalEquipment" !== data) {
          const err0 = { instancePath, schemaPath: "#/const", keyword: "const", params: { allowedValue: "OST_MechanicalEquipment" }, message: "must be equal to constant", schema: "OST_MechanicalEquipment", parentSchema: schema14, data };
          if (vErrors === null) {
            vErrors = [err0];
          } else {
            vErrors.push(err0);
          }
          errors++;
        }
        validate13.errors = vErrors;
        return errors === 0;
      }
      exports["124985bd"] = validate14;
      var schema15 = { "const": "OST_DuctAccessory", "title": "\u98A8\u7BA1\u9644\u4EF6", "$id": "124985bd" };
      function validate14(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
        ;
        let vErrors = null;
        let errors = 0;
        if ("OST_DuctAccessory" !== data) {
          const err0 = { instancePath, schemaPath: "#/const", keyword: "const", params: { allowedValue: "OST_DuctAccessory" }, message: "must be equal to constant", schema: "OST_DuctAccessory", parentSchema: schema15, data };
          if (vErrors === null) {
            vErrors = [err0];
          } else {
            vErrors.push(err0);
          }
          errors++;
        }
        validate14.errors = vErrors;
        return errors === 0;
      }
      exports["-a6580a0"] = validate15;
      var schema16 = { "const": "OST_PlumbingFixtures", "title": "\u885B\u5DE5\u8A2D\u5099", "$id": "-a6580a0" };
      function validate15(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
        ;
        let vErrors = null;
        let errors = 0;
        if ("OST_PlumbingFixtures" !== data) {
          const err0 = { instancePath, schemaPath: "#/const", keyword: "const", params: { allowedValue: "OST_PlumbingFixtures" }, message: "must be equal to constant", schema: "OST_PlumbingFixtures", parentSchema: schema16, data };
          if (vErrors === null) {
            vErrors = [err0];
          } else {
            vErrors.push(err0);
          }
          errors++;
        }
        validate15.errors = vErrors;
        return errors === 0;
      }
      exports["62986a02"] = validate16;
      var schema17 = { "const": "OST_PlumbingEquipment", "title": "\u7D66\u6392\u6C34\u8A2D\u5099", "$id": "62986a02" };
      function validate16(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
        ;
        let vErrors = null;
        let errors = 0;
        if ("OST_PlumbingEquipment" !== data) {
          const err0 = { instancePath, schemaPath: "#/const", keyword: "const", params: { allowedValue: "OST_PlumbingEquipment" }, message: "must be equal to constant", schema: "OST_PlumbingEquipment", parentSchema: schema17, data };
          if (vErrors === null) {
            vErrors = [err0];
          } else {
            vErrors.push(err0);
          }
          errors++;
        }
        validate16.errors = vErrors;
        return errors === 0;
      }
      exports["-32e08ed5"] = validate17;
      var schema18 = { "const": "OST_PipeAccessory", "title": "\u7BA1\u9644\u4EF6", "$id": "-32e08ed5" };
      function validate17(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
        ;
        let vErrors = null;
        let errors = 0;
        if ("OST_PipeAccessory" !== data) {
          const err0 = { instancePath, schemaPath: "#/const", keyword: "const", params: { allowedValue: "OST_PipeAccessory" }, message: "must be equal to constant", schema: "OST_PipeAccessory", parentSchema: schema18, data };
          if (vErrors === null) {
            vErrors = [err0];
          } else {
            vErrors.push(err0);
          }
          errors++;
        }
        validate17.errors = vErrors;
        return errors === 0;
      }
      exports["-60100bbd"] = validate18;
      var schema19 = { "const": "OST_Sprinklers", "title": "\u7051\u6C34\u982D", "$id": "-60100bbd" };
      function validate18(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
        ;
        let vErrors = null;
        let errors = 0;
        if ("OST_Sprinklers" !== data) {
          const err0 = { instancePath, schemaPath: "#/const", keyword: "const", params: { allowedValue: "OST_Sprinklers" }, message: "must be equal to constant", schema: "OST_Sprinklers", parentSchema: schema19, data };
          if (vErrors === null) {
            vErrors = [err0];
          } else {
            vErrors.push(err0);
          }
          errors++;
        }
        validate18.errors = vErrors;
        return errors === 0;
      }
      exports["-65faa36e"] = validate19;
      var schema20 = { "const": "OST_FireAlarmDevices", "title": "\u706B\u8B66\u88DD\u7F6E", "$id": "-65faa36e" };
      function validate19(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
        ;
        let vErrors = null;
        let errors = 0;
        if ("OST_FireAlarmDevices" !== data) {
          const err0 = { instancePath, schemaPath: "#/const", keyword: "const", params: { allowedValue: "OST_FireAlarmDevices" }, message: "must be equal to constant", schema: "OST_FireAlarmDevices", parentSchema: schema20, data };
          if (vErrors === null) {
            vErrors = [err0];
          } else {
            vErrors.push(err0);
          }
          errors++;
        }
        validate19.errors = vErrors;
        return errors === 0;
      }
      exports["-9ca1fd0"] = validate20;
      var schema21 = { "const": "OST_ElectricalEquipment", "title": "\u96FB\u6C23\u8A2D\u5099", "$id": "-9ca1fd0" };
      function validate20(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
        ;
        let vErrors = null;
        let errors = 0;
        if ("OST_ElectricalEquipment" !== data) {
          const err0 = { instancePath, schemaPath: "#/const", keyword: "const", params: { allowedValue: "OST_ElectricalEquipment" }, message: "must be equal to constant", schema: "OST_ElectricalEquipment", parentSchema: schema21, data };
          if (vErrors === null) {
            vErrors = [err0];
          } else {
            vErrors.push(err0);
          }
          errors++;
        }
        validate20.errors = vErrors;
        return errors === 0;
      }
      exports["-1b73b391"] = validate21;
      var schema22 = { "const": "OST_ElectricalFixtures", "title": "\u96FB\u6C23\u88DD\u7F6E", "$id": "-1b73b391" };
      function validate21(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
        ;
        let vErrors = null;
        let errors = 0;
        if ("OST_ElectricalFixtures" !== data) {
          const err0 = { instancePath, schemaPath: "#/const", keyword: "const", params: { allowedValue: "OST_ElectricalFixtures" }, message: "must be equal to constant", schema: "OST_ElectricalFixtures", parentSchema: schema22, data };
          if (vErrors === null) {
            vErrors = [err0];
          } else {
            vErrors.push(err0);
          }
          errors++;
        }
        validate21.errors = vErrors;
        return errors === 0;
      }
      exports["6d303d45"] = validate22;
      var schema23 = { "const": "OST_LightingFixtures", "title": "\u7167\u660E\u8A2D\u5099", "$id": "6d303d45" };
      function validate22(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
        ;
        let vErrors = null;
        let errors = 0;
        if ("OST_LightingFixtures" !== data) {
          const err0 = { instancePath, schemaPath: "#/const", keyword: "const", params: { allowedValue: "OST_LightingFixtures" }, message: "must be equal to constant", schema: "OST_LightingFixtures", parentSchema: schema23, data };
          if (vErrors === null) {
            vErrors = [err0];
          } else {
            vErrors.push(err0);
          }
          errors++;
        }
        validate22.errors = vErrors;
        return errors === 0;
      }
      exports["-6f8d0f57"] = validate23;
      var schema24 = { "const": "OST_LightingDevices", "title": "\u7167\u660E\u88DD\u7F6E", "$id": "-6f8d0f57" };
      function validate23(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
        ;
        let vErrors = null;
        let errors = 0;
        if ("OST_LightingDevices" !== data) {
          const err0 = { instancePath, schemaPath: "#/const", keyword: "const", params: { allowedValue: "OST_LightingDevices" }, message: "must be equal to constant", schema: "OST_LightingDevices", parentSchema: schema24, data };
          if (vErrors === null) {
            vErrors = [err0];
          } else {
            vErrors.push(err0);
          }
          errors++;
        }
        validate23.errors = vErrors;
        return errors === 0;
      }
      exports["-65ed517e"] = validate24;
      var schema25 = { "const": "OST_CommunicationDevices", "title": "\u901A\u8A0A\u88DD\u7F6E", "$id": "-65ed517e" };
      function validate24(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
        ;
        let vErrors = null;
        let errors = 0;
        if ("OST_CommunicationDevices" !== data) {
          const err0 = { instancePath, schemaPath: "#/const", keyword: "const", params: { allowedValue: "OST_CommunicationDevices" }, message: "must be equal to constant", schema: "OST_CommunicationDevices", parentSchema: schema25, data };
          if (vErrors === null) {
            vErrors = [err0];
          } else {
            vErrors.push(err0);
          }
          errors++;
        }
        validate24.errors = vErrors;
        return errors === 0;
      }
      exports["-6b14838e"] = validate25;
      var schema26 = { "const": "OST_DataDevices", "title": "\u8CC7\u6599\u88DD\u7F6E", "$id": "-6b14838e" };
      function validate25(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
        ;
        let vErrors = null;
        let errors = 0;
        if ("OST_DataDevices" !== data) {
          const err0 = { instancePath, schemaPath: "#/const", keyword: "const", params: { allowedValue: "OST_DataDevices" }, message: "must be equal to constant", schema: "OST_DataDevices", parentSchema: schema26, data };
          if (vErrors === null) {
            vErrors = [err0];
          } else {
            vErrors.push(err0);
          }
          errors++;
        }
        validate25.errors = vErrors;
        return errors === 0;
      }
      exports["22f63281"] = validate26;
      var schema27 = { "const": "OST_SecurityDevices", "title": "\u4FDD\u5168\u88DD\u7F6E", "$id": "22f63281" };
      function validate26(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
        ;
        let vErrors = null;
        let errors = 0;
        if ("OST_SecurityDevices" !== data) {
          const err0 = { instancePath, schemaPath: "#/const", keyword: "const", params: { allowedValue: "OST_SecurityDevices" }, message: "must be equal to constant", schema: "OST_SecurityDevices", parentSchema: schema27, data };
          if (vErrors === null) {
            vErrors = [err0];
          } else {
            vErrors.push(err0);
          }
          errors++;
        }
        validate26.errors = vErrors;
        return errors === 0;
      }
      exports["3dda1ff5"] = validate27;
      var schema28 = { "const": "OST_NurseCallDevices", "title": "\u8B77\u7406\u547C\u53EB\u88DD\u7F6E", "$id": "3dda1ff5" };
      function validate27(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
        ;
        let vErrors = null;
        let errors = 0;
        if ("OST_NurseCallDevices" !== data) {
          const err0 = { instancePath, schemaPath: "#/const", keyword: "const", params: { allowedValue: "OST_NurseCallDevices" }, message: "must be equal to constant", schema: "OST_NurseCallDevices", parentSchema: schema28, data };
          if (vErrors === null) {
            vErrors = [err0];
          } else {
            vErrors.push(err0);
          }
          errors++;
        }
        validate27.errors = vErrors;
        return errors === 0;
      }
      exports["69eef4d6"] = validate28;
      var schema29 = { "const": "OST_TelephoneDevices", "title": "\u96FB\u8A71\u88DD\u7F6E", "$id": "69eef4d6" };
      function validate28(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
        ;
        let vErrors = null;
        let errors = 0;
        if ("OST_TelephoneDevices" !== data) {
          const err0 = { instancePath, schemaPath: "#/const", keyword: "const", params: { allowedValue: "OST_TelephoneDevices" }, message: "must be equal to constant", schema: "OST_TelephoneDevices", parentSchema: schema29, data };
          if (vErrors === null) {
            vErrors = [err0];
          } else {
            vErrors.push(err0);
          }
          errors++;
        }
        validate28.errors = vErrors;
        return errors === 0;
      }
      exports["-dccfdcc"] = validate29;
      var schema30 = { "const": "OST_AudioVisualDevices", "title": "\u8996\u807D\u8A2D\u5099", "$id": "-dccfdcc" };
      function validate29(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
        ;
        let vErrors = null;
        let errors = 0;
        if ("OST_AudioVisualDevices" !== data) {
          const err0 = { instancePath, schemaPath: "#/const", keyword: "const", params: { allowedValue: "OST_AudioVisualDevices" }, message: "must be equal to constant", schema: "OST_AudioVisualDevices", parentSchema: schema30, data };
          if (vErrors === null) {
            vErrors = [err0];
          } else {
            vErrors.push(err0);
          }
          errors++;
        }
        validate29.errors = vErrors;
        return errors === 0;
      }
      exports["596906d5"] = validate30;
      var schema31 = { "const": "OST_SpecialityEquipment", "title": "\u5C08\u7528\u8A2D\u5099", "$id": "596906d5" };
      function validate30(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
        ;
        let vErrors = null;
        let errors = 0;
        if ("OST_SpecialityEquipment" !== data) {
          const err0 = { instancePath, schemaPath: "#/const", keyword: "const", params: { allowedValue: "OST_SpecialityEquipment" }, message: "must be equal to constant", schema: "OST_SpecialityEquipment", parentSchema: schema31, data };
          if (vErrors === null) {
            vErrors = [err0];
          } else {
            vErrors.push(err0);
          }
          errors++;
        }
        validate30.errors = vErrors;
        return errors === 0;
      }
      exports["-de986b2"] = validate31;
      var schema32 = { "const": "OST_MedicalEquipment", "title": "\u91AB\u7642\u8A2D\u5099", "$id": "-de986b2" };
      function validate31(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
        ;
        let vErrors = null;
        let errors = 0;
        if ("OST_MedicalEquipment" !== data) {
          const err0 = { instancePath, schemaPath: "#/const", keyword: "const", params: { allowedValue: "OST_MedicalEquipment" }, message: "must be equal to constant", schema: "OST_MedicalEquipment", parentSchema: schema32, data };
          if (vErrors === null) {
            vErrors = [err0];
          } else {
            vErrors.push(err0);
          }
          errors++;
        }
        validate31.errors = vErrors;
        return errors === 0;
      }
      exports["-38cd6761"] = validate32;
      var schema33 = { "const": "OST_FoodServiceEquipment", "title": "\u9910\u98F2\u8A2D\u5099", "$id": "-38cd6761" };
      function validate32(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
        ;
        let vErrors = null;
        let errors = 0;
        if ("OST_FoodServiceEquipment" !== data) {
          const err0 = { instancePath, schemaPath: "#/const", keyword: "const", params: { allowedValue: "OST_FoodServiceEquipment" }, message: "must be equal to constant", schema: "OST_FoodServiceEquipment", parentSchema: schema33, data };
          if (vErrors === null) {
            vErrors = [err0];
          } else {
            vErrors.push(err0);
          }
          errors++;
        }
        validate32.errors = vErrors;
        return errors === 0;
      }
      exports["-71dadd13"] = validate33;
      var schema34 = { "const": "OST_FurnitureSystems", "title": "\u5BB6\u5177\u7CFB\u7D71", "$id": "-71dadd13" };
      function validate33(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
        ;
        let vErrors = null;
        let errors = 0;
        if ("OST_FurnitureSystems" !== data) {
          const err0 = { instancePath, schemaPath: "#/const", keyword: "const", params: { allowedValue: "OST_FurnitureSystems" }, message: "must be equal to constant", schema: "OST_FurnitureSystems", parentSchema: schema34, data };
          if (vErrors === null) {
            vErrors = [err0];
          } else {
            vErrors.push(err0);
          }
          errors++;
        }
        validate33.errors = vErrors;
        return errors === 0;
      }
      exports["-3403cefb"] = validate34;
      var schema35 = { "const": "OST_Casework", "title": "\u6AE5\u6AC3", "$id": "-3403cefb" };
      function validate34(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
        ;
        let vErrors = null;
        let errors = 0;
        if ("OST_Casework" !== data) {
          const err0 = { instancePath, schemaPath: "#/const", keyword: "const", params: { allowedValue: "OST_Casework" }, message: "must be equal to constant", schema: "OST_Casework", parentSchema: schema35, data };
          if (vErrors === null) {
            vErrors = [err0];
          } else {
            vErrors.push(err0);
          }
          errors++;
        }
        validate34.errors = vErrors;
        return errors === 0;
      }
      exports["-72da6f27"] = validate35;
      var schema36 = { "const": "OST_Doors", "title": "\u9580", "$id": "-72da6f27" };
      function validate35(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
        ;
        let vErrors = null;
        let errors = 0;
        if ("OST_Doors" !== data) {
          const err0 = { instancePath, schemaPath: "#/const", keyword: "const", params: { allowedValue: "OST_Doors" }, message: "must be equal to constant", schema: "OST_Doors", parentSchema: schema36, data };
          if (vErrors === null) {
            vErrors = [err0];
          } else {
            vErrors.push(err0);
          }
          errors++;
        }
        validate35.errors = vErrors;
        return errors === 0;
      }
      exports["-5362dd12"] = validate36;
      var schema37 = { "const": "OST_Windows", "title": "\u7A97", "$id": "-5362dd12" };
      function validate36(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
        ;
        let vErrors = null;
        let errors = 0;
        if ("OST_Windows" !== data) {
          const err0 = { instancePath, schemaPath: "#/const", keyword: "const", params: { allowedValue: "OST_Windows" }, message: "must be equal to constant", schema: "OST_Windows", parentSchema: schema37, data };
          if (vErrors === null) {
            vErrors = [err0];
          } else {
            vErrors.push(err0);
          }
          errors++;
        }
        validate36.errors = vErrors;
        return errors === 0;
      }
    }
  });
  return require_validator_1();
})();

"use strict";
var compiled2 = (() => {
  var __getOwnPropNames = Object.getOwnPropertyNames;
  var __commonJS = (cb, mod) => function __require() {
    return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
  };

  // src/web/node_modules/ajv/dist/runtime/ucs2length.js
  var require_ucs2length = __commonJS({
    "src/web/node_modules/ajv/dist/runtime/ucs2length.js"(exports) {
      "use strict";
      Object.defineProperty(exports, "__esModule", { value: true });
      function ucs2length(str) {
        const len = str.length;
        let length = 0;
        let pos = 0;
        let value;
        while (pos < len) {
          length++;
          value = str.charCodeAt(pos++);
          if (value >= 55296 && value <= 56319 && pos < len) {
            value = str.charCodeAt(pos);
            if ((value & 64512) === 56320)
              pos++;
          }
        }
        return length;
      }
      exports.default = ucs2length;
      ucs2length.code = 'require("ajv/dist/runtime/ucs2length").default';
    }
  });

  // src/web/validator-2.cjs
  var require_validator_2 = __commonJS({
    "src/web/validator-2.cjs"(exports) {
      exports["3250ea27"] = validate10;
      var schema11 = { "$schema": "http://json-schema.org/draft-07/schema#", "type": "object", "additionalProperties": false, "properties": { "toolCallLimit": { "type": "integer", "title": "Tool call limit per execution", "default": 80, "minimum": 1, "maximum": 80, "description": "Set 1\u201380 calls; default 80. Each execution or continuation has its own allowance. The final report is excluded. Limits below 50 may require continuation. Estimates vary with model size and data completeness; they are neither a completion guarantee nor a timeout." }, "formFile": { "type": "string", "title": "Input form (Excel)", "default": "", "maxLength": 4096, "description": "Provides project, contact and equipment type data not available in the model. For a new form, confirm the delivery categories and generate a form from the current Revit model to list its types and quantities. Complete and save the form, then select it to create the delivery. Regenerating with a form selected saves an updated copy and preserves existing entries." }, "outputFolder": { "type": "string", "title": "Delivery folder", "default": "", "maxLength": 4096, "description": "Sets the output location; defaults to the Desktop. A separate subfolder contains the COBie workbook, delivery notes and final input form, plus the model copy when that option is selected. Use the final input form for subsequent checks and deliveries." }, "categories": { "type": "array", "title": "Categories to deliver", "description": "Defines the delivery categories for form generation and model updates. All categories are selected by default; at least one is required. Set whether each type is included in the input form.", "default": ["OST_MechanicalEquipment", "OST_DuctTerminal", "OST_DuctAccessory", "OST_PlumbingFixtures", "OST_PlumbingEquipment", "OST_PipeAccessory", "OST_Sprinklers", "OST_FireAlarmDevices", "OST_ElectricalEquipment", "OST_ElectricalFixtures", "OST_LightingFixtures", "OST_LightingDevices", "OST_CommunicationDevices", "OST_DataDevices", "OST_SecurityDevices", "OST_NurseCallDevices", "OST_TelephoneDevices", "OST_AudioVisualDevices", "OST_SpecialityEquipment", "OST_MedicalEquipment", "OST_FoodServiceEquipment", "OST_Furniture", "OST_FurnitureSystems", "OST_Casework", "OST_Doors", "OST_Windows"], "uniqueItems": true, "minItems": 1, "items": { "type": "string", "oneOf": [{ "const": "OST_MechanicalEquipment", "title": "Mechanical equipment" }, { "const": "OST_DuctTerminal", "title": "Air terminals" }, { "const": "OST_DuctAccessory", "title": "Duct accessories" }, { "const": "OST_PlumbingFixtures", "title": "Plumbing fixtures" }, { "const": "OST_PlumbingEquipment", "title": "Plumbing equipment" }, { "const": "OST_PipeAccessory", "title": "Pipe accessories" }, { "const": "OST_Sprinklers", "title": "Sprinklers" }, { "const": "OST_FireAlarmDevices", "title": "Fire alarm devices" }, { "const": "OST_ElectricalEquipment", "title": "Electrical equipment" }, { "const": "OST_ElectricalFixtures", "title": "Electrical fixtures" }, { "const": "OST_LightingFixtures", "title": "Lighting fixtures" }, { "const": "OST_LightingDevices", "title": "Lighting devices" }, { "const": "OST_CommunicationDevices", "title": "Communication devices" }, { "const": "OST_DataDevices", "title": "Data devices" }, { "const": "OST_SecurityDevices", "title": "Security devices" }, { "const": "OST_NurseCallDevices", "title": "Nurse call devices" }, { "const": "OST_TelephoneDevices", "title": "Telephone devices" }, { "const": "OST_AudioVisualDevices", "title": "Audio visual devices" }, { "const": "OST_SpecialityEquipment", "title": "Specialty equipment" }, { "const": "OST_MedicalEquipment", "title": "Medical equipment" }, { "const": "OST_FoodServiceEquipment", "title": "Food service equipment" }, { "const": "OST_Furniture", "title": "Furniture" }, { "const": "OST_FurnitureSystems", "title": "Furniture systems" }, { "const": "OST_Casework", "title": "Casework" }, { "const": "OST_Doors", "title": "Doors" }, { "const": "OST_Windows", "title": "Windows" }] } }, "modelHandling": { "type": "string", "title": "Model handling", "default": "copy", "description": "Writes the delivery scope and COBie data into the model. Saving a copy preserves the original, saves the copy in the delivery folder and opens it in Revit. Changing the open model updates and saves the current document.", "oneOf": [{ "const": "copy", "title": "Save a copy, then change the copy" }, { "const": "in-place", "title": "Change the open model" }] }, "existingValues": { "type": "string", "title": "Existing data handling", "default": "overwrite", "description": "Controls how differences between model COBie parameters and the input form are handled. Overwrite and record uses form values and records the originals for restoration. Keeping model values preserves the originals and uses them in the COBie workbook. Both options report data differences.", "oneOf": [{ "const": "overwrite", "title": "Overwrite and record" }, { "const": "keep", "title": "Keep the model's values" }] }, "coordinates": { "type": "string", "title": "Coordinates", "default": "shared", "description": "The origin of the Coordinate sheet's positions. Shared coordinates match the survey point, other disciplines' models and GIS; without shared coordinates set up they are the internal origin. The project base point gives smaller numbers relative to the project. Lengths are in the form's length unit.", "oneOf": [{ "const": "shared", "title": "Shared coordinates" }, { "const": "project-base", "title": "Project base point" }, { "const": "internal", "title": "Revit internal origin" }] }, "notes": { "type": "string", "title": "Requirements and notes", "default": "", "maxLength": 1e4, "description": "Optional delivery scope, data requirements or special handling instructions. Applies to the project currently open in Revit." } }, "$id": "3250ea27" };
      var func2 = require_ucs2length().default;
      function validate10(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
        ;
        let vErrors = null;
        let errors = 0;
        if (data && typeof data == "object" && !Array.isArray(data)) {
          for (const key0 in data) {
            if (!(key0 === "toolCallLimit" || key0 === "formFile" || key0 === "outputFolder" || key0 === "categories" || key0 === "modelHandling" || key0 === "existingValues" || key0 === "coordinates" || key0 === "notes")) {
              const err0 = { instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties", schema: false, parentSchema: schema11, data };
              if (vErrors === null) {
                vErrors = [err0];
              } else {
                vErrors.push(err0);
              }
              errors++;
            }
          }
          if (data.toolCallLimit !== void 0) {
            let data0 = data.toolCallLimit;
            if (!(typeof data0 == "number" && (!(data0 % 1) && !isNaN(data0)) && isFinite(data0))) {
              const err1 = { instancePath: instancePath + "/toolCallLimit", schemaPath: "#/properties/toolCallLimit/type", keyword: "type", params: { type: "integer" }, message: "must be integer", schema: schema11.properties.toolCallLimit.type, parentSchema: schema11.properties.toolCallLimit, data: data0 };
              if (vErrors === null) {
                vErrors = [err1];
              } else {
                vErrors.push(err1);
              }
              errors++;
            }
            if (typeof data0 == "number" && isFinite(data0)) {
              if (data0 > 80 || isNaN(data0)) {
                const err2 = { instancePath: instancePath + "/toolCallLimit", schemaPath: "#/properties/toolCallLimit/maximum", keyword: "maximum", params: { comparison: "<=", limit: 80 }, message: "must be <= 80", schema: 80, parentSchema: schema11.properties.toolCallLimit, data: data0 };
                if (vErrors === null) {
                  vErrors = [err2];
                } else {
                  vErrors.push(err2);
                }
                errors++;
              }
              if (data0 < 1 || isNaN(data0)) {
                const err3 = { instancePath: instancePath + "/toolCallLimit", schemaPath: "#/properties/toolCallLimit/minimum", keyword: "minimum", params: { comparison: ">=", limit: 1 }, message: "must be >= 1", schema: 1, parentSchema: schema11.properties.toolCallLimit, data: data0 };
                if (vErrors === null) {
                  vErrors = [err3];
                } else {
                  vErrors.push(err3);
                }
                errors++;
              }
            }
          }
          if (data.formFile !== void 0) {
            let data1 = data.formFile;
            if (typeof data1 === "string") {
              if (func2(data1) > 4096) {
                const err4 = { instancePath: instancePath + "/formFile", schemaPath: "#/properties/formFile/maxLength", keyword: "maxLength", params: { limit: 4096 }, message: "must NOT have more than 4096 characters", schema: 4096, parentSchema: schema11.properties.formFile, data: data1 };
                if (vErrors === null) {
                  vErrors = [err4];
                } else {
                  vErrors.push(err4);
                }
                errors++;
              }
            } else {
              const err5 = { instancePath: instancePath + "/formFile", schemaPath: "#/properties/formFile/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: schema11.properties.formFile.type, parentSchema: schema11.properties.formFile, data: data1 };
              if (vErrors === null) {
                vErrors = [err5];
              } else {
                vErrors.push(err5);
              }
              errors++;
            }
          }
          if (data.outputFolder !== void 0) {
            let data2 = data.outputFolder;
            if (typeof data2 === "string") {
              if (func2(data2) > 4096) {
                const err6 = { instancePath: instancePath + "/outputFolder", schemaPath: "#/properties/outputFolder/maxLength", keyword: "maxLength", params: { limit: 4096 }, message: "must NOT have more than 4096 characters", schema: 4096, parentSchema: schema11.properties.outputFolder, data: data2 };
                if (vErrors === null) {
                  vErrors = [err6];
                } else {
                  vErrors.push(err6);
                }
                errors++;
              }
            } else {
              const err7 = { instancePath: instancePath + "/outputFolder", schemaPath: "#/properties/outputFolder/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: schema11.properties.outputFolder.type, parentSchema: schema11.properties.outputFolder, data: data2 };
              if (vErrors === null) {
                vErrors = [err7];
              } else {
                vErrors.push(err7);
              }
              errors++;
            }
          }
          if (data.categories !== void 0) {
            let data3 = data.categories;
            if (Array.isArray(data3)) {
              if (data3.length < 1) {
                const err8 = { instancePath: instancePath + "/categories", schemaPath: "#/properties/categories/minItems", keyword: "minItems", params: { limit: 1 }, message: "must NOT have fewer than 1 items", schema: 1, parentSchema: schema11.properties.categories, data: data3 };
                if (vErrors === null) {
                  vErrors = [err8];
                } else {
                  vErrors.push(err8);
                }
                errors++;
              }
              const len0 = data3.length;
              for (let i0 = 0; i0 < len0; i0++) {
                let data4 = data3[i0];
                if (typeof data4 !== "string") {
                  const err9 = { instancePath: instancePath + "/categories/" + i0, schemaPath: "#/properties/categories/items/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: schema11.properties.categories.items.type, parentSchema: schema11.properties.categories.items, data: data4 };
                  if (vErrors === null) {
                    vErrors = [err9];
                  } else {
                    vErrors.push(err9);
                  }
                  errors++;
                }
                const _errs12 = errors;
                let valid3 = false;
                let passing0 = null;
                const _errs13 = errors;
                if ("OST_MechanicalEquipment" !== data4) {
                  const err10 = { instancePath: instancePath + "/categories/" + i0, schemaPath: "#/properties/categories/items/oneOf/0/const", keyword: "const", params: { allowedValue: "OST_MechanicalEquipment" }, message: "must be equal to constant", schema: "OST_MechanicalEquipment", parentSchema: schema11.properties.categories.items.oneOf[0], data: data4 };
                  if (vErrors === null) {
                    vErrors = [err10];
                  } else {
                    vErrors.push(err10);
                  }
                  errors++;
                }
                var _valid0 = _errs13 === errors;
                if (_valid0) {
                  valid3 = true;
                  passing0 = 0;
                }
                const _errs14 = errors;
                if ("OST_DuctTerminal" !== data4) {
                  const err11 = { instancePath: instancePath + "/categories/" + i0, schemaPath: "#/properties/categories/items/oneOf/1/const", keyword: "const", params: { allowedValue: "OST_DuctTerminal" }, message: "must be equal to constant", schema: "OST_DuctTerminal", parentSchema: schema11.properties.categories.items.oneOf[1], data: data4 };
                  if (vErrors === null) {
                    vErrors = [err11];
                  } else {
                    vErrors.push(err11);
                  }
                  errors++;
                }
                var _valid0 = _errs14 === errors;
                if (_valid0 && valid3) {
                  valid3 = false;
                  passing0 = [passing0, 1];
                } else {
                  if (_valid0) {
                    valid3 = true;
                    passing0 = 1;
                  }
                  const _errs15 = errors;
                  if ("OST_DuctAccessory" !== data4) {
                    const err12 = { instancePath: instancePath + "/categories/" + i0, schemaPath: "#/properties/categories/items/oneOf/2/const", keyword: "const", params: { allowedValue: "OST_DuctAccessory" }, message: "must be equal to constant", schema: "OST_DuctAccessory", parentSchema: schema11.properties.categories.items.oneOf[2], data: data4 };
                    if (vErrors === null) {
                      vErrors = [err12];
                    } else {
                      vErrors.push(err12);
                    }
                    errors++;
                  }
                  var _valid0 = _errs15 === errors;
                  if (_valid0 && valid3) {
                    valid3 = false;
                    passing0 = [passing0, 2];
                  } else {
                    if (_valid0) {
                      valid3 = true;
                      passing0 = 2;
                    }
                    const _errs16 = errors;
                    if ("OST_PlumbingFixtures" !== data4) {
                      const err13 = { instancePath: instancePath + "/categories/" + i0, schemaPath: "#/properties/categories/items/oneOf/3/const", keyword: "const", params: { allowedValue: "OST_PlumbingFixtures" }, message: "must be equal to constant", schema: "OST_PlumbingFixtures", parentSchema: schema11.properties.categories.items.oneOf[3], data: data4 };
                      if (vErrors === null) {
                        vErrors = [err13];
                      } else {
                        vErrors.push(err13);
                      }
                      errors++;
                    }
                    var _valid0 = _errs16 === errors;
                    if (_valid0 && valid3) {
                      valid3 = false;
                      passing0 = [passing0, 3];
                    } else {
                      if (_valid0) {
                        valid3 = true;
                        passing0 = 3;
                      }
                      const _errs17 = errors;
                      if ("OST_PlumbingEquipment" !== data4) {
                        const err14 = { instancePath: instancePath + "/categories/" + i0, schemaPath: "#/properties/categories/items/oneOf/4/const", keyword: "const", params: { allowedValue: "OST_PlumbingEquipment" }, message: "must be equal to constant", schema: "OST_PlumbingEquipment", parentSchema: schema11.properties.categories.items.oneOf[4], data: data4 };
                        if (vErrors === null) {
                          vErrors = [err14];
                        } else {
                          vErrors.push(err14);
                        }
                        errors++;
                      }
                      var _valid0 = _errs17 === errors;
                      if (_valid0 && valid3) {
                        valid3 = false;
                        passing0 = [passing0, 4];
                      } else {
                        if (_valid0) {
                          valid3 = true;
                          passing0 = 4;
                        }
                        const _errs18 = errors;
                        if ("OST_PipeAccessory" !== data4) {
                          const err15 = { instancePath: instancePath + "/categories/" + i0, schemaPath: "#/properties/categories/items/oneOf/5/const", keyword: "const", params: { allowedValue: "OST_PipeAccessory" }, message: "must be equal to constant", schema: "OST_PipeAccessory", parentSchema: schema11.properties.categories.items.oneOf[5], data: data4 };
                          if (vErrors === null) {
                            vErrors = [err15];
                          } else {
                            vErrors.push(err15);
                          }
                          errors++;
                        }
                        var _valid0 = _errs18 === errors;
                        if (_valid0 && valid3) {
                          valid3 = false;
                          passing0 = [passing0, 5];
                        } else {
                          if (_valid0) {
                            valid3 = true;
                            passing0 = 5;
                          }
                          const _errs19 = errors;
                          if ("OST_Sprinklers" !== data4) {
                            const err16 = { instancePath: instancePath + "/categories/" + i0, schemaPath: "#/properties/categories/items/oneOf/6/const", keyword: "const", params: { allowedValue: "OST_Sprinklers" }, message: "must be equal to constant", schema: "OST_Sprinklers", parentSchema: schema11.properties.categories.items.oneOf[6], data: data4 };
                            if (vErrors === null) {
                              vErrors = [err16];
                            } else {
                              vErrors.push(err16);
                            }
                            errors++;
                          }
                          var _valid0 = _errs19 === errors;
                          if (_valid0 && valid3) {
                            valid3 = false;
                            passing0 = [passing0, 6];
                          } else {
                            if (_valid0) {
                              valid3 = true;
                              passing0 = 6;
                            }
                            const _errs20 = errors;
                            if ("OST_FireAlarmDevices" !== data4) {
                              const err17 = { instancePath: instancePath + "/categories/" + i0, schemaPath: "#/properties/categories/items/oneOf/7/const", keyword: "const", params: { allowedValue: "OST_FireAlarmDevices" }, message: "must be equal to constant", schema: "OST_FireAlarmDevices", parentSchema: schema11.properties.categories.items.oneOf[7], data: data4 };
                              if (vErrors === null) {
                                vErrors = [err17];
                              } else {
                                vErrors.push(err17);
                              }
                              errors++;
                            }
                            var _valid0 = _errs20 === errors;
                            if (_valid0 && valid3) {
                              valid3 = false;
                              passing0 = [passing0, 7];
                            } else {
                              if (_valid0) {
                                valid3 = true;
                                passing0 = 7;
                              }
                              const _errs21 = errors;
                              if ("OST_ElectricalEquipment" !== data4) {
                                const err18 = { instancePath: instancePath + "/categories/" + i0, schemaPath: "#/properties/categories/items/oneOf/8/const", keyword: "const", params: { allowedValue: "OST_ElectricalEquipment" }, message: "must be equal to constant", schema: "OST_ElectricalEquipment", parentSchema: schema11.properties.categories.items.oneOf[8], data: data4 };
                                if (vErrors === null) {
                                  vErrors = [err18];
                                } else {
                                  vErrors.push(err18);
                                }
                                errors++;
                              }
                              var _valid0 = _errs21 === errors;
                              if (_valid0 && valid3) {
                                valid3 = false;
                                passing0 = [passing0, 8];
                              } else {
                                if (_valid0) {
                                  valid3 = true;
                                  passing0 = 8;
                                }
                                const _errs22 = errors;
                                if ("OST_ElectricalFixtures" !== data4) {
                                  const err19 = { instancePath: instancePath + "/categories/" + i0, schemaPath: "#/properties/categories/items/oneOf/9/const", keyword: "const", params: { allowedValue: "OST_ElectricalFixtures" }, message: "must be equal to constant", schema: "OST_ElectricalFixtures", parentSchema: schema11.properties.categories.items.oneOf[9], data: data4 };
                                  if (vErrors === null) {
                                    vErrors = [err19];
                                  } else {
                                    vErrors.push(err19);
                                  }
                                  errors++;
                                }
                                var _valid0 = _errs22 === errors;
                                if (_valid0 && valid3) {
                                  valid3 = false;
                                  passing0 = [passing0, 9];
                                } else {
                                  if (_valid0) {
                                    valid3 = true;
                                    passing0 = 9;
                                  }
                                  const _errs23 = errors;
                                  if ("OST_LightingFixtures" !== data4) {
                                    const err20 = { instancePath: instancePath + "/categories/" + i0, schemaPath: "#/properties/categories/items/oneOf/10/const", keyword: "const", params: { allowedValue: "OST_LightingFixtures" }, message: "must be equal to constant", schema: "OST_LightingFixtures", parentSchema: schema11.properties.categories.items.oneOf[10], data: data4 };
                                    if (vErrors === null) {
                                      vErrors = [err20];
                                    } else {
                                      vErrors.push(err20);
                                    }
                                    errors++;
                                  }
                                  var _valid0 = _errs23 === errors;
                                  if (_valid0 && valid3) {
                                    valid3 = false;
                                    passing0 = [passing0, 10];
                                  } else {
                                    if (_valid0) {
                                      valid3 = true;
                                      passing0 = 10;
                                    }
                                    const _errs24 = errors;
                                    if ("OST_LightingDevices" !== data4) {
                                      const err21 = { instancePath: instancePath + "/categories/" + i0, schemaPath: "#/properties/categories/items/oneOf/11/const", keyword: "const", params: { allowedValue: "OST_LightingDevices" }, message: "must be equal to constant", schema: "OST_LightingDevices", parentSchema: schema11.properties.categories.items.oneOf[11], data: data4 };
                                      if (vErrors === null) {
                                        vErrors = [err21];
                                      } else {
                                        vErrors.push(err21);
                                      }
                                      errors++;
                                    }
                                    var _valid0 = _errs24 === errors;
                                    if (_valid0 && valid3) {
                                      valid3 = false;
                                      passing0 = [passing0, 11];
                                    } else {
                                      if (_valid0) {
                                        valid3 = true;
                                        passing0 = 11;
                                      }
                                      const _errs25 = errors;
                                      if ("OST_CommunicationDevices" !== data4) {
                                        const err22 = { instancePath: instancePath + "/categories/" + i0, schemaPath: "#/properties/categories/items/oneOf/12/const", keyword: "const", params: { allowedValue: "OST_CommunicationDevices" }, message: "must be equal to constant", schema: "OST_CommunicationDevices", parentSchema: schema11.properties.categories.items.oneOf[12], data: data4 };
                                        if (vErrors === null) {
                                          vErrors = [err22];
                                        } else {
                                          vErrors.push(err22);
                                        }
                                        errors++;
                                      }
                                      var _valid0 = _errs25 === errors;
                                      if (_valid0 && valid3) {
                                        valid3 = false;
                                        passing0 = [passing0, 12];
                                      } else {
                                        if (_valid0) {
                                          valid3 = true;
                                          passing0 = 12;
                                        }
                                        const _errs26 = errors;
                                        if ("OST_DataDevices" !== data4) {
                                          const err23 = { instancePath: instancePath + "/categories/" + i0, schemaPath: "#/properties/categories/items/oneOf/13/const", keyword: "const", params: { allowedValue: "OST_DataDevices" }, message: "must be equal to constant", schema: "OST_DataDevices", parentSchema: schema11.properties.categories.items.oneOf[13], data: data4 };
                                          if (vErrors === null) {
                                            vErrors = [err23];
                                          } else {
                                            vErrors.push(err23);
                                          }
                                          errors++;
                                        }
                                        var _valid0 = _errs26 === errors;
                                        if (_valid0 && valid3) {
                                          valid3 = false;
                                          passing0 = [passing0, 13];
                                        } else {
                                          if (_valid0) {
                                            valid3 = true;
                                            passing0 = 13;
                                          }
                                          const _errs27 = errors;
                                          if ("OST_SecurityDevices" !== data4) {
                                            const err24 = { instancePath: instancePath + "/categories/" + i0, schemaPath: "#/properties/categories/items/oneOf/14/const", keyword: "const", params: { allowedValue: "OST_SecurityDevices" }, message: "must be equal to constant", schema: "OST_SecurityDevices", parentSchema: schema11.properties.categories.items.oneOf[14], data: data4 };
                                            if (vErrors === null) {
                                              vErrors = [err24];
                                            } else {
                                              vErrors.push(err24);
                                            }
                                            errors++;
                                          }
                                          var _valid0 = _errs27 === errors;
                                          if (_valid0 && valid3) {
                                            valid3 = false;
                                            passing0 = [passing0, 14];
                                          } else {
                                            if (_valid0) {
                                              valid3 = true;
                                              passing0 = 14;
                                            }
                                            const _errs28 = errors;
                                            if ("OST_NurseCallDevices" !== data4) {
                                              const err25 = { instancePath: instancePath + "/categories/" + i0, schemaPath: "#/properties/categories/items/oneOf/15/const", keyword: "const", params: { allowedValue: "OST_NurseCallDevices" }, message: "must be equal to constant", schema: "OST_NurseCallDevices", parentSchema: schema11.properties.categories.items.oneOf[15], data: data4 };
                                              if (vErrors === null) {
                                                vErrors = [err25];
                                              } else {
                                                vErrors.push(err25);
                                              }
                                              errors++;
                                            }
                                            var _valid0 = _errs28 === errors;
                                            if (_valid0 && valid3) {
                                              valid3 = false;
                                              passing0 = [passing0, 15];
                                            } else {
                                              if (_valid0) {
                                                valid3 = true;
                                                passing0 = 15;
                                              }
                                              const _errs29 = errors;
                                              if ("OST_TelephoneDevices" !== data4) {
                                                const err26 = { instancePath: instancePath + "/categories/" + i0, schemaPath: "#/properties/categories/items/oneOf/16/const", keyword: "const", params: { allowedValue: "OST_TelephoneDevices" }, message: "must be equal to constant", schema: "OST_TelephoneDevices", parentSchema: schema11.properties.categories.items.oneOf[16], data: data4 };
                                                if (vErrors === null) {
                                                  vErrors = [err26];
                                                } else {
                                                  vErrors.push(err26);
                                                }
                                                errors++;
                                              }
                                              var _valid0 = _errs29 === errors;
                                              if (_valid0 && valid3) {
                                                valid3 = false;
                                                passing0 = [passing0, 16];
                                              } else {
                                                if (_valid0) {
                                                  valid3 = true;
                                                  passing0 = 16;
                                                }
                                                const _errs30 = errors;
                                                if ("OST_AudioVisualDevices" !== data4) {
                                                  const err27 = { instancePath: instancePath + "/categories/" + i0, schemaPath: "#/properties/categories/items/oneOf/17/const", keyword: "const", params: { allowedValue: "OST_AudioVisualDevices" }, message: "must be equal to constant", schema: "OST_AudioVisualDevices", parentSchema: schema11.properties.categories.items.oneOf[17], data: data4 };
                                                  if (vErrors === null) {
                                                    vErrors = [err27];
                                                  } else {
                                                    vErrors.push(err27);
                                                  }
                                                  errors++;
                                                }
                                                var _valid0 = _errs30 === errors;
                                                if (_valid0 && valid3) {
                                                  valid3 = false;
                                                  passing0 = [passing0, 17];
                                                } else {
                                                  if (_valid0) {
                                                    valid3 = true;
                                                    passing0 = 17;
                                                  }
                                                  const _errs31 = errors;
                                                  if ("OST_SpecialityEquipment" !== data4) {
                                                    const err28 = { instancePath: instancePath + "/categories/" + i0, schemaPath: "#/properties/categories/items/oneOf/18/const", keyword: "const", params: { allowedValue: "OST_SpecialityEquipment" }, message: "must be equal to constant", schema: "OST_SpecialityEquipment", parentSchema: schema11.properties.categories.items.oneOf[18], data: data4 };
                                                    if (vErrors === null) {
                                                      vErrors = [err28];
                                                    } else {
                                                      vErrors.push(err28);
                                                    }
                                                    errors++;
                                                  }
                                                  var _valid0 = _errs31 === errors;
                                                  if (_valid0 && valid3) {
                                                    valid3 = false;
                                                    passing0 = [passing0, 18];
                                                  } else {
                                                    if (_valid0) {
                                                      valid3 = true;
                                                      passing0 = 18;
                                                    }
                                                    const _errs32 = errors;
                                                    if ("OST_MedicalEquipment" !== data4) {
                                                      const err29 = { instancePath: instancePath + "/categories/" + i0, schemaPath: "#/properties/categories/items/oneOf/19/const", keyword: "const", params: { allowedValue: "OST_MedicalEquipment" }, message: "must be equal to constant", schema: "OST_MedicalEquipment", parentSchema: schema11.properties.categories.items.oneOf[19], data: data4 };
                                                      if (vErrors === null) {
                                                        vErrors = [err29];
                                                      } else {
                                                        vErrors.push(err29);
                                                      }
                                                      errors++;
                                                    }
                                                    var _valid0 = _errs32 === errors;
                                                    if (_valid0 && valid3) {
                                                      valid3 = false;
                                                      passing0 = [passing0, 19];
                                                    } else {
                                                      if (_valid0) {
                                                        valid3 = true;
                                                        passing0 = 19;
                                                      }
                                                      const _errs33 = errors;
                                                      if ("OST_FoodServiceEquipment" !== data4) {
                                                        const err30 = { instancePath: instancePath + "/categories/" + i0, schemaPath: "#/properties/categories/items/oneOf/20/const", keyword: "const", params: { allowedValue: "OST_FoodServiceEquipment" }, message: "must be equal to constant", schema: "OST_FoodServiceEquipment", parentSchema: schema11.properties.categories.items.oneOf[20], data: data4 };
                                                        if (vErrors === null) {
                                                          vErrors = [err30];
                                                        } else {
                                                          vErrors.push(err30);
                                                        }
                                                        errors++;
                                                      }
                                                      var _valid0 = _errs33 === errors;
                                                      if (_valid0 && valid3) {
                                                        valid3 = false;
                                                        passing0 = [passing0, 20];
                                                      } else {
                                                        if (_valid0) {
                                                          valid3 = true;
                                                          passing0 = 20;
                                                        }
                                                        const _errs34 = errors;
                                                        if ("OST_Furniture" !== data4) {
                                                          const err31 = { instancePath: instancePath + "/categories/" + i0, schemaPath: "#/properties/categories/items/oneOf/21/const", keyword: "const", params: { allowedValue: "OST_Furniture" }, message: "must be equal to constant", schema: "OST_Furniture", parentSchema: schema11.properties.categories.items.oneOf[21], data: data4 };
                                                          if (vErrors === null) {
                                                            vErrors = [err31];
                                                          } else {
                                                            vErrors.push(err31);
                                                          }
                                                          errors++;
                                                        }
                                                        var _valid0 = _errs34 === errors;
                                                        if (_valid0 && valid3) {
                                                          valid3 = false;
                                                          passing0 = [passing0, 21];
                                                        } else {
                                                          if (_valid0) {
                                                            valid3 = true;
                                                            passing0 = 21;
                                                          }
                                                          const _errs35 = errors;
                                                          if ("OST_FurnitureSystems" !== data4) {
                                                            const err32 = { instancePath: instancePath + "/categories/" + i0, schemaPath: "#/properties/categories/items/oneOf/22/const", keyword: "const", params: { allowedValue: "OST_FurnitureSystems" }, message: "must be equal to constant", schema: "OST_FurnitureSystems", parentSchema: schema11.properties.categories.items.oneOf[22], data: data4 };
                                                            if (vErrors === null) {
                                                              vErrors = [err32];
                                                            } else {
                                                              vErrors.push(err32);
                                                            }
                                                            errors++;
                                                          }
                                                          var _valid0 = _errs35 === errors;
                                                          if (_valid0 && valid3) {
                                                            valid3 = false;
                                                            passing0 = [passing0, 22];
                                                          } else {
                                                            if (_valid0) {
                                                              valid3 = true;
                                                              passing0 = 22;
                                                            }
                                                            const _errs36 = errors;
                                                            if ("OST_Casework" !== data4) {
                                                              const err33 = { instancePath: instancePath + "/categories/" + i0, schemaPath: "#/properties/categories/items/oneOf/23/const", keyword: "const", params: { allowedValue: "OST_Casework" }, message: "must be equal to constant", schema: "OST_Casework", parentSchema: schema11.properties.categories.items.oneOf[23], data: data4 };
                                                              if (vErrors === null) {
                                                                vErrors = [err33];
                                                              } else {
                                                                vErrors.push(err33);
                                                              }
                                                              errors++;
                                                            }
                                                            var _valid0 = _errs36 === errors;
                                                            if (_valid0 && valid3) {
                                                              valid3 = false;
                                                              passing0 = [passing0, 23];
                                                            } else {
                                                              if (_valid0) {
                                                                valid3 = true;
                                                                passing0 = 23;
                                                              }
                                                              const _errs37 = errors;
                                                              if ("OST_Doors" !== data4) {
                                                                const err34 = { instancePath: instancePath + "/categories/" + i0, schemaPath: "#/properties/categories/items/oneOf/24/const", keyword: "const", params: { allowedValue: "OST_Doors" }, message: "must be equal to constant", schema: "OST_Doors", parentSchema: schema11.properties.categories.items.oneOf[24], data: data4 };
                                                                if (vErrors === null) {
                                                                  vErrors = [err34];
                                                                } else {
                                                                  vErrors.push(err34);
                                                                }
                                                                errors++;
                                                              }
                                                              var _valid0 = _errs37 === errors;
                                                              if (_valid0 && valid3) {
                                                                valid3 = false;
                                                                passing0 = [passing0, 24];
                                                              } else {
                                                                if (_valid0) {
                                                                  valid3 = true;
                                                                  passing0 = 24;
                                                                }
                                                                const _errs38 = errors;
                                                                if ("OST_Windows" !== data4) {
                                                                  const err35 = { instancePath: instancePath + "/categories/" + i0, schemaPath: "#/properties/categories/items/oneOf/25/const", keyword: "const", params: { allowedValue: "OST_Windows" }, message: "must be equal to constant", schema: "OST_Windows", parentSchema: schema11.properties.categories.items.oneOf[25], data: data4 };
                                                                  if (vErrors === null) {
                                                                    vErrors = [err35];
                                                                  } else {
                                                                    vErrors.push(err35);
                                                                  }
                                                                  errors++;
                                                                }
                                                                var _valid0 = _errs38 === errors;
                                                                if (_valid0 && valid3) {
                                                                  valid3 = false;
                                                                  passing0 = [passing0, 25];
                                                                } else {
                                                                  if (_valid0) {
                                                                    valid3 = true;
                                                                    passing0 = 25;
                                                                  }
                                                                }
                                                              }
                                                            }
                                                          }
                                                        }
                                                      }
                                                    }
                                                  }
                                                }
                                              }
                                            }
                                          }
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
                if (!valid3) {
                  const err36 = { instancePath: instancePath + "/categories/" + i0, schemaPath: "#/properties/categories/items/oneOf", keyword: "oneOf", params: { passingSchemas: passing0 }, message: "must match exactly one schema in oneOf", schema: schema11.properties.categories.items.oneOf, parentSchema: schema11.properties.categories.items, data: data4 };
                  if (vErrors === null) {
                    vErrors = [err36];
                  } else {
                    vErrors.push(err36);
                  }
                  errors++;
                } else {
                  errors = _errs12;
                  if (vErrors !== null) {
                    if (_errs12) {
                      vErrors.length = _errs12;
                    } else {
                      vErrors = null;
                    }
                  }
                }
              }
              let i1 = data3.length;
              let j0;
              if (i1 > 1) {
                const indices0 = {};
                for (; i1--; ) {
                  let item0 = data3[i1];
                  if (typeof item0 !== "string") {
                    continue;
                  }
                  if (typeof indices0[item0] == "number") {
                    j0 = indices0[item0];
                    const err37 = { instancePath: instancePath + "/categories", schemaPath: "#/properties/categories/uniqueItems", keyword: "uniqueItems", params: { i: i1, j: j0 }, message: "must NOT have duplicate items (items ## " + j0 + " and " + i1 + " are identical)", schema: true, parentSchema: schema11.properties.categories, data: data3 };
                    if (vErrors === null) {
                      vErrors = [err37];
                    } else {
                      vErrors.push(err37);
                    }
                    errors++;
                    break;
                  }
                  indices0[item0] = i1;
                }
              }
            } else {
              const err38 = { instancePath: instancePath + "/categories", schemaPath: "#/properties/categories/type", keyword: "type", params: { type: "array" }, message: "must be array", schema: schema11.properties.categories.type, parentSchema: schema11.properties.categories, data: data3 };
              if (vErrors === null) {
                vErrors = [err38];
              } else {
                vErrors.push(err38);
              }
              errors++;
            }
          }
          if (data.modelHandling !== void 0) {
            let data5 = data.modelHandling;
            if (typeof data5 !== "string") {
              const err39 = { instancePath: instancePath + "/modelHandling", schemaPath: "#/properties/modelHandling/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: schema11.properties.modelHandling.type, parentSchema: schema11.properties.modelHandling, data: data5 };
              if (vErrors === null) {
                vErrors = [err39];
              } else {
                vErrors.push(err39);
              }
              errors++;
            }
            const _errs41 = errors;
            let valid5 = false;
            let passing1 = null;
            const _errs42 = errors;
            if ("copy" !== data5) {
              const err40 = { instancePath: instancePath + "/modelHandling", schemaPath: "#/properties/modelHandling/oneOf/0/const", keyword: "const", params: { allowedValue: "copy" }, message: "must be equal to constant", schema: "copy", parentSchema: schema11.properties.modelHandling.oneOf[0], data: data5 };
              if (vErrors === null) {
                vErrors = [err40];
              } else {
                vErrors.push(err40);
              }
              errors++;
            }
            var _valid1 = _errs42 === errors;
            if (_valid1) {
              valid5 = true;
              passing1 = 0;
            }
            const _errs43 = errors;
            if ("in-place" !== data5) {
              const err41 = { instancePath: instancePath + "/modelHandling", schemaPath: "#/properties/modelHandling/oneOf/1/const", keyword: "const", params: { allowedValue: "in-place" }, message: "must be equal to constant", schema: "in-place", parentSchema: schema11.properties.modelHandling.oneOf[1], data: data5 };
              if (vErrors === null) {
                vErrors = [err41];
              } else {
                vErrors.push(err41);
              }
              errors++;
            }
            var _valid1 = _errs43 === errors;
            if (_valid1 && valid5) {
              valid5 = false;
              passing1 = [passing1, 1];
            } else {
              if (_valid1) {
                valid5 = true;
                passing1 = 1;
              }
            }
            if (!valid5) {
              const err42 = { instancePath: instancePath + "/modelHandling", schemaPath: "#/properties/modelHandling/oneOf", keyword: "oneOf", params: { passingSchemas: passing1 }, message: "must match exactly one schema in oneOf", schema: schema11.properties.modelHandling.oneOf, parentSchema: schema11.properties.modelHandling, data: data5 };
              if (vErrors === null) {
                vErrors = [err42];
              } else {
                vErrors.push(err42);
              }
              errors++;
            } else {
              errors = _errs41;
              if (vErrors !== null) {
                if (_errs41) {
                  vErrors.length = _errs41;
                } else {
                  vErrors = null;
                }
              }
            }
          }
          if (data.existingValues !== void 0) {
            let data6 = data.existingValues;
            if (typeof data6 !== "string") {
              const err43 = { instancePath: instancePath + "/existingValues", schemaPath: "#/properties/existingValues/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: schema11.properties.existingValues.type, parentSchema: schema11.properties.existingValues, data: data6 };
              if (vErrors === null) {
                vErrors = [err43];
              } else {
                vErrors.push(err43);
              }
              errors++;
            }
            const _errs46 = errors;
            let valid6 = false;
            let passing2 = null;
            const _errs47 = errors;
            if ("overwrite" !== data6) {
              const err44 = { instancePath: instancePath + "/existingValues", schemaPath: "#/properties/existingValues/oneOf/0/const", keyword: "const", params: { allowedValue: "overwrite" }, message: "must be equal to constant", schema: "overwrite", parentSchema: schema11.properties.existingValues.oneOf[0], data: data6 };
              if (vErrors === null) {
                vErrors = [err44];
              } else {
                vErrors.push(err44);
              }
              errors++;
            }
            var _valid2 = _errs47 === errors;
            if (_valid2) {
              valid6 = true;
              passing2 = 0;
            }
            const _errs48 = errors;
            if ("keep" !== data6) {
              const err45 = { instancePath: instancePath + "/existingValues", schemaPath: "#/properties/existingValues/oneOf/1/const", keyword: "const", params: { allowedValue: "keep" }, message: "must be equal to constant", schema: "keep", parentSchema: schema11.properties.existingValues.oneOf[1], data: data6 };
              if (vErrors === null) {
                vErrors = [err45];
              } else {
                vErrors.push(err45);
              }
              errors++;
            }
            var _valid2 = _errs48 === errors;
            if (_valid2 && valid6) {
              valid6 = false;
              passing2 = [passing2, 1];
            } else {
              if (_valid2) {
                valid6 = true;
                passing2 = 1;
              }
            }
            if (!valid6) {
              const err46 = { instancePath: instancePath + "/existingValues", schemaPath: "#/properties/existingValues/oneOf", keyword: "oneOf", params: { passingSchemas: passing2 }, message: "must match exactly one schema in oneOf", schema: schema11.properties.existingValues.oneOf, parentSchema: schema11.properties.existingValues, data: data6 };
              if (vErrors === null) {
                vErrors = [err46];
              } else {
                vErrors.push(err46);
              }
              errors++;
            } else {
              errors = _errs46;
              if (vErrors !== null) {
                if (_errs46) {
                  vErrors.length = _errs46;
                } else {
                  vErrors = null;
                }
              }
            }
          }
          if (data.coordinates !== void 0) {
            let data7 = data.coordinates;
            if (typeof data7 !== "string") {
              const err47 = { instancePath: instancePath + "/coordinates", schemaPath: "#/properties/coordinates/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: schema11.properties.coordinates.type, parentSchema: schema11.properties.coordinates, data: data7 };
              if (vErrors === null) {
                vErrors = [err47];
              } else {
                vErrors.push(err47);
              }
              errors++;
            }
            const _errs51 = errors;
            let valid7 = false;
            let passing3 = null;
            const _errs52 = errors;
            if ("shared" !== data7) {
              const err48 = { instancePath: instancePath + "/coordinates", schemaPath: "#/properties/coordinates/oneOf/0/const", keyword: "const", params: { allowedValue: "shared" }, message: "must be equal to constant", schema: "shared", parentSchema: schema11.properties.coordinates.oneOf[0], data: data7 };
              if (vErrors === null) {
                vErrors = [err48];
              } else {
                vErrors.push(err48);
              }
              errors++;
            }
            var _valid3 = _errs52 === errors;
            if (_valid3) {
              valid7 = true;
              passing3 = 0;
            }
            const _errs53 = errors;
            if ("project-base" !== data7) {
              const err49 = { instancePath: instancePath + "/coordinates", schemaPath: "#/properties/coordinates/oneOf/1/const", keyword: "const", params: { allowedValue: "project-base" }, message: "must be equal to constant", schema: "project-base", parentSchema: schema11.properties.coordinates.oneOf[1], data: data7 };
              if (vErrors === null) {
                vErrors = [err49];
              } else {
                vErrors.push(err49);
              }
              errors++;
            }
            var _valid3 = _errs53 === errors;
            if (_valid3 && valid7) {
              valid7 = false;
              passing3 = [passing3, 1];
            } else {
              if (_valid3) {
                valid7 = true;
                passing3 = 1;
              }
              const _errs54 = errors;
              if ("internal" !== data7) {
                const err50 = { instancePath: instancePath + "/coordinates", schemaPath: "#/properties/coordinates/oneOf/2/const", keyword: "const", params: { allowedValue: "internal" }, message: "must be equal to constant", schema: "internal", parentSchema: schema11.properties.coordinates.oneOf[2], data: data7 };
                if (vErrors === null) {
                  vErrors = [err50];
                } else {
                  vErrors.push(err50);
                }
                errors++;
              }
              var _valid3 = _errs54 === errors;
              if (_valid3 && valid7) {
                valid7 = false;
                passing3 = [passing3, 2];
              } else {
                if (_valid3) {
                  valid7 = true;
                  passing3 = 2;
                }
              }
            }
            if (!valid7) {
              const err51 = { instancePath: instancePath + "/coordinates", schemaPath: "#/properties/coordinates/oneOf", keyword: "oneOf", params: { passingSchemas: passing3 }, message: "must match exactly one schema in oneOf", schema: schema11.properties.coordinates.oneOf, parentSchema: schema11.properties.coordinates, data: data7 };
              if (vErrors === null) {
                vErrors = [err51];
              } else {
                vErrors.push(err51);
              }
              errors++;
            } else {
              errors = _errs51;
              if (vErrors !== null) {
                if (_errs51) {
                  vErrors.length = _errs51;
                } else {
                  vErrors = null;
                }
              }
            }
          }
          if (data.notes !== void 0) {
            let data8 = data.notes;
            if (typeof data8 === "string") {
              if (func2(data8) > 1e4) {
                const err52 = { instancePath: instancePath + "/notes", schemaPath: "#/properties/notes/maxLength", keyword: "maxLength", params: { limit: 1e4 }, message: "must NOT have more than 10000 characters", schema: 1e4, parentSchema: schema11.properties.notes, data: data8 };
                if (vErrors === null) {
                  vErrors = [err52];
                } else {
                  vErrors.push(err52);
                }
                errors++;
              }
            } else {
              const err53 = { instancePath: instancePath + "/notes", schemaPath: "#/properties/notes/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: schema11.properties.notes.type, parentSchema: schema11.properties.notes, data: data8 };
              if (vErrors === null) {
                vErrors = [err53];
              } else {
                vErrors.push(err53);
              }
              errors++;
            }
          }
        } else {
          const err54 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object", schema: schema11.type, parentSchema: schema11, data };
          if (vErrors === null) {
            vErrors = [err54];
          } else {
            vErrors.push(err54);
          }
          errors++;
        }
        validate10.errors = vErrors;
        return errors === 0;
      }
      exports["19a4bec0"] = validate11;
      var schema12 = { "const": "OST_MechanicalEquipment", "title": "Mechanical equipment", "$id": "19a4bec0" };
      function validate11(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
        ;
        let vErrors = null;
        let errors = 0;
        if ("OST_MechanicalEquipment" !== data) {
          const err0 = { instancePath, schemaPath: "#/const", keyword: "const", params: { allowedValue: "OST_MechanicalEquipment" }, message: "must be equal to constant", schema: "OST_MechanicalEquipment", parentSchema: schema12, data };
          if (vErrors === null) {
            vErrors = [err0];
          } else {
            vErrors.push(err0);
          }
          errors++;
        }
        validate11.errors = vErrors;
        return errors === 0;
      }
      exports["-7a870233"] = validate12;
      var schema13 = { "const": "OST_DuctTerminal", "title": "Air terminals", "$id": "-7a870233" };
      function validate12(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
        ;
        let vErrors = null;
        let errors = 0;
        if ("OST_DuctTerminal" !== data) {
          const err0 = { instancePath, schemaPath: "#/const", keyword: "const", params: { allowedValue: "OST_DuctTerminal" }, message: "must be equal to constant", schema: "OST_DuctTerminal", parentSchema: schema13, data };
          if (vErrors === null) {
            vErrors = [err0];
          } else {
            vErrors.push(err0);
          }
          errors++;
        }
        validate12.errors = vErrors;
        return errors === 0;
      }
      exports["-5d12407c"] = validate13;
      var schema14 = { "const": "OST_DuctAccessory", "title": "Duct accessories", "$id": "-5d12407c" };
      function validate13(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
        ;
        let vErrors = null;
        let errors = 0;
        if ("OST_DuctAccessory" !== data) {
          const err0 = { instancePath, schemaPath: "#/const", keyword: "const", params: { allowedValue: "OST_DuctAccessory" }, message: "must be equal to constant", schema: "OST_DuctAccessory", parentSchema: schema14, data };
          if (vErrors === null) {
            vErrors = [err0];
          } else {
            vErrors.push(err0);
          }
          errors++;
        }
        validate13.errors = vErrors;
        return errors === 0;
      }
      exports["5064bfe2"] = validate14;
      var schema15 = { "const": "OST_PlumbingFixtures", "title": "Plumbing fixtures", "$id": "5064bfe2" };
      function validate14(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
        ;
        let vErrors = null;
        let errors = 0;
        if ("OST_PlumbingFixtures" !== data) {
          const err0 = { instancePath, schemaPath: "#/const", keyword: "const", params: { allowedValue: "OST_PlumbingFixtures" }, message: "must be equal to constant", schema: "OST_PlumbingFixtures", parentSchema: schema15, data };
          if (vErrors === null) {
            vErrors = [err0];
          } else {
            vErrors.push(err0);
          }
          errors++;
        }
        validate14.errors = vErrors;
        return errors === 0;
      }
      exports["324315ca"] = validate15;
      var schema16 = { "const": "OST_PlumbingEquipment", "title": "Plumbing equipment", "$id": "324315ca" };
      function validate15(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
        ;
        let vErrors = null;
        let errors = 0;
        if ("OST_PlumbingEquipment" !== data) {
          const err0 = { instancePath, schemaPath: "#/const", keyword: "const", params: { allowedValue: "OST_PlumbingEquipment" }, message: "must be equal to constant", schema: "OST_PlumbingEquipment", parentSchema: schema16, data };
          if (vErrors === null) {
            vErrors = [err0];
          } else {
            vErrors.push(err0);
          }
          errors++;
        }
        validate15.errors = vErrors;
        return errors === 0;
      }
      exports["-56f1cca4"] = validate16;
      var schema17 = { "const": "OST_PipeAccessory", "title": "Pipe accessories", "$id": "-56f1cca4" };
      function validate16(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
        ;
        let vErrors = null;
        let errors = 0;
        if ("OST_PipeAccessory" !== data) {
          const err0 = { instancePath, schemaPath: "#/const", keyword: "const", params: { allowedValue: "OST_PipeAccessory" }, message: "must be equal to constant", schema: "OST_PipeAccessory", parentSchema: schema17, data };
          if (vErrors === null) {
            vErrors = [err0];
          } else {
            vErrors.push(err0);
          }
          errors++;
        }
        validate16.errors = vErrors;
        return errors === 0;
      }
      exports["14d3afa8"] = validate17;
      var schema18 = { "const": "OST_Sprinklers", "title": "Sprinklers", "$id": "14d3afa8" };
      function validate17(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
        ;
        let vErrors = null;
        let errors = 0;
        if ("OST_Sprinklers" !== data) {
          const err0 = { instancePath, schemaPath: "#/const", keyword: "const", params: { allowedValue: "OST_Sprinklers" }, message: "must be equal to constant", schema: "OST_Sprinklers", parentSchema: schema18, data };
          if (vErrors === null) {
            vErrors = [err0];
          } else {
            vErrors.push(err0);
          }
          errors++;
        }
        validate17.errors = vErrors;
        return errors === 0;
      }
      exports["-70a286b6"] = validate18;
      var schema19 = { "const": "OST_FireAlarmDevices", "title": "Fire alarm devices", "$id": "-70a286b6" };
      function validate18(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
        ;
        let vErrors = null;
        let errors = 0;
        if ("OST_FireAlarmDevices" !== data) {
          const err0 = { instancePath, schemaPath: "#/const", keyword: "const", params: { allowedValue: "OST_FireAlarmDevices" }, message: "must be equal to constant", schema: "OST_FireAlarmDevices", parentSchema: schema19, data };
          if (vErrors === null) {
            vErrors = [err0];
          } else {
            vErrors.push(err0);
          }
          errors++;
        }
        validate18.errors = vErrors;
        return errors === 0;
      }
      exports["51af88b2"] = validate19;
      var schema20 = { "const": "OST_ElectricalEquipment", "title": "Electrical equipment", "$id": "51af88b2" };
      function validate19(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
        ;
        let vErrors = null;
        let errors = 0;
        if ("OST_ElectricalEquipment" !== data) {
          const err0 = { instancePath, schemaPath: "#/const", keyword: "const", params: { allowedValue: "OST_ElectricalEquipment" }, message: "must be equal to constant", schema: "OST_ElectricalEquipment", parentSchema: schema20, data };
          if (vErrors === null) {
            vErrors = [err0];
          } else {
            vErrors.push(err0);
          }
          errors++;
        }
        validate19.errors = vErrors;
        return errors === 0;
      }
      exports["-4ba7d81e"] = validate20;
      var schema21 = { "const": "OST_ElectricalFixtures", "title": "Electrical fixtures", "$id": "-4ba7d81e" };
      function validate20(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
        ;
        let vErrors = null;
        let errors = 0;
        if ("OST_ElectricalFixtures" !== data) {
          const err0 = { instancePath, schemaPath: "#/const", keyword: "const", params: { allowedValue: "OST_ElectricalFixtures" }, message: "must be equal to constant", schema: "OST_ElectricalFixtures", parentSchema: schema21, data };
          if (vErrors === null) {
            vErrors = [err0];
          } else {
            vErrors.push(err0);
          }
          errors++;
        }
        validate20.errors = vErrors;
        return errors === 0;
      }
      exports["-7881d1e"] = validate21;
      var schema22 = { "const": "OST_LightingFixtures", "title": "Lighting fixtures", "$id": "-7881d1e" };
      function validate21(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
        ;
        let vErrors = null;
        let errors = 0;
        if ("OST_LightingFixtures" !== data) {
          const err0 = { instancePath, schemaPath: "#/const", keyword: "const", params: { allowedValue: "OST_LightingFixtures" }, message: "must be equal to constant", schema: "OST_LightingFixtures", parentSchema: schema22, data };
          if (vErrors === null) {
            vErrors = [err0];
          } else {
            vErrors.push(err0);
          }
          errors++;
        }
        validate21.errors = vErrors;
        return errors === 0;
      }
      exports["-565a22a6"] = validate22;
      var schema23 = { "const": "OST_LightingDevices", "title": "Lighting devices", "$id": "-565a22a6" };
      function validate22(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
        ;
        let vErrors = null;
        let errors = 0;
        if ("OST_LightingDevices" !== data) {
          const err0 = { instancePath, schemaPath: "#/const", keyword: "const", params: { allowedValue: "OST_LightingDevices" }, message: "must be equal to constant", schema: "OST_LightingDevices", parentSchema: schema23, data };
          if (vErrors === null) {
            vErrors = [err0];
          } else {
            vErrors.push(err0);
          }
          errors++;
        }
        validate22.errors = vErrors;
        return errors === 0;
      }
      exports["15a81048"] = validate23;
      var schema24 = { "const": "OST_CommunicationDevices", "title": "Communication devices", "$id": "15a81048" };
      function validate23(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
        ;
        let vErrors = null;
        let errors = 0;
        if ("OST_CommunicationDevices" !== data) {
          const err0 = { instancePath, schemaPath: "#/const", keyword: "const", params: { allowedValue: "OST_CommunicationDevices" }, message: "must be equal to constant", schema: "OST_CommunicationDevices", parentSchema: schema24, data };
          if (vErrors === null) {
            vErrors = [err0];
          } else {
            vErrors.push(err0);
          }
          errors++;
        }
        validate23.errors = vErrors;
        return errors === 0;
      }
      exports["10af3296"] = validate24;
      var schema25 = { "const": "OST_DataDevices", "title": "Data devices", "$id": "10af3296" };
      function validate24(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
        ;
        let vErrors = null;
        let errors = 0;
        if ("OST_DataDevices" !== data) {
          const err0 = { instancePath, schemaPath: "#/const", keyword: "const", params: { allowedValue: "OST_DataDevices" }, message: "must be equal to constant", schema: "OST_DataDevices", parentSchema: schema25, data };
          if (vErrors === null) {
            vErrors = [err0];
          } else {
            vErrors.push(err0);
          }
          errors++;
        }
        validate24.errors = vErrors;
        return errors === 0;
      }
      exports["74da8ac2"] = validate25;
      var schema26 = { "const": "OST_SecurityDevices", "title": "Security devices", "$id": "74da8ac2" };
      function validate25(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
        ;
        let vErrors = null;
        let errors = 0;
        if ("OST_SecurityDevices" !== data) {
          const err0 = { instancePath, schemaPath: "#/const", keyword: "const", params: { allowedValue: "OST_SecurityDevices" }, message: "must be equal to constant", schema: "OST_SecurityDevices", parentSchema: schema26, data };
          if (vErrors === null) {
            vErrors = [err0];
          } else {
            vErrors.push(err0);
          }
          errors++;
        }
        validate25.errors = vErrors;
        return errors === 0;
      }
      exports["62161bc4"] = validate26;
      var schema27 = { "const": "OST_NurseCallDevices", "title": "Nurse call devices", "$id": "62161bc4" };
      function validate26(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
        ;
        let vErrors = null;
        let errors = 0;
        if ("OST_NurseCallDevices" !== data) {
          const err0 = { instancePath, schemaPath: "#/const", keyword: "const", params: { allowedValue: "OST_NurseCallDevices" }, message: "must be equal to constant", schema: "OST_NurseCallDevices", parentSchema: schema27, data };
          if (vErrors === null) {
            vErrors = [err0];
          } else {
            vErrors.push(err0);
          }
          errors++;
        }
        validate26.errors = vErrors;
        return errors === 0;
      }
      exports["-462ab8f8"] = validate27;
      var schema28 = { "const": "OST_TelephoneDevices", "title": "Telephone devices", "$id": "-462ab8f8" };
      function validate27(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
        ;
        let vErrors = null;
        let errors = 0;
        if ("OST_TelephoneDevices" !== data) {
          const err0 = { instancePath, schemaPath: "#/const", keyword: "const", params: { allowedValue: "OST_TelephoneDevices" }, message: "must be equal to constant", schema: "OST_TelephoneDevices", parentSchema: schema28, data };
          if (vErrors === null) {
            vErrors = [err0];
          } else {
            vErrors.push(err0);
          }
          errors++;
        }
        validate27.errors = vErrors;
        return errors === 0;
      }
      exports["-1c430518"] = validate28;
      var schema29 = { "const": "OST_AudioVisualDevices", "title": "Audio visual devices", "$id": "-1c430518" };
      function validate28(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
        ;
        let vErrors = null;
        let errors = 0;
        if ("OST_AudioVisualDevices" !== data) {
          const err0 = { instancePath, schemaPath: "#/const", keyword: "const", params: { allowedValue: "OST_AudioVisualDevices" }, message: "must be equal to constant", schema: "OST_AudioVisualDevices", parentSchema: schema29, data };
          if (vErrors === null) {
            vErrors = [err0];
          } else {
            vErrors.push(err0);
          }
          errors++;
        }
        validate28.errors = vErrors;
        return errors === 0;
      }
      exports["1b6c3599"] = validate29;
      var schema30 = { "const": "OST_SpecialityEquipment", "title": "Specialty equipment", "$id": "1b6c3599" };
      function validate29(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
        ;
        let vErrors = null;
        let errors = 0;
        if ("OST_SpecialityEquipment" !== data) {
          const err0 = { instancePath, schemaPath: "#/const", keyword: "const", params: { allowedValue: "OST_SpecialityEquipment" }, message: "must be equal to constant", schema: "OST_SpecialityEquipment", parentSchema: schema30, data };
          if (vErrors === null) {
            vErrors = [err0];
          } else {
            vErrors.push(err0);
          }
          errors++;
        }
        validate29.errors = vErrors;
        return errors === 0;
      }
      exports["4d29f44a"] = validate30;
      var schema31 = { "const": "OST_MedicalEquipment", "title": "Medical equipment", "$id": "4d29f44a" };
      function validate30(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
        ;
        let vErrors = null;
        let errors = 0;
        if ("OST_MedicalEquipment" !== data) {
          const err0 = { instancePath, schemaPath: "#/const", keyword: "const", params: { allowedValue: "OST_MedicalEquipment" }, message: "must be equal to constant", schema: "OST_MedicalEquipment", parentSchema: schema31, data };
          if (vErrors === null) {
            vErrors = [err0];
          } else {
            vErrors.push(err0);
          }
          errors++;
        }
        validate30.errors = vErrors;
        return errors === 0;
      }
      exports["-4770344e"] = validate31;
      var schema32 = { "const": "OST_FoodServiceEquipment", "title": "Food service equipment", "$id": "-4770344e" };
      function validate31(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
        ;
        let vErrors = null;
        let errors = 0;
        if ("OST_FoodServiceEquipment" !== data) {
          const err0 = { instancePath, schemaPath: "#/const", keyword: "const", params: { allowedValue: "OST_FoodServiceEquipment" }, message: "must be equal to constant", schema: "OST_FoodServiceEquipment", parentSchema: schema32, data };
          if (vErrors === null) {
            vErrors = [err0];
          } else {
            vErrors.push(err0);
          }
          errors++;
        }
        validate31.errors = vErrors;
        return errors === 0;
      }
      exports["6493f4d8"] = validate32;
      var schema33 = { "const": "OST_Furniture", "title": "Furniture", "$id": "6493f4d8" };
      function validate32(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
        ;
        let vErrors = null;
        let errors = 0;
        if ("OST_Furniture" !== data) {
          const err0 = { instancePath, schemaPath: "#/const", keyword: "const", params: { allowedValue: "OST_Furniture" }, message: "must be equal to constant", schema: "OST_Furniture", parentSchema: schema33, data };
          if (vErrors === null) {
            vErrors = [err0];
          } else {
            vErrors.push(err0);
          }
          errors++;
        }
        validate32.errors = vErrors;
        return errors === 0;
      }
      exports["4c6214d6"] = validate33;
      var schema34 = { "const": "OST_FurnitureSystems", "title": "Furniture systems", "$id": "4c6214d6" };
      function validate33(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
        ;
        let vErrors = null;
        let errors = 0;
        if ("OST_FurnitureSystems" !== data) {
          const err0 = { instancePath, schemaPath: "#/const", keyword: "const", params: { allowedValue: "OST_FurnitureSystems" }, message: "must be equal to constant", schema: "OST_FurnitureSystems", parentSchema: schema34, data };
          if (vErrors === null) {
            vErrors = [err0];
          } else {
            vErrors.push(err0);
          }
          errors++;
        }
        validate33.errors = vErrors;
        return errors === 0;
      }
      exports["-649acad8"] = validate34;
      var schema35 = { "const": "OST_Casework", "title": "Casework", "$id": "-649acad8" };
      function validate34(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
        ;
        let vErrors = null;
        let errors = 0;
        if ("OST_Casework" !== data) {
          const err0 = { instancePath, schemaPath: "#/const", keyword: "const", params: { allowedValue: "OST_Casework" }, message: "must be equal to constant", schema: "OST_Casework", parentSchema: schema35, data };
          if (vErrors === null) {
            vErrors = [err0];
          } else {
            vErrors.push(err0);
          }
          errors++;
        }
        validate34.errors = vErrors;
        return errors === 0;
      }
      exports["-77cdd682"] = validate35;
      var schema36 = { "const": "OST_Doors", "title": "Doors", "$id": "-77cdd682" };
      function validate35(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
        ;
        let vErrors = null;
        let errors = 0;
        if ("OST_Doors" !== data) {
          const err0 = { instancePath, schemaPath: "#/const", keyword: "const", params: { allowedValue: "OST_Doors" }, message: "must be equal to constant", schema: "OST_Doors", parentSchema: schema36, data };
          if (vErrors === null) {
            vErrors = [err0];
          } else {
            vErrors.push(err0);
          }
          errors++;
        }
        validate35.errors = vErrors;
        return errors === 0;
      }
      exports["7db312ba"] = validate36;
      var schema37 = { "const": "OST_Windows", "title": "Windows", "$id": "7db312ba" };
      function validate36(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
        ;
        let vErrors = null;
        let errors = 0;
        if ("OST_Windows" !== data) {
          const err0 = { instancePath, schemaPath: "#/const", keyword: "const", params: { allowedValue: "OST_Windows" }, message: "must be equal to constant", schema: "OST_Windows", parentSchema: schema37, data };
          if (vErrors === null) {
            vErrors = [err0];
          } else {
            vErrors.push(err0);
          }
          errors++;
        }
        validate36.errors = vErrors;
        return errors === 0;
      }
      exports["-1d019150"] = validate37;
      var schema38 = { "const": "copy", "title": "Save a copy, then change the copy", "$id": "-1d019150" };
      function validate37(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
        ;
        let vErrors = null;
        let errors = 0;
        if ("copy" !== data) {
          const err0 = { instancePath, schemaPath: "#/const", keyword: "const", params: { allowedValue: "copy" }, message: "must be equal to constant", schema: "copy", parentSchema: schema38, data };
          if (vErrors === null) {
            vErrors = [err0];
          } else {
            vErrors.push(err0);
          }
          errors++;
        }
        validate37.errors = vErrors;
        return errors === 0;
      }
      exports["3358b730"] = validate38;
      var schema39 = { "const": "in-place", "title": "Change the open model", "$id": "3358b730" };
      function validate38(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
        ;
        let vErrors = null;
        let errors = 0;
        if ("in-place" !== data) {
          const err0 = { instancePath, schemaPath: "#/const", keyword: "const", params: { allowedValue: "in-place" }, message: "must be equal to constant", schema: "in-place", parentSchema: schema39, data };
          if (vErrors === null) {
            vErrors = [err0];
          } else {
            vErrors.push(err0);
          }
          errors++;
        }
        validate38.errors = vErrors;
        return errors === 0;
      }
      exports["6f738357"] = validate39;
      var schema40 = { "const": "overwrite", "title": "Overwrite and record", "$id": "6f738357" };
      function validate39(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
        ;
        let vErrors = null;
        let errors = 0;
        if ("overwrite" !== data) {
          const err0 = { instancePath, schemaPath: "#/const", keyword: "const", params: { allowedValue: "overwrite" }, message: "must be equal to constant", schema: "overwrite", parentSchema: schema40, data };
          if (vErrors === null) {
            vErrors = [err0];
          } else {
            vErrors.push(err0);
          }
          errors++;
        }
        validate39.errors = vErrors;
        return errors === 0;
      }
      exports["-14f89b65"] = validate40;
      var schema41 = { "const": "keep", "title": "Keep the model's values", "$id": "-14f89b65" };
      function validate40(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
        ;
        let vErrors = null;
        let errors = 0;
        if ("keep" !== data) {
          const err0 = { instancePath, schemaPath: "#/const", keyword: "const", params: { allowedValue: "keep" }, message: "must be equal to constant", schema: "keep", parentSchema: schema41, data };
          if (vErrors === null) {
            vErrors = [err0];
          } else {
            vErrors.push(err0);
          }
          errors++;
        }
        validate40.errors = vErrors;
        return errors === 0;
      }
      exports["55f9f432"] = validate41;
      var schema42 = { "const": "shared", "title": "Shared coordinates", "$id": "55f9f432" };
      function validate41(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
        ;
        let vErrors = null;
        let errors = 0;
        if ("shared" !== data) {
          const err0 = { instancePath, schemaPath: "#/const", keyword: "const", params: { allowedValue: "shared" }, message: "must be equal to constant", schema: "shared", parentSchema: schema42, data };
          if (vErrors === null) {
            vErrors = [err0];
          } else {
            vErrors.push(err0);
          }
          errors++;
        }
        validate41.errors = vErrors;
        return errors === 0;
      }
      exports["2495503a"] = validate42;
      var schema43 = { "const": "project-base", "title": "Project base point", "$id": "2495503a" };
      function validate42(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
        ;
        let vErrors = null;
        let errors = 0;
        if ("project-base" !== data) {
          const err0 = { instancePath, schemaPath: "#/const", keyword: "const", params: { allowedValue: "project-base" }, message: "must be equal to constant", schema: "project-base", parentSchema: schema43, data };
          if (vErrors === null) {
            vErrors = [err0];
          } else {
            vErrors.push(err0);
          }
          errors++;
        }
        validate42.errors = vErrors;
        return errors === 0;
      }
      exports["-392fc1ad"] = validate43;
      var schema44 = { "const": "internal", "title": "Revit internal origin", "$id": "-392fc1ad" };
      function validate43(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
        ;
        let vErrors = null;
        let errors = 0;
        if ("internal" !== data) {
          const err0 = { instancePath, schemaPath: "#/const", keyword: "const", params: { allowedValue: "internal" }, message: "must be equal to constant", schema: "internal", parentSchema: schema44, data };
          if (vErrors === null) {
            vErrors = [err0];
          } else {
            vErrors.push(err0);
          }
          errors++;
        }
        validate43.errors = vErrors;
        return errors === 0;
      }
    }
  });
  return require_validator_2();
})();

"use strict";
var compiled3 = (() => {
  var __getOwnPropNames = Object.getOwnPropertyNames;
  var __commonJS = (cb, mod) => function __require() {
    return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
  };

  // src/web/node_modules/ajv/dist/runtime/ucs2length.js
  var require_ucs2length = __commonJS({
    "src/web/node_modules/ajv/dist/runtime/ucs2length.js"(exports) {
      "use strict";
      Object.defineProperty(exports, "__esModule", { value: true });
      function ucs2length(str) {
        const len = str.length;
        let length = 0;
        let pos = 0;
        let value;
        while (pos < len) {
          length++;
          value = str.charCodeAt(pos++);
          if (value >= 55296 && value <= 56319 && pos < len) {
            value = str.charCodeAt(pos);
            if ((value & 64512) === 56320)
              pos++;
          }
        }
        return length;
      }
      exports.default = ucs2length;
      ucs2length.code = 'require("ajv/dist/runtime/ucs2length").default';
    }
  });

  // src/web/validator-3.cjs
  var require_validator_3 = __commonJS({
    "src/web/validator-3.cjs"(exports) {
      exports["106430"] = validate10;
      var schema11 = { "const": "OST_DuctTerminal", "title": "\u98A8\u7BA1\u7D42\u7AEF", "$id": "106430" };
      function validate10(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
        ;
        let vErrors = null;
        let errors = 0;
        if ("OST_DuctTerminal" !== data) {
          const err0 = { instancePath, schemaPath: "#/const", keyword: "const", params: { allowedValue: "OST_DuctTerminal" }, message: "must be equal to constant", schema: "OST_DuctTerminal", parentSchema: schema11, data };
          if (vErrors === null) {
            vErrors = [err0];
          } else {
            vErrors.push(err0);
          }
          errors++;
        }
        validate10.errors = vErrors;
        return errors === 0;
      }
      exports["49941251"] = validate11;
      var schema12 = { "const": "OST_Furniture", "title": "\u5BB6\u5177", "$id": "49941251" };
      function validate11(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
        ;
        let vErrors = null;
        let errors = 0;
        if ("OST_Furniture" !== data) {
          const err0 = { instancePath, schemaPath: "#/const", keyword: "const", params: { allowedValue: "OST_Furniture" }, message: "must be equal to constant", schema: "OST_Furniture", parentSchema: schema12, data };
          if (vErrors === null) {
            vErrors = [err0];
          } else {
            vErrors.push(err0);
          }
          errors++;
        }
        validate11.errors = vErrors;
        return errors === 0;
      }
      exports["56808151"] = validate12;
      var schema13 = { "const": "in-place", "title": "\u76F4\u63A5\u4FEE\u6539\u76EE\u524D\u7684\u6A21\u578B", "$id": "56808151" };
      function validate12(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
        ;
        let vErrors = null;
        let errors = 0;
        if ("in-place" !== data) {
          const err0 = { instancePath, schemaPath: "#/const", keyword: "const", params: { allowedValue: "in-place" }, message: "must be equal to constant", schema: "in-place", parentSchema: schema13, data };
          if (vErrors === null) {
            vErrors = [err0];
          } else {
            vErrors.push(err0);
          }
          errors++;
        }
        validate12.errors = vErrors;
        return errors === 0;
      }
      exports["-293bcc94"] = validate13;
      var schema14 = { "$schema": "http://json-schema.org/draft-07/schema#", "type": "object", "additionalProperties": false, "properties": { "toolCallLimit": { "type": "integer", "title": "\u6BCF\u6B21\u57F7\u884C\u5DE5\u5177\u4E0A\u9650\uFF08\u6B21\uFF09", "default": 80, "minimum": 1, "maximum": 80, "description": "\u53EF\u8A2D\u5B9A 1\u201380 \u6B21\uFF0C\u9810\u8A2D 80 \u6B21\u3002\u57F7\u884C\u6216\u7E8C\u8DD1\u5404\u81EA\u8A08\u7B97\uFF1B\u7D50\u6848\u5831\u544A\u4E0D\u8A08\u5165\u3002\u4F4E\u65BC 50 \u6B21\u53EF\u80FD\u9700\u8981\u7E8C\u8DD1\u3002\u9810\u4F30\u6703\u96A8\u6A21\u578B\u898F\u6A21\u8207\u8CC7\u6599\u5B8C\u6574\u5EA6\u8B8A\u52D5\uFF0C\u4E26\u975E\u5B8C\u6210\u4FDD\u8B49\u6216\u903E\u6642\u9650\u5236\u3002" }, "formFile": { "type": "string", "title": "\u586B\u5BEB\u8868 Excel", "default": "", "maxLength": 4096, "description": "\u7528\u65BC\u88DC\u5145\u6A21\u578B\u672A\u63D0\u4F9B\u7684\u5C08\u6848\u3001\u806F\u7D61\u4EBA\u53CA\u8A2D\u5099\u985E\u578B\u8CC7\u6599\u3002\u9996\u6B21\u4F7F\u7528\u6642\uFF0C\u8ACB\u5148\u78BA\u8A8D\u8F38\u51FA\u54C1\u985E\uFF0C\u518D\u9078\u64C7\u300C\u4F9D\u6A21\u578B\u7522\u751F\u586B\u5BEB\u8868\u300D\uFF0C\u4F9D\u76EE\u524D Revit \u6A21\u578B\u5217\u51FA\u985E\u578B\u8207\u6578\u91CF\u3002\u5B8C\u6210\u586B\u5BEB\u4E26\u5132\u5B58\u5F8C\uFF0C\u9078\u53D6\u8A72\u6A94\u6848\u958B\u59CB\u88FD\u4F5C\u3002\u82E5\u5DF2\u9078\u53D6\u586B\u5BEB\u8868\uFF0C\u91CD\u65B0\u7522\u751F\u6642\u6703\u4FDD\u7559\u65E2\u6709\u586B\u5BEB\u5167\u5BB9\uFF0C\u53E6\u5B58\u66F4\u65B0\u7248\u672C\u3002" }, "outputFolder": { "type": "string", "title": "\u6210\u679C\u8CC7\u6599\u593E", "default": "", "maxLength": 4096, "description": "\u6307\u5B9A\u6210\u679C\u5132\u5B58\u4F4D\u7F6E\uFF0C\u672A\u6307\u5B9A\u6642\u4F7F\u7528\u684C\u9762\u3002\u7CFB\u7D71\u6703\u5EFA\u7ACB\u7368\u7ACB\u5B50\u8CC7\u6599\u593E\uFF0C\u5B58\u653E COBie Excel\u3001\u88FD\u4F5C\u8AAA\u660E\u53CA\u6700\u7D42\u586B\u5BEB\u8868\uFF1B\u63A1\u7528\u53E6\u5B58\u65B0\u6A94\u6642\uFF0C\u4E5F\u6703\u5305\u542B\u6A21\u578B\u526F\u672C\u3002\u5F8C\u7E8C\u6AA2\u6838\u8207\u518D\u6B21\u88FD\u4F5C\u8ACB\u4F7F\u7528\u6700\u7D42\u586B\u5BEB\u8868\u3002" }, "categories": { "type": "array", "title": "\u8F38\u51FA\u54C1\u985E", "description": "\u8A2D\u5B9A\u4EA4\u4ED8\u6DB5\u84CB\u7684\u54C1\u985E\uFF0C\u9069\u7528\u65BC\u586B\u5BEB\u8868\u7522\u751F\u8207\u6A21\u578B\u8CC7\u6599\u5BEB\u5165\u3002\u9810\u8A2D\u5168\u9078\uFF0C\u81F3\u5C11\u9808\u9078\u64C7\u4E00\u9805\u3002\u5404\u985E\u578B\u662F\u5426\u7D0D\u5165\u4EA4\u4ED8\uFF0C\u8ACB\u65BC\u586B\u5BEB\u8868\u7684\u300C\u7D0D\u5165COBie\u300D\u6B04\u8A2D\u5B9A\u3002", "default": ["OST_MechanicalEquipment", "OST_DuctTerminal", "OST_DuctAccessory", "OST_PlumbingFixtures", "OST_PlumbingEquipment", "OST_PipeAccessory", "OST_Sprinklers", "OST_FireAlarmDevices", "OST_ElectricalEquipment", "OST_ElectricalFixtures", "OST_LightingFixtures", "OST_LightingDevices", "OST_CommunicationDevices", "OST_DataDevices", "OST_SecurityDevices", "OST_NurseCallDevices", "OST_TelephoneDevices", "OST_AudioVisualDevices", "OST_SpecialityEquipment", "OST_MedicalEquipment", "OST_FoodServiceEquipment", "OST_Furniture", "OST_FurnitureSystems", "OST_Casework", "OST_Doors", "OST_Windows"], "uniqueItems": true, "minItems": 1, "items": { "type": "string", "oneOf": [{ "const": "OST_MechanicalEquipment", "title": "\u6A5F\u68B0\u8A2D\u5099" }, { "const": "OST_DuctTerminal", "title": "\u98A8\u7BA1\u7D42\u7AEF" }, { "const": "OST_DuctAccessory", "title": "\u98A8\u7BA1\u9644\u4EF6" }, { "const": "OST_PlumbingFixtures", "title": "\u885B\u5DE5\u8A2D\u5099" }, { "const": "OST_PlumbingEquipment", "title": "\u7D66\u6392\u6C34\u8A2D\u5099" }, { "const": "OST_PipeAccessory", "title": "\u7BA1\u9644\u4EF6" }, { "const": "OST_Sprinklers", "title": "\u7051\u6C34\u982D" }, { "const": "OST_FireAlarmDevices", "title": "\u706B\u8B66\u88DD\u7F6E" }, { "const": "OST_ElectricalEquipment", "title": "\u96FB\u6C23\u8A2D\u5099" }, { "const": "OST_ElectricalFixtures", "title": "\u96FB\u6C23\u88DD\u7F6E" }, { "const": "OST_LightingFixtures", "title": "\u7167\u660E\u8A2D\u5099" }, { "const": "OST_LightingDevices", "title": "\u7167\u660E\u88DD\u7F6E" }, { "const": "OST_CommunicationDevices", "title": "\u901A\u8A0A\u88DD\u7F6E" }, { "const": "OST_DataDevices", "title": "\u8CC7\u6599\u88DD\u7F6E" }, { "const": "OST_SecurityDevices", "title": "\u4FDD\u5168\u88DD\u7F6E" }, { "const": "OST_NurseCallDevices", "title": "\u8B77\u7406\u547C\u53EB\u88DD\u7F6E" }, { "const": "OST_TelephoneDevices", "title": "\u96FB\u8A71\u88DD\u7F6E" }, { "const": "OST_AudioVisualDevices", "title": "\u8996\u807D\u8A2D\u5099" }, { "const": "OST_SpecialityEquipment", "title": "\u5C08\u7528\u8A2D\u5099" }, { "const": "OST_MedicalEquipment", "title": "\u91AB\u7642\u8A2D\u5099" }, { "const": "OST_FoodServiceEquipment", "title": "\u9910\u98F2\u8A2D\u5099" }, { "const": "OST_Furniture", "title": "\u5BB6\u5177" }, { "const": "OST_FurnitureSystems", "title": "\u5BB6\u5177\u7CFB\u7D71" }, { "const": "OST_Casework", "title": "\u6AE5\u6AC3" }, { "const": "OST_Doors", "title": "\u9580" }, { "const": "OST_Windows", "title": "\u7A97" }] } }, "modelHandling": { "type": "string", "title": "\u6A21\u578B\u8655\u7406", "default": "copy", "description": "\u88FD\u4F5C\u6642\u6703\u5C07\u4EA4\u4ED8\u7BC4\u570D\u8207 COBie \u8CC7\u6599\u5BEB\u5165\u6A21\u578B\u3002\u9078\u64C7\u300C\u53E6\u5B58\u65B0\u6A94\u5F8C\u4FEE\u6539\u300D\u6703\u4FDD\u7559\u539F\u6A21\u578B\uFF0C\u5C07\u526F\u672C\u5132\u5B58\u65BC\u6210\u679C\u8CC7\u6599\u593E\uFF0C\u4E26\u5728 Revit \u958B\u555F\u8A72\u526F\u672C\u3002\u9078\u64C7\u300C\u76F4\u63A5\u4FEE\u6539\u76EE\u524D\u7684\u6A21\u578B\u300D\u5247\u6703\u66F4\u65B0\u4E26\u5132\u5B58\u76EE\u524D\u958B\u555F\u7684\u6A21\u578B\u3002", "oneOf": [{ "const": "copy", "title": "\u53E6\u5B58\u65B0\u6A94\u5F8C\u4FEE\u6539" }, { "const": "in-place", "title": "\u76F4\u63A5\u4FEE\u6539\u76EE\u524D\u7684\u6A21\u578B" }] }, "existingValues": { "type": "string", "title": "\u65E2\u6709\u8CC7\u6599\u8655\u7406", "default": "overwrite", "description": "\u8A2D\u5B9A\u6A21\u578B COBie \u53C3\u6578\u8207\u586B\u5BEB\u8868\u4E0D\u4E00\u81F4\u6642\u7684\u8655\u7406\u65B9\u5F0F\u3002\u300C\u8986\u5BEB\u4E26\u8A18\u9304\u300D\u63A1\u7528\u586B\u5BEB\u8868\u8CC7\u6599\uFF0C\u4E26\u8A18\u9304\u539F\u503C\u4F9B\u5F8C\u7E8C\u9084\u539F\uFF1B\u300C\u4FDD\u7559\u6A21\u578B\u65E2\u6709\u7684\u503C\u300D\u4FDD\u7559\u539F\u503C\uFF0CCOBie Excel \u4E5F\u63A1\u7528\u8A72\u503C\u3002\u5169\u7A2E\u65B9\u5F0F\u5747\u6703\u5217\u51FA\u8CC7\u6599\u5DEE\u7570\u3002", "oneOf": [{ "const": "overwrite", "title": "\u8986\u5BEB\u4E26\u8A18\u9304" }, { "const": "keep", "title": "\u4FDD\u7559\u6A21\u578B\u65E2\u6709\u7684\u503C" }] }, "coordinates": { "type": "string", "title": "\u5EA7\u6A19\u57FA\u6E96", "default": "shared", "description": "Coordinate \u9801\u7684\u4F4D\u7F6E\u4EE5\u54EA\u500B\u539F\u9EDE\u70BA\u6E96\u3002\u5171\u7528\u5EA7\u6A19\u8207\u6E2C\u91CF\u9EDE\u3001\u5176\u4ED6\u5C08\u696D\u7684\u6A21\u578B\u53CA GIS \u4E00\u81F4\uFF1B\u6A21\u578B\u6C92\u6709\u8A2D\u5B9A\u5171\u7528\u5EA7\u6A19\u6642\uFF0C\u7B49\u540C\u5167\u90E8\u539F\u9EDE\u3002\u5C08\u6848\u57FA\u6E96\u9EDE\u7684\u6578\u5B57\u8F03\u5C0F\uFF0C\u4EE5\u5C08\u6848\u70BA\u6E96\u3002\u9577\u5EA6\u63A1\u7528\u586B\u5BEB\u8868\u7684\u9577\u5EA6\u55AE\u4F4D\u3002", "oneOf": [{ "const": "shared", "title": "\u5171\u7528\u5EA7\u6A19" }, { "const": "project-base", "title": "\u5C08\u6848\u57FA\u6E96\u9EDE" }, { "const": "internal", "title": "Revit \u5167\u90E8\u539F\u9EDE" }] }, "notes": { "type": "string", "title": "\u8981\u6C42\u8207\u8AAA\u660E", "default": "", "maxLength": 1e4, "description": "\u88DC\u5145\u4EA4\u4ED8\u7BC4\u570D\u3001\u8CC7\u6599\u8981\u6C42\u6216\u7279\u6B8A\u8655\u7406\u4E8B\u9805\uFF0C\u53EF\u7559\u7A7A\u3002\u4F5C\u696D\u5C0D\u8C61\u70BA\u76EE\u524D\u5728 Revit \u958B\u555F\u7684\u5C08\u6848\u3002" } }, "$id": "-293bcc94" };
      var func2 = require_ucs2length().default;
      function validate13(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
        ;
        let vErrors = null;
        let errors = 0;
        if (data && typeof data == "object" && !Array.isArray(data)) {
          for (const key0 in data) {
            if (!(key0 === "toolCallLimit" || key0 === "formFile" || key0 === "outputFolder" || key0 === "categories" || key0 === "modelHandling" || key0 === "existingValues" || key0 === "coordinates" || key0 === "notes")) {
              const err0 = { instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties", schema: false, parentSchema: schema14, data };
              if (vErrors === null) {
                vErrors = [err0];
              } else {
                vErrors.push(err0);
              }
              errors++;
            }
          }
          if (data.toolCallLimit !== void 0) {
            let data0 = data.toolCallLimit;
            if (!(typeof data0 == "number" && (!(data0 % 1) && !isNaN(data0)) && isFinite(data0))) {
              const err1 = { instancePath: instancePath + "/toolCallLimit", schemaPath: "#/properties/toolCallLimit/type", keyword: "type", params: { type: "integer" }, message: "must be integer", schema: schema14.properties.toolCallLimit.type, parentSchema: schema14.properties.toolCallLimit, data: data0 };
              if (vErrors === null) {
                vErrors = [err1];
              } else {
                vErrors.push(err1);
              }
              errors++;
            }
            if (typeof data0 == "number" && isFinite(data0)) {
              if (data0 > 80 || isNaN(data0)) {
                const err2 = { instancePath: instancePath + "/toolCallLimit", schemaPath: "#/properties/toolCallLimit/maximum", keyword: "maximum", params: { comparison: "<=", limit: 80 }, message: "must be <= 80", schema: 80, parentSchema: schema14.properties.toolCallLimit, data: data0 };
                if (vErrors === null) {
                  vErrors = [err2];
                } else {
                  vErrors.push(err2);
                }
                errors++;
              }
              if (data0 < 1 || isNaN(data0)) {
                const err3 = { instancePath: instancePath + "/toolCallLimit", schemaPath: "#/properties/toolCallLimit/minimum", keyword: "minimum", params: { comparison: ">=", limit: 1 }, message: "must be >= 1", schema: 1, parentSchema: schema14.properties.toolCallLimit, data: data0 };
                if (vErrors === null) {
                  vErrors = [err3];
                } else {
                  vErrors.push(err3);
                }
                errors++;
              }
            }
          }
          if (data.formFile !== void 0) {
            let data1 = data.formFile;
            if (typeof data1 === "string") {
              if (func2(data1) > 4096) {
                const err4 = { instancePath: instancePath + "/formFile", schemaPath: "#/properties/formFile/maxLength", keyword: "maxLength", params: { limit: 4096 }, message: "must NOT have more than 4096 characters", schema: 4096, parentSchema: schema14.properties.formFile, data: data1 };
                if (vErrors === null) {
                  vErrors = [err4];
                } else {
                  vErrors.push(err4);
                }
                errors++;
              }
            } else {
              const err5 = { instancePath: instancePath + "/formFile", schemaPath: "#/properties/formFile/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: schema14.properties.formFile.type, parentSchema: schema14.properties.formFile, data: data1 };
              if (vErrors === null) {
                vErrors = [err5];
              } else {
                vErrors.push(err5);
              }
              errors++;
            }
          }
          if (data.outputFolder !== void 0) {
            let data2 = data.outputFolder;
            if (typeof data2 === "string") {
              if (func2(data2) > 4096) {
                const err6 = { instancePath: instancePath + "/outputFolder", schemaPath: "#/properties/outputFolder/maxLength", keyword: "maxLength", params: { limit: 4096 }, message: "must NOT have more than 4096 characters", schema: 4096, parentSchema: schema14.properties.outputFolder, data: data2 };
                if (vErrors === null) {
                  vErrors = [err6];
                } else {
                  vErrors.push(err6);
                }
                errors++;
              }
            } else {
              const err7 = { instancePath: instancePath + "/outputFolder", schemaPath: "#/properties/outputFolder/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: schema14.properties.outputFolder.type, parentSchema: schema14.properties.outputFolder, data: data2 };
              if (vErrors === null) {
                vErrors = [err7];
              } else {
                vErrors.push(err7);
              }
              errors++;
            }
          }
          if (data.categories !== void 0) {
            let data3 = data.categories;
            if (Array.isArray(data3)) {
              if (data3.length < 1) {
                const err8 = { instancePath: instancePath + "/categories", schemaPath: "#/properties/categories/minItems", keyword: "minItems", params: { limit: 1 }, message: "must NOT have fewer than 1 items", schema: 1, parentSchema: schema14.properties.categories, data: data3 };
                if (vErrors === null) {
                  vErrors = [err8];
                } else {
                  vErrors.push(err8);
                }
                errors++;
              }
              const len0 = data3.length;
              for (let i0 = 0; i0 < len0; i0++) {
                let data4 = data3[i0];
                if (typeof data4 !== "string") {
                  const err9 = { instancePath: instancePath + "/categories/" + i0, schemaPath: "#/properties/categories/items/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: schema14.properties.categories.items.type, parentSchema: schema14.properties.categories.items, data: data4 };
                  if (vErrors === null) {
                    vErrors = [err9];
                  } else {
                    vErrors.push(err9);
                  }
                  errors++;
                }
                const _errs12 = errors;
                let valid3 = false;
                let passing0 = null;
                const _errs13 = errors;
                if ("OST_MechanicalEquipment" !== data4) {
                  const err10 = { instancePath: instancePath + "/categories/" + i0, schemaPath: "#/properties/categories/items/oneOf/0/const", keyword: "const", params: { allowedValue: "OST_MechanicalEquipment" }, message: "must be equal to constant", schema: "OST_MechanicalEquipment", parentSchema: schema14.properties.categories.items.oneOf[0], data: data4 };
                  if (vErrors === null) {
                    vErrors = [err10];
                  } else {
                    vErrors.push(err10);
                  }
                  errors++;
                }
                var _valid0 = _errs13 === errors;
                if (_valid0) {
                  valid3 = true;
                  passing0 = 0;
                }
                const _errs14 = errors;
                if ("OST_DuctTerminal" !== data4) {
                  const err11 = { instancePath: instancePath + "/categories/" + i0, schemaPath: "#/properties/categories/items/oneOf/1/const", keyword: "const", params: { allowedValue: "OST_DuctTerminal" }, message: "must be equal to constant", schema: "OST_DuctTerminal", parentSchema: schema14.properties.categories.items.oneOf[1], data: data4 };
                  if (vErrors === null) {
                    vErrors = [err11];
                  } else {
                    vErrors.push(err11);
                  }
                  errors++;
                }
                var _valid0 = _errs14 === errors;
                if (_valid0 && valid3) {
                  valid3 = false;
                  passing0 = [passing0, 1];
                } else {
                  if (_valid0) {
                    valid3 = true;
                    passing0 = 1;
                  }
                  const _errs15 = errors;
                  if ("OST_DuctAccessory" !== data4) {
                    const err12 = { instancePath: instancePath + "/categories/" + i0, schemaPath: "#/properties/categories/items/oneOf/2/const", keyword: "const", params: { allowedValue: "OST_DuctAccessory" }, message: "must be equal to constant", schema: "OST_DuctAccessory", parentSchema: schema14.properties.categories.items.oneOf[2], data: data4 };
                    if (vErrors === null) {
                      vErrors = [err12];
                    } else {
                      vErrors.push(err12);
                    }
                    errors++;
                  }
                  var _valid0 = _errs15 === errors;
                  if (_valid0 && valid3) {
                    valid3 = false;
                    passing0 = [passing0, 2];
                  } else {
                    if (_valid0) {
                      valid3 = true;
                      passing0 = 2;
                    }
                    const _errs16 = errors;
                    if ("OST_PlumbingFixtures" !== data4) {
                      const err13 = { instancePath: instancePath + "/categories/" + i0, schemaPath: "#/properties/categories/items/oneOf/3/const", keyword: "const", params: { allowedValue: "OST_PlumbingFixtures" }, message: "must be equal to constant", schema: "OST_PlumbingFixtures", parentSchema: schema14.properties.categories.items.oneOf[3], data: data4 };
                      if (vErrors === null) {
                        vErrors = [err13];
                      } else {
                        vErrors.push(err13);
                      }
                      errors++;
                    }
                    var _valid0 = _errs16 === errors;
                    if (_valid0 && valid3) {
                      valid3 = false;
                      passing0 = [passing0, 3];
                    } else {
                      if (_valid0) {
                        valid3 = true;
                        passing0 = 3;
                      }
                      const _errs17 = errors;
                      if ("OST_PlumbingEquipment" !== data4) {
                        const err14 = { instancePath: instancePath + "/categories/" + i0, schemaPath: "#/properties/categories/items/oneOf/4/const", keyword: "const", params: { allowedValue: "OST_PlumbingEquipment" }, message: "must be equal to constant", schema: "OST_PlumbingEquipment", parentSchema: schema14.properties.categories.items.oneOf[4], data: data4 };
                        if (vErrors === null) {
                          vErrors = [err14];
                        } else {
                          vErrors.push(err14);
                        }
                        errors++;
                      }
                      var _valid0 = _errs17 === errors;
                      if (_valid0 && valid3) {
                        valid3 = false;
                        passing0 = [passing0, 4];
                      } else {
                        if (_valid0) {
                          valid3 = true;
                          passing0 = 4;
                        }
                        const _errs18 = errors;
                        if ("OST_PipeAccessory" !== data4) {
                          const err15 = { instancePath: instancePath + "/categories/" + i0, schemaPath: "#/properties/categories/items/oneOf/5/const", keyword: "const", params: { allowedValue: "OST_PipeAccessory" }, message: "must be equal to constant", schema: "OST_PipeAccessory", parentSchema: schema14.properties.categories.items.oneOf[5], data: data4 };
                          if (vErrors === null) {
                            vErrors = [err15];
                          } else {
                            vErrors.push(err15);
                          }
                          errors++;
                        }
                        var _valid0 = _errs18 === errors;
                        if (_valid0 && valid3) {
                          valid3 = false;
                          passing0 = [passing0, 5];
                        } else {
                          if (_valid0) {
                            valid3 = true;
                            passing0 = 5;
                          }
                          const _errs19 = errors;
                          if ("OST_Sprinklers" !== data4) {
                            const err16 = { instancePath: instancePath + "/categories/" + i0, schemaPath: "#/properties/categories/items/oneOf/6/const", keyword: "const", params: { allowedValue: "OST_Sprinklers" }, message: "must be equal to constant", schema: "OST_Sprinklers", parentSchema: schema14.properties.categories.items.oneOf[6], data: data4 };
                            if (vErrors === null) {
                              vErrors = [err16];
                            } else {
                              vErrors.push(err16);
                            }
                            errors++;
                          }
                          var _valid0 = _errs19 === errors;
                          if (_valid0 && valid3) {
                            valid3 = false;
                            passing0 = [passing0, 6];
                          } else {
                            if (_valid0) {
                              valid3 = true;
                              passing0 = 6;
                            }
                            const _errs20 = errors;
                            if ("OST_FireAlarmDevices" !== data4) {
                              const err17 = { instancePath: instancePath + "/categories/" + i0, schemaPath: "#/properties/categories/items/oneOf/7/const", keyword: "const", params: { allowedValue: "OST_FireAlarmDevices" }, message: "must be equal to constant", schema: "OST_FireAlarmDevices", parentSchema: schema14.properties.categories.items.oneOf[7], data: data4 };
                              if (vErrors === null) {
                                vErrors = [err17];
                              } else {
                                vErrors.push(err17);
                              }
                              errors++;
                            }
                            var _valid0 = _errs20 === errors;
                            if (_valid0 && valid3) {
                              valid3 = false;
                              passing0 = [passing0, 7];
                            } else {
                              if (_valid0) {
                                valid3 = true;
                                passing0 = 7;
                              }
                              const _errs21 = errors;
                              if ("OST_ElectricalEquipment" !== data4) {
                                const err18 = { instancePath: instancePath + "/categories/" + i0, schemaPath: "#/properties/categories/items/oneOf/8/const", keyword: "const", params: { allowedValue: "OST_ElectricalEquipment" }, message: "must be equal to constant", schema: "OST_ElectricalEquipment", parentSchema: schema14.properties.categories.items.oneOf[8], data: data4 };
                                if (vErrors === null) {
                                  vErrors = [err18];
                                } else {
                                  vErrors.push(err18);
                                }
                                errors++;
                              }
                              var _valid0 = _errs21 === errors;
                              if (_valid0 && valid3) {
                                valid3 = false;
                                passing0 = [passing0, 8];
                              } else {
                                if (_valid0) {
                                  valid3 = true;
                                  passing0 = 8;
                                }
                                const _errs22 = errors;
                                if ("OST_ElectricalFixtures" !== data4) {
                                  const err19 = { instancePath: instancePath + "/categories/" + i0, schemaPath: "#/properties/categories/items/oneOf/9/const", keyword: "const", params: { allowedValue: "OST_ElectricalFixtures" }, message: "must be equal to constant", schema: "OST_ElectricalFixtures", parentSchema: schema14.properties.categories.items.oneOf[9], data: data4 };
                                  if (vErrors === null) {
                                    vErrors = [err19];
                                  } else {
                                    vErrors.push(err19);
                                  }
                                  errors++;
                                }
                                var _valid0 = _errs22 === errors;
                                if (_valid0 && valid3) {
                                  valid3 = false;
                                  passing0 = [passing0, 9];
                                } else {
                                  if (_valid0) {
                                    valid3 = true;
                                    passing0 = 9;
                                  }
                                  const _errs23 = errors;
                                  if ("OST_LightingFixtures" !== data4) {
                                    const err20 = { instancePath: instancePath + "/categories/" + i0, schemaPath: "#/properties/categories/items/oneOf/10/const", keyword: "const", params: { allowedValue: "OST_LightingFixtures" }, message: "must be equal to constant", schema: "OST_LightingFixtures", parentSchema: schema14.properties.categories.items.oneOf[10], data: data4 };
                                    if (vErrors === null) {
                                      vErrors = [err20];
                                    } else {
                                      vErrors.push(err20);
                                    }
                                    errors++;
                                  }
                                  var _valid0 = _errs23 === errors;
                                  if (_valid0 && valid3) {
                                    valid3 = false;
                                    passing0 = [passing0, 10];
                                  } else {
                                    if (_valid0) {
                                      valid3 = true;
                                      passing0 = 10;
                                    }
                                    const _errs24 = errors;
                                    if ("OST_LightingDevices" !== data4) {
                                      const err21 = { instancePath: instancePath + "/categories/" + i0, schemaPath: "#/properties/categories/items/oneOf/11/const", keyword: "const", params: { allowedValue: "OST_LightingDevices" }, message: "must be equal to constant", schema: "OST_LightingDevices", parentSchema: schema14.properties.categories.items.oneOf[11], data: data4 };
                                      if (vErrors === null) {
                                        vErrors = [err21];
                                      } else {
                                        vErrors.push(err21);
                                      }
                                      errors++;
                                    }
                                    var _valid0 = _errs24 === errors;
                                    if (_valid0 && valid3) {
                                      valid3 = false;
                                      passing0 = [passing0, 11];
                                    } else {
                                      if (_valid0) {
                                        valid3 = true;
                                        passing0 = 11;
                                      }
                                      const _errs25 = errors;
                                      if ("OST_CommunicationDevices" !== data4) {
                                        const err22 = { instancePath: instancePath + "/categories/" + i0, schemaPath: "#/properties/categories/items/oneOf/12/const", keyword: "const", params: { allowedValue: "OST_CommunicationDevices" }, message: "must be equal to constant", schema: "OST_CommunicationDevices", parentSchema: schema14.properties.categories.items.oneOf[12], data: data4 };
                                        if (vErrors === null) {
                                          vErrors = [err22];
                                        } else {
                                          vErrors.push(err22);
                                        }
                                        errors++;
                                      }
                                      var _valid0 = _errs25 === errors;
                                      if (_valid0 && valid3) {
                                        valid3 = false;
                                        passing0 = [passing0, 12];
                                      } else {
                                        if (_valid0) {
                                          valid3 = true;
                                          passing0 = 12;
                                        }
                                        const _errs26 = errors;
                                        if ("OST_DataDevices" !== data4) {
                                          const err23 = { instancePath: instancePath + "/categories/" + i0, schemaPath: "#/properties/categories/items/oneOf/13/const", keyword: "const", params: { allowedValue: "OST_DataDevices" }, message: "must be equal to constant", schema: "OST_DataDevices", parentSchema: schema14.properties.categories.items.oneOf[13], data: data4 };
                                          if (vErrors === null) {
                                            vErrors = [err23];
                                          } else {
                                            vErrors.push(err23);
                                          }
                                          errors++;
                                        }
                                        var _valid0 = _errs26 === errors;
                                        if (_valid0 && valid3) {
                                          valid3 = false;
                                          passing0 = [passing0, 13];
                                        } else {
                                          if (_valid0) {
                                            valid3 = true;
                                            passing0 = 13;
                                          }
                                          const _errs27 = errors;
                                          if ("OST_SecurityDevices" !== data4) {
                                            const err24 = { instancePath: instancePath + "/categories/" + i0, schemaPath: "#/properties/categories/items/oneOf/14/const", keyword: "const", params: { allowedValue: "OST_SecurityDevices" }, message: "must be equal to constant", schema: "OST_SecurityDevices", parentSchema: schema14.properties.categories.items.oneOf[14], data: data4 };
                                            if (vErrors === null) {
                                              vErrors = [err24];
                                            } else {
                                              vErrors.push(err24);
                                            }
                                            errors++;
                                          }
                                          var _valid0 = _errs27 === errors;
                                          if (_valid0 && valid3) {
                                            valid3 = false;
                                            passing0 = [passing0, 14];
                                          } else {
                                            if (_valid0) {
                                              valid3 = true;
                                              passing0 = 14;
                                            }
                                            const _errs28 = errors;
                                            if ("OST_NurseCallDevices" !== data4) {
                                              const err25 = { instancePath: instancePath + "/categories/" + i0, schemaPath: "#/properties/categories/items/oneOf/15/const", keyword: "const", params: { allowedValue: "OST_NurseCallDevices" }, message: "must be equal to constant", schema: "OST_NurseCallDevices", parentSchema: schema14.properties.categories.items.oneOf[15], data: data4 };
                                              if (vErrors === null) {
                                                vErrors = [err25];
                                              } else {
                                                vErrors.push(err25);
                                              }
                                              errors++;
                                            }
                                            var _valid0 = _errs28 === errors;
                                            if (_valid0 && valid3) {
                                              valid3 = false;
                                              passing0 = [passing0, 15];
                                            } else {
                                              if (_valid0) {
                                                valid3 = true;
                                                passing0 = 15;
                                              }
                                              const _errs29 = errors;
                                              if ("OST_TelephoneDevices" !== data4) {
                                                const err26 = { instancePath: instancePath + "/categories/" + i0, schemaPath: "#/properties/categories/items/oneOf/16/const", keyword: "const", params: { allowedValue: "OST_TelephoneDevices" }, message: "must be equal to constant", schema: "OST_TelephoneDevices", parentSchema: schema14.properties.categories.items.oneOf[16], data: data4 };
                                                if (vErrors === null) {
                                                  vErrors = [err26];
                                                } else {
                                                  vErrors.push(err26);
                                                }
                                                errors++;
                                              }
                                              var _valid0 = _errs29 === errors;
                                              if (_valid0 && valid3) {
                                                valid3 = false;
                                                passing0 = [passing0, 16];
                                              } else {
                                                if (_valid0) {
                                                  valid3 = true;
                                                  passing0 = 16;
                                                }
                                                const _errs30 = errors;
                                                if ("OST_AudioVisualDevices" !== data4) {
                                                  const err27 = { instancePath: instancePath + "/categories/" + i0, schemaPath: "#/properties/categories/items/oneOf/17/const", keyword: "const", params: { allowedValue: "OST_AudioVisualDevices" }, message: "must be equal to constant", schema: "OST_AudioVisualDevices", parentSchema: schema14.properties.categories.items.oneOf[17], data: data4 };
                                                  if (vErrors === null) {
                                                    vErrors = [err27];
                                                  } else {
                                                    vErrors.push(err27);
                                                  }
                                                  errors++;
                                                }
                                                var _valid0 = _errs30 === errors;
                                                if (_valid0 && valid3) {
                                                  valid3 = false;
                                                  passing0 = [passing0, 17];
                                                } else {
                                                  if (_valid0) {
                                                    valid3 = true;
                                                    passing0 = 17;
                                                  }
                                                  const _errs31 = errors;
                                                  if ("OST_SpecialityEquipment" !== data4) {
                                                    const err28 = { instancePath: instancePath + "/categories/" + i0, schemaPath: "#/properties/categories/items/oneOf/18/const", keyword: "const", params: { allowedValue: "OST_SpecialityEquipment" }, message: "must be equal to constant", schema: "OST_SpecialityEquipment", parentSchema: schema14.properties.categories.items.oneOf[18], data: data4 };
                                                    if (vErrors === null) {
                                                      vErrors = [err28];
                                                    } else {
                                                      vErrors.push(err28);
                                                    }
                                                    errors++;
                                                  }
                                                  var _valid0 = _errs31 === errors;
                                                  if (_valid0 && valid3) {
                                                    valid3 = false;
                                                    passing0 = [passing0, 18];
                                                  } else {
                                                    if (_valid0) {
                                                      valid3 = true;
                                                      passing0 = 18;
                                                    }
                                                    const _errs32 = errors;
                                                    if ("OST_MedicalEquipment" !== data4) {
                                                      const err29 = { instancePath: instancePath + "/categories/" + i0, schemaPath: "#/properties/categories/items/oneOf/19/const", keyword: "const", params: { allowedValue: "OST_MedicalEquipment" }, message: "must be equal to constant", schema: "OST_MedicalEquipment", parentSchema: schema14.properties.categories.items.oneOf[19], data: data4 };
                                                      if (vErrors === null) {
                                                        vErrors = [err29];
                                                      } else {
                                                        vErrors.push(err29);
                                                      }
                                                      errors++;
                                                    }
                                                    var _valid0 = _errs32 === errors;
                                                    if (_valid0 && valid3) {
                                                      valid3 = false;
                                                      passing0 = [passing0, 19];
                                                    } else {
                                                      if (_valid0) {
                                                        valid3 = true;
                                                        passing0 = 19;
                                                      }
                                                      const _errs33 = errors;
                                                      if ("OST_FoodServiceEquipment" !== data4) {
                                                        const err30 = { instancePath: instancePath + "/categories/" + i0, schemaPath: "#/properties/categories/items/oneOf/20/const", keyword: "const", params: { allowedValue: "OST_FoodServiceEquipment" }, message: "must be equal to constant", schema: "OST_FoodServiceEquipment", parentSchema: schema14.properties.categories.items.oneOf[20], data: data4 };
                                                        if (vErrors === null) {
                                                          vErrors = [err30];
                                                        } else {
                                                          vErrors.push(err30);
                                                        }
                                                        errors++;
                                                      }
                                                      var _valid0 = _errs33 === errors;
                                                      if (_valid0 && valid3) {
                                                        valid3 = false;
                                                        passing0 = [passing0, 20];
                                                      } else {
                                                        if (_valid0) {
                                                          valid3 = true;
                                                          passing0 = 20;
                                                        }
                                                        const _errs34 = errors;
                                                        if ("OST_Furniture" !== data4) {
                                                          const err31 = { instancePath: instancePath + "/categories/" + i0, schemaPath: "#/properties/categories/items/oneOf/21/const", keyword: "const", params: { allowedValue: "OST_Furniture" }, message: "must be equal to constant", schema: "OST_Furniture", parentSchema: schema14.properties.categories.items.oneOf[21], data: data4 };
                                                          if (vErrors === null) {
                                                            vErrors = [err31];
                                                          } else {
                                                            vErrors.push(err31);
                                                          }
                                                          errors++;
                                                        }
                                                        var _valid0 = _errs34 === errors;
                                                        if (_valid0 && valid3) {
                                                          valid3 = false;
                                                          passing0 = [passing0, 21];
                                                        } else {
                                                          if (_valid0) {
                                                            valid3 = true;
                                                            passing0 = 21;
                                                          }
                                                          const _errs35 = errors;
                                                          if ("OST_FurnitureSystems" !== data4) {
                                                            const err32 = { instancePath: instancePath + "/categories/" + i0, schemaPath: "#/properties/categories/items/oneOf/22/const", keyword: "const", params: { allowedValue: "OST_FurnitureSystems" }, message: "must be equal to constant", schema: "OST_FurnitureSystems", parentSchema: schema14.properties.categories.items.oneOf[22], data: data4 };
                                                            if (vErrors === null) {
                                                              vErrors = [err32];
                                                            } else {
                                                              vErrors.push(err32);
                                                            }
                                                            errors++;
                                                          }
                                                          var _valid0 = _errs35 === errors;
                                                          if (_valid0 && valid3) {
                                                            valid3 = false;
                                                            passing0 = [passing0, 22];
                                                          } else {
                                                            if (_valid0) {
                                                              valid3 = true;
                                                              passing0 = 22;
                                                            }
                                                            const _errs36 = errors;
                                                            if ("OST_Casework" !== data4) {
                                                              const err33 = { instancePath: instancePath + "/categories/" + i0, schemaPath: "#/properties/categories/items/oneOf/23/const", keyword: "const", params: { allowedValue: "OST_Casework" }, message: "must be equal to constant", schema: "OST_Casework", parentSchema: schema14.properties.categories.items.oneOf[23], data: data4 };
                                                              if (vErrors === null) {
                                                                vErrors = [err33];
                                                              } else {
                                                                vErrors.push(err33);
                                                              }
                                                              errors++;
                                                            }
                                                            var _valid0 = _errs36 === errors;
                                                            if (_valid0 && valid3) {
                                                              valid3 = false;
                                                              passing0 = [passing0, 23];
                                                            } else {
                                                              if (_valid0) {
                                                                valid3 = true;
                                                                passing0 = 23;
                                                              }
                                                              const _errs37 = errors;
                                                              if ("OST_Doors" !== data4) {
                                                                const err34 = { instancePath: instancePath + "/categories/" + i0, schemaPath: "#/properties/categories/items/oneOf/24/const", keyword: "const", params: { allowedValue: "OST_Doors" }, message: "must be equal to constant", schema: "OST_Doors", parentSchema: schema14.properties.categories.items.oneOf[24], data: data4 };
                                                                if (vErrors === null) {
                                                                  vErrors = [err34];
                                                                } else {
                                                                  vErrors.push(err34);
                                                                }
                                                                errors++;
                                                              }
                                                              var _valid0 = _errs37 === errors;
                                                              if (_valid0 && valid3) {
                                                                valid3 = false;
                                                                passing0 = [passing0, 24];
                                                              } else {
                                                                if (_valid0) {
                                                                  valid3 = true;
                                                                  passing0 = 24;
                                                                }
                                                                const _errs38 = errors;
                                                                if ("OST_Windows" !== data4) {
                                                                  const err35 = { instancePath: instancePath + "/categories/" + i0, schemaPath: "#/properties/categories/items/oneOf/25/const", keyword: "const", params: { allowedValue: "OST_Windows" }, message: "must be equal to constant", schema: "OST_Windows", parentSchema: schema14.properties.categories.items.oneOf[25], data: data4 };
                                                                  if (vErrors === null) {
                                                                    vErrors = [err35];
                                                                  } else {
                                                                    vErrors.push(err35);
                                                                  }
                                                                  errors++;
                                                                }
                                                                var _valid0 = _errs38 === errors;
                                                                if (_valid0 && valid3) {
                                                                  valid3 = false;
                                                                  passing0 = [passing0, 25];
                                                                } else {
                                                                  if (_valid0) {
                                                                    valid3 = true;
                                                                    passing0 = 25;
                                                                  }
                                                                }
                                                              }
                                                            }
                                                          }
                                                        }
                                                      }
                                                    }
                                                  }
                                                }
                                              }
                                            }
                                          }
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
                if (!valid3) {
                  const err36 = { instancePath: instancePath + "/categories/" + i0, schemaPath: "#/properties/categories/items/oneOf", keyword: "oneOf", params: { passingSchemas: passing0 }, message: "must match exactly one schema in oneOf", schema: schema14.properties.categories.items.oneOf, parentSchema: schema14.properties.categories.items, data: data4 };
                  if (vErrors === null) {
                    vErrors = [err36];
                  } else {
                    vErrors.push(err36);
                  }
                  errors++;
                } else {
                  errors = _errs12;
                  if (vErrors !== null) {
                    if (_errs12) {
                      vErrors.length = _errs12;
                    } else {
                      vErrors = null;
                    }
                  }
                }
              }
              let i1 = data3.length;
              let j0;
              if (i1 > 1) {
                const indices0 = {};
                for (; i1--; ) {
                  let item0 = data3[i1];
                  if (typeof item0 !== "string") {
                    continue;
                  }
                  if (typeof indices0[item0] == "number") {
                    j0 = indices0[item0];
                    const err37 = { instancePath: instancePath + "/categories", schemaPath: "#/properties/categories/uniqueItems", keyword: "uniqueItems", params: { i: i1, j: j0 }, message: "must NOT have duplicate items (items ## " + j0 + " and " + i1 + " are identical)", schema: true, parentSchema: schema14.properties.categories, data: data3 };
                    if (vErrors === null) {
                      vErrors = [err37];
                    } else {
                      vErrors.push(err37);
                    }
                    errors++;
                    break;
                  }
                  indices0[item0] = i1;
                }
              }
            } else {
              const err38 = { instancePath: instancePath + "/categories", schemaPath: "#/properties/categories/type", keyword: "type", params: { type: "array" }, message: "must be array", schema: schema14.properties.categories.type, parentSchema: schema14.properties.categories, data: data3 };
              if (vErrors === null) {
                vErrors = [err38];
              } else {
                vErrors.push(err38);
              }
              errors++;
            }
          }
          if (data.modelHandling !== void 0) {
            let data5 = data.modelHandling;
            if (typeof data5 !== "string") {
              const err39 = { instancePath: instancePath + "/modelHandling", schemaPath: "#/properties/modelHandling/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: schema14.properties.modelHandling.type, parentSchema: schema14.properties.modelHandling, data: data5 };
              if (vErrors === null) {
                vErrors = [err39];
              } else {
                vErrors.push(err39);
              }
              errors++;
            }
            const _errs41 = errors;
            let valid5 = false;
            let passing1 = null;
            const _errs42 = errors;
            if ("copy" !== data5) {
              const err40 = { instancePath: instancePath + "/modelHandling", schemaPath: "#/properties/modelHandling/oneOf/0/const", keyword: "const", params: { allowedValue: "copy" }, message: "must be equal to constant", schema: "copy", parentSchema: schema14.properties.modelHandling.oneOf[0], data: data5 };
              if (vErrors === null) {
                vErrors = [err40];
              } else {
                vErrors.push(err40);
              }
              errors++;
            }
            var _valid1 = _errs42 === errors;
            if (_valid1) {
              valid5 = true;
              passing1 = 0;
            }
            const _errs43 = errors;
            if ("in-place" !== data5) {
              const err41 = { instancePath: instancePath + "/modelHandling", schemaPath: "#/properties/modelHandling/oneOf/1/const", keyword: "const", params: { allowedValue: "in-place" }, message: "must be equal to constant", schema: "in-place", parentSchema: schema14.properties.modelHandling.oneOf[1], data: data5 };
              if (vErrors === null) {
                vErrors = [err41];
              } else {
                vErrors.push(err41);
              }
              errors++;
            }
            var _valid1 = _errs43 === errors;
            if (_valid1 && valid5) {
              valid5 = false;
              passing1 = [passing1, 1];
            } else {
              if (_valid1) {
                valid5 = true;
                passing1 = 1;
              }
            }
            if (!valid5) {
              const err42 = { instancePath: instancePath + "/modelHandling", schemaPath: "#/properties/modelHandling/oneOf", keyword: "oneOf", params: { passingSchemas: passing1 }, message: "must match exactly one schema in oneOf", schema: schema14.properties.modelHandling.oneOf, parentSchema: schema14.properties.modelHandling, data: data5 };
              if (vErrors === null) {
                vErrors = [err42];
              } else {
                vErrors.push(err42);
              }
              errors++;
            } else {
              errors = _errs41;
              if (vErrors !== null) {
                if (_errs41) {
                  vErrors.length = _errs41;
                } else {
                  vErrors = null;
                }
              }
            }
          }
          if (data.existingValues !== void 0) {
            let data6 = data.existingValues;
            if (typeof data6 !== "string") {
              const err43 = { instancePath: instancePath + "/existingValues", schemaPath: "#/properties/existingValues/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: schema14.properties.existingValues.type, parentSchema: schema14.properties.existingValues, data: data6 };
              if (vErrors === null) {
                vErrors = [err43];
              } else {
                vErrors.push(err43);
              }
              errors++;
            }
            const _errs46 = errors;
            let valid6 = false;
            let passing2 = null;
            const _errs47 = errors;
            if ("overwrite" !== data6) {
              const err44 = { instancePath: instancePath + "/existingValues", schemaPath: "#/properties/existingValues/oneOf/0/const", keyword: "const", params: { allowedValue: "overwrite" }, message: "must be equal to constant", schema: "overwrite", parentSchema: schema14.properties.existingValues.oneOf[0], data: data6 };
              if (vErrors === null) {
                vErrors = [err44];
              } else {
                vErrors.push(err44);
              }
              errors++;
            }
            var _valid2 = _errs47 === errors;
            if (_valid2) {
              valid6 = true;
              passing2 = 0;
            }
            const _errs48 = errors;
            if ("keep" !== data6) {
              const err45 = { instancePath: instancePath + "/existingValues", schemaPath: "#/properties/existingValues/oneOf/1/const", keyword: "const", params: { allowedValue: "keep" }, message: "must be equal to constant", schema: "keep", parentSchema: schema14.properties.existingValues.oneOf[1], data: data6 };
              if (vErrors === null) {
                vErrors = [err45];
              } else {
                vErrors.push(err45);
              }
              errors++;
            }
            var _valid2 = _errs48 === errors;
            if (_valid2 && valid6) {
              valid6 = false;
              passing2 = [passing2, 1];
            } else {
              if (_valid2) {
                valid6 = true;
                passing2 = 1;
              }
            }
            if (!valid6) {
              const err46 = { instancePath: instancePath + "/existingValues", schemaPath: "#/properties/existingValues/oneOf", keyword: "oneOf", params: { passingSchemas: passing2 }, message: "must match exactly one schema in oneOf", schema: schema14.properties.existingValues.oneOf, parentSchema: schema14.properties.existingValues, data: data6 };
              if (vErrors === null) {
                vErrors = [err46];
              } else {
                vErrors.push(err46);
              }
              errors++;
            } else {
              errors = _errs46;
              if (vErrors !== null) {
                if (_errs46) {
                  vErrors.length = _errs46;
                } else {
                  vErrors = null;
                }
              }
            }
          }
          if (data.coordinates !== void 0) {
            let data7 = data.coordinates;
            if (typeof data7 !== "string") {
              const err47 = { instancePath: instancePath + "/coordinates", schemaPath: "#/properties/coordinates/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: schema14.properties.coordinates.type, parentSchema: schema14.properties.coordinates, data: data7 };
              if (vErrors === null) {
                vErrors = [err47];
              } else {
                vErrors.push(err47);
              }
              errors++;
            }
            const _errs51 = errors;
            let valid7 = false;
            let passing3 = null;
            const _errs52 = errors;
            if ("shared" !== data7) {
              const err48 = { instancePath: instancePath + "/coordinates", schemaPath: "#/properties/coordinates/oneOf/0/const", keyword: "const", params: { allowedValue: "shared" }, message: "must be equal to constant", schema: "shared", parentSchema: schema14.properties.coordinates.oneOf[0], data: data7 };
              if (vErrors === null) {
                vErrors = [err48];
              } else {
                vErrors.push(err48);
              }
              errors++;
            }
            var _valid3 = _errs52 === errors;
            if (_valid3) {
              valid7 = true;
              passing3 = 0;
            }
            const _errs53 = errors;
            if ("project-base" !== data7) {
              const err49 = { instancePath: instancePath + "/coordinates", schemaPath: "#/properties/coordinates/oneOf/1/const", keyword: "const", params: { allowedValue: "project-base" }, message: "must be equal to constant", schema: "project-base", parentSchema: schema14.properties.coordinates.oneOf[1], data: data7 };
              if (vErrors === null) {
                vErrors = [err49];
              } else {
                vErrors.push(err49);
              }
              errors++;
            }
            var _valid3 = _errs53 === errors;
            if (_valid3 && valid7) {
              valid7 = false;
              passing3 = [passing3, 1];
            } else {
              if (_valid3) {
                valid7 = true;
                passing3 = 1;
              }
              const _errs54 = errors;
              if ("internal" !== data7) {
                const err50 = { instancePath: instancePath + "/coordinates", schemaPath: "#/properties/coordinates/oneOf/2/const", keyword: "const", params: { allowedValue: "internal" }, message: "must be equal to constant", schema: "internal", parentSchema: schema14.properties.coordinates.oneOf[2], data: data7 };
                if (vErrors === null) {
                  vErrors = [err50];
                } else {
                  vErrors.push(err50);
                }
                errors++;
              }
              var _valid3 = _errs54 === errors;
              if (_valid3 && valid7) {
                valid7 = false;
                passing3 = [passing3, 2];
              } else {
                if (_valid3) {
                  valid7 = true;
                  passing3 = 2;
                }
              }
            }
            if (!valid7) {
              const err51 = { instancePath: instancePath + "/coordinates", schemaPath: "#/properties/coordinates/oneOf", keyword: "oneOf", params: { passingSchemas: passing3 }, message: "must match exactly one schema in oneOf", schema: schema14.properties.coordinates.oneOf, parentSchema: schema14.properties.coordinates, data: data7 };
              if (vErrors === null) {
                vErrors = [err51];
              } else {
                vErrors.push(err51);
              }
              errors++;
            } else {
              errors = _errs51;
              if (vErrors !== null) {
                if (_errs51) {
                  vErrors.length = _errs51;
                } else {
                  vErrors = null;
                }
              }
            }
          }
          if (data.notes !== void 0) {
            let data8 = data.notes;
            if (typeof data8 === "string") {
              if (func2(data8) > 1e4) {
                const err52 = { instancePath: instancePath + "/notes", schemaPath: "#/properties/notes/maxLength", keyword: "maxLength", params: { limit: 1e4 }, message: "must NOT have more than 10000 characters", schema: 1e4, parentSchema: schema14.properties.notes, data: data8 };
                if (vErrors === null) {
                  vErrors = [err52];
                } else {
                  vErrors.push(err52);
                }
                errors++;
              }
            } else {
              const err53 = { instancePath: instancePath + "/notes", schemaPath: "#/properties/notes/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: schema14.properties.notes.type, parentSchema: schema14.properties.notes, data: data8 };
              if (vErrors === null) {
                vErrors = [err53];
              } else {
                vErrors.push(err53);
              }
              errors++;
            }
          }
        } else {
          const err54 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object", schema: schema14.type, parentSchema: schema14, data };
          if (vErrors === null) {
            vErrors = [err54];
          } else {
            vErrors.push(err54);
          }
          errors++;
        }
        validate13.errors = vErrors;
        return errors === 0;
      }
      exports["3f74340"] = validate14;
      var schema15 = { "const": "OST_MechanicalEquipment", "title": "\u6A5F\u68B0\u8A2D\u5099", "$id": "3f74340" };
      function validate14(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
        ;
        let vErrors = null;
        let errors = 0;
        if ("OST_MechanicalEquipment" !== data) {
          const err0 = { instancePath, schemaPath: "#/const", keyword: "const", params: { allowedValue: "OST_MechanicalEquipment" }, message: "must be equal to constant", schema: "OST_MechanicalEquipment", parentSchema: schema15, data };
          if (vErrors === null) {
            vErrors = [err0];
          } else {
            vErrors.push(err0);
          }
          errors++;
        }
        validate14.errors = vErrors;
        return errors === 0;
      }
      exports["124985bd"] = validate15;
      var schema16 = { "const": "OST_DuctAccessory", "title": "\u98A8\u7BA1\u9644\u4EF6", "$id": "124985bd" };
      function validate15(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
        ;
        let vErrors = null;
        let errors = 0;
        if ("OST_DuctAccessory" !== data) {
          const err0 = { instancePath, schemaPath: "#/const", keyword: "const", params: { allowedValue: "OST_DuctAccessory" }, message: "must be equal to constant", schema: "OST_DuctAccessory", parentSchema: schema16, data };
          if (vErrors === null) {
            vErrors = [err0];
          } else {
            vErrors.push(err0);
          }
          errors++;
        }
        validate15.errors = vErrors;
        return errors === 0;
      }
      exports["-a6580a0"] = validate16;
      var schema17 = { "const": "OST_PlumbingFixtures", "title": "\u885B\u5DE5\u8A2D\u5099", "$id": "-a6580a0" };
      function validate16(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
        ;
        let vErrors = null;
        let errors = 0;
        if ("OST_PlumbingFixtures" !== data) {
          const err0 = { instancePath, schemaPath: "#/const", keyword: "const", params: { allowedValue: "OST_PlumbingFixtures" }, message: "must be equal to constant", schema: "OST_PlumbingFixtures", parentSchema: schema17, data };
          if (vErrors === null) {
            vErrors = [err0];
          } else {
            vErrors.push(err0);
          }
          errors++;
        }
        validate16.errors = vErrors;
        return errors === 0;
      }
      exports["62986a02"] = validate17;
      var schema18 = { "const": "OST_PlumbingEquipment", "title": "\u7D66\u6392\u6C34\u8A2D\u5099", "$id": "62986a02" };
      function validate17(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
        ;
        let vErrors = null;
        let errors = 0;
        if ("OST_PlumbingEquipment" !== data) {
          const err0 = { instancePath, schemaPath: "#/const", keyword: "const", params: { allowedValue: "OST_PlumbingEquipment" }, message: "must be equal to constant", schema: "OST_PlumbingEquipment", parentSchema: schema18, data };
          if (vErrors === null) {
            vErrors = [err0];
          } else {
            vErrors.push(err0);
          }
          errors++;
        }
        validate17.errors = vErrors;
        return errors === 0;
      }
      exports["-32e08ed5"] = validate18;
      var schema19 = { "const": "OST_PipeAccessory", "title": "\u7BA1\u9644\u4EF6", "$id": "-32e08ed5" };
      function validate18(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
        ;
        let vErrors = null;
        let errors = 0;
        if ("OST_PipeAccessory" !== data) {
          const err0 = { instancePath, schemaPath: "#/const", keyword: "const", params: { allowedValue: "OST_PipeAccessory" }, message: "must be equal to constant", schema: "OST_PipeAccessory", parentSchema: schema19, data };
          if (vErrors === null) {
            vErrors = [err0];
          } else {
            vErrors.push(err0);
          }
          errors++;
        }
        validate18.errors = vErrors;
        return errors === 0;
      }
      exports["-60100bbd"] = validate19;
      var schema20 = { "const": "OST_Sprinklers", "title": "\u7051\u6C34\u982D", "$id": "-60100bbd" };
      function validate19(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
        ;
        let vErrors = null;
        let errors = 0;
        if ("OST_Sprinklers" !== data) {
          const err0 = { instancePath, schemaPath: "#/const", keyword: "const", params: { allowedValue: "OST_Sprinklers" }, message: "must be equal to constant", schema: "OST_Sprinklers", parentSchema: schema20, data };
          if (vErrors === null) {
            vErrors = [err0];
          } else {
            vErrors.push(err0);
          }
          errors++;
        }
        validate19.errors = vErrors;
        return errors === 0;
      }
      exports["-65faa36e"] = validate20;
      var schema21 = { "const": "OST_FireAlarmDevices", "title": "\u706B\u8B66\u88DD\u7F6E", "$id": "-65faa36e" };
      function validate20(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
        ;
        let vErrors = null;
        let errors = 0;
        if ("OST_FireAlarmDevices" !== data) {
          const err0 = { instancePath, schemaPath: "#/const", keyword: "const", params: { allowedValue: "OST_FireAlarmDevices" }, message: "must be equal to constant", schema: "OST_FireAlarmDevices", parentSchema: schema21, data };
          if (vErrors === null) {
            vErrors = [err0];
          } else {
            vErrors.push(err0);
          }
          errors++;
        }
        validate20.errors = vErrors;
        return errors === 0;
      }
      exports["-9ca1fd0"] = validate21;
      var schema22 = { "const": "OST_ElectricalEquipment", "title": "\u96FB\u6C23\u8A2D\u5099", "$id": "-9ca1fd0" };
      function validate21(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
        ;
        let vErrors = null;
        let errors = 0;
        if ("OST_ElectricalEquipment" !== data) {
          const err0 = { instancePath, schemaPath: "#/const", keyword: "const", params: { allowedValue: "OST_ElectricalEquipment" }, message: "must be equal to constant", schema: "OST_ElectricalEquipment", parentSchema: schema22, data };
          if (vErrors === null) {
            vErrors = [err0];
          } else {
            vErrors.push(err0);
          }
          errors++;
        }
        validate21.errors = vErrors;
        return errors === 0;
      }
      exports["-1b73b391"] = validate22;
      var schema23 = { "const": "OST_ElectricalFixtures", "title": "\u96FB\u6C23\u88DD\u7F6E", "$id": "-1b73b391" };
      function validate22(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
        ;
        let vErrors = null;
        let errors = 0;
        if ("OST_ElectricalFixtures" !== data) {
          const err0 = { instancePath, schemaPath: "#/const", keyword: "const", params: { allowedValue: "OST_ElectricalFixtures" }, message: "must be equal to constant", schema: "OST_ElectricalFixtures", parentSchema: schema23, data };
          if (vErrors === null) {
            vErrors = [err0];
          } else {
            vErrors.push(err0);
          }
          errors++;
        }
        validate22.errors = vErrors;
        return errors === 0;
      }
      exports["6d303d45"] = validate23;
      var schema24 = { "const": "OST_LightingFixtures", "title": "\u7167\u660E\u8A2D\u5099", "$id": "6d303d45" };
      function validate23(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
        ;
        let vErrors = null;
        let errors = 0;
        if ("OST_LightingFixtures" !== data) {
          const err0 = { instancePath, schemaPath: "#/const", keyword: "const", params: { allowedValue: "OST_LightingFixtures" }, message: "must be equal to constant", schema: "OST_LightingFixtures", parentSchema: schema24, data };
          if (vErrors === null) {
            vErrors = [err0];
          } else {
            vErrors.push(err0);
          }
          errors++;
        }
        validate23.errors = vErrors;
        return errors === 0;
      }
      exports["-6f8d0f57"] = validate24;
      var schema25 = { "const": "OST_LightingDevices", "title": "\u7167\u660E\u88DD\u7F6E", "$id": "-6f8d0f57" };
      function validate24(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
        ;
        let vErrors = null;
        let errors = 0;
        if ("OST_LightingDevices" !== data) {
          const err0 = { instancePath, schemaPath: "#/const", keyword: "const", params: { allowedValue: "OST_LightingDevices" }, message: "must be equal to constant", schema: "OST_LightingDevices", parentSchema: schema25, data };
          if (vErrors === null) {
            vErrors = [err0];
          } else {
            vErrors.push(err0);
          }
          errors++;
        }
        validate24.errors = vErrors;
        return errors === 0;
      }
      exports["-65ed517e"] = validate25;
      var schema26 = { "const": "OST_CommunicationDevices", "title": "\u901A\u8A0A\u88DD\u7F6E", "$id": "-65ed517e" };
      function validate25(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
        ;
        let vErrors = null;
        let errors = 0;
        if ("OST_CommunicationDevices" !== data) {
          const err0 = { instancePath, schemaPath: "#/const", keyword: "const", params: { allowedValue: "OST_CommunicationDevices" }, message: "must be equal to constant", schema: "OST_CommunicationDevices", parentSchema: schema26, data };
          if (vErrors === null) {
            vErrors = [err0];
          } else {
            vErrors.push(err0);
          }
          errors++;
        }
        validate25.errors = vErrors;
        return errors === 0;
      }
      exports["-6b14838e"] = validate26;
      var schema27 = { "const": "OST_DataDevices", "title": "\u8CC7\u6599\u88DD\u7F6E", "$id": "-6b14838e" };
      function validate26(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
        ;
        let vErrors = null;
        let errors = 0;
        if ("OST_DataDevices" !== data) {
          const err0 = { instancePath, schemaPath: "#/const", keyword: "const", params: { allowedValue: "OST_DataDevices" }, message: "must be equal to constant", schema: "OST_DataDevices", parentSchema: schema27, data };
          if (vErrors === null) {
            vErrors = [err0];
          } else {
            vErrors.push(err0);
          }
          errors++;
        }
        validate26.errors = vErrors;
        return errors === 0;
      }
      exports["22f63281"] = validate27;
      var schema28 = { "const": "OST_SecurityDevices", "title": "\u4FDD\u5168\u88DD\u7F6E", "$id": "22f63281" };
      function validate27(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
        ;
        let vErrors = null;
        let errors = 0;
        if ("OST_SecurityDevices" !== data) {
          const err0 = { instancePath, schemaPath: "#/const", keyword: "const", params: { allowedValue: "OST_SecurityDevices" }, message: "must be equal to constant", schema: "OST_SecurityDevices", parentSchema: schema28, data };
          if (vErrors === null) {
            vErrors = [err0];
          } else {
            vErrors.push(err0);
          }
          errors++;
        }
        validate27.errors = vErrors;
        return errors === 0;
      }
      exports["3dda1ff5"] = validate28;
      var schema29 = { "const": "OST_NurseCallDevices", "title": "\u8B77\u7406\u547C\u53EB\u88DD\u7F6E", "$id": "3dda1ff5" };
      function validate28(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
        ;
        let vErrors = null;
        let errors = 0;
        if ("OST_NurseCallDevices" !== data) {
          const err0 = { instancePath, schemaPath: "#/const", keyword: "const", params: { allowedValue: "OST_NurseCallDevices" }, message: "must be equal to constant", schema: "OST_NurseCallDevices", parentSchema: schema29, data };
          if (vErrors === null) {
            vErrors = [err0];
          } else {
            vErrors.push(err0);
          }
          errors++;
        }
        validate28.errors = vErrors;
        return errors === 0;
      }
      exports["69eef4d6"] = validate29;
      var schema30 = { "const": "OST_TelephoneDevices", "title": "\u96FB\u8A71\u88DD\u7F6E", "$id": "69eef4d6" };
      function validate29(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
        ;
        let vErrors = null;
        let errors = 0;
        if ("OST_TelephoneDevices" !== data) {
          const err0 = { instancePath, schemaPath: "#/const", keyword: "const", params: { allowedValue: "OST_TelephoneDevices" }, message: "must be equal to constant", schema: "OST_TelephoneDevices", parentSchema: schema30, data };
          if (vErrors === null) {
            vErrors = [err0];
          } else {
            vErrors.push(err0);
          }
          errors++;
        }
        validate29.errors = vErrors;
        return errors === 0;
      }
      exports["-dccfdcc"] = validate30;
      var schema31 = { "const": "OST_AudioVisualDevices", "title": "\u8996\u807D\u8A2D\u5099", "$id": "-dccfdcc" };
      function validate30(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
        ;
        let vErrors = null;
        let errors = 0;
        if ("OST_AudioVisualDevices" !== data) {
          const err0 = { instancePath, schemaPath: "#/const", keyword: "const", params: { allowedValue: "OST_AudioVisualDevices" }, message: "must be equal to constant", schema: "OST_AudioVisualDevices", parentSchema: schema31, data };
          if (vErrors === null) {
            vErrors = [err0];
          } else {
            vErrors.push(err0);
          }
          errors++;
        }
        validate30.errors = vErrors;
        return errors === 0;
      }
      exports["596906d5"] = validate31;
      var schema32 = { "const": "OST_SpecialityEquipment", "title": "\u5C08\u7528\u8A2D\u5099", "$id": "596906d5" };
      function validate31(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
        ;
        let vErrors = null;
        let errors = 0;
        if ("OST_SpecialityEquipment" !== data) {
          const err0 = { instancePath, schemaPath: "#/const", keyword: "const", params: { allowedValue: "OST_SpecialityEquipment" }, message: "must be equal to constant", schema: "OST_SpecialityEquipment", parentSchema: schema32, data };
          if (vErrors === null) {
            vErrors = [err0];
          } else {
            vErrors.push(err0);
          }
          errors++;
        }
        validate31.errors = vErrors;
        return errors === 0;
      }
      exports["-de986b2"] = validate32;
      var schema33 = { "const": "OST_MedicalEquipment", "title": "\u91AB\u7642\u8A2D\u5099", "$id": "-de986b2" };
      function validate32(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
        ;
        let vErrors = null;
        let errors = 0;
        if ("OST_MedicalEquipment" !== data) {
          const err0 = { instancePath, schemaPath: "#/const", keyword: "const", params: { allowedValue: "OST_MedicalEquipment" }, message: "must be equal to constant", schema: "OST_MedicalEquipment", parentSchema: schema33, data };
          if (vErrors === null) {
            vErrors = [err0];
          } else {
            vErrors.push(err0);
          }
          errors++;
        }
        validate32.errors = vErrors;
        return errors === 0;
      }
      exports["-38cd6761"] = validate33;
      var schema34 = { "const": "OST_FoodServiceEquipment", "title": "\u9910\u98F2\u8A2D\u5099", "$id": "-38cd6761" };
      function validate33(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
        ;
        let vErrors = null;
        let errors = 0;
        if ("OST_FoodServiceEquipment" !== data) {
          const err0 = { instancePath, schemaPath: "#/const", keyword: "const", params: { allowedValue: "OST_FoodServiceEquipment" }, message: "must be equal to constant", schema: "OST_FoodServiceEquipment", parentSchema: schema34, data };
          if (vErrors === null) {
            vErrors = [err0];
          } else {
            vErrors.push(err0);
          }
          errors++;
        }
        validate33.errors = vErrors;
        return errors === 0;
      }
      exports["-71dadd13"] = validate34;
      var schema35 = { "const": "OST_FurnitureSystems", "title": "\u5BB6\u5177\u7CFB\u7D71", "$id": "-71dadd13" };
      function validate34(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
        ;
        let vErrors = null;
        let errors = 0;
        if ("OST_FurnitureSystems" !== data) {
          const err0 = { instancePath, schemaPath: "#/const", keyword: "const", params: { allowedValue: "OST_FurnitureSystems" }, message: "must be equal to constant", schema: "OST_FurnitureSystems", parentSchema: schema35, data };
          if (vErrors === null) {
            vErrors = [err0];
          } else {
            vErrors.push(err0);
          }
          errors++;
        }
        validate34.errors = vErrors;
        return errors === 0;
      }
      exports["-3403cefb"] = validate35;
      var schema36 = { "const": "OST_Casework", "title": "\u6AE5\u6AC3", "$id": "-3403cefb" };
      function validate35(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
        ;
        let vErrors = null;
        let errors = 0;
        if ("OST_Casework" !== data) {
          const err0 = { instancePath, schemaPath: "#/const", keyword: "const", params: { allowedValue: "OST_Casework" }, message: "must be equal to constant", schema: "OST_Casework", parentSchema: schema36, data };
          if (vErrors === null) {
            vErrors = [err0];
          } else {
            vErrors.push(err0);
          }
          errors++;
        }
        validate35.errors = vErrors;
        return errors === 0;
      }
      exports["-72da6f27"] = validate36;
      var schema37 = { "const": "OST_Doors", "title": "\u9580", "$id": "-72da6f27" };
      function validate36(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
        ;
        let vErrors = null;
        let errors = 0;
        if ("OST_Doors" !== data) {
          const err0 = { instancePath, schemaPath: "#/const", keyword: "const", params: { allowedValue: "OST_Doors" }, message: "must be equal to constant", schema: "OST_Doors", parentSchema: schema37, data };
          if (vErrors === null) {
            vErrors = [err0];
          } else {
            vErrors.push(err0);
          }
          errors++;
        }
        validate36.errors = vErrors;
        return errors === 0;
      }
      exports["-5362dd12"] = validate37;
      var schema38 = { "const": "OST_Windows", "title": "\u7A97", "$id": "-5362dd12" };
      function validate37(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
        ;
        let vErrors = null;
        let errors = 0;
        if ("OST_Windows" !== data) {
          const err0 = { instancePath, schemaPath: "#/const", keyword: "const", params: { allowedValue: "OST_Windows" }, message: "must be equal to constant", schema: "OST_Windows", parentSchema: schema38, data };
          if (vErrors === null) {
            vErrors = [err0];
          } else {
            vErrors.push(err0);
          }
          errors++;
        }
        validate37.errors = vErrors;
        return errors === 0;
      }
      exports["56ab7d5"] = validate38;
      var schema39 = { "const": "copy", "title": "\u53E6\u5B58\u65B0\u6A94\u5F8C\u4FEE\u6539", "$id": "56ab7d5" };
      function validate38(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
        ;
        let vErrors = null;
        let errors = 0;
        if ("copy" !== data) {
          const err0 = { instancePath, schemaPath: "#/const", keyword: "const", params: { allowedValue: "copy" }, message: "must be equal to constant", schema: "copy", parentSchema: schema39, data };
          if (vErrors === null) {
            vErrors = [err0];
          } else {
            vErrors.push(err0);
          }
          errors++;
        }
        validate38.errors = vErrors;
        return errors === 0;
      }
      exports["-744bc3a5"] = validate39;
      var schema40 = { "const": "overwrite", "title": "\u8986\u5BEB\u4E26\u8A18\u9304", "$id": "-744bc3a5" };
      function validate39(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
        ;
        let vErrors = null;
        let errors = 0;
        if ("overwrite" !== data) {
          const err0 = { instancePath, schemaPath: "#/const", keyword: "const", params: { allowedValue: "overwrite" }, message: "must be equal to constant", schema: "overwrite", parentSchema: schema40, data };
          if (vErrors === null) {
            vErrors = [err0];
          } else {
            vErrors.push(err0);
          }
          errors++;
        }
        validate39.errors = vErrors;
        return errors === 0;
      }
      exports["5ccc04b7"] = validate40;
      var schema41 = { "const": "keep", "title": "\u4FDD\u7559\u6A21\u578B\u65E2\u6709\u7684\u503C", "$id": "5ccc04b7" };
      function validate40(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
        ;
        let vErrors = null;
        let errors = 0;
        if ("keep" !== data) {
          const err0 = { instancePath, schemaPath: "#/const", keyword: "const", params: { allowedValue: "keep" }, message: "must be equal to constant", schema: "keep", parentSchema: schema41, data };
          if (vErrors === null) {
            vErrors = [err0];
          } else {
            vErrors.push(err0);
          }
          errors++;
        }
        validate40.errors = vErrors;
        return errors === 0;
      }
      exports["714e6bbb"] = validate41;
      var schema42 = { "const": "shared", "title": "\u5171\u7528\u5EA7\u6A19", "$id": "714e6bbb" };
      function validate41(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
        ;
        let vErrors = null;
        let errors = 0;
        if ("shared" !== data) {
          const err0 = { instancePath, schemaPath: "#/const", keyword: "const", params: { allowedValue: "shared" }, message: "must be equal to constant", schema: "shared", parentSchema: schema42, data };
          if (vErrors === null) {
            vErrors = [err0];
          } else {
            vErrors.push(err0);
          }
          errors++;
        }
        validate41.errors = vErrors;
        return errors === 0;
      }
      exports["-225c8c9a"] = validate42;
      var schema43 = { "const": "project-base", "title": "\u5C08\u6848\u57FA\u6E96\u9EDE", "$id": "-225c8c9a" };
      function validate42(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
        ;
        let vErrors = null;
        let errors = 0;
        if ("project-base" !== data) {
          const err0 = { instancePath, schemaPath: "#/const", keyword: "const", params: { allowedValue: "project-base" }, message: "must be equal to constant", schema: "project-base", parentSchema: schema43, data };
          if (vErrors === null) {
            vErrors = [err0];
          } else {
            vErrors.push(err0);
          }
          errors++;
        }
        validate42.errors = vErrors;
        return errors === 0;
      }
      exports["-72275ed4"] = validate43;
      var schema44 = { "const": "internal", "title": "Revit \u5167\u90E8\u539F\u9EDE", "$id": "-72275ed4" };
      function validate43(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
        ;
        let vErrors = null;
        let errors = 0;
        if ("internal" !== data) {
          const err0 = { instancePath, schemaPath: "#/const", keyword: "const", params: { allowedValue: "internal" }, message: "must be equal to constant", schema: "internal", parentSchema: schema44, data };
          if (vErrors === null) {
            vErrors = [err0];
          } else {
            vErrors.push(err0);
          }
          errors++;
        }
        validate43.errors = vErrors;
        return errors === 0;
      }
    }
  });
  return require_validator_3();
})();

"use strict";
var compiled4 = (() => {
  var __getOwnPropNames = Object.getOwnPropertyNames;
  var __commonJS = (cb, mod) => function __require() {
    return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
  };

  // src/web/node_modules/ajv/dist/runtime/ucs2length.js
  var require_ucs2length = __commonJS({
    "src/web/node_modules/ajv/dist/runtime/ucs2length.js"(exports) {
      "use strict";
      Object.defineProperty(exports, "__esModule", { value: true });
      function ucs2length(str) {
        const len = str.length;
        let length = 0;
        let pos = 0;
        let value;
        while (pos < len) {
          length++;
          value = str.charCodeAt(pos++);
          if (value >= 55296 && value <= 56319 && pos < len) {
            value = str.charCodeAt(pos);
            if ((value & 64512) === 56320)
              pos++;
          }
        }
        return length;
      }
      exports.default = ucs2length;
      ucs2length.code = 'require("ajv/dist/runtime/ucs2length").default';
    }
  });

  // src/web/validator-4.cjs
  var require_validator_4 = __commonJS({
    "src/web/validator-4.cjs"(exports) {
      exports["33154136"] = validate10;
      var schema11 = { "const": "mm", "title": "Millimeters", "$id": "33154136" };
      function validate10(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
        ;
        let vErrors = null;
        let errors = 0;
        if ("mm" !== data) {
          const err0 = { instancePath, schemaPath: "#/const", keyword: "const", params: { allowedValue: "mm" }, message: "must be equal to constant", schema: "mm", parentSchema: schema11, data };
          if (vErrors === null) {
            vErrors = [err0];
          } else {
            vErrors.push(err0);
          }
          errors++;
        }
        validate10.errors = vErrors;
        return errors === 0;
      }
      exports["-33be94af"] = validate11;
      var schema12 = { "$schema": "http://json-schema.org/draft-07/schema#", "type": "object", "additionalProperties": false, "required": ["drawingUnit", "level", "pipeType", "pipeHeightCm", "sprinklerHeightCm", "crossingOffsetCm", "executionMode", "drawingQuality", "cadOverlay", "jointType", "missingComponents"], "properties": { "toolCallLimit": { "type": "integer", "title": "Tool call limit per execution", "description": "Choose 1\u201380 calls; default 40. Each execution or continuation has its own allowance. The final report is excluded.", "minimum": 1, "maximum": 80, "default": 40 }, "drawingUnit": { "type": "string", "title": "Actual drawing units", "description": "The actual unit used in the CAD drawing. Use this setting for unit conversion.", "default": "cm", "oneOf": [{ "const": "cm", "title": "Centimeters" }, { "const": "mm", "title": "Millimeters" }, { "const": "m", "title": "Meters" }] }, "level": { "type": "object", "title": "Target Revit level", "description": "The Revit level for the network. Measure pipe and sprinkler heights from this level.", "additionalProperties": false, "required": ["id", "name", "type", "documentId", "documentName", "documentPath", "sessionId", "revitVersion", "lastUpdated"], "properties": { "id": { "type": "string", "minLength": 1 }, "name": { "type": "string", "minLength": 1 }, "type": { "const": "Level" }, "documentId": { "type": "string", "minLength": 1 }, "documentName": { "type": "string" }, "documentPath": { "type": "string" }, "sessionId": { "type": "string", "minLength": 1 }, "revitVersion": { "type": "string", "pattern": "^[0-9]{4}$" }, "lastUpdated": { "type": "string", "minLength": 1 } } }, "pipeType": { "type": "object", "title": "Revit pipe type", "description": "The Revit pipe type for the model, including material, available diameters, and fitting settings.", "additionalProperties": false, "default": { "type": "PipeType", "agentChoice": true }, "required": ["type"], "if": { "type": "object", "properties": { "agentChoice": { "const": true } }, "required": ["agentChoice"] }, "then": { "type": "object", "maxProperties": 2 }, "else": { "type": "object", "properties": { "id": true, "name": true, "documentId": true, "documentName": true, "documentPath": true, "sessionId": true, "revitVersion": true, "lastUpdated": true }, "required": ["id", "name", "documentId", "documentName", "documentPath", "sessionId", "revitVersion", "lastUpdated"] }, "properties": { "agentChoice": { "type": "boolean" }, "id": { "type": "string", "minLength": 1 }, "name": { "type": "string", "minLength": 1 }, "type": { "const": "PipeType" }, "documentId": { "type": "string", "minLength": 1 }, "documentName": { "type": "string" }, "documentPath": { "type": "string" }, "sessionId": { "type": "string", "minLength": 1 }, "revitVersion": { "type": "string", "pattern": "^[0-9]{4}$" }, "lastUpdated": { "type": "string", "minLength": 1 } } }, "systemType": { "type": "object", "title": "Revit system type", "description": "Choose a piping system type from the project, or let the agent select one for the sprinkler network.", "additionalProperties": false, "default": { "type": "MEPSystemType", "agentChoice": true }, "required": ["type"], "if": { "type": "object", "properties": { "agentChoice": { "const": true } }, "required": ["agentChoice"] }, "then": { "type": "object", "maxProperties": 2 }, "else": { "type": "object", "properties": { "id": true, "name": true, "documentId": true, "documentName": true, "documentPath": true, "sessionId": true, "revitVersion": true, "lastUpdated": true }, "required": ["id", "name", "documentId", "documentName", "documentPath", "sessionId", "revitVersion", "lastUpdated"] }, "properties": { "agentChoice": { "type": "boolean" }, "id": { "type": "string", "minLength": 1 }, "name": { "type": "string", "minLength": 1 }, "type": { "const": "MEPSystemType" }, "documentId": { "type": "string", "minLength": 1 }, "documentName": { "type": "string" }, "documentPath": { "type": "string" }, "sessionId": { "type": "string", "minLength": 1 }, "revitVersion": { "type": "string", "pattern": "^[0-9]{4}$" }, "lastUpdated": { "type": "string", "minLength": 1 } } }, "pipeHeightCm": { "type": "number", "title": "Pipe centerline height (cm)", "description": "Height of the pipe centerline above the target level.", "minimum": 0, "default": 280 }, "sprinklerHeightCm": { "type": "number", "title": "Sprinkler outlet above level (cm)", "description": "Height of the sprinkler outlet above the target level.", "minimum": 0, "default": 260 }, "crossingOffsetCm": { "type": "number", "title": "Rise at unconnected crossings (cm)", "description": "The distance to raise one pipe where two pipes cross without a connection.", "exclusiveMinimum": 0, "default": 20 }, "executionMode": { "type": "string", "title": "Execution mode", "description": "Choose to complete the model or confirm the modeling plan first.", "default": "complete", "oneOf": [{ "const": "complete", "title": "Complete the model", "description": "Interpret the drawing. Resolve modeling problems. Complete the entire network." }, { "const": "investigate", "title": "Confirm the plan first", "description": "Interpret the drawing. Propose a modeling plan. Build the model only after confirmation of the plan." }] }, "drawingQuality": { "type": "string", "title": "Drawing quality", "description": "Select the current cleanup status of the CAD drawing.", "default": "unknown", "oneOf": [{ "const": "unknown", "title": "Not checked", "description": "Components can be on incorrect layers. Use lines, symbols, and annotations to identify component functions and pipe connections. Correct errors when drawing evidence supports the change." }, { "const": "cleaned", "title": "Cleaned", "description": "Interpret the drawing as shown. Correct only obvious errors." }] }, "cadOverlay": { "type": "string", "title": "CAD overlay", "description": "Choose to import a CAD overlay, use an existing overlay, or skip the import.", "default": "include", "oneOf": [{ "const": "include", "title": "Import into Revit", "description": "Place the CAD drawing on the target level for comparison with the model." }, { "const": "existing", "title": "Already imported into Revit", "description": "Compare the model with the existing CAD overlay in Revit. Do not import the drawing again." }, { "const": "skip", "title": "Do not import", "description": "Do not import the CAD drawing into Revit. Use images to compare the model with the drawing." }] }, "jointType": { "type": "string", "title": "Joint type", "description": "Select the joint type for pipe fittings. The default uses the selected pipe type's routing preferences.", "default": "routing", "oneOf": [{ "const": "routing", "title": "Follow the pipe type's routing preferences" }, { "const": "mechanical", "title": "Mechanical joints" }, { "const": "threaded", "title": "Threaded joints" }, { "const": "agent", "title": "Inspect and recommend" }] }, "missingComponents": { "type": "string", "title": "Missing components", "description": "Select how to handle required families that the Revit project does not contain, such as valve families.", "default": "create", "oneOf": [{ "const": "create", "title": "Create required components", "description": "Create the missing families with the required component shapes and dimensions. Connect the components to the pipes." }, { "const": "substitute", "title": "Use substitute components", "description": "Use similar existing components as substitutes. Connect the substitutes to the pipes." }, { "const": "list", "title": "List missing components", "description": "List missing components and their locations. Do not create these components." }] }, "notes": { "type": "string", "title": "Additional instructions", "description": "Specify the scope, priorities, or special requirements.", "maxLength": 1e4 } }, "$id": "-33be94af" };
      var func2 = Object.prototype.hasOwnProperty;
      var func4 = require_ucs2length().default;
      var pattern0 = new RegExp("^[0-9]{4}$", "u");
      function validate11(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
        ;
        let vErrors = null;
        let errors = 0;
        if (data && typeof data == "object" && !Array.isArray(data)) {
          if (data.drawingUnit === void 0) {
            const err0 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "drawingUnit" }, message: "must have required property 'drawingUnit'", schema: schema12.required, parentSchema: schema12, data };
            if (vErrors === null) {
              vErrors = [err0];
            } else {
              vErrors.push(err0);
            }
            errors++;
          }
          if (data.level === void 0) {
            const err1 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "level" }, message: "must have required property 'level'", schema: schema12.required, parentSchema: schema12, data };
            if (vErrors === null) {
              vErrors = [err1];
            } else {
              vErrors.push(err1);
            }
            errors++;
          }
          if (data.pipeType === void 0) {
            const err2 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "pipeType" }, message: "must have required property 'pipeType'", schema: schema12.required, parentSchema: schema12, data };
            if (vErrors === null) {
              vErrors = [err2];
            } else {
              vErrors.push(err2);
            }
            errors++;
          }
          if (data.pipeHeightCm === void 0) {
            const err3 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "pipeHeightCm" }, message: "must have required property 'pipeHeightCm'", schema: schema12.required, parentSchema: schema12, data };
            if (vErrors === null) {
              vErrors = [err3];
            } else {
              vErrors.push(err3);
            }
            errors++;
          }
          if (data.sprinklerHeightCm === void 0) {
            const err4 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "sprinklerHeightCm" }, message: "must have required property 'sprinklerHeightCm'", schema: schema12.required, parentSchema: schema12, data };
            if (vErrors === null) {
              vErrors = [err4];
            } else {
              vErrors.push(err4);
            }
            errors++;
          }
          if (data.crossingOffsetCm === void 0) {
            const err5 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "crossingOffsetCm" }, message: "must have required property 'crossingOffsetCm'", schema: schema12.required, parentSchema: schema12, data };
            if (vErrors === null) {
              vErrors = [err5];
            } else {
              vErrors.push(err5);
            }
            errors++;
          }
          if (data.executionMode === void 0) {
            const err6 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "executionMode" }, message: "must have required property 'executionMode'", schema: schema12.required, parentSchema: schema12, data };
            if (vErrors === null) {
              vErrors = [err6];
            } else {
              vErrors.push(err6);
            }
            errors++;
          }
          if (data.drawingQuality === void 0) {
            const err7 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "drawingQuality" }, message: "must have required property 'drawingQuality'", schema: schema12.required, parentSchema: schema12, data };
            if (vErrors === null) {
              vErrors = [err7];
            } else {
              vErrors.push(err7);
            }
            errors++;
          }
          if (data.cadOverlay === void 0) {
            const err8 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "cadOverlay" }, message: "must have required property 'cadOverlay'", schema: schema12.required, parentSchema: schema12, data };
            if (vErrors === null) {
              vErrors = [err8];
            } else {
              vErrors.push(err8);
            }
            errors++;
          }
          if (data.jointType === void 0) {
            const err9 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "jointType" }, message: "must have required property 'jointType'", schema: schema12.required, parentSchema: schema12, data };
            if (vErrors === null) {
              vErrors = [err9];
            } else {
              vErrors.push(err9);
            }
            errors++;
          }
          if (data.missingComponents === void 0) {
            const err10 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "missingComponents" }, message: "must have required property 'missingComponents'", schema: schema12.required, parentSchema: schema12, data };
            if (vErrors === null) {
              vErrors = [err10];
            } else {
              vErrors.push(err10);
            }
            errors++;
          }
          for (const key0 in data) {
            if (!func2.call(schema12.properties, key0)) {
              const err11 = { instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties", schema: false, parentSchema: schema12, data };
              if (vErrors === null) {
                vErrors = [err11];
              } else {
                vErrors.push(err11);
              }
              errors++;
            }
          }
          if (data.toolCallLimit !== void 0) {
            let data0 = data.toolCallLimit;
            if (!(typeof data0 == "number" && (!(data0 % 1) && !isNaN(data0)) && isFinite(data0))) {
              const err12 = { instancePath: instancePath + "/toolCallLimit", schemaPath: "#/properties/toolCallLimit/type", keyword: "type", params: { type: "integer" }, message: "must be integer", schema: schema12.properties.toolCallLimit.type, parentSchema: schema12.properties.toolCallLimit, data: data0 };
              if (vErrors === null) {
                vErrors = [err12];
              } else {
                vErrors.push(err12);
              }
              errors++;
            }
            if (typeof data0 == "number" && isFinite(data0)) {
              if (data0 > 80 || isNaN(data0)) {
                const err13 = { instancePath: instancePath + "/toolCallLimit", schemaPath: "#/properties/toolCallLimit/maximum", keyword: "maximum", params: { comparison: "<=", limit: 80 }, message: "must be <= 80", schema: 80, parentSchema: schema12.properties.toolCallLimit, data: data0 };
                if (vErrors === null) {
                  vErrors = [err13];
                } else {
                  vErrors.push(err13);
                }
                errors++;
              }
              if (data0 < 1 || isNaN(data0)) {
                const err14 = { instancePath: instancePath + "/toolCallLimit", schemaPath: "#/properties/toolCallLimit/minimum", keyword: "minimum", params: { comparison: ">=", limit: 1 }, message: "must be >= 1", schema: 1, parentSchema: schema12.properties.toolCallLimit, data: data0 };
                if (vErrors === null) {
                  vErrors = [err14];
                } else {
                  vErrors.push(err14);
                }
                errors++;
              }
            }
          }
          if (data.drawingUnit !== void 0) {
            let data1 = data.drawingUnit;
            if (typeof data1 !== "string") {
              const err15 = { instancePath: instancePath + "/drawingUnit", schemaPath: "#/properties/drawingUnit/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: schema12.properties.drawingUnit.type, parentSchema: schema12.properties.drawingUnit, data: data1 };
              if (vErrors === null) {
                vErrors = [err15];
              } else {
                vErrors.push(err15);
              }
              errors++;
            }
            const _errs6 = errors;
            let valid1 = false;
            let passing0 = null;
            const _errs7 = errors;
            if ("cm" !== data1) {
              const err16 = { instancePath: instancePath + "/drawingUnit", schemaPath: "#/properties/drawingUnit/oneOf/0/const", keyword: "const", params: { allowedValue: "cm" }, message: "must be equal to constant", schema: "cm", parentSchema: schema12.properties.drawingUnit.oneOf[0], data: data1 };
              if (vErrors === null) {
                vErrors = [err16];
              } else {
                vErrors.push(err16);
              }
              errors++;
            }
            var _valid0 = _errs7 === errors;
            if (_valid0) {
              valid1 = true;
              passing0 = 0;
            }
            const _errs8 = errors;
            if ("mm" !== data1) {
              const err17 = { instancePath: instancePath + "/drawingUnit", schemaPath: "#/properties/drawingUnit/oneOf/1/const", keyword: "const", params: { allowedValue: "mm" }, message: "must be equal to constant", schema: "mm", parentSchema: schema12.properties.drawingUnit.oneOf[1], data: data1 };
              if (vErrors === null) {
                vErrors = [err17];
              } else {
                vErrors.push(err17);
              }
              errors++;
            }
            var _valid0 = _errs8 === errors;
            if (_valid0 && valid1) {
              valid1 = false;
              passing0 = [passing0, 1];
            } else {
              if (_valid0) {
                valid1 = true;
                passing0 = 1;
              }
              const _errs9 = errors;
              if ("m" !== data1) {
                const err18 = { instancePath: instancePath + "/drawingUnit", schemaPath: "#/properties/drawingUnit/oneOf/2/const", keyword: "const", params: { allowedValue: "m" }, message: "must be equal to constant", schema: "m", parentSchema: schema12.properties.drawingUnit.oneOf[2], data: data1 };
                if (vErrors === null) {
                  vErrors = [err18];
                } else {
                  vErrors.push(err18);
                }
                errors++;
              }
              var _valid0 = _errs9 === errors;
              if (_valid0 && valid1) {
                valid1 = false;
                passing0 = [passing0, 2];
              } else {
                if (_valid0) {
                  valid1 = true;
                  passing0 = 2;
                }
              }
            }
            if (!valid1) {
              const err19 = { instancePath: instancePath + "/drawingUnit", schemaPath: "#/properties/drawingUnit/oneOf", keyword: "oneOf", params: { passingSchemas: passing0 }, message: "must match exactly one schema in oneOf", schema: schema12.properties.drawingUnit.oneOf, parentSchema: schema12.properties.drawingUnit, data: data1 };
              if (vErrors === null) {
                vErrors = [err19];
              } else {
                vErrors.push(err19);
              }
              errors++;
            } else {
              errors = _errs6;
              if (vErrors !== null) {
                if (_errs6) {
                  vErrors.length = _errs6;
                } else {
                  vErrors = null;
                }
              }
            }
          }
          if (data.level !== void 0) {
            let data2 = data.level;
            if (data2 && typeof data2 == "object" && !Array.isArray(data2)) {
              if (data2.id === void 0) {
                const err20 = { instancePath: instancePath + "/level", schemaPath: "#/properties/level/required", keyword: "required", params: { missingProperty: "id" }, message: "must have required property 'id'", schema: schema12.properties.level.required, parentSchema: schema12.properties.level, data: data2 };
                if (vErrors === null) {
                  vErrors = [err20];
                } else {
                  vErrors.push(err20);
                }
                errors++;
              }
              if (data2.name === void 0) {
                const err21 = { instancePath: instancePath + "/level", schemaPath: "#/properties/level/required", keyword: "required", params: { missingProperty: "name" }, message: "must have required property 'name'", schema: schema12.properties.level.required, parentSchema: schema12.properties.level, data: data2 };
                if (vErrors === null) {
                  vErrors = [err21];
                } else {
                  vErrors.push(err21);
                }
                errors++;
              }
              if (data2.type === void 0) {
                const err22 = { instancePath: instancePath + "/level", schemaPath: "#/properties/level/required", keyword: "required", params: { missingProperty: "type" }, message: "must have required property 'type'", schema: schema12.properties.level.required, parentSchema: schema12.properties.level, data: data2 };
                if (vErrors === null) {
                  vErrors = [err22];
                } else {
                  vErrors.push(err22);
                }
                errors++;
              }
              if (data2.documentId === void 0) {
                const err23 = { instancePath: instancePath + "/level", schemaPath: "#/properties/level/required", keyword: "required", params: { missingProperty: "documentId" }, message: "must have required property 'documentId'", schema: schema12.properties.level.required, parentSchema: schema12.properties.level, data: data2 };
                if (vErrors === null) {
                  vErrors = [err23];
                } else {
                  vErrors.push(err23);
                }
                errors++;
              }
              if (data2.documentName === void 0) {
                const err24 = { instancePath: instancePath + "/level", schemaPath: "#/properties/level/required", keyword: "required", params: { missingProperty: "documentName" }, message: "must have required property 'documentName'", schema: schema12.properties.level.required, parentSchema: schema12.properties.level, data: data2 };
                if (vErrors === null) {
                  vErrors = [err24];
                } else {
                  vErrors.push(err24);
                }
                errors++;
              }
              if (data2.documentPath === void 0) {
                const err25 = { instancePath: instancePath + "/level", schemaPath: "#/properties/level/required", keyword: "required", params: { missingProperty: "documentPath" }, message: "must have required property 'documentPath'", schema: schema12.properties.level.required, parentSchema: schema12.properties.level, data: data2 };
                if (vErrors === null) {
                  vErrors = [err25];
                } else {
                  vErrors.push(err25);
                }
                errors++;
              }
              if (data2.sessionId === void 0) {
                const err26 = { instancePath: instancePath + "/level", schemaPath: "#/properties/level/required", keyword: "required", params: { missingProperty: "sessionId" }, message: "must have required property 'sessionId'", schema: schema12.properties.level.required, parentSchema: schema12.properties.level, data: data2 };
                if (vErrors === null) {
                  vErrors = [err26];
                } else {
                  vErrors.push(err26);
                }
                errors++;
              }
              if (data2.revitVersion === void 0) {
                const err27 = { instancePath: instancePath + "/level", schemaPath: "#/properties/level/required", keyword: "required", params: { missingProperty: "revitVersion" }, message: "must have required property 'revitVersion'", schema: schema12.properties.level.required, parentSchema: schema12.properties.level, data: data2 };
                if (vErrors === null) {
                  vErrors = [err27];
                } else {
                  vErrors.push(err27);
                }
                errors++;
              }
              if (data2.lastUpdated === void 0) {
                const err28 = { instancePath: instancePath + "/level", schemaPath: "#/properties/level/required", keyword: "required", params: { missingProperty: "lastUpdated" }, message: "must have required property 'lastUpdated'", schema: schema12.properties.level.required, parentSchema: schema12.properties.level, data: data2 };
                if (vErrors === null) {
                  vErrors = [err28];
                } else {
                  vErrors.push(err28);
                }
                errors++;
              }
              for (const key1 in data2) {
                if (!func2.call(schema12.properties.level.properties, key1)) {
                  const err29 = { instancePath: instancePath + "/level", schemaPath: "#/properties/level/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key1 }, message: "must NOT have additional properties", schema: false, parentSchema: schema12.properties.level, data: data2 };
                  if (vErrors === null) {
                    vErrors = [err29];
                  } else {
                    vErrors.push(err29);
                  }
                  errors++;
                }
              }
              if (data2.id !== void 0) {
                let data3 = data2.id;
                if (typeof data3 === "string") {
                  if (func4(data3) < 1) {
                    const err30 = { instancePath: instancePath + "/level/id", schemaPath: "#/properties/level/properties/id/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters", schema: 1, parentSchema: schema12.properties.level.properties.id, data: data3 };
                    if (vErrors === null) {
                      vErrors = [err30];
                    } else {
                      vErrors.push(err30);
                    }
                    errors++;
                  }
                } else {
                  const err31 = { instancePath: instancePath + "/level/id", schemaPath: "#/properties/level/properties/id/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: schema12.properties.level.properties.id.type, parentSchema: schema12.properties.level.properties.id, data: data3 };
                  if (vErrors === null) {
                    vErrors = [err31];
                  } else {
                    vErrors.push(err31);
                  }
                  errors++;
                }
              }
              if (data2.name !== void 0) {
                let data4 = data2.name;
                if (typeof data4 === "string") {
                  if (func4(data4) < 1) {
                    const err32 = { instancePath: instancePath + "/level/name", schemaPath: "#/properties/level/properties/name/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters", schema: 1, parentSchema: schema12.properties.level.properties.name, data: data4 };
                    if (vErrors === null) {
                      vErrors = [err32];
                    } else {
                      vErrors.push(err32);
                    }
                    errors++;
                  }
                } else {
                  const err33 = { instancePath: instancePath + "/level/name", schemaPath: "#/properties/level/properties/name/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: schema12.properties.level.properties.name.type, parentSchema: schema12.properties.level.properties.name, data: data4 };
                  if (vErrors === null) {
                    vErrors = [err33];
                  } else {
                    vErrors.push(err33);
                  }
                  errors++;
                }
              }
              if (data2.type !== void 0) {
                let data5 = data2.type;
                if ("Level" !== data5) {
                  const err34 = { instancePath: instancePath + "/level/type", schemaPath: "#/properties/level/properties/type/const", keyword: "const", params: { allowedValue: "Level" }, message: "must be equal to constant", schema: "Level", parentSchema: schema12.properties.level.properties.type, data: data5 };
                  if (vErrors === null) {
                    vErrors = [err34];
                  } else {
                    vErrors.push(err34);
                  }
                  errors++;
                }
              }
              if (data2.documentId !== void 0) {
                let data6 = data2.documentId;
                if (typeof data6 === "string") {
                  if (func4(data6) < 1) {
                    const err35 = { instancePath: instancePath + "/level/documentId", schemaPath: "#/properties/level/properties/documentId/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters", schema: 1, parentSchema: schema12.properties.level.properties.documentId, data: data6 };
                    if (vErrors === null) {
                      vErrors = [err35];
                    } else {
                      vErrors.push(err35);
                    }
                    errors++;
                  }
                } else {
                  const err36 = { instancePath: instancePath + "/level/documentId", schemaPath: "#/properties/level/properties/documentId/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: schema12.properties.level.properties.documentId.type, parentSchema: schema12.properties.level.properties.documentId, data: data6 };
                  if (vErrors === null) {
                    vErrors = [err36];
                  } else {
                    vErrors.push(err36);
                  }
                  errors++;
                }
              }
              if (data2.documentName !== void 0) {
                let data7 = data2.documentName;
                if (typeof data7 !== "string") {
                  const err37 = { instancePath: instancePath + "/level/documentName", schemaPath: "#/properties/level/properties/documentName/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: schema12.properties.level.properties.documentName.type, parentSchema: schema12.properties.level.properties.documentName, data: data7 };
                  if (vErrors === null) {
                    vErrors = [err37];
                  } else {
                    vErrors.push(err37);
                  }
                  errors++;
                }
              }
              if (data2.documentPath !== void 0) {
                let data8 = data2.documentPath;
                if (typeof data8 !== "string") {
                  const err38 = { instancePath: instancePath + "/level/documentPath", schemaPath: "#/properties/level/properties/documentPath/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: schema12.properties.level.properties.documentPath.type, parentSchema: schema12.properties.level.properties.documentPath, data: data8 };
                  if (vErrors === null) {
                    vErrors = [err38];
                  } else {
                    vErrors.push(err38);
                  }
                  errors++;
                }
              }
              if (data2.sessionId !== void 0) {
                let data9 = data2.sessionId;
                if (typeof data9 === "string") {
                  if (func4(data9) < 1) {
                    const err39 = { instancePath: instancePath + "/level/sessionId", schemaPath: "#/properties/level/properties/sessionId/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters", schema: 1, parentSchema: schema12.properties.level.properties.sessionId, data: data9 };
                    if (vErrors === null) {
                      vErrors = [err39];
                    } else {
                      vErrors.push(err39);
                    }
                    errors++;
                  }
                } else {
                  const err40 = { instancePath: instancePath + "/level/sessionId", schemaPath: "#/properties/level/properties/sessionId/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: schema12.properties.level.properties.sessionId.type, parentSchema: schema12.properties.level.properties.sessionId, data: data9 };
                  if (vErrors === null) {
                    vErrors = [err40];
                  } else {
                    vErrors.push(err40);
                  }
                  errors++;
                }
              }
              if (data2.revitVersion !== void 0) {
                let data10 = data2.revitVersion;
                if (typeof data10 === "string") {
                  if (!pattern0.test(data10)) {
                    const err41 = { instancePath: instancePath + "/level/revitVersion", schemaPath: "#/properties/level/properties/revitVersion/pattern", keyword: "pattern", params: { pattern: "^[0-9]{4}$" }, message: 'must match pattern "^[0-9]{4}$"', schema: "^[0-9]{4}$", parentSchema: schema12.properties.level.properties.revitVersion, data: data10 };
                    if (vErrors === null) {
                      vErrors = [err41];
                    } else {
                      vErrors.push(err41);
                    }
                    errors++;
                  }
                } else {
                  const err42 = { instancePath: instancePath + "/level/revitVersion", schemaPath: "#/properties/level/properties/revitVersion/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: schema12.properties.level.properties.revitVersion.type, parentSchema: schema12.properties.level.properties.revitVersion, data: data10 };
                  if (vErrors === null) {
                    vErrors = [err42];
                  } else {
                    vErrors.push(err42);
                  }
                  errors++;
                }
              }
              if (data2.lastUpdated !== void 0) {
                let data11 = data2.lastUpdated;
                if (typeof data11 === "string") {
                  if (func4(data11) < 1) {
                    const err43 = { instancePath: instancePath + "/level/lastUpdated", schemaPath: "#/properties/level/properties/lastUpdated/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters", schema: 1, parentSchema: schema12.properties.level.properties.lastUpdated, data: data11 };
                    if (vErrors === null) {
                      vErrors = [err43];
                    } else {
                      vErrors.push(err43);
                    }
                    errors++;
                  }
                } else {
                  const err44 = { instancePath: instancePath + "/level/lastUpdated", schemaPath: "#/properties/level/properties/lastUpdated/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: schema12.properties.level.properties.lastUpdated.type, parentSchema: schema12.properties.level.properties.lastUpdated, data: data11 };
                  if (vErrors === null) {
                    vErrors = [err44];
                  } else {
                    vErrors.push(err44);
                  }
                  errors++;
                }
              }
            } else {
              const err45 = { instancePath: instancePath + "/level", schemaPath: "#/properties/level/type", keyword: "type", params: { type: "object" }, message: "must be object", schema: schema12.properties.level.type, parentSchema: schema12.properties.level, data: data2 };
              if (vErrors === null) {
                vErrors = [err45];
              } else {
                vErrors.push(err45);
              }
              errors++;
            }
          }
          if (data.pipeType !== void 0) {
            let data12 = data.pipeType;
            const _errs32 = errors;
            let valid3 = true;
            const _errs33 = errors;
            if (errors === _errs33) {
              if (data12 && typeof data12 == "object" && !Array.isArray(data12)) {
                let missing0;
                if (data12.agentChoice === void 0 && (missing0 = "agentChoice")) {
                  const err46 = {};
                  if (vErrors === null) {
                    vErrors = [err46];
                  } else {
                    vErrors.push(err46);
                  }
                  errors++;
                } else {
                  if (data12.agentChoice !== void 0) {
                    if (true !== data12.agentChoice) {
                      const err47 = {};
                      if (vErrors === null) {
                        vErrors = [err47];
                      } else {
                        vErrors.push(err47);
                      }
                      errors++;
                    }
                  }
                }
              } else {
                const err48 = {};
                if (vErrors === null) {
                  vErrors = [err48];
                } else {
                  vErrors.push(err48);
                }
                errors++;
              }
            }
            var _valid1 = _errs33 === errors;
            errors = _errs32;
            if (vErrors !== null) {
              if (_errs32) {
                vErrors.length = _errs32;
              } else {
                vErrors = null;
              }
            }
            let ifClause0;
            if (_valid1) {
              const _errs36 = errors;
              if (data12 && typeof data12 == "object" && !Array.isArray(data12)) {
                if (Object.keys(data12).length > 2) {
                  const err49 = { instancePath: instancePath + "/pipeType", schemaPath: "#/properties/pipeType/then/maxProperties", keyword: "maxProperties", params: { limit: 2 }, message: "must NOT have more than 2 properties", schema: 2, parentSchema: schema12.properties.pipeType.then, data: data12 };
                  if (vErrors === null) {
                    vErrors = [err49];
                  } else {
                    vErrors.push(err49);
                  }
                  errors++;
                }
              } else {
                const err50 = { instancePath: instancePath + "/pipeType", schemaPath: "#/properties/pipeType/then/type", keyword: "type", params: { type: "object" }, message: "must be object", schema: schema12.properties.pipeType.then.type, parentSchema: schema12.properties.pipeType.then, data: data12 };
                if (vErrors === null) {
                  vErrors = [err50];
                } else {
                  vErrors.push(err50);
                }
                errors++;
              }
              var _valid1 = _errs36 === errors;
              valid3 = _valid1;
              ifClause0 = "then";
            } else {
              const _errs38 = errors;
              if (data12 && typeof data12 == "object" && !Array.isArray(data12)) {
                if (data12.id === void 0) {
                  const err51 = { instancePath: instancePath + "/pipeType", schemaPath: "#/properties/pipeType/else/required", keyword: "required", params: { missingProperty: "id" }, message: "must have required property 'id'", schema: schema12.properties.pipeType.else.required, parentSchema: schema12.properties.pipeType.else, data: data12 };
                  if (vErrors === null) {
                    vErrors = [err51];
                  } else {
                    vErrors.push(err51);
                  }
                  errors++;
                }
                if (data12.name === void 0) {
                  const err52 = { instancePath: instancePath + "/pipeType", schemaPath: "#/properties/pipeType/else/required", keyword: "required", params: { missingProperty: "name" }, message: "must have required property 'name'", schema: schema12.properties.pipeType.else.required, parentSchema: schema12.properties.pipeType.else, data: data12 };
                  if (vErrors === null) {
                    vErrors = [err52];
                  } else {
                    vErrors.push(err52);
                  }
                  errors++;
                }
                if (data12.documentId === void 0) {
                  const err53 = { instancePath: instancePath + "/pipeType", schemaPath: "#/properties/pipeType/else/required", keyword: "required", params: { missingProperty: "documentId" }, message: "must have required property 'documentId'", schema: schema12.properties.pipeType.else.required, parentSchema: schema12.properties.pipeType.else, data: data12 };
                  if (vErrors === null) {
                    vErrors = [err53];
                  } else {
                    vErrors.push(err53);
                  }
                  errors++;
                }
                if (data12.documentName === void 0) {
                  const err54 = { instancePath: instancePath + "/pipeType", schemaPath: "#/properties/pipeType/else/required", keyword: "required", params: { missingProperty: "documentName" }, message: "must have required property 'documentName'", schema: schema12.properties.pipeType.else.required, parentSchema: schema12.properties.pipeType.else, data: data12 };
                  if (vErrors === null) {
                    vErrors = [err54];
                  } else {
                    vErrors.push(err54);
                  }
                  errors++;
                }
                if (data12.documentPath === void 0) {
                  const err55 = { instancePath: instancePath + "/pipeType", schemaPath: "#/properties/pipeType/else/required", keyword: "required", params: { missingProperty: "documentPath" }, message: "must have required property 'documentPath'", schema: schema12.properties.pipeType.else.required, parentSchema: schema12.properties.pipeType.else, data: data12 };
                  if (vErrors === null) {
                    vErrors = [err55];
                  } else {
                    vErrors.push(err55);
                  }
                  errors++;
                }
                if (data12.sessionId === void 0) {
                  const err56 = { instancePath: instancePath + "/pipeType", schemaPath: "#/properties/pipeType/else/required", keyword: "required", params: { missingProperty: "sessionId" }, message: "must have required property 'sessionId'", schema: schema12.properties.pipeType.else.required, parentSchema: schema12.properties.pipeType.else, data: data12 };
                  if (vErrors === null) {
                    vErrors = [err56];
                  } else {
                    vErrors.push(err56);
                  }
                  errors++;
                }
                if (data12.revitVersion === void 0) {
                  const err57 = { instancePath: instancePath + "/pipeType", schemaPath: "#/properties/pipeType/else/required", keyword: "required", params: { missingProperty: "revitVersion" }, message: "must have required property 'revitVersion'", schema: schema12.properties.pipeType.else.required, parentSchema: schema12.properties.pipeType.else, data: data12 };
                  if (vErrors === null) {
                    vErrors = [err57];
                  } else {
                    vErrors.push(err57);
                  }
                  errors++;
                }
                if (data12.lastUpdated === void 0) {
                  const err58 = { instancePath: instancePath + "/pipeType", schemaPath: "#/properties/pipeType/else/required", keyword: "required", params: { missingProperty: "lastUpdated" }, message: "must have required property 'lastUpdated'", schema: schema12.properties.pipeType.else.required, parentSchema: schema12.properties.pipeType.else, data: data12 };
                  if (vErrors === null) {
                    vErrors = [err58];
                  } else {
                    vErrors.push(err58);
                  }
                  errors++;
                }
              } else {
                const err59 = { instancePath: instancePath + "/pipeType", schemaPath: "#/properties/pipeType/else/type", keyword: "type", params: { type: "object" }, message: "must be object", schema: schema12.properties.pipeType.else.type, parentSchema: schema12.properties.pipeType.else, data: data12 };
                if (vErrors === null) {
                  vErrors = [err59];
                } else {
                  vErrors.push(err59);
                }
                errors++;
              }
              var _valid1 = _errs38 === errors;
              valid3 = _valid1;
              ifClause0 = "else";
            }
            if (!valid3) {
              const err60 = { instancePath: instancePath + "/pipeType", schemaPath: "#/properties/pipeType/if", keyword: "if", params: { failingKeyword: ifClause0 }, message: 'must match "' + ifClause0 + '" schema', schema: schema12.properties.pipeType.if, parentSchema: schema12.properties.pipeType, data: data12 };
              if (vErrors === null) {
                vErrors = [err60];
              } else {
                vErrors.push(err60);
              }
              errors++;
            }
            if (data12 && typeof data12 == "object" && !Array.isArray(data12)) {
              if (data12.type === void 0) {
                const err61 = { instancePath: instancePath + "/pipeType", schemaPath: "#/properties/pipeType/required", keyword: "required", params: { missingProperty: "type" }, message: "must have required property 'type'", schema: schema12.properties.pipeType.required, parentSchema: schema12.properties.pipeType, data: data12 };
                if (vErrors === null) {
                  vErrors = [err61];
                } else {
                  vErrors.push(err61);
                }
                errors++;
              }
              for (const key2 in data12) {
                if (!func2.call(schema12.properties.pipeType.properties, key2)) {
                  const err62 = { instancePath: instancePath + "/pipeType", schemaPath: "#/properties/pipeType/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key2 }, message: "must NOT have additional properties", schema: false, parentSchema: schema12.properties.pipeType, data: data12 };
                  if (vErrors === null) {
                    vErrors = [err62];
                  } else {
                    vErrors.push(err62);
                  }
                  errors++;
                }
              }
              if (data12.agentChoice !== void 0) {
                let data14 = data12.agentChoice;
                if (typeof data14 !== "boolean") {
                  const err63 = { instancePath: instancePath + "/pipeType/agentChoice", schemaPath: "#/properties/pipeType/properties/agentChoice/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean", schema: schema12.properties.pipeType.properties.agentChoice.type, parentSchema: schema12.properties.pipeType.properties.agentChoice, data: data14 };
                  if (vErrors === null) {
                    vErrors = [err63];
                  } else {
                    vErrors.push(err63);
                  }
                  errors++;
                }
              }
              if (data12.id !== void 0) {
                let data15 = data12.id;
                if (typeof data15 === "string") {
                  if (func4(data15) < 1) {
                    const err64 = { instancePath: instancePath + "/pipeType/id", schemaPath: "#/properties/pipeType/properties/id/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters", schema: 1, parentSchema: schema12.properties.pipeType.properties.id, data: data15 };
                    if (vErrors === null) {
                      vErrors = [err64];
                    } else {
                      vErrors.push(err64);
                    }
                    errors++;
                  }
                } else {
                  const err65 = { instancePath: instancePath + "/pipeType/id", schemaPath: "#/properties/pipeType/properties/id/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: schema12.properties.pipeType.properties.id.type, parentSchema: schema12.properties.pipeType.properties.id, data: data15 };
                  if (vErrors === null) {
                    vErrors = [err65];
                  } else {
                    vErrors.push(err65);
                  }
                  errors++;
                }
              }
              if (data12.name !== void 0) {
                let data16 = data12.name;
                if (typeof data16 === "string") {
                  if (func4(data16) < 1) {
                    const err66 = { instancePath: instancePath + "/pipeType/name", schemaPath: "#/properties/pipeType/properties/name/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters", schema: 1, parentSchema: schema12.properties.pipeType.properties.name, data: data16 };
                    if (vErrors === null) {
                      vErrors = [err66];
                    } else {
                      vErrors.push(err66);
                    }
                    errors++;
                  }
                } else {
                  const err67 = { instancePath: instancePath + "/pipeType/name", schemaPath: "#/properties/pipeType/properties/name/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: schema12.properties.pipeType.properties.name.type, parentSchema: schema12.properties.pipeType.properties.name, data: data16 };
                  if (vErrors === null) {
                    vErrors = [err67];
                  } else {
                    vErrors.push(err67);
                  }
                  errors++;
                }
              }
              if (data12.type !== void 0) {
                let data17 = data12.type;
                if ("PipeType" !== data17) {
                  const err68 = { instancePath: instancePath + "/pipeType/type", schemaPath: "#/properties/pipeType/properties/type/const", keyword: "const", params: { allowedValue: "PipeType" }, message: "must be equal to constant", schema: "PipeType", parentSchema: schema12.properties.pipeType.properties.type, data: data17 };
                  if (vErrors === null) {
                    vErrors = [err68];
                  } else {
                    vErrors.push(err68);
                  }
                  errors++;
                }
              }
              if (data12.documentId !== void 0) {
                let data18 = data12.documentId;
                if (typeof data18 === "string") {
                  if (func4(data18) < 1) {
                    const err69 = { instancePath: instancePath + "/pipeType/documentId", schemaPath: "#/properties/pipeType/properties/documentId/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters", schema: 1, parentSchema: schema12.properties.pipeType.properties.documentId, data: data18 };
                    if (vErrors === null) {
                      vErrors = [err69];
                    } else {
                      vErrors.push(err69);
                    }
                    errors++;
                  }
                } else {
                  const err70 = { instancePath: instancePath + "/pipeType/documentId", schemaPath: "#/properties/pipeType/properties/documentId/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: schema12.properties.pipeType.properties.documentId.type, parentSchema: schema12.properties.pipeType.properties.documentId, data: data18 };
                  if (vErrors === null) {
                    vErrors = [err70];
                  } else {
                    vErrors.push(err70);
                  }
                  errors++;
                }
              }
              if (data12.documentName !== void 0) {
                let data19 = data12.documentName;
                if (typeof data19 !== "string") {
                  const err71 = { instancePath: instancePath + "/pipeType/documentName", schemaPath: "#/properties/pipeType/properties/documentName/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: schema12.properties.pipeType.properties.documentName.type, parentSchema: schema12.properties.pipeType.properties.documentName, data: data19 };
                  if (vErrors === null) {
                    vErrors = [err71];
                  } else {
                    vErrors.push(err71);
                  }
                  errors++;
                }
              }
              if (data12.documentPath !== void 0) {
                let data20 = data12.documentPath;
                if (typeof data20 !== "string") {
                  const err72 = { instancePath: instancePath + "/pipeType/documentPath", schemaPath: "#/properties/pipeType/properties/documentPath/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: schema12.properties.pipeType.properties.documentPath.type, parentSchema: schema12.properties.pipeType.properties.documentPath, data: data20 };
                  if (vErrors === null) {
                    vErrors = [err72];
                  } else {
                    vErrors.push(err72);
                  }
                  errors++;
                }
              }
              if (data12.sessionId !== void 0) {
                let data21 = data12.sessionId;
                if (typeof data21 === "string") {
                  if (func4(data21) < 1) {
                    const err73 = { instancePath: instancePath + "/pipeType/sessionId", schemaPath: "#/properties/pipeType/properties/sessionId/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters", schema: 1, parentSchema: schema12.properties.pipeType.properties.sessionId, data: data21 };
                    if (vErrors === null) {
                      vErrors = [err73];
                    } else {
                      vErrors.push(err73);
                    }
                    errors++;
                  }
                } else {
                  const err74 = { instancePath: instancePath + "/pipeType/sessionId", schemaPath: "#/properties/pipeType/properties/sessionId/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: schema12.properties.pipeType.properties.sessionId.type, parentSchema: schema12.properties.pipeType.properties.sessionId, data: data21 };
                  if (vErrors === null) {
                    vErrors = [err74];
                  } else {
                    vErrors.push(err74);
                  }
                  errors++;
                }
              }
              if (data12.revitVersion !== void 0) {
                let data22 = data12.revitVersion;
                if (typeof data22 === "string") {
                  if (!pattern0.test(data22)) {
                    const err75 = { instancePath: instancePath + "/pipeType/revitVersion", schemaPath: "#/properties/pipeType/properties/revitVersion/pattern", keyword: "pattern", params: { pattern: "^[0-9]{4}$" }, message: 'must match pattern "^[0-9]{4}$"', schema: "^[0-9]{4}$", parentSchema: schema12.properties.pipeType.properties.revitVersion, data: data22 };
                    if (vErrors === null) {
                      vErrors = [err75];
                    } else {
                      vErrors.push(err75);
                    }
                    errors++;
                  }
                } else {
                  const err76 = { instancePath: instancePath + "/pipeType/revitVersion", schemaPath: "#/properties/pipeType/properties/revitVersion/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: schema12.properties.pipeType.properties.revitVersion.type, parentSchema: schema12.properties.pipeType.properties.revitVersion, data: data22 };
                  if (vErrors === null) {
                    vErrors = [err76];
                  } else {
                    vErrors.push(err76);
                  }
                  errors++;
                }
              }
              if (data12.lastUpdated !== void 0) {
                let data23 = data12.lastUpdated;
                if (typeof data23 === "string") {
                  if (func4(data23) < 1) {
                    const err77 = { instancePath: instancePath + "/pipeType/lastUpdated", schemaPath: "#/properties/pipeType/properties/lastUpdated/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters", schema: 1, parentSchema: schema12.properties.pipeType.properties.lastUpdated, data: data23 };
                    if (vErrors === null) {
                      vErrors = [err77];
                    } else {
                      vErrors.push(err77);
                    }
                    errors++;
                  }
                } else {
                  const err78 = { instancePath: instancePath + "/pipeType/lastUpdated", schemaPath: "#/properties/pipeType/properties/lastUpdated/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: schema12.properties.pipeType.properties.lastUpdated.type, parentSchema: schema12.properties.pipeType.properties.lastUpdated, data: data23 };
                  if (vErrors === null) {
                    vErrors = [err78];
                  } else {
                    vErrors.push(err78);
                  }
                  errors++;
                }
              }
            } else {
              const err79 = { instancePath: instancePath + "/pipeType", schemaPath: "#/properties/pipeType/type", keyword: "type", params: { type: "object" }, message: "must be object", schema: schema12.properties.pipeType.type, parentSchema: schema12.properties.pipeType, data: data12 };
              if (vErrors === null) {
                vErrors = [err79];
              } else {
                vErrors.push(err79);
              }
              errors++;
            }
          }
          if (data.systemType !== void 0) {
            let data24 = data.systemType;
            const _errs62 = errors;
            let valid6 = true;
            const _errs63 = errors;
            if (errors === _errs63) {
              if (data24 && typeof data24 == "object" && !Array.isArray(data24)) {
                let missing1;
                if (data24.agentChoice === void 0 && (missing1 = "agentChoice")) {
                  const err80 = {};
                  if (vErrors === null) {
                    vErrors = [err80];
                  } else {
                    vErrors.push(err80);
                  }
                  errors++;
                } else {
                  if (data24.agentChoice !== void 0) {
                    if (true !== data24.agentChoice) {
                      const err81 = {};
                      if (vErrors === null) {
                        vErrors = [err81];
                      } else {
                        vErrors.push(err81);
                      }
                      errors++;
                    }
                  }
                }
              } else {
                const err82 = {};
                if (vErrors === null) {
                  vErrors = [err82];
                } else {
                  vErrors.push(err82);
                }
                errors++;
              }
            }
            var _valid2 = _errs63 === errors;
            errors = _errs62;
            if (vErrors !== null) {
              if (_errs62) {
                vErrors.length = _errs62;
              } else {
                vErrors = null;
              }
            }
            let ifClause1;
            if (_valid2) {
              const _errs66 = errors;
              if (data24 && typeof data24 == "object" && !Array.isArray(data24)) {
                if (Object.keys(data24).length > 2) {
                  const err83 = { instancePath: instancePath + "/systemType", schemaPath: "#/properties/systemType/then/maxProperties", keyword: "maxProperties", params: { limit: 2 }, message: "must NOT have more than 2 properties", schema: 2, parentSchema: schema12.properties.systemType.then, data: data24 };
                  if (vErrors === null) {
                    vErrors = [err83];
                  } else {
                    vErrors.push(err83);
                  }
                  errors++;
                }
              } else {
                const err84 = { instancePath: instancePath + "/systemType", schemaPath: "#/properties/systemType/then/type", keyword: "type", params: { type: "object" }, message: "must be object", schema: schema12.properties.systemType.then.type, parentSchema: schema12.properties.systemType.then, data: data24 };
                if (vErrors === null) {
                  vErrors = [err84];
                } else {
                  vErrors.push(err84);
                }
                errors++;
              }
              var _valid2 = _errs66 === errors;
              valid6 = _valid2;
              ifClause1 = "then";
            } else {
              const _errs68 = errors;
              if (data24 && typeof data24 == "object" && !Array.isArray(data24)) {
                if (data24.id === void 0) {
                  const err85 = { instancePath: instancePath + "/systemType", schemaPath: "#/properties/systemType/else/required", keyword: "required", params: { missingProperty: "id" }, message: "must have required property 'id'", schema: schema12.properties.systemType.else.required, parentSchema: schema12.properties.systemType.else, data: data24 };
                  if (vErrors === null) {
                    vErrors = [err85];
                  } else {
                    vErrors.push(err85);
                  }
                  errors++;
                }
                if (data24.name === void 0) {
                  const err86 = { instancePath: instancePath + "/systemType", schemaPath: "#/properties/systemType/else/required", keyword: "required", params: { missingProperty: "name" }, message: "must have required property 'name'", schema: schema12.properties.systemType.else.required, parentSchema: schema12.properties.systemType.else, data: data24 };
                  if (vErrors === null) {
                    vErrors = [err86];
                  } else {
                    vErrors.push(err86);
                  }
                  errors++;
                }
                if (data24.documentId === void 0) {
                  const err87 = { instancePath: instancePath + "/systemType", schemaPath: "#/properties/systemType/else/required", keyword: "required", params: { missingProperty: "documentId" }, message: "must have required property 'documentId'", schema: schema12.properties.systemType.else.required, parentSchema: schema12.properties.systemType.else, data: data24 };
                  if (vErrors === null) {
                    vErrors = [err87];
                  } else {
                    vErrors.push(err87);
                  }
                  errors++;
                }
                if (data24.documentName === void 0) {
                  const err88 = { instancePath: instancePath + "/systemType", schemaPath: "#/properties/systemType/else/required", keyword: "required", params: { missingProperty: "documentName" }, message: "must have required property 'documentName'", schema: schema12.properties.systemType.else.required, parentSchema: schema12.properties.systemType.else, data: data24 };
                  if (vErrors === null) {
                    vErrors = [err88];
                  } else {
                    vErrors.push(err88);
                  }
                  errors++;
                }
                if (data24.documentPath === void 0) {
                  const err89 = { instancePath: instancePath + "/systemType", schemaPath: "#/properties/systemType/else/required", keyword: "required", params: { missingProperty: "documentPath" }, message: "must have required property 'documentPath'", schema: schema12.properties.systemType.else.required, parentSchema: schema12.properties.systemType.else, data: data24 };
                  if (vErrors === null) {
                    vErrors = [err89];
                  } else {
                    vErrors.push(err89);
                  }
                  errors++;
                }
                if (data24.sessionId === void 0) {
                  const err90 = { instancePath: instancePath + "/systemType", schemaPath: "#/properties/systemType/else/required", keyword: "required", params: { missingProperty: "sessionId" }, message: "must have required property 'sessionId'", schema: schema12.properties.systemType.else.required, parentSchema: schema12.properties.systemType.else, data: data24 };
                  if (vErrors === null) {
                    vErrors = [err90];
                  } else {
                    vErrors.push(err90);
                  }
                  errors++;
                }
                if (data24.revitVersion === void 0) {
                  const err91 = { instancePath: instancePath + "/systemType", schemaPath: "#/properties/systemType/else/required", keyword: "required", params: { missingProperty: "revitVersion" }, message: "must have required property 'revitVersion'", schema: schema12.properties.systemType.else.required, parentSchema: schema12.properties.systemType.else, data: data24 };
                  if (vErrors === null) {
                    vErrors = [err91];
                  } else {
                    vErrors.push(err91);
                  }
                  errors++;
                }
                if (data24.lastUpdated === void 0) {
                  const err92 = { instancePath: instancePath + "/systemType", schemaPath: "#/properties/systemType/else/required", keyword: "required", params: { missingProperty: "lastUpdated" }, message: "must have required property 'lastUpdated'", schema: schema12.properties.systemType.else.required, parentSchema: schema12.properties.systemType.else, data: data24 };
                  if (vErrors === null) {
                    vErrors = [err92];
                  } else {
                    vErrors.push(err92);
                  }
                  errors++;
                }
              } else {
                const err93 = { instancePath: instancePath + "/systemType", schemaPath: "#/properties/systemType/else/type", keyword: "type", params: { type: "object" }, message: "must be object", schema: schema12.properties.systemType.else.type, parentSchema: schema12.properties.systemType.else, data: data24 };
                if (vErrors === null) {
                  vErrors = [err93];
                } else {
                  vErrors.push(err93);
                }
                errors++;
              }
              var _valid2 = _errs68 === errors;
              valid6 = _valid2;
              ifClause1 = "else";
            }
            if (!valid6) {
              const err94 = { instancePath: instancePath + "/systemType", schemaPath: "#/properties/systemType/if", keyword: "if", params: { failingKeyword: ifClause1 }, message: 'must match "' + ifClause1 + '" schema', schema: schema12.properties.systemType.if, parentSchema: schema12.properties.systemType, data: data24 };
              if (vErrors === null) {
                vErrors = [err94];
              } else {
                vErrors.push(err94);
              }
              errors++;
            }
            if (data24 && typeof data24 == "object" && !Array.isArray(data24)) {
              if (data24.type === void 0) {
                const err95 = { instancePath: instancePath + "/systemType", schemaPath: "#/properties/systemType/required", keyword: "required", params: { missingProperty: "type" }, message: "must have required property 'type'", schema: schema12.properties.systemType.required, parentSchema: schema12.properties.systemType, data: data24 };
                if (vErrors === null) {
                  vErrors = [err95];
                } else {
                  vErrors.push(err95);
                }
                errors++;
              }
              for (const key3 in data24) {
                if (!func2.call(schema12.properties.systemType.properties, key3)) {
                  const err96 = { instancePath: instancePath + "/systemType", schemaPath: "#/properties/systemType/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key3 }, message: "must NOT have additional properties", schema: false, parentSchema: schema12.properties.systemType, data: data24 };
                  if (vErrors === null) {
                    vErrors = [err96];
                  } else {
                    vErrors.push(err96);
                  }
                  errors++;
                }
              }
              if (data24.agentChoice !== void 0) {
                let data26 = data24.agentChoice;
                if (typeof data26 !== "boolean") {
                  const err97 = { instancePath: instancePath + "/systemType/agentChoice", schemaPath: "#/properties/systemType/properties/agentChoice/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean", schema: schema12.properties.systemType.properties.agentChoice.type, parentSchema: schema12.properties.systemType.properties.agentChoice, data: data26 };
                  if (vErrors === null) {
                    vErrors = [err97];
                  } else {
                    vErrors.push(err97);
                  }
                  errors++;
                }
              }
              if (data24.id !== void 0) {
                let data27 = data24.id;
                if (typeof data27 === "string") {
                  if (func4(data27) < 1) {
                    const err98 = { instancePath: instancePath + "/systemType/id", schemaPath: "#/properties/systemType/properties/id/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters", schema: 1, parentSchema: schema12.properties.systemType.properties.id, data: data27 };
                    if (vErrors === null) {
                      vErrors = [err98];
                    } else {
                      vErrors.push(err98);
                    }
                    errors++;
                  }
                } else {
                  const err99 = { instancePath: instancePath + "/systemType/id", schemaPath: "#/properties/systemType/properties/id/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: schema12.properties.systemType.properties.id.type, parentSchema: schema12.properties.systemType.properties.id, data: data27 };
                  if (vErrors === null) {
                    vErrors = [err99];
                  } else {
                    vErrors.push(err99);
                  }
                  errors++;
                }
              }
              if (data24.name !== void 0) {
                let data28 = data24.name;
                if (typeof data28 === "string") {
                  if (func4(data28) < 1) {
                    const err100 = { instancePath: instancePath + "/systemType/name", schemaPath: "#/properties/systemType/properties/name/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters", schema: 1, parentSchema: schema12.properties.systemType.properties.name, data: data28 };
                    if (vErrors === null) {
                      vErrors = [err100];
                    } else {
                      vErrors.push(err100);
                    }
                    errors++;
                  }
                } else {
                  const err101 = { instancePath: instancePath + "/systemType/name", schemaPath: "#/properties/systemType/properties/name/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: schema12.properties.systemType.properties.name.type, parentSchema: schema12.properties.systemType.properties.name, data: data28 };
                  if (vErrors === null) {
                    vErrors = [err101];
                  } else {
                    vErrors.push(err101);
                  }
                  errors++;
                }
              }
              if (data24.type !== void 0) {
                let data29 = data24.type;
                if ("MEPSystemType" !== data29) {
                  const err102 = { instancePath: instancePath + "/systemType/type", schemaPath: "#/properties/systemType/properties/type/const", keyword: "const", params: { allowedValue: "MEPSystemType" }, message: "must be equal to constant", schema: "MEPSystemType", parentSchema: schema12.properties.systemType.properties.type, data: data29 };
                  if (vErrors === null) {
                    vErrors = [err102];
                  } else {
                    vErrors.push(err102);
                  }
                  errors++;
                }
              }
              if (data24.documentId !== void 0) {
                let data30 = data24.documentId;
                if (typeof data30 === "string") {
                  if (func4(data30) < 1) {
                    const err103 = { instancePath: instancePath + "/systemType/documentId", schemaPath: "#/properties/systemType/properties/documentId/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters", schema: 1, parentSchema: schema12.properties.systemType.properties.documentId, data: data30 };
                    if (vErrors === null) {
                      vErrors = [err103];
                    } else {
                      vErrors.push(err103);
                    }
                    errors++;
                  }
                } else {
                  const err104 = { instancePath: instancePath + "/systemType/documentId", schemaPath: "#/properties/systemType/properties/documentId/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: schema12.properties.systemType.properties.documentId.type, parentSchema: schema12.properties.systemType.properties.documentId, data: data30 };
                  if (vErrors === null) {
                    vErrors = [err104];
                  } else {
                    vErrors.push(err104);
                  }
                  errors++;
                }
              }
              if (data24.documentName !== void 0) {
                let data31 = data24.documentName;
                if (typeof data31 !== "string") {
                  const err105 = { instancePath: instancePath + "/systemType/documentName", schemaPath: "#/properties/systemType/properties/documentName/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: schema12.properties.systemType.properties.documentName.type, parentSchema: schema12.properties.systemType.properties.documentName, data: data31 };
                  if (vErrors === null) {
                    vErrors = [err105];
                  } else {
                    vErrors.push(err105);
                  }
                  errors++;
                }
              }
              if (data24.documentPath !== void 0) {
                let data32 = data24.documentPath;
                if (typeof data32 !== "string") {
                  const err106 = { instancePath: instancePath + "/systemType/documentPath", schemaPath: "#/properties/systemType/properties/documentPath/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: schema12.properties.systemType.properties.documentPath.type, parentSchema: schema12.properties.systemType.properties.documentPath, data: data32 };
                  if (vErrors === null) {
                    vErrors = [err106];
                  } else {
                    vErrors.push(err106);
                  }
                  errors++;
                }
              }
              if (data24.sessionId !== void 0) {
                let data33 = data24.sessionId;
                if (typeof data33 === "string") {
                  if (func4(data33) < 1) {
                    const err107 = { instancePath: instancePath + "/systemType/sessionId", schemaPath: "#/properties/systemType/properties/sessionId/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters", schema: 1, parentSchema: schema12.properties.systemType.properties.sessionId, data: data33 };
                    if (vErrors === null) {
                      vErrors = [err107];
                    } else {
                      vErrors.push(err107);
                    }
                    errors++;
                  }
                } else {
                  const err108 = { instancePath: instancePath + "/systemType/sessionId", schemaPath: "#/properties/systemType/properties/sessionId/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: schema12.properties.systemType.properties.sessionId.type, parentSchema: schema12.properties.systemType.properties.sessionId, data: data33 };
                  if (vErrors === null) {
                    vErrors = [err108];
                  } else {
                    vErrors.push(err108);
                  }
                  errors++;
                }
              }
              if (data24.revitVersion !== void 0) {
                let data34 = data24.revitVersion;
                if (typeof data34 === "string") {
                  if (!pattern0.test(data34)) {
                    const err109 = { instancePath: instancePath + "/systemType/revitVersion", schemaPath: "#/properties/systemType/properties/revitVersion/pattern", keyword: "pattern", params: { pattern: "^[0-9]{4}$" }, message: 'must match pattern "^[0-9]{4}$"', schema: "^[0-9]{4}$", parentSchema: schema12.properties.systemType.properties.revitVersion, data: data34 };
                    if (vErrors === null) {
                      vErrors = [err109];
                    } else {
                      vErrors.push(err109);
                    }
                    errors++;
                  }
                } else {
                  const err110 = { instancePath: instancePath + "/systemType/revitVersion", schemaPath: "#/properties/systemType/properties/revitVersion/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: schema12.properties.systemType.properties.revitVersion.type, parentSchema: schema12.properties.systemType.properties.revitVersion, data: data34 };
                  if (vErrors === null) {
                    vErrors = [err110];
                  } else {
                    vErrors.push(err110);
                  }
                  errors++;
                }
              }
              if (data24.lastUpdated !== void 0) {
                let data35 = data24.lastUpdated;
                if (typeof data35 === "string") {
                  if (func4(data35) < 1) {
                    const err111 = { instancePath: instancePath + "/systemType/lastUpdated", schemaPath: "#/properties/systemType/properties/lastUpdated/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters", schema: 1, parentSchema: schema12.properties.systemType.properties.lastUpdated, data: data35 };
                    if (vErrors === null) {
                      vErrors = [err111];
                    } else {
                      vErrors.push(err111);
                    }
                    errors++;
                  }
                } else {
                  const err112 = { instancePath: instancePath + "/systemType/lastUpdated", schemaPath: "#/properties/systemType/properties/lastUpdated/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: schema12.properties.systemType.properties.lastUpdated.type, parentSchema: schema12.properties.systemType.properties.lastUpdated, data: data35 };
                  if (vErrors === null) {
                    vErrors = [err112];
                  } else {
                    vErrors.push(err112);
                  }
                  errors++;
                }
              }
            } else {
              const err113 = { instancePath: instancePath + "/systemType", schemaPath: "#/properties/systemType/type", keyword: "type", params: { type: "object" }, message: "must be object", schema: schema12.properties.systemType.type, parentSchema: schema12.properties.systemType, data: data24 };
              if (vErrors === null) {
                vErrors = [err113];
              } else {
                vErrors.push(err113);
              }
              errors++;
            }
          }
          if (data.pipeHeightCm !== void 0) {
            let data36 = data.pipeHeightCm;
            if (typeof data36 == "number" && isFinite(data36)) {
              if (data36 < 0 || isNaN(data36)) {
                const err114 = { instancePath: instancePath + "/pipeHeightCm", schemaPath: "#/properties/pipeHeightCm/minimum", keyword: "minimum", params: { comparison: ">=", limit: 0 }, message: "must be >= 0", schema: 0, parentSchema: schema12.properties.pipeHeightCm, data: data36 };
                if (vErrors === null) {
                  vErrors = [err114];
                } else {
                  vErrors.push(err114);
                }
                errors++;
              }
            } else {
              const err115 = { instancePath: instancePath + "/pipeHeightCm", schemaPath: "#/properties/pipeHeightCm/type", keyword: "type", params: { type: "number" }, message: "must be number", schema: schema12.properties.pipeHeightCm.type, parentSchema: schema12.properties.pipeHeightCm, data: data36 };
              if (vErrors === null) {
                vErrors = [err115];
              } else {
                vErrors.push(err115);
              }
              errors++;
            }
          }
          if (data.sprinklerHeightCm !== void 0) {
            let data37 = data.sprinklerHeightCm;
            if (typeof data37 == "number" && isFinite(data37)) {
              if (data37 < 0 || isNaN(data37)) {
                const err116 = { instancePath: instancePath + "/sprinklerHeightCm", schemaPath: "#/properties/sprinklerHeightCm/minimum", keyword: "minimum", params: { comparison: ">=", limit: 0 }, message: "must be >= 0", schema: 0, parentSchema: schema12.properties.sprinklerHeightCm, data: data37 };
                if (vErrors === null) {
                  vErrors = [err116];
                } else {
                  vErrors.push(err116);
                }
                errors++;
              }
            } else {
              const err117 = { instancePath: instancePath + "/sprinklerHeightCm", schemaPath: "#/properties/sprinklerHeightCm/type", keyword: "type", params: { type: "number" }, message: "must be number", schema: schema12.properties.sprinklerHeightCm.type, parentSchema: schema12.properties.sprinklerHeightCm, data: data37 };
              if (vErrors === null) {
                vErrors = [err117];
              } else {
                vErrors.push(err117);
              }
              errors++;
            }
          }
          if (data.crossingOffsetCm !== void 0) {
            let data38 = data.crossingOffsetCm;
            if (typeof data38 == "number" && isFinite(data38)) {
              if (data38 <= 0 || isNaN(data38)) {
                const err118 = { instancePath: instancePath + "/crossingOffsetCm", schemaPath: "#/properties/crossingOffsetCm/exclusiveMinimum", keyword: "exclusiveMinimum", params: { comparison: ">", limit: 0 }, message: "must be > 0", schema: 0, parentSchema: schema12.properties.crossingOffsetCm, data: data38 };
                if (vErrors === null) {
                  vErrors = [err118];
                } else {
                  vErrors.push(err118);
                }
                errors++;
              }
            } else {
              const err119 = { instancePath: instancePath + "/crossingOffsetCm", schemaPath: "#/properties/crossingOffsetCm/type", keyword: "type", params: { type: "number" }, message: "must be number", schema: schema12.properties.crossingOffsetCm.type, parentSchema: schema12.properties.crossingOffsetCm, data: data38 };
              if (vErrors === null) {
                vErrors = [err119];
              } else {
                vErrors.push(err119);
              }
              errors++;
            }
          }
          if (data.executionMode !== void 0) {
            let data39 = data.executionMode;
            if (typeof data39 !== "string") {
              const err120 = { instancePath: instancePath + "/executionMode", schemaPath: "#/properties/executionMode/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: schema12.properties.executionMode.type, parentSchema: schema12.properties.executionMode, data: data39 };
              if (vErrors === null) {
                vErrors = [err120];
              } else {
                vErrors.push(err120);
              }
              errors++;
            }
            const _errs98 = errors;
            let valid9 = false;
            let passing1 = null;
            const _errs99 = errors;
            if ("complete" !== data39) {
              const err121 = { instancePath: instancePath + "/executionMode", schemaPath: "#/properties/executionMode/oneOf/0/const", keyword: "const", params: { allowedValue: "complete" }, message: "must be equal to constant", schema: "complete", parentSchema: schema12.properties.executionMode.oneOf[0], data: data39 };
              if (vErrors === null) {
                vErrors = [err121];
              } else {
                vErrors.push(err121);
              }
              errors++;
            }
            var _valid3 = _errs99 === errors;
            if (_valid3) {
              valid9 = true;
              passing1 = 0;
            }
            const _errs100 = errors;
            if ("investigate" !== data39) {
              const err122 = { instancePath: instancePath + "/executionMode", schemaPath: "#/properties/executionMode/oneOf/1/const", keyword: "const", params: { allowedValue: "investigate" }, message: "must be equal to constant", schema: "investigate", parentSchema: schema12.properties.executionMode.oneOf[1], data: data39 };
              if (vErrors === null) {
                vErrors = [err122];
              } else {
                vErrors.push(err122);
              }
              errors++;
            }
            var _valid3 = _errs100 === errors;
            if (_valid3 && valid9) {
              valid9 = false;
              passing1 = [passing1, 1];
            } else {
              if (_valid3) {
                valid9 = true;
                passing1 = 1;
              }
            }
            if (!valid9) {
              const err123 = { instancePath: instancePath + "/executionMode", schemaPath: "#/properties/executionMode/oneOf", keyword: "oneOf", params: { passingSchemas: passing1 }, message: "must match exactly one schema in oneOf", schema: schema12.properties.executionMode.oneOf, parentSchema: schema12.properties.executionMode, data: data39 };
              if (vErrors === null) {
                vErrors = [err123];
              } else {
                vErrors.push(err123);
              }
              errors++;
            } else {
              errors = _errs98;
              if (vErrors !== null) {
                if (_errs98) {
                  vErrors.length = _errs98;
                } else {
                  vErrors = null;
                }
              }
            }
          }
          if (data.drawingQuality !== void 0) {
            let data40 = data.drawingQuality;
            if (typeof data40 !== "string") {
              const err124 = { instancePath: instancePath + "/drawingQuality", schemaPath: "#/properties/drawingQuality/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: schema12.properties.drawingQuality.type, parentSchema: schema12.properties.drawingQuality, data: data40 };
              if (vErrors === null) {
                vErrors = [err124];
              } else {
                vErrors.push(err124);
              }
              errors++;
            }
            const _errs103 = errors;
            let valid10 = false;
            let passing2 = null;
            const _errs104 = errors;
            if ("unknown" !== data40) {
              const err125 = { instancePath: instancePath + "/drawingQuality", schemaPath: "#/properties/drawingQuality/oneOf/0/const", keyword: "const", params: { allowedValue: "unknown" }, message: "must be equal to constant", schema: "unknown", parentSchema: schema12.properties.drawingQuality.oneOf[0], data: data40 };
              if (vErrors === null) {
                vErrors = [err125];
              } else {
                vErrors.push(err125);
              }
              errors++;
            }
            var _valid4 = _errs104 === errors;
            if (_valid4) {
              valid10 = true;
              passing2 = 0;
            }
            const _errs105 = errors;
            if ("cleaned" !== data40) {
              const err126 = { instancePath: instancePath + "/drawingQuality", schemaPath: "#/properties/drawingQuality/oneOf/1/const", keyword: "const", params: { allowedValue: "cleaned" }, message: "must be equal to constant", schema: "cleaned", parentSchema: schema12.properties.drawingQuality.oneOf[1], data: data40 };
              if (vErrors === null) {
                vErrors = [err126];
              } else {
                vErrors.push(err126);
              }
              errors++;
            }
            var _valid4 = _errs105 === errors;
            if (_valid4 && valid10) {
              valid10 = false;
              passing2 = [passing2, 1];
            } else {
              if (_valid4) {
                valid10 = true;
                passing2 = 1;
              }
            }
            if (!valid10) {
              const err127 = { instancePath: instancePath + "/drawingQuality", schemaPath: "#/properties/drawingQuality/oneOf", keyword: "oneOf", params: { passingSchemas: passing2 }, message: "must match exactly one schema in oneOf", schema: schema12.properties.drawingQuality.oneOf, parentSchema: schema12.properties.drawingQuality, data: data40 };
              if (vErrors === null) {
                vErrors = [err127];
              } else {
                vErrors.push(err127);
              }
              errors++;
            } else {
              errors = _errs103;
              if (vErrors !== null) {
                if (_errs103) {
                  vErrors.length = _errs103;
                } else {
                  vErrors = null;
                }
              }
            }
          }
          if (data.cadOverlay !== void 0) {
            let data41 = data.cadOverlay;
            if (typeof data41 !== "string") {
              const err128 = { instancePath: instancePath + "/cadOverlay", schemaPath: "#/properties/cadOverlay/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: schema12.properties.cadOverlay.type, parentSchema: schema12.properties.cadOverlay, data: data41 };
              if (vErrors === null) {
                vErrors = [err128];
              } else {
                vErrors.push(err128);
              }
              errors++;
            }
            const _errs108 = errors;
            let valid11 = false;
            let passing3 = null;
            const _errs109 = errors;
            if ("include" !== data41) {
              const err129 = { instancePath: instancePath + "/cadOverlay", schemaPath: "#/properties/cadOverlay/oneOf/0/const", keyword: "const", params: { allowedValue: "include" }, message: "must be equal to constant", schema: "include", parentSchema: schema12.properties.cadOverlay.oneOf[0], data: data41 };
              if (vErrors === null) {
                vErrors = [err129];
              } else {
                vErrors.push(err129);
              }
              errors++;
            }
            var _valid5 = _errs109 === errors;
            if (_valid5) {
              valid11 = true;
              passing3 = 0;
            }
            const _errs110 = errors;
            if ("existing" !== data41) {
              const err130 = { instancePath: instancePath + "/cadOverlay", schemaPath: "#/properties/cadOverlay/oneOf/1/const", keyword: "const", params: { allowedValue: "existing" }, message: "must be equal to constant", schema: "existing", parentSchema: schema12.properties.cadOverlay.oneOf[1], data: data41 };
              if (vErrors === null) {
                vErrors = [err130];
              } else {
                vErrors.push(err130);
              }
              errors++;
            }
            var _valid5 = _errs110 === errors;
            if (_valid5 && valid11) {
              valid11 = false;
              passing3 = [passing3, 1];
            } else {
              if (_valid5) {
                valid11 = true;
                passing3 = 1;
              }
              const _errs111 = errors;
              if ("skip" !== data41) {
                const err131 = { instancePath: instancePath + "/cadOverlay", schemaPath: "#/properties/cadOverlay/oneOf/2/const", keyword: "const", params: { allowedValue: "skip" }, message: "must be equal to constant", schema: "skip", parentSchema: schema12.properties.cadOverlay.oneOf[2], data: data41 };
                if (vErrors === null) {
                  vErrors = [err131];
                } else {
                  vErrors.push(err131);
                }
                errors++;
              }
              var _valid5 = _errs111 === errors;
              if (_valid5 && valid11) {
                valid11 = false;
                passing3 = [passing3, 2];
              } else {
                if (_valid5) {
                  valid11 = true;
                  passing3 = 2;
                }
              }
            }
            if (!valid11) {
              const err132 = { instancePath: instancePath + "/cadOverlay", schemaPath: "#/properties/cadOverlay/oneOf", keyword: "oneOf", params: { passingSchemas: passing3 }, message: "must match exactly one schema in oneOf", schema: schema12.properties.cadOverlay.oneOf, parentSchema: schema12.properties.cadOverlay, data: data41 };
              if (vErrors === null) {
                vErrors = [err132];
              } else {
                vErrors.push(err132);
              }
              errors++;
            } else {
              errors = _errs108;
              if (vErrors !== null) {
                if (_errs108) {
                  vErrors.length = _errs108;
                } else {
                  vErrors = null;
                }
              }
            }
          }
          if (data.jointType !== void 0) {
            let data42 = data.jointType;
            if (typeof data42 !== "string") {
              const err133 = { instancePath: instancePath + "/jointType", schemaPath: "#/properties/jointType/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: schema12.properties.jointType.type, parentSchema: schema12.properties.jointType, data: data42 };
              if (vErrors === null) {
                vErrors = [err133];
              } else {
                vErrors.push(err133);
              }
              errors++;
            }
            const _errs114 = errors;
            let valid12 = false;
            let passing4 = null;
            const _errs115 = errors;
            if ("routing" !== data42) {
              const err134 = { instancePath: instancePath + "/jointType", schemaPath: "#/properties/jointType/oneOf/0/const", keyword: "const", params: { allowedValue: "routing" }, message: "must be equal to constant", schema: "routing", parentSchema: schema12.properties.jointType.oneOf[0], data: data42 };
              if (vErrors === null) {
                vErrors = [err134];
              } else {
                vErrors.push(err134);
              }
              errors++;
            }
            var _valid6 = _errs115 === errors;
            if (_valid6) {
              valid12 = true;
              passing4 = 0;
            }
            const _errs116 = errors;
            if ("mechanical" !== data42) {
              const err135 = { instancePath: instancePath + "/jointType", schemaPath: "#/properties/jointType/oneOf/1/const", keyword: "const", params: { allowedValue: "mechanical" }, message: "must be equal to constant", schema: "mechanical", parentSchema: schema12.properties.jointType.oneOf[1], data: data42 };
              if (vErrors === null) {
                vErrors = [err135];
              } else {
                vErrors.push(err135);
              }
              errors++;
            }
            var _valid6 = _errs116 === errors;
            if (_valid6 && valid12) {
              valid12 = false;
              passing4 = [passing4, 1];
            } else {
              if (_valid6) {
                valid12 = true;
                passing4 = 1;
              }
              const _errs117 = errors;
              if ("threaded" !== data42) {
                const err136 = { instancePath: instancePath + "/jointType", schemaPath: "#/properties/jointType/oneOf/2/const", keyword: "const", params: { allowedValue: "threaded" }, message: "must be equal to constant", schema: "threaded", parentSchema: schema12.properties.jointType.oneOf[2], data: data42 };
                if (vErrors === null) {
                  vErrors = [err136];
                } else {
                  vErrors.push(err136);
                }
                errors++;
              }
              var _valid6 = _errs117 === errors;
              if (_valid6 && valid12) {
                valid12 = false;
                passing4 = [passing4, 2];
              } else {
                if (_valid6) {
                  valid12 = true;
                  passing4 = 2;
                }
                const _errs118 = errors;
                if ("agent" !== data42) {
                  const err137 = { instancePath: instancePath + "/jointType", schemaPath: "#/properties/jointType/oneOf/3/const", keyword: "const", params: { allowedValue: "agent" }, message: "must be equal to constant", schema: "agent", parentSchema: schema12.properties.jointType.oneOf[3], data: data42 };
                  if (vErrors === null) {
                    vErrors = [err137];
                  } else {
                    vErrors.push(err137);
                  }
                  errors++;
                }
                var _valid6 = _errs118 === errors;
                if (_valid6 && valid12) {
                  valid12 = false;
                  passing4 = [passing4, 3];
                } else {
                  if (_valid6) {
                    valid12 = true;
                    passing4 = 3;
                  }
                }
              }
            }
            if (!valid12) {
              const err138 = { instancePath: instancePath + "/jointType", schemaPath: "#/properties/jointType/oneOf", keyword: "oneOf", params: { passingSchemas: passing4 }, message: "must match exactly one schema in oneOf", schema: schema12.properties.jointType.oneOf, parentSchema: schema12.properties.jointType, data: data42 };
              if (vErrors === null) {
                vErrors = [err138];
              } else {
                vErrors.push(err138);
              }
              errors++;
            } else {
              errors = _errs114;
              if (vErrors !== null) {
                if (_errs114) {
                  vErrors.length = _errs114;
                } else {
                  vErrors = null;
                }
              }
            }
          }
          if (data.missingComponents !== void 0) {
            let data43 = data.missingComponents;
            if (typeof data43 !== "string") {
              const err139 = { instancePath: instancePath + "/missingComponents", schemaPath: "#/properties/missingComponents/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: schema12.properties.missingComponents.type, parentSchema: schema12.properties.missingComponents, data: data43 };
              if (vErrors === null) {
                vErrors = [err139];
              } else {
                vErrors.push(err139);
              }
              errors++;
            }
            const _errs121 = errors;
            let valid13 = false;
            let passing5 = null;
            const _errs122 = errors;
            if ("create" !== data43) {
              const err140 = { instancePath: instancePath + "/missingComponents", schemaPath: "#/properties/missingComponents/oneOf/0/const", keyword: "const", params: { allowedValue: "create" }, message: "must be equal to constant", schema: "create", parentSchema: schema12.properties.missingComponents.oneOf[0], data: data43 };
              if (vErrors === null) {
                vErrors = [err140];
              } else {
                vErrors.push(err140);
              }
              errors++;
            }
            var _valid7 = _errs122 === errors;
            if (_valid7) {
              valid13 = true;
              passing5 = 0;
            }
            const _errs123 = errors;
            if ("substitute" !== data43) {
              const err141 = { instancePath: instancePath + "/missingComponents", schemaPath: "#/properties/missingComponents/oneOf/1/const", keyword: "const", params: { allowedValue: "substitute" }, message: "must be equal to constant", schema: "substitute", parentSchema: schema12.properties.missingComponents.oneOf[1], data: data43 };
              if (vErrors === null) {
                vErrors = [err141];
              } else {
                vErrors.push(err141);
              }
              errors++;
            }
            var _valid7 = _errs123 === errors;
            if (_valid7 && valid13) {
              valid13 = false;
              passing5 = [passing5, 1];
            } else {
              if (_valid7) {
                valid13 = true;
                passing5 = 1;
              }
              const _errs124 = errors;
              if ("list" !== data43) {
                const err142 = { instancePath: instancePath + "/missingComponents", schemaPath: "#/properties/missingComponents/oneOf/2/const", keyword: "const", params: { allowedValue: "list" }, message: "must be equal to constant", schema: "list", parentSchema: schema12.properties.missingComponents.oneOf[2], data: data43 };
                if (vErrors === null) {
                  vErrors = [err142];
                } else {
                  vErrors.push(err142);
                }
                errors++;
              }
              var _valid7 = _errs124 === errors;
              if (_valid7 && valid13) {
                valid13 = false;
                passing5 = [passing5, 2];
              } else {
                if (_valid7) {
                  valid13 = true;
                  passing5 = 2;
                }
              }
            }
            if (!valid13) {
              const err143 = { instancePath: instancePath + "/missingComponents", schemaPath: "#/properties/missingComponents/oneOf", keyword: "oneOf", params: { passingSchemas: passing5 }, message: "must match exactly one schema in oneOf", schema: schema12.properties.missingComponents.oneOf, parentSchema: schema12.properties.missingComponents, data: data43 };
              if (vErrors === null) {
                vErrors = [err143];
              } else {
                vErrors.push(err143);
              }
              errors++;
            } else {
              errors = _errs121;
              if (vErrors !== null) {
                if (_errs121) {
                  vErrors.length = _errs121;
                } else {
                  vErrors = null;
                }
              }
            }
          }
          if (data.notes !== void 0) {
            let data44 = data.notes;
            if (typeof data44 === "string") {
              if (func4(data44) > 1e4) {
                const err144 = { instancePath: instancePath + "/notes", schemaPath: "#/properties/notes/maxLength", keyword: "maxLength", params: { limit: 1e4 }, message: "must NOT have more than 10000 characters", schema: 1e4, parentSchema: schema12.properties.notes, data: data44 };
                if (vErrors === null) {
                  vErrors = [err144];
                } else {
                  vErrors.push(err144);
                }
                errors++;
              }
            } else {
              const err145 = { instancePath: instancePath + "/notes", schemaPath: "#/properties/notes/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: schema12.properties.notes.type, parentSchema: schema12.properties.notes, data: data44 };
              if (vErrors === null) {
                vErrors = [err145];
              } else {
                vErrors.push(err145);
              }
              errors++;
            }
          }
        } else {
          const err146 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object", schema: schema12.type, parentSchema: schema12, data };
          if (vErrors === null) {
            vErrors = [err146];
          } else {
            vErrors.push(err146);
          }
          errors++;
        }
        validate11.errors = vErrors;
        return errors === 0;
      }
      exports["7cc819f4"] = validate12;
      var schema13 = { "const": "cm", "title": "Centimeters", "$id": "7cc819f4" };
      function validate12(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
        ;
        let vErrors = null;
        let errors = 0;
        if ("cm" !== data) {
          const err0 = { instancePath, schemaPath: "#/const", keyword: "const", params: { allowedValue: "cm" }, message: "must be equal to constant", schema: "cm", parentSchema: schema13, data };
          if (vErrors === null) {
            vErrors = [err0];
          } else {
            vErrors.push(err0);
          }
          errors++;
        }
        validate12.errors = vErrors;
        return errors === 0;
      }
      exports["650b38d0"] = validate13;
      var schema14 = { "const": "m", "title": "Meters", "$id": "650b38d0" };
      function validate13(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
        ;
        let vErrors = null;
        let errors = 0;
        if ("m" !== data) {
          const err0 = { instancePath, schemaPath: "#/const", keyword: "const", params: { allowedValue: "m" }, message: "must be equal to constant", schema: "m", parentSchema: schema14, data };
          if (vErrors === null) {
            vErrors = [err0];
          } else {
            vErrors.push(err0);
          }
          errors++;
        }
        validate13.errors = vErrors;
        return errors === 0;
      }
      exports["-2437a79c"] = validate14;
      var schema15 = { "type": "object", "properties": { "agentChoice": { "const": true } }, "required": ["agentChoice"], "$id": "-2437a79c" };
      function validate14(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
        ;
        let vErrors = null;
        let errors = 0;
        if (data && typeof data == "object" && !Array.isArray(data)) {
          if (data.agentChoice === void 0) {
            const err0 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "agentChoice" }, message: "must have required property 'agentChoice'", schema: schema15.required, parentSchema: schema15, data };
            if (vErrors === null) {
              vErrors = [err0];
            } else {
              vErrors.push(err0);
            }
            errors++;
          }
          if (data.agentChoice !== void 0) {
            let data0 = data.agentChoice;
            if (true !== data0) {
              const err1 = { instancePath: instancePath + "/agentChoice", schemaPath: "#/properties/agentChoice/const", keyword: "const", params: { allowedValue: true }, message: "must be equal to constant", schema: true, parentSchema: schema15.properties.agentChoice, data: data0 };
              if (vErrors === null) {
                vErrors = [err1];
              } else {
                vErrors.push(err1);
              }
              errors++;
            }
          }
        } else {
          const err2 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object", schema: schema15.type, parentSchema: schema15, data };
          if (vErrors === null) {
            vErrors = [err2];
          } else {
            vErrors.push(err2);
          }
          errors++;
        }
        validate14.errors = vErrors;
        return errors === 0;
      }
      exports["-49861cb"] = validate15;
      var schema16 = { "const": "complete", "title": "Complete the model", "description": "Interpret the drawing. Resolve modeling problems. Complete the entire network.", "$id": "-49861cb" };
      function validate15(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
        ;
        let vErrors = null;
        let errors = 0;
        if ("complete" !== data) {
          const err0 = { instancePath, schemaPath: "#/const", keyword: "const", params: { allowedValue: "complete" }, message: "must be equal to constant", schema: "complete", parentSchema: schema16, data };
          if (vErrors === null) {
            vErrors = [err0];
          } else {
            vErrors.push(err0);
          }
          errors++;
        }
        validate15.errors = vErrors;
        return errors === 0;
      }
      exports["-4a001013"] = validate16;
      var schema17 = { "const": "investigate", "title": "Confirm the plan first", "description": "Interpret the drawing. Propose a modeling plan. Build the model only after confirmation of the plan.", "$id": "-4a001013" };
      function validate16(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
        ;
        let vErrors = null;
        let errors = 0;
        if ("investigate" !== data) {
          const err0 = { instancePath, schemaPath: "#/const", keyword: "const", params: { allowedValue: "investigate" }, message: "must be equal to constant", schema: "investigate", parentSchema: schema17, data };
          if (vErrors === null) {
            vErrors = [err0];
          } else {
            vErrors.push(err0);
          }
          errors++;
        }
        validate16.errors = vErrors;
        return errors === 0;
      }
      exports["39758f4c"] = validate17;
      var schema18 = { "const": "unknown", "title": "Not checked", "description": "Components can be on incorrect layers. Use lines, symbols, and annotations to identify component functions and pipe connections. Correct errors when drawing evidence supports the change.", "$id": "39758f4c" };
      function validate17(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
        ;
        let vErrors = null;
        let errors = 0;
        if ("unknown" !== data) {
          const err0 = { instancePath, schemaPath: "#/const", keyword: "const", params: { allowedValue: "unknown" }, message: "must be equal to constant", schema: "unknown", parentSchema: schema18, data };
          if (vErrors === null) {
            vErrors = [err0];
          } else {
            vErrors.push(err0);
          }
          errors++;
        }
        validate17.errors = vErrors;
        return errors === 0;
      }
      exports["449f700a"] = validate18;
      var schema19 = { "const": "cleaned", "title": "Cleaned", "description": "Interpret the drawing as shown. Correct only obvious errors.", "$id": "449f700a" };
      function validate18(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
        ;
        let vErrors = null;
        let errors = 0;
        if ("cleaned" !== data) {
          const err0 = { instancePath, schemaPath: "#/const", keyword: "const", params: { allowedValue: "cleaned" }, message: "must be equal to constant", schema: "cleaned", parentSchema: schema19, data };
          if (vErrors === null) {
            vErrors = [err0];
          } else {
            vErrors.push(err0);
          }
          errors++;
        }
        validate18.errors = vErrors;
        return errors === 0;
      }
      exports["-3ac93d4d"] = validate19;
      var schema20 = { "const": "include", "title": "Import into Revit", "description": "Place the CAD drawing on the target level for comparison with the model.", "$id": "-3ac93d4d" };
      function validate19(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
        ;
        let vErrors = null;
        let errors = 0;
        if ("include" !== data) {
          const err0 = { instancePath, schemaPath: "#/const", keyword: "const", params: { allowedValue: "include" }, message: "must be equal to constant", schema: "include", parentSchema: schema20, data };
          if (vErrors === null) {
            vErrors = [err0];
          } else {
            vErrors.push(err0);
          }
          errors++;
        }
        validate19.errors = vErrors;
        return errors === 0;
      }
      exports["-1edca12c"] = validate20;
      var schema21 = { "const": "existing", "title": "Already imported into Revit", "description": "Compare the model with the existing CAD overlay in Revit. Do not import the drawing again.", "$id": "-1edca12c" };
      function validate20(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
        ;
        let vErrors = null;
        let errors = 0;
        if ("existing" !== data) {
          const err0 = { instancePath, schemaPath: "#/const", keyword: "const", params: { allowedValue: "existing" }, message: "must be equal to constant", schema: "existing", parentSchema: schema21, data };
          if (vErrors === null) {
            vErrors = [err0];
          } else {
            vErrors.push(err0);
          }
          errors++;
        }
        validate20.errors = vErrors;
        return errors === 0;
      }
      exports["-7e459e03"] = validate21;
      var schema22 = { "const": "skip", "title": "Do not import", "description": "Do not import the CAD drawing into Revit. Use images to compare the model with the drawing.", "$id": "-7e459e03" };
      function validate21(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
        ;
        let vErrors = null;
        let errors = 0;
        if ("skip" !== data) {
          const err0 = { instancePath, schemaPath: "#/const", keyword: "const", params: { allowedValue: "skip" }, message: "must be equal to constant", schema: "skip", parentSchema: schema22, data };
          if (vErrors === null) {
            vErrors = [err0];
          } else {
            vErrors.push(err0);
          }
          errors++;
        }
        validate21.errors = vErrors;
        return errors === 0;
      }
      exports["-5521aabb"] = validate22;
      var schema23 = { "const": "routing", "title": "Follow the pipe type's routing preferences", "$id": "-5521aabb" };
      function validate22(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
        ;
        let vErrors = null;
        let errors = 0;
        if ("routing" !== data) {
          const err0 = { instancePath, schemaPath: "#/const", keyword: "const", params: { allowedValue: "routing" }, message: "must be equal to constant", schema: "routing", parentSchema: schema23, data };
          if (vErrors === null) {
            vErrors = [err0];
          } else {
            vErrors.push(err0);
          }
          errors++;
        }
        validate22.errors = vErrors;
        return errors === 0;
      }
      exports["-44599818"] = validate23;
      var schema24 = { "const": "mechanical", "title": "Mechanical joints", "$id": "-44599818" };
      function validate23(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
        ;
        let vErrors = null;
        let errors = 0;
        if ("mechanical" !== data) {
          const err0 = { instancePath, schemaPath: "#/const", keyword: "const", params: { allowedValue: "mechanical" }, message: "must be equal to constant", schema: "mechanical", parentSchema: schema24, data };
          if (vErrors === null) {
            vErrors = [err0];
          } else {
            vErrors.push(err0);
          }
          errors++;
        }
        validate23.errors = vErrors;
        return errors === 0;
      }
      exports["3e3fea68"] = validate24;
      var schema25 = { "const": "threaded", "title": "Threaded joints", "$id": "3e3fea68" };
      function validate24(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
        ;
        let vErrors = null;
        let errors = 0;
        if ("threaded" !== data) {
          const err0 = { instancePath, schemaPath: "#/const", keyword: "const", params: { allowedValue: "threaded" }, message: "must be equal to constant", schema: "threaded", parentSchema: schema25, data };
          if (vErrors === null) {
            vErrors = [err0];
          } else {
            vErrors.push(err0);
          }
          errors++;
        }
        validate24.errors = vErrors;
        return errors === 0;
      }
      exports["-2b3038f1"] = validate25;
      var schema26 = { "const": "agent", "title": "Inspect and recommend", "$id": "-2b3038f1" };
      function validate25(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
        ;
        let vErrors = null;
        let errors = 0;
        if ("agent" !== data) {
          const err0 = { instancePath, schemaPath: "#/const", keyword: "const", params: { allowedValue: "agent" }, message: "must be equal to constant", schema: "agent", parentSchema: schema26, data };
          if (vErrors === null) {
            vErrors = [err0];
          } else {
            vErrors.push(err0);
          }
          errors++;
        }
        validate25.errors = vErrors;
        return errors === 0;
      }
      exports["7b308ab2"] = validate26;
      var schema27 = { "const": "create", "title": "Create required components", "description": "Create the missing families with the required component shapes and dimensions. Connect the components to the pipes.", "$id": "7b308ab2" };
      function validate26(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
        ;
        let vErrors = null;
        let errors = 0;
        if ("create" !== data) {
          const err0 = { instancePath, schemaPath: "#/const", keyword: "const", params: { allowedValue: "create" }, message: "must be equal to constant", schema: "create", parentSchema: schema27, data };
          if (vErrors === null) {
            vErrors = [err0];
          } else {
            vErrors.push(err0);
          }
          errors++;
        }
        validate26.errors = vErrors;
        return errors === 0;
      }
      exports["992fe47"] = validate27;
      var schema28 = { "const": "substitute", "title": "Use substitute components", "description": "Use similar existing components as substitutes. Connect the substitutes to the pipes.", "$id": "992fe47" };
      function validate27(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
        ;
        let vErrors = null;
        let errors = 0;
        if ("substitute" !== data) {
          const err0 = { instancePath, schemaPath: "#/const", keyword: "const", params: { allowedValue: "substitute" }, message: "must be equal to constant", schema: "substitute", parentSchema: schema28, data };
          if (vErrors === null) {
            vErrors = [err0];
          } else {
            vErrors.push(err0);
          }
          errors++;
        }
        validate27.errors = vErrors;
        return errors === 0;
      }
      exports["-74da255d"] = validate28;
      var schema29 = { "const": "list", "title": "List missing components", "description": "List missing components and their locations. Do not create these components.", "$id": "-74da255d" };
      function validate28(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
        ;
        let vErrors = null;
        let errors = 0;
        if ("list" !== data) {
          const err0 = { instancePath, schemaPath: "#/const", keyword: "const", params: { allowedValue: "list" }, message: "must be equal to constant", schema: "list", parentSchema: schema29, data };
          if (vErrors === null) {
            vErrors = [err0];
          } else {
            vErrors.push(err0);
          }
          errors++;
        }
        validate28.errors = vErrors;
        return errors === 0;
      }
    }
  });
  return require_validator_4();
})();

"use strict";
var compiled5 = (() => {
  var __getOwnPropNames = Object.getOwnPropertyNames;
  var __commonJS = (cb, mod) => function __require() {
    return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
  };

  // src/web/node_modules/ajv/dist/runtime/ucs2length.js
  var require_ucs2length = __commonJS({
    "src/web/node_modules/ajv/dist/runtime/ucs2length.js"(exports) {
      "use strict";
      Object.defineProperty(exports, "__esModule", { value: true });
      function ucs2length(str) {
        const len = str.length;
        let length = 0;
        let pos = 0;
        let value;
        while (pos < len) {
          length++;
          value = str.charCodeAt(pos++);
          if (value >= 55296 && value <= 56319 && pos < len) {
            value = str.charCodeAt(pos);
            if ((value & 64512) === 56320)
              pos++;
          }
        }
        return length;
      }
      exports.default = ucs2length;
      ucs2length.code = 'require("ajv/dist/runtime/ucs2length").default';
    }
  });

  // src/web/validator-5.cjs
  var require_validator_5 = __commonJS({
    "src/web/validator-5.cjs"(exports) {
      exports["-1b796927"] = validate10;
      var schema11 = { "$schema": "http://json-schema.org/draft-07/schema#", "type": "object", "additionalProperties": false, "required": ["drawingUnit", "level", "pipeType", "pipeHeightCm", "sprinklerHeightCm", "crossingOffsetCm", "executionMode", "drawingQuality", "cadOverlay", "jointType", "missingComponents"], "properties": { "toolCallLimit": { "type": "integer", "title": "\u6BCF\u6B21\u57F7\u884C\u5DE5\u5177\u4E0A\u9650\uFF08\u6B21\uFF09", "description": "\u53EF\u8A2D\u5B9A 1\u201380 \u6B21\uFF0C\u9810\u8A2D 40 \u6B21\u3002\u6BCF\u6B21\u57F7\u884C\u6216\u7E8C\u8DD1\u5404\u81EA\u8A08\u7B97\uFF0C\u7D50\u6848\u5831\u544A\u4E0D\u8A08\u5165\u3002", "minimum": 1, "maximum": 80, "default": 40 }, "drawingUnit": { "type": "string", "title": "\u5716\u9762\u5BE6\u969B\u55AE\u4F4D", "description": "CAD \u5716\u5BE6\u969B\u4F7F\u7528\u7684\u7E6A\u5716\u55AE\u4F4D\u3002\u63DB\u7B97\u6642\u4EE5\u6B64\u8A2D\u5B9A\u70BA\u6E96\u3002", "default": "cm", "oneOf": [{ "const": "cm", "title": "\u516C\u5206" }, { "const": "mm", "title": "\u6BEB\u7C73" }, { "const": "m", "title": "\u516C\u5C3A" }] }, "level": { "type": "object", "title": "Revit \u76EE\u6A19\u6A13\u5C64", "description": "\u7BA1\u7DB2\u6240\u5728\u7684 Revit \u6A13\u5C64\u3002\u7BA1\u7DDA\u8207\u7051\u6C34\u982D\u7684\u9AD8\u5EA6\u4EE5\u6B64\u6A13\u5C64\u70BA\u57FA\u6E96\u3002", "additionalProperties": false, "required": ["id", "name", "type", "documentId", "documentName", "documentPath", "sessionId", "revitVersion", "lastUpdated"], "properties": { "id": { "type": "string", "minLength": 1 }, "name": { "type": "string", "minLength": 1 }, "type": { "const": "Level" }, "documentId": { "type": "string", "minLength": 1 }, "documentName": { "type": "string" }, "documentPath": { "type": "string" }, "sessionId": { "type": "string", "minLength": 1 }, "revitVersion": { "type": "string", "pattern": "^[0-9]{4}$" }, "lastUpdated": { "type": "string", "minLength": 1 } } }, "pipeType": { "type": "object", "title": "Revit \u7BA1\u985E\u578B", "description": "\u5EFA\u6A21\u4F7F\u7528\u7684 Revit \u7BA1\u985E\u578B\uFF0C\u5305\u542B\u7BA1\u6750\u3001\u53EF\u7528\u7BA1\u5F91\u8207\u63A5\u982D\u8A2D\u5B9A\u3002", "additionalProperties": false, "default": { "type": "PipeType", "agentChoice": true }, "required": ["type"], "if": { "type": "object", "properties": { "agentChoice": { "const": true } }, "required": ["agentChoice"] }, "then": { "type": "object", "maxProperties": 2 }, "else": { "type": "object", "properties": { "id": true, "name": true, "documentId": true, "documentName": true, "documentPath": true, "sessionId": true, "revitVersion": true, "lastUpdated": true }, "required": ["id", "name", "documentId", "documentName", "documentPath", "sessionId", "revitVersion", "lastUpdated"] }, "properties": { "agentChoice": { "type": "boolean" }, "id": { "type": "string", "minLength": 1 }, "name": { "type": "string", "minLength": 1 }, "type": { "const": "PipeType" }, "documentId": { "type": "string", "minLength": 1 }, "documentName": { "type": "string" }, "documentPath": { "type": "string" }, "sessionId": { "type": "string", "minLength": 1 }, "revitVersion": { "type": "string", "pattern": "^[0-9]{4}$" }, "lastUpdated": { "type": "string", "minLength": 1 } } }, "systemType": { "type": "object", "title": "Revit \u7CFB\u7D71\u985E\u578B", "description": "\u5F9E\u5C08\u6848\u9078\u64C7\u914D\u7BA1\u7CFB\u7D71\u985E\u578B\uFF0C\u6216\u7531 Agent \u9078\u64C7\u9069\u5408\u7051\u6C34\u7BA1\u7DB2\u7684\u985E\u578B\u3002", "additionalProperties": false, "default": { "type": "MEPSystemType", "agentChoice": true }, "required": ["type"], "if": { "type": "object", "properties": { "agentChoice": { "const": true } }, "required": ["agentChoice"] }, "then": { "type": "object", "maxProperties": 2 }, "else": { "type": "object", "properties": { "id": true, "name": true, "documentId": true, "documentName": true, "documentPath": true, "sessionId": true, "revitVersion": true, "lastUpdated": true }, "required": ["id", "name", "documentId", "documentName", "documentPath", "sessionId", "revitVersion", "lastUpdated"] }, "properties": { "agentChoice": { "type": "boolean" }, "id": { "type": "string", "minLength": 1 }, "name": { "type": "string", "minLength": 1 }, "type": { "const": "MEPSystemType" }, "documentId": { "type": "string", "minLength": 1 }, "documentName": { "type": "string" }, "documentPath": { "type": "string" }, "sessionId": { "type": "string", "minLength": 1 }, "revitVersion": { "type": "string", "pattern": "^[0-9]{4}$" }, "lastUpdated": { "type": "string", "minLength": 1 } } }, "pipeHeightCm": { "type": "number", "title": "\u7BA1\u7DDA\u4E2D\u5FC3\u8DDD\u6A13\u5C64\u9AD8\u5EA6\uFF08cm\uFF09", "description": "\u7BA1\u7DDA\u4E2D\u5FC3\u7DDA\u8DDD\u96E2\u76EE\u6A19\u6A13\u5C64\u7684\u9AD8\u5EA6\u3002", "minimum": 0, "default": 280 }, "sprinklerHeightCm": { "type": "number", "title": "\u7051\u6C34\u982D\u51FA\u6C34\u53E3\u8DDD\u6A13\u5C64\u9AD8\u5EA6\uFF08cm\uFF09", "description": "\u7051\u6C34\u982D\u51FA\u6C34\u53E3\u8DDD\u96E2\u76EE\u6A19\u6A13\u5C64\u7684\u9AD8\u5EA6\u3002", "minimum": 0, "default": 260 }, "crossingOffsetCm": { "type": "number", "title": "\u4E0D\u9023\u901A\u4EA4\u53C9\u7684\u62AC\u5347\u91CF\uFF08cm\uFF09", "description": "\u5169\u689D\u7BA1\u7DDA\u4EA4\u53C9\u4F46\u4E0D\u76F8\u9023\u6642\uFF0C\u5176\u4E2D\u4E00\u689D\u7BA1\u7DDA\u5411\u4E0A\u62AC\u5347\u7684\u8DDD\u96E2\u3002", "exclusiveMinimum": 0, "default": 20 }, "executionMode": { "type": "string", "title": "\u57F7\u884C\u65B9\u5F0F", "description": "\u9078\u64C7\u5B8C\u6210\u5EFA\u6A21\uFF0C\u6216\u5148\u78BA\u8A8D\u5EFA\u6A21\u65B9\u6848\u3002", "default": "complete", "oneOf": [{ "const": "complete", "title": "\u5B8C\u6210\u5EFA\u6A21", "description": "\u5224\u8B80\u5716\u9762\u3001\u8655\u7406\u5EFA\u6A21\u554F\u984C\uFF0C\u4E26\u5B8C\u6210\u6574\u500B\u7BA1\u7DB2\u3002" }, { "const": "investigate", "title": "\u5148\u78BA\u8A8D\u65B9\u6848", "description": "\u5224\u8B80\u5716\u9762\u4E26\u63D0\u51FA\u5EFA\u6A21\u65B9\u6848\uFF0C\u65B9\u6848\u78BA\u8A8D\u5F8C\u518D\u5EFA\u7ACB\u6A21\u578B\u3002" }] }, "drawingQuality": { "type": "string", "title": "\u5716\u9762\u54C1\u8CEA", "description": "\u9078\u64C7\u76EE\u524D CAD \u5716\u9762\u7684\u6574\u7406\u72C0\u614B\u3002", "default": "unknown", "oneOf": [{ "const": "unknown", "title": "\u5C1A\u672A\u78BA\u8A8D", "description": "\u5143\u4EF6\u53EF\u80FD\u653E\u932F\u5716\u5C64\u3002\u7D9C\u5408\u7DDA\u6BB5\u3001\u7B26\u865F\u8207\u6A19\u8A3B\u5224\u8B80\u7528\u9014\u53CA\u9023\u63A5\u95DC\u4FC2\uFF0C\u4FEE\u6B63\u6709\u4F9D\u64DA\u7684\u932F\u8AA4\u3002" }, { "const": "cleaned", "title": "\u5DF2\u6E05\u7406", "description": "\u4F9D\u5716\u9762\u5224\u8B80\uFF0C\u50C5\u4FEE\u6B63\u660E\u986F\u932F\u8AA4\u3002" }] }, "cadOverlay": { "type": "string", "title": "CAD \u5E95\u5716\u5C0D\u7167", "description": "\u9078\u64C7\u532F\u5165 CAD \u5E95\u5716\u3001\u4F7F\u7528\u65E2\u6709\u5E95\u5716\uFF0C\u6216\u4E0D\u532F\u5165\u3002", "default": "include", "oneOf": [{ "const": "include", "title": "\u532F\u5165 Revit \u5C0D\u7167", "description": "\u5C07 CAD \u5716\u653E\u5728\u76EE\u6A19\u6A13\u5C64\uFF0C\u4F9B\u6A21\u578B\u8207\u539F\u5716\u758A\u5716\u6BD4\u5C0D\u3002" }, { "const": "existing", "title": "\u5DF2\u532F\u5165 Revit", "description": "\u4F7F\u7528 Revit \u4E2D\u65E2\u6709\u7684 CAD \u5E95\u5716\u6BD4\u5C0D\u6A21\u578B\uFF0C\u4E0D\u91CD\u8907\u532F\u5165\u3002" }, { "const": "skip", "title": "\u4E0D\u532F\u5165", "description": "\u4E0D\u5C07 CAD \u5716\u532F\u5165 Revit\uFF0C\u6539\u7528\u5716\u7247\u6BD4\u5C0D\u6A21\u578B\u8207\u539F\u5716\u3002" }] }, "jointType": { "type": "string", "title": "\u63A5\u982D\u5F62\u5F0F", "description": "\u9078\u64C7\u7BA1\u4EF6\u7684\u63A5\u982D\u5F62\u5F0F\u3002\u9810\u8A2D\u6CBF\u7528\u6240\u9078\u7BA1\u985E\u578B\u7684\u4F48\u7BA1\u504F\u597D\u3002", "default": "routing", "oneOf": [{ "const": "routing", "title": "\u4F9D\u7BA1\u985E\u578B\u4F48\u7BA1\u504F\u597D" }, { "const": "mechanical", "title": "\u6A5F\u68B0\u63A5\u982D" }, { "const": "threaded", "title": "\u87BA\u7D0B\u63A5\u982D" }, { "const": "agent", "title": "\u8ABF\u67E5\u5F8C\u5EFA\u8B70" }] }, "missingComponents": { "type": "string", "title": "\u7F3A\u5143\u4EF6\u8655\u7406", "description": "\u9078\u64C7 Revit \u5C08\u6848\u7F3A\u5C11\u95A5\u4EF6\u7B49\u6240\u9700\u65CF\u7FA4\u6642\u7684\u8655\u7406\u65B9\u5F0F\u3002", "default": "create", "oneOf": [{ "const": "create", "title": "\u5EFA\u7ACB\u6240\u9700\u5143\u4EF6", "description": "\u5EFA\u7ACB\u7F3A\u5C11\u7684\u65CF\u7FA4\uFF0C\u4F7F\u5916\u5F62\u8207\u5C3A\u5BF8\u7B26\u5408\u6240\u9700\u5143\u4EF6\uFF0C\u4E26\u9023\u63A5\u7BA1\u7DDA\u3002" }, { "const": "substitute", "title": "\u4F7F\u7528\u66FF\u4EE3\u5143\u4EF6", "description": "\u4F7F\u7528\u73FE\u6709\u7684\u76F8\u8FD1\u5143\u4EF6\u66FF\u4EE3\uFF0C\u4E26\u9023\u63A5\u7BA1\u7DDA\u3002" }, { "const": "list", "title": "\u5217\u51FA\u7F3A\u5C11\u9805\u76EE", "description": "\u5217\u51FA\u7F3A\u5C11\u7684\u5143\u4EF6\u53CA\u4F4D\u7F6E\uFF0C\u4E0D\u5EFA\u7ACB\u9019\u4E9B\u5143\u4EF6\u3002" }] }, "notes": { "type": "string", "title": "\u88DC\u5145\u8AAA\u660E", "description": "\u88DC\u5145\u8655\u7406\u7BC4\u570D\u3001\u512A\u5148\u9806\u5E8F\u6216\u7279\u6B8A\u8981\u6C42\u3002", "maxLength": 1e4 } }, "$id": "-1b796927" };
      var func2 = Object.prototype.hasOwnProperty;
      var func4 = require_ucs2length().default;
      var pattern0 = new RegExp("^[0-9]{4}$", "u");
      function validate10(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
        ;
        let vErrors = null;
        let errors = 0;
        if (data && typeof data == "object" && !Array.isArray(data)) {
          if (data.drawingUnit === void 0) {
            const err0 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "drawingUnit" }, message: "must have required property 'drawingUnit'", schema: schema11.required, parentSchema: schema11, data };
            if (vErrors === null) {
              vErrors = [err0];
            } else {
              vErrors.push(err0);
            }
            errors++;
          }
          if (data.level === void 0) {
            const err1 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "level" }, message: "must have required property 'level'", schema: schema11.required, parentSchema: schema11, data };
            if (vErrors === null) {
              vErrors = [err1];
            } else {
              vErrors.push(err1);
            }
            errors++;
          }
          if (data.pipeType === void 0) {
            const err2 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "pipeType" }, message: "must have required property 'pipeType'", schema: schema11.required, parentSchema: schema11, data };
            if (vErrors === null) {
              vErrors = [err2];
            } else {
              vErrors.push(err2);
            }
            errors++;
          }
          if (data.pipeHeightCm === void 0) {
            const err3 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "pipeHeightCm" }, message: "must have required property 'pipeHeightCm'", schema: schema11.required, parentSchema: schema11, data };
            if (vErrors === null) {
              vErrors = [err3];
            } else {
              vErrors.push(err3);
            }
            errors++;
          }
          if (data.sprinklerHeightCm === void 0) {
            const err4 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "sprinklerHeightCm" }, message: "must have required property 'sprinklerHeightCm'", schema: schema11.required, parentSchema: schema11, data };
            if (vErrors === null) {
              vErrors = [err4];
            } else {
              vErrors.push(err4);
            }
            errors++;
          }
          if (data.crossingOffsetCm === void 0) {
            const err5 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "crossingOffsetCm" }, message: "must have required property 'crossingOffsetCm'", schema: schema11.required, parentSchema: schema11, data };
            if (vErrors === null) {
              vErrors = [err5];
            } else {
              vErrors.push(err5);
            }
            errors++;
          }
          if (data.executionMode === void 0) {
            const err6 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "executionMode" }, message: "must have required property 'executionMode'", schema: schema11.required, parentSchema: schema11, data };
            if (vErrors === null) {
              vErrors = [err6];
            } else {
              vErrors.push(err6);
            }
            errors++;
          }
          if (data.drawingQuality === void 0) {
            const err7 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "drawingQuality" }, message: "must have required property 'drawingQuality'", schema: schema11.required, parentSchema: schema11, data };
            if (vErrors === null) {
              vErrors = [err7];
            } else {
              vErrors.push(err7);
            }
            errors++;
          }
          if (data.cadOverlay === void 0) {
            const err8 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "cadOverlay" }, message: "must have required property 'cadOverlay'", schema: schema11.required, parentSchema: schema11, data };
            if (vErrors === null) {
              vErrors = [err8];
            } else {
              vErrors.push(err8);
            }
            errors++;
          }
          if (data.jointType === void 0) {
            const err9 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "jointType" }, message: "must have required property 'jointType'", schema: schema11.required, parentSchema: schema11, data };
            if (vErrors === null) {
              vErrors = [err9];
            } else {
              vErrors.push(err9);
            }
            errors++;
          }
          if (data.missingComponents === void 0) {
            const err10 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "missingComponents" }, message: "must have required property 'missingComponents'", schema: schema11.required, parentSchema: schema11, data };
            if (vErrors === null) {
              vErrors = [err10];
            } else {
              vErrors.push(err10);
            }
            errors++;
          }
          for (const key0 in data) {
            if (!func2.call(schema11.properties, key0)) {
              const err11 = { instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties", schema: false, parentSchema: schema11, data };
              if (vErrors === null) {
                vErrors = [err11];
              } else {
                vErrors.push(err11);
              }
              errors++;
            }
          }
          if (data.toolCallLimit !== void 0) {
            let data0 = data.toolCallLimit;
            if (!(typeof data0 == "number" && (!(data0 % 1) && !isNaN(data0)) && isFinite(data0))) {
              const err12 = { instancePath: instancePath + "/toolCallLimit", schemaPath: "#/properties/toolCallLimit/type", keyword: "type", params: { type: "integer" }, message: "must be integer", schema: schema11.properties.toolCallLimit.type, parentSchema: schema11.properties.toolCallLimit, data: data0 };
              if (vErrors === null) {
                vErrors = [err12];
              } else {
                vErrors.push(err12);
              }
              errors++;
            }
            if (typeof data0 == "number" && isFinite(data0)) {
              if (data0 > 80 || isNaN(data0)) {
                const err13 = { instancePath: instancePath + "/toolCallLimit", schemaPath: "#/properties/toolCallLimit/maximum", keyword: "maximum", params: { comparison: "<=", limit: 80 }, message: "must be <= 80", schema: 80, parentSchema: schema11.properties.toolCallLimit, data: data0 };
                if (vErrors === null) {
                  vErrors = [err13];
                } else {
                  vErrors.push(err13);
                }
                errors++;
              }
              if (data0 < 1 || isNaN(data0)) {
                const err14 = { instancePath: instancePath + "/toolCallLimit", schemaPath: "#/properties/toolCallLimit/minimum", keyword: "minimum", params: { comparison: ">=", limit: 1 }, message: "must be >= 1", schema: 1, parentSchema: schema11.properties.toolCallLimit, data: data0 };
                if (vErrors === null) {
                  vErrors = [err14];
                } else {
                  vErrors.push(err14);
                }
                errors++;
              }
            }
          }
          if (data.drawingUnit !== void 0) {
            let data1 = data.drawingUnit;
            if (typeof data1 !== "string") {
              const err15 = { instancePath: instancePath + "/drawingUnit", schemaPath: "#/properties/drawingUnit/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: schema11.properties.drawingUnit.type, parentSchema: schema11.properties.drawingUnit, data: data1 };
              if (vErrors === null) {
                vErrors = [err15];
              } else {
                vErrors.push(err15);
              }
              errors++;
            }
            const _errs6 = errors;
            let valid1 = false;
            let passing0 = null;
            const _errs7 = errors;
            if ("cm" !== data1) {
              const err16 = { instancePath: instancePath + "/drawingUnit", schemaPath: "#/properties/drawingUnit/oneOf/0/const", keyword: "const", params: { allowedValue: "cm" }, message: "must be equal to constant", schema: "cm", parentSchema: schema11.properties.drawingUnit.oneOf[0], data: data1 };
              if (vErrors === null) {
                vErrors = [err16];
              } else {
                vErrors.push(err16);
              }
              errors++;
            }
            var _valid0 = _errs7 === errors;
            if (_valid0) {
              valid1 = true;
              passing0 = 0;
            }
            const _errs8 = errors;
            if ("mm" !== data1) {
              const err17 = { instancePath: instancePath + "/drawingUnit", schemaPath: "#/properties/drawingUnit/oneOf/1/const", keyword: "const", params: { allowedValue: "mm" }, message: "must be equal to constant", schema: "mm", parentSchema: schema11.properties.drawingUnit.oneOf[1], data: data1 };
              if (vErrors === null) {
                vErrors = [err17];
              } else {
                vErrors.push(err17);
              }
              errors++;
            }
            var _valid0 = _errs8 === errors;
            if (_valid0 && valid1) {
              valid1 = false;
              passing0 = [passing0, 1];
            } else {
              if (_valid0) {
                valid1 = true;
                passing0 = 1;
              }
              const _errs9 = errors;
              if ("m" !== data1) {
                const err18 = { instancePath: instancePath + "/drawingUnit", schemaPath: "#/properties/drawingUnit/oneOf/2/const", keyword: "const", params: { allowedValue: "m" }, message: "must be equal to constant", schema: "m", parentSchema: schema11.properties.drawingUnit.oneOf[2], data: data1 };
                if (vErrors === null) {
                  vErrors = [err18];
                } else {
                  vErrors.push(err18);
                }
                errors++;
              }
              var _valid0 = _errs9 === errors;
              if (_valid0 && valid1) {
                valid1 = false;
                passing0 = [passing0, 2];
              } else {
                if (_valid0) {
                  valid1 = true;
                  passing0 = 2;
                }
              }
            }
            if (!valid1) {
              const err19 = { instancePath: instancePath + "/drawingUnit", schemaPath: "#/properties/drawingUnit/oneOf", keyword: "oneOf", params: { passingSchemas: passing0 }, message: "must match exactly one schema in oneOf", schema: schema11.properties.drawingUnit.oneOf, parentSchema: schema11.properties.drawingUnit, data: data1 };
              if (vErrors === null) {
                vErrors = [err19];
              } else {
                vErrors.push(err19);
              }
              errors++;
            } else {
              errors = _errs6;
              if (vErrors !== null) {
                if (_errs6) {
                  vErrors.length = _errs6;
                } else {
                  vErrors = null;
                }
              }
            }
          }
          if (data.level !== void 0) {
            let data2 = data.level;
            if (data2 && typeof data2 == "object" && !Array.isArray(data2)) {
              if (data2.id === void 0) {
                const err20 = { instancePath: instancePath + "/level", schemaPath: "#/properties/level/required", keyword: "required", params: { missingProperty: "id" }, message: "must have required property 'id'", schema: schema11.properties.level.required, parentSchema: schema11.properties.level, data: data2 };
                if (vErrors === null) {
                  vErrors = [err20];
                } else {
                  vErrors.push(err20);
                }
                errors++;
              }
              if (data2.name === void 0) {
                const err21 = { instancePath: instancePath + "/level", schemaPath: "#/properties/level/required", keyword: "required", params: { missingProperty: "name" }, message: "must have required property 'name'", schema: schema11.properties.level.required, parentSchema: schema11.properties.level, data: data2 };
                if (vErrors === null) {
                  vErrors = [err21];
                } else {
                  vErrors.push(err21);
                }
                errors++;
              }
              if (data2.type === void 0) {
                const err22 = { instancePath: instancePath + "/level", schemaPath: "#/properties/level/required", keyword: "required", params: { missingProperty: "type" }, message: "must have required property 'type'", schema: schema11.properties.level.required, parentSchema: schema11.properties.level, data: data2 };
                if (vErrors === null) {
                  vErrors = [err22];
                } else {
                  vErrors.push(err22);
                }
                errors++;
              }
              if (data2.documentId === void 0) {
                const err23 = { instancePath: instancePath + "/level", schemaPath: "#/properties/level/required", keyword: "required", params: { missingProperty: "documentId" }, message: "must have required property 'documentId'", schema: schema11.properties.level.required, parentSchema: schema11.properties.level, data: data2 };
                if (vErrors === null) {
                  vErrors = [err23];
                } else {
                  vErrors.push(err23);
                }
                errors++;
              }
              if (data2.documentName === void 0) {
                const err24 = { instancePath: instancePath + "/level", schemaPath: "#/properties/level/required", keyword: "required", params: { missingProperty: "documentName" }, message: "must have required property 'documentName'", schema: schema11.properties.level.required, parentSchema: schema11.properties.level, data: data2 };
                if (vErrors === null) {
                  vErrors = [err24];
                } else {
                  vErrors.push(err24);
                }
                errors++;
              }
              if (data2.documentPath === void 0) {
                const err25 = { instancePath: instancePath + "/level", schemaPath: "#/properties/level/required", keyword: "required", params: { missingProperty: "documentPath" }, message: "must have required property 'documentPath'", schema: schema11.properties.level.required, parentSchema: schema11.properties.level, data: data2 };
                if (vErrors === null) {
                  vErrors = [err25];
                } else {
                  vErrors.push(err25);
                }
                errors++;
              }
              if (data2.sessionId === void 0) {
                const err26 = { instancePath: instancePath + "/level", schemaPath: "#/properties/level/required", keyword: "required", params: { missingProperty: "sessionId" }, message: "must have required property 'sessionId'", schema: schema11.properties.level.required, parentSchema: schema11.properties.level, data: data2 };
                if (vErrors === null) {
                  vErrors = [err26];
                } else {
                  vErrors.push(err26);
                }
                errors++;
              }
              if (data2.revitVersion === void 0) {
                const err27 = { instancePath: instancePath + "/level", schemaPath: "#/properties/level/required", keyword: "required", params: { missingProperty: "revitVersion" }, message: "must have required property 'revitVersion'", schema: schema11.properties.level.required, parentSchema: schema11.properties.level, data: data2 };
                if (vErrors === null) {
                  vErrors = [err27];
                } else {
                  vErrors.push(err27);
                }
                errors++;
              }
              if (data2.lastUpdated === void 0) {
                const err28 = { instancePath: instancePath + "/level", schemaPath: "#/properties/level/required", keyword: "required", params: { missingProperty: "lastUpdated" }, message: "must have required property 'lastUpdated'", schema: schema11.properties.level.required, parentSchema: schema11.properties.level, data: data2 };
                if (vErrors === null) {
                  vErrors = [err28];
                } else {
                  vErrors.push(err28);
                }
                errors++;
              }
              for (const key1 in data2) {
                if (!func2.call(schema11.properties.level.properties, key1)) {
                  const err29 = { instancePath: instancePath + "/level", schemaPath: "#/properties/level/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key1 }, message: "must NOT have additional properties", schema: false, parentSchema: schema11.properties.level, data: data2 };
                  if (vErrors === null) {
                    vErrors = [err29];
                  } else {
                    vErrors.push(err29);
                  }
                  errors++;
                }
              }
              if (data2.id !== void 0) {
                let data3 = data2.id;
                if (typeof data3 === "string") {
                  if (func4(data3) < 1) {
                    const err30 = { instancePath: instancePath + "/level/id", schemaPath: "#/properties/level/properties/id/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters", schema: 1, parentSchema: schema11.properties.level.properties.id, data: data3 };
                    if (vErrors === null) {
                      vErrors = [err30];
                    } else {
                      vErrors.push(err30);
                    }
                    errors++;
                  }
                } else {
                  const err31 = { instancePath: instancePath + "/level/id", schemaPath: "#/properties/level/properties/id/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: schema11.properties.level.properties.id.type, parentSchema: schema11.properties.level.properties.id, data: data3 };
                  if (vErrors === null) {
                    vErrors = [err31];
                  } else {
                    vErrors.push(err31);
                  }
                  errors++;
                }
              }
              if (data2.name !== void 0) {
                let data4 = data2.name;
                if (typeof data4 === "string") {
                  if (func4(data4) < 1) {
                    const err32 = { instancePath: instancePath + "/level/name", schemaPath: "#/properties/level/properties/name/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters", schema: 1, parentSchema: schema11.properties.level.properties.name, data: data4 };
                    if (vErrors === null) {
                      vErrors = [err32];
                    } else {
                      vErrors.push(err32);
                    }
                    errors++;
                  }
                } else {
                  const err33 = { instancePath: instancePath + "/level/name", schemaPath: "#/properties/level/properties/name/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: schema11.properties.level.properties.name.type, parentSchema: schema11.properties.level.properties.name, data: data4 };
                  if (vErrors === null) {
                    vErrors = [err33];
                  } else {
                    vErrors.push(err33);
                  }
                  errors++;
                }
              }
              if (data2.type !== void 0) {
                let data5 = data2.type;
                if ("Level" !== data5) {
                  const err34 = { instancePath: instancePath + "/level/type", schemaPath: "#/properties/level/properties/type/const", keyword: "const", params: { allowedValue: "Level" }, message: "must be equal to constant", schema: "Level", parentSchema: schema11.properties.level.properties.type, data: data5 };
                  if (vErrors === null) {
                    vErrors = [err34];
                  } else {
                    vErrors.push(err34);
                  }
                  errors++;
                }
              }
              if (data2.documentId !== void 0) {
                let data6 = data2.documentId;
                if (typeof data6 === "string") {
                  if (func4(data6) < 1) {
                    const err35 = { instancePath: instancePath + "/level/documentId", schemaPath: "#/properties/level/properties/documentId/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters", schema: 1, parentSchema: schema11.properties.level.properties.documentId, data: data6 };
                    if (vErrors === null) {
                      vErrors = [err35];
                    } else {
                      vErrors.push(err35);
                    }
                    errors++;
                  }
                } else {
                  const err36 = { instancePath: instancePath + "/level/documentId", schemaPath: "#/properties/level/properties/documentId/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: schema11.properties.level.properties.documentId.type, parentSchema: schema11.properties.level.properties.documentId, data: data6 };
                  if (vErrors === null) {
                    vErrors = [err36];
                  } else {
                    vErrors.push(err36);
                  }
                  errors++;
                }
              }
              if (data2.documentName !== void 0) {
                let data7 = data2.documentName;
                if (typeof data7 !== "string") {
                  const err37 = { instancePath: instancePath + "/level/documentName", schemaPath: "#/properties/level/properties/documentName/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: schema11.properties.level.properties.documentName.type, parentSchema: schema11.properties.level.properties.documentName, data: data7 };
                  if (vErrors === null) {
                    vErrors = [err37];
                  } else {
                    vErrors.push(err37);
                  }
                  errors++;
                }
              }
              if (data2.documentPath !== void 0) {
                let data8 = data2.documentPath;
                if (typeof data8 !== "string") {
                  const err38 = { instancePath: instancePath + "/level/documentPath", schemaPath: "#/properties/level/properties/documentPath/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: schema11.properties.level.properties.documentPath.type, parentSchema: schema11.properties.level.properties.documentPath, data: data8 };
                  if (vErrors === null) {
                    vErrors = [err38];
                  } else {
                    vErrors.push(err38);
                  }
                  errors++;
                }
              }
              if (data2.sessionId !== void 0) {
                let data9 = data2.sessionId;
                if (typeof data9 === "string") {
                  if (func4(data9) < 1) {
                    const err39 = { instancePath: instancePath + "/level/sessionId", schemaPath: "#/properties/level/properties/sessionId/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters", schema: 1, parentSchema: schema11.properties.level.properties.sessionId, data: data9 };
                    if (vErrors === null) {
                      vErrors = [err39];
                    } else {
                      vErrors.push(err39);
                    }
                    errors++;
                  }
                } else {
                  const err40 = { instancePath: instancePath + "/level/sessionId", schemaPath: "#/properties/level/properties/sessionId/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: schema11.properties.level.properties.sessionId.type, parentSchema: schema11.properties.level.properties.sessionId, data: data9 };
                  if (vErrors === null) {
                    vErrors = [err40];
                  } else {
                    vErrors.push(err40);
                  }
                  errors++;
                }
              }
              if (data2.revitVersion !== void 0) {
                let data10 = data2.revitVersion;
                if (typeof data10 === "string") {
                  if (!pattern0.test(data10)) {
                    const err41 = { instancePath: instancePath + "/level/revitVersion", schemaPath: "#/properties/level/properties/revitVersion/pattern", keyword: "pattern", params: { pattern: "^[0-9]{4}$" }, message: 'must match pattern "^[0-9]{4}$"', schema: "^[0-9]{4}$", parentSchema: schema11.properties.level.properties.revitVersion, data: data10 };
                    if (vErrors === null) {
                      vErrors = [err41];
                    } else {
                      vErrors.push(err41);
                    }
                    errors++;
                  }
                } else {
                  const err42 = { instancePath: instancePath + "/level/revitVersion", schemaPath: "#/properties/level/properties/revitVersion/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: schema11.properties.level.properties.revitVersion.type, parentSchema: schema11.properties.level.properties.revitVersion, data: data10 };
                  if (vErrors === null) {
                    vErrors = [err42];
                  } else {
                    vErrors.push(err42);
                  }
                  errors++;
                }
              }
              if (data2.lastUpdated !== void 0) {
                let data11 = data2.lastUpdated;
                if (typeof data11 === "string") {
                  if (func4(data11) < 1) {
                    const err43 = { instancePath: instancePath + "/level/lastUpdated", schemaPath: "#/properties/level/properties/lastUpdated/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters", schema: 1, parentSchema: schema11.properties.level.properties.lastUpdated, data: data11 };
                    if (vErrors === null) {
                      vErrors = [err43];
                    } else {
                      vErrors.push(err43);
                    }
                    errors++;
                  }
                } else {
                  const err44 = { instancePath: instancePath + "/level/lastUpdated", schemaPath: "#/properties/level/properties/lastUpdated/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: schema11.properties.level.properties.lastUpdated.type, parentSchema: schema11.properties.level.properties.lastUpdated, data: data11 };
                  if (vErrors === null) {
                    vErrors = [err44];
                  } else {
                    vErrors.push(err44);
                  }
                  errors++;
                }
              }
            } else {
              const err45 = { instancePath: instancePath + "/level", schemaPath: "#/properties/level/type", keyword: "type", params: { type: "object" }, message: "must be object", schema: schema11.properties.level.type, parentSchema: schema11.properties.level, data: data2 };
              if (vErrors === null) {
                vErrors = [err45];
              } else {
                vErrors.push(err45);
              }
              errors++;
            }
          }
          if (data.pipeType !== void 0) {
            let data12 = data.pipeType;
            const _errs32 = errors;
            let valid3 = true;
            const _errs33 = errors;
            if (errors === _errs33) {
              if (data12 && typeof data12 == "object" && !Array.isArray(data12)) {
                let missing0;
                if (data12.agentChoice === void 0 && (missing0 = "agentChoice")) {
                  const err46 = {};
                  if (vErrors === null) {
                    vErrors = [err46];
                  } else {
                    vErrors.push(err46);
                  }
                  errors++;
                } else {
                  if (data12.agentChoice !== void 0) {
                    if (true !== data12.agentChoice) {
                      const err47 = {};
                      if (vErrors === null) {
                        vErrors = [err47];
                      } else {
                        vErrors.push(err47);
                      }
                      errors++;
                    }
                  }
                }
              } else {
                const err48 = {};
                if (vErrors === null) {
                  vErrors = [err48];
                } else {
                  vErrors.push(err48);
                }
                errors++;
              }
            }
            var _valid1 = _errs33 === errors;
            errors = _errs32;
            if (vErrors !== null) {
              if (_errs32) {
                vErrors.length = _errs32;
              } else {
                vErrors = null;
              }
            }
            let ifClause0;
            if (_valid1) {
              const _errs36 = errors;
              if (data12 && typeof data12 == "object" && !Array.isArray(data12)) {
                if (Object.keys(data12).length > 2) {
                  const err49 = { instancePath: instancePath + "/pipeType", schemaPath: "#/properties/pipeType/then/maxProperties", keyword: "maxProperties", params: { limit: 2 }, message: "must NOT have more than 2 properties", schema: 2, parentSchema: schema11.properties.pipeType.then, data: data12 };
                  if (vErrors === null) {
                    vErrors = [err49];
                  } else {
                    vErrors.push(err49);
                  }
                  errors++;
                }
              } else {
                const err50 = { instancePath: instancePath + "/pipeType", schemaPath: "#/properties/pipeType/then/type", keyword: "type", params: { type: "object" }, message: "must be object", schema: schema11.properties.pipeType.then.type, parentSchema: schema11.properties.pipeType.then, data: data12 };
                if (vErrors === null) {
                  vErrors = [err50];
                } else {
                  vErrors.push(err50);
                }
                errors++;
              }
              var _valid1 = _errs36 === errors;
              valid3 = _valid1;
              ifClause0 = "then";
            } else {
              const _errs38 = errors;
              if (data12 && typeof data12 == "object" && !Array.isArray(data12)) {
                if (data12.id === void 0) {
                  const err51 = { instancePath: instancePath + "/pipeType", schemaPath: "#/properties/pipeType/else/required", keyword: "required", params: { missingProperty: "id" }, message: "must have required property 'id'", schema: schema11.properties.pipeType.else.required, parentSchema: schema11.properties.pipeType.else, data: data12 };
                  if (vErrors === null) {
                    vErrors = [err51];
                  } else {
                    vErrors.push(err51);
                  }
                  errors++;
                }
                if (data12.name === void 0) {
                  const err52 = { instancePath: instancePath + "/pipeType", schemaPath: "#/properties/pipeType/else/required", keyword: "required", params: { missingProperty: "name" }, message: "must have required property 'name'", schema: schema11.properties.pipeType.else.required, parentSchema: schema11.properties.pipeType.else, data: data12 };
                  if (vErrors === null) {
                    vErrors = [err52];
                  } else {
                    vErrors.push(err52);
                  }
                  errors++;
                }
                if (data12.documentId === void 0) {
                  const err53 = { instancePath: instancePath + "/pipeType", schemaPath: "#/properties/pipeType/else/required", keyword: "required", params: { missingProperty: "documentId" }, message: "must have required property 'documentId'", schema: schema11.properties.pipeType.else.required, parentSchema: schema11.properties.pipeType.else, data: data12 };
                  if (vErrors === null) {
                    vErrors = [err53];
                  } else {
                    vErrors.push(err53);
                  }
                  errors++;
                }
                if (data12.documentName === void 0) {
                  const err54 = { instancePath: instancePath + "/pipeType", schemaPath: "#/properties/pipeType/else/required", keyword: "required", params: { missingProperty: "documentName" }, message: "must have required property 'documentName'", schema: schema11.properties.pipeType.else.required, parentSchema: schema11.properties.pipeType.else, data: data12 };
                  if (vErrors === null) {
                    vErrors = [err54];
                  } else {
                    vErrors.push(err54);
                  }
                  errors++;
                }
                if (data12.documentPath === void 0) {
                  const err55 = { instancePath: instancePath + "/pipeType", schemaPath: "#/properties/pipeType/else/required", keyword: "required", params: { missingProperty: "documentPath" }, message: "must have required property 'documentPath'", schema: schema11.properties.pipeType.else.required, parentSchema: schema11.properties.pipeType.else, data: data12 };
                  if (vErrors === null) {
                    vErrors = [err55];
                  } else {
                    vErrors.push(err55);
                  }
                  errors++;
                }
                if (data12.sessionId === void 0) {
                  const err56 = { instancePath: instancePath + "/pipeType", schemaPath: "#/properties/pipeType/else/required", keyword: "required", params: { missingProperty: "sessionId" }, message: "must have required property 'sessionId'", schema: schema11.properties.pipeType.else.required, parentSchema: schema11.properties.pipeType.else, data: data12 };
                  if (vErrors === null) {
                    vErrors = [err56];
                  } else {
                    vErrors.push(err56);
                  }
                  errors++;
                }
                if (data12.revitVersion === void 0) {
                  const err57 = { instancePath: instancePath + "/pipeType", schemaPath: "#/properties/pipeType/else/required", keyword: "required", params: { missingProperty: "revitVersion" }, message: "must have required property 'revitVersion'", schema: schema11.properties.pipeType.else.required, parentSchema: schema11.properties.pipeType.else, data: data12 };
                  if (vErrors === null) {
                    vErrors = [err57];
                  } else {
                    vErrors.push(err57);
                  }
                  errors++;
                }
                if (data12.lastUpdated === void 0) {
                  const err58 = { instancePath: instancePath + "/pipeType", schemaPath: "#/properties/pipeType/else/required", keyword: "required", params: { missingProperty: "lastUpdated" }, message: "must have required property 'lastUpdated'", schema: schema11.properties.pipeType.else.required, parentSchema: schema11.properties.pipeType.else, data: data12 };
                  if (vErrors === null) {
                    vErrors = [err58];
                  } else {
                    vErrors.push(err58);
                  }
                  errors++;
                }
              } else {
                const err59 = { instancePath: instancePath + "/pipeType", schemaPath: "#/properties/pipeType/else/type", keyword: "type", params: { type: "object" }, message: "must be object", schema: schema11.properties.pipeType.else.type, parentSchema: schema11.properties.pipeType.else, data: data12 };
                if (vErrors === null) {
                  vErrors = [err59];
                } else {
                  vErrors.push(err59);
                }
                errors++;
              }
              var _valid1 = _errs38 === errors;
              valid3 = _valid1;
              ifClause0 = "else";
            }
            if (!valid3) {
              const err60 = { instancePath: instancePath + "/pipeType", schemaPath: "#/properties/pipeType/if", keyword: "if", params: { failingKeyword: ifClause0 }, message: 'must match "' + ifClause0 + '" schema', schema: schema11.properties.pipeType.if, parentSchema: schema11.properties.pipeType, data: data12 };
              if (vErrors === null) {
                vErrors = [err60];
              } else {
                vErrors.push(err60);
              }
              errors++;
            }
            if (data12 && typeof data12 == "object" && !Array.isArray(data12)) {
              if (data12.type === void 0) {
                const err61 = { instancePath: instancePath + "/pipeType", schemaPath: "#/properties/pipeType/required", keyword: "required", params: { missingProperty: "type" }, message: "must have required property 'type'", schema: schema11.properties.pipeType.required, parentSchema: schema11.properties.pipeType, data: data12 };
                if (vErrors === null) {
                  vErrors = [err61];
                } else {
                  vErrors.push(err61);
                }
                errors++;
              }
              for (const key2 in data12) {
                if (!func2.call(schema11.properties.pipeType.properties, key2)) {
                  const err62 = { instancePath: instancePath + "/pipeType", schemaPath: "#/properties/pipeType/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key2 }, message: "must NOT have additional properties", schema: false, parentSchema: schema11.properties.pipeType, data: data12 };
                  if (vErrors === null) {
                    vErrors = [err62];
                  } else {
                    vErrors.push(err62);
                  }
                  errors++;
                }
              }
              if (data12.agentChoice !== void 0) {
                let data14 = data12.agentChoice;
                if (typeof data14 !== "boolean") {
                  const err63 = { instancePath: instancePath + "/pipeType/agentChoice", schemaPath: "#/properties/pipeType/properties/agentChoice/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean", schema: schema11.properties.pipeType.properties.agentChoice.type, parentSchema: schema11.properties.pipeType.properties.agentChoice, data: data14 };
                  if (vErrors === null) {
                    vErrors = [err63];
                  } else {
                    vErrors.push(err63);
                  }
                  errors++;
                }
              }
              if (data12.id !== void 0) {
                let data15 = data12.id;
                if (typeof data15 === "string") {
                  if (func4(data15) < 1) {
                    const err64 = { instancePath: instancePath + "/pipeType/id", schemaPath: "#/properties/pipeType/properties/id/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters", schema: 1, parentSchema: schema11.properties.pipeType.properties.id, data: data15 };
                    if (vErrors === null) {
                      vErrors = [err64];
                    } else {
                      vErrors.push(err64);
                    }
                    errors++;
                  }
                } else {
                  const err65 = { instancePath: instancePath + "/pipeType/id", schemaPath: "#/properties/pipeType/properties/id/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: schema11.properties.pipeType.properties.id.type, parentSchema: schema11.properties.pipeType.properties.id, data: data15 };
                  if (vErrors === null) {
                    vErrors = [err65];
                  } else {
                    vErrors.push(err65);
                  }
                  errors++;
                }
              }
              if (data12.name !== void 0) {
                let data16 = data12.name;
                if (typeof data16 === "string") {
                  if (func4(data16) < 1) {
                    const err66 = { instancePath: instancePath + "/pipeType/name", schemaPath: "#/properties/pipeType/properties/name/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters", schema: 1, parentSchema: schema11.properties.pipeType.properties.name, data: data16 };
                    if (vErrors === null) {
                      vErrors = [err66];
                    } else {
                      vErrors.push(err66);
                    }
                    errors++;
                  }
                } else {
                  const err67 = { instancePath: instancePath + "/pipeType/name", schemaPath: "#/properties/pipeType/properties/name/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: schema11.properties.pipeType.properties.name.type, parentSchema: schema11.properties.pipeType.properties.name, data: data16 };
                  if (vErrors === null) {
                    vErrors = [err67];
                  } else {
                    vErrors.push(err67);
                  }
                  errors++;
                }
              }
              if (data12.type !== void 0) {
                let data17 = data12.type;
                if ("PipeType" !== data17) {
                  const err68 = { instancePath: instancePath + "/pipeType/type", schemaPath: "#/properties/pipeType/properties/type/const", keyword: "const", params: { allowedValue: "PipeType" }, message: "must be equal to constant", schema: "PipeType", parentSchema: schema11.properties.pipeType.properties.type, data: data17 };
                  if (vErrors === null) {
                    vErrors = [err68];
                  } else {
                    vErrors.push(err68);
                  }
                  errors++;
                }
              }
              if (data12.documentId !== void 0) {
                let data18 = data12.documentId;
                if (typeof data18 === "string") {
                  if (func4(data18) < 1) {
                    const err69 = { instancePath: instancePath + "/pipeType/documentId", schemaPath: "#/properties/pipeType/properties/documentId/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters", schema: 1, parentSchema: schema11.properties.pipeType.properties.documentId, data: data18 };
                    if (vErrors === null) {
                      vErrors = [err69];
                    } else {
                      vErrors.push(err69);
                    }
                    errors++;
                  }
                } else {
                  const err70 = { instancePath: instancePath + "/pipeType/documentId", schemaPath: "#/properties/pipeType/properties/documentId/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: schema11.properties.pipeType.properties.documentId.type, parentSchema: schema11.properties.pipeType.properties.documentId, data: data18 };
                  if (vErrors === null) {
                    vErrors = [err70];
                  } else {
                    vErrors.push(err70);
                  }
                  errors++;
                }
              }
              if (data12.documentName !== void 0) {
                let data19 = data12.documentName;
                if (typeof data19 !== "string") {
                  const err71 = { instancePath: instancePath + "/pipeType/documentName", schemaPath: "#/properties/pipeType/properties/documentName/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: schema11.properties.pipeType.properties.documentName.type, parentSchema: schema11.properties.pipeType.properties.documentName, data: data19 };
                  if (vErrors === null) {
                    vErrors = [err71];
                  } else {
                    vErrors.push(err71);
                  }
                  errors++;
                }
              }
              if (data12.documentPath !== void 0) {
                let data20 = data12.documentPath;
                if (typeof data20 !== "string") {
                  const err72 = { instancePath: instancePath + "/pipeType/documentPath", schemaPath: "#/properties/pipeType/properties/documentPath/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: schema11.properties.pipeType.properties.documentPath.type, parentSchema: schema11.properties.pipeType.properties.documentPath, data: data20 };
                  if (vErrors === null) {
                    vErrors = [err72];
                  } else {
                    vErrors.push(err72);
                  }
                  errors++;
                }
              }
              if (data12.sessionId !== void 0) {
                let data21 = data12.sessionId;
                if (typeof data21 === "string") {
                  if (func4(data21) < 1) {
                    const err73 = { instancePath: instancePath + "/pipeType/sessionId", schemaPath: "#/properties/pipeType/properties/sessionId/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters", schema: 1, parentSchema: schema11.properties.pipeType.properties.sessionId, data: data21 };
                    if (vErrors === null) {
                      vErrors = [err73];
                    } else {
                      vErrors.push(err73);
                    }
                    errors++;
                  }
                } else {
                  const err74 = { instancePath: instancePath + "/pipeType/sessionId", schemaPath: "#/properties/pipeType/properties/sessionId/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: schema11.properties.pipeType.properties.sessionId.type, parentSchema: schema11.properties.pipeType.properties.sessionId, data: data21 };
                  if (vErrors === null) {
                    vErrors = [err74];
                  } else {
                    vErrors.push(err74);
                  }
                  errors++;
                }
              }
              if (data12.revitVersion !== void 0) {
                let data22 = data12.revitVersion;
                if (typeof data22 === "string") {
                  if (!pattern0.test(data22)) {
                    const err75 = { instancePath: instancePath + "/pipeType/revitVersion", schemaPath: "#/properties/pipeType/properties/revitVersion/pattern", keyword: "pattern", params: { pattern: "^[0-9]{4}$" }, message: 'must match pattern "^[0-9]{4}$"', schema: "^[0-9]{4}$", parentSchema: schema11.properties.pipeType.properties.revitVersion, data: data22 };
                    if (vErrors === null) {
                      vErrors = [err75];
                    } else {
                      vErrors.push(err75);
                    }
                    errors++;
                  }
                } else {
                  const err76 = { instancePath: instancePath + "/pipeType/revitVersion", schemaPath: "#/properties/pipeType/properties/revitVersion/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: schema11.properties.pipeType.properties.revitVersion.type, parentSchema: schema11.properties.pipeType.properties.revitVersion, data: data22 };
                  if (vErrors === null) {
                    vErrors = [err76];
                  } else {
                    vErrors.push(err76);
                  }
                  errors++;
                }
              }
              if (data12.lastUpdated !== void 0) {
                let data23 = data12.lastUpdated;
                if (typeof data23 === "string") {
                  if (func4(data23) < 1) {
                    const err77 = { instancePath: instancePath + "/pipeType/lastUpdated", schemaPath: "#/properties/pipeType/properties/lastUpdated/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters", schema: 1, parentSchema: schema11.properties.pipeType.properties.lastUpdated, data: data23 };
                    if (vErrors === null) {
                      vErrors = [err77];
                    } else {
                      vErrors.push(err77);
                    }
                    errors++;
                  }
                } else {
                  const err78 = { instancePath: instancePath + "/pipeType/lastUpdated", schemaPath: "#/properties/pipeType/properties/lastUpdated/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: schema11.properties.pipeType.properties.lastUpdated.type, parentSchema: schema11.properties.pipeType.properties.lastUpdated, data: data23 };
                  if (vErrors === null) {
                    vErrors = [err78];
                  } else {
                    vErrors.push(err78);
                  }
                  errors++;
                }
              }
            } else {
              const err79 = { instancePath: instancePath + "/pipeType", schemaPath: "#/properties/pipeType/type", keyword: "type", params: { type: "object" }, message: "must be object", schema: schema11.properties.pipeType.type, parentSchema: schema11.properties.pipeType, data: data12 };
              if (vErrors === null) {
                vErrors = [err79];
              } else {
                vErrors.push(err79);
              }
              errors++;
            }
          }
          if (data.systemType !== void 0) {
            let data24 = data.systemType;
            const _errs62 = errors;
            let valid6 = true;
            const _errs63 = errors;
            if (errors === _errs63) {
              if (data24 && typeof data24 == "object" && !Array.isArray(data24)) {
                let missing1;
                if (data24.agentChoice === void 0 && (missing1 = "agentChoice")) {
                  const err80 = {};
                  if (vErrors === null) {
                    vErrors = [err80];
                  } else {
                    vErrors.push(err80);
                  }
                  errors++;
                } else {
                  if (data24.agentChoice !== void 0) {
                    if (true !== data24.agentChoice) {
                      const err81 = {};
                      if (vErrors === null) {
                        vErrors = [err81];
                      } else {
                        vErrors.push(err81);
                      }
                      errors++;
                    }
                  }
                }
              } else {
                const err82 = {};
                if (vErrors === null) {
                  vErrors = [err82];
                } else {
                  vErrors.push(err82);
                }
                errors++;
              }
            }
            var _valid2 = _errs63 === errors;
            errors = _errs62;
            if (vErrors !== null) {
              if (_errs62) {
                vErrors.length = _errs62;
              } else {
                vErrors = null;
              }
            }
            let ifClause1;
            if (_valid2) {
              const _errs66 = errors;
              if (data24 && typeof data24 == "object" && !Array.isArray(data24)) {
                if (Object.keys(data24).length > 2) {
                  const err83 = { instancePath: instancePath + "/systemType", schemaPath: "#/properties/systemType/then/maxProperties", keyword: "maxProperties", params: { limit: 2 }, message: "must NOT have more than 2 properties", schema: 2, parentSchema: schema11.properties.systemType.then, data: data24 };
                  if (vErrors === null) {
                    vErrors = [err83];
                  } else {
                    vErrors.push(err83);
                  }
                  errors++;
                }
              } else {
                const err84 = { instancePath: instancePath + "/systemType", schemaPath: "#/properties/systemType/then/type", keyword: "type", params: { type: "object" }, message: "must be object", schema: schema11.properties.systemType.then.type, parentSchema: schema11.properties.systemType.then, data: data24 };
                if (vErrors === null) {
                  vErrors = [err84];
                } else {
                  vErrors.push(err84);
                }
                errors++;
              }
              var _valid2 = _errs66 === errors;
              valid6 = _valid2;
              ifClause1 = "then";
            } else {
              const _errs68 = errors;
              if (data24 && typeof data24 == "object" && !Array.isArray(data24)) {
                if (data24.id === void 0) {
                  const err85 = { instancePath: instancePath + "/systemType", schemaPath: "#/properties/systemType/else/required", keyword: "required", params: { missingProperty: "id" }, message: "must have required property 'id'", schema: schema11.properties.systemType.else.required, parentSchema: schema11.properties.systemType.else, data: data24 };
                  if (vErrors === null) {
                    vErrors = [err85];
                  } else {
                    vErrors.push(err85);
                  }
                  errors++;
                }
                if (data24.name === void 0) {
                  const err86 = { instancePath: instancePath + "/systemType", schemaPath: "#/properties/systemType/else/required", keyword: "required", params: { missingProperty: "name" }, message: "must have required property 'name'", schema: schema11.properties.systemType.else.required, parentSchema: schema11.properties.systemType.else, data: data24 };
                  if (vErrors === null) {
                    vErrors = [err86];
                  } else {
                    vErrors.push(err86);
                  }
                  errors++;
                }
                if (data24.documentId === void 0) {
                  const err87 = { instancePath: instancePath + "/systemType", schemaPath: "#/properties/systemType/else/required", keyword: "required", params: { missingProperty: "documentId" }, message: "must have required property 'documentId'", schema: schema11.properties.systemType.else.required, parentSchema: schema11.properties.systemType.else, data: data24 };
                  if (vErrors === null) {
                    vErrors = [err87];
                  } else {
                    vErrors.push(err87);
                  }
                  errors++;
                }
                if (data24.documentName === void 0) {
                  const err88 = { instancePath: instancePath + "/systemType", schemaPath: "#/properties/systemType/else/required", keyword: "required", params: { missingProperty: "documentName" }, message: "must have required property 'documentName'", schema: schema11.properties.systemType.else.required, parentSchema: schema11.properties.systemType.else, data: data24 };
                  if (vErrors === null) {
                    vErrors = [err88];
                  } else {
                    vErrors.push(err88);
                  }
                  errors++;
                }
                if (data24.documentPath === void 0) {
                  const err89 = { instancePath: instancePath + "/systemType", schemaPath: "#/properties/systemType/else/required", keyword: "required", params: { missingProperty: "documentPath" }, message: "must have required property 'documentPath'", schema: schema11.properties.systemType.else.required, parentSchema: schema11.properties.systemType.else, data: data24 };
                  if (vErrors === null) {
                    vErrors = [err89];
                  } else {
                    vErrors.push(err89);
                  }
                  errors++;
                }
                if (data24.sessionId === void 0) {
                  const err90 = { instancePath: instancePath + "/systemType", schemaPath: "#/properties/systemType/else/required", keyword: "required", params: { missingProperty: "sessionId" }, message: "must have required property 'sessionId'", schema: schema11.properties.systemType.else.required, parentSchema: schema11.properties.systemType.else, data: data24 };
                  if (vErrors === null) {
                    vErrors = [err90];
                  } else {
                    vErrors.push(err90);
                  }
                  errors++;
                }
                if (data24.revitVersion === void 0) {
                  const err91 = { instancePath: instancePath + "/systemType", schemaPath: "#/properties/systemType/else/required", keyword: "required", params: { missingProperty: "revitVersion" }, message: "must have required property 'revitVersion'", schema: schema11.properties.systemType.else.required, parentSchema: schema11.properties.systemType.else, data: data24 };
                  if (vErrors === null) {
                    vErrors = [err91];
                  } else {
                    vErrors.push(err91);
                  }
                  errors++;
                }
                if (data24.lastUpdated === void 0) {
                  const err92 = { instancePath: instancePath + "/systemType", schemaPath: "#/properties/systemType/else/required", keyword: "required", params: { missingProperty: "lastUpdated" }, message: "must have required property 'lastUpdated'", schema: schema11.properties.systemType.else.required, parentSchema: schema11.properties.systemType.else, data: data24 };
                  if (vErrors === null) {
                    vErrors = [err92];
                  } else {
                    vErrors.push(err92);
                  }
                  errors++;
                }
              } else {
                const err93 = { instancePath: instancePath + "/systemType", schemaPath: "#/properties/systemType/else/type", keyword: "type", params: { type: "object" }, message: "must be object", schema: schema11.properties.systemType.else.type, parentSchema: schema11.properties.systemType.else, data: data24 };
                if (vErrors === null) {
                  vErrors = [err93];
                } else {
                  vErrors.push(err93);
                }
                errors++;
              }
              var _valid2 = _errs68 === errors;
              valid6 = _valid2;
              ifClause1 = "else";
            }
            if (!valid6) {
              const err94 = { instancePath: instancePath + "/systemType", schemaPath: "#/properties/systemType/if", keyword: "if", params: { failingKeyword: ifClause1 }, message: 'must match "' + ifClause1 + '" schema', schema: schema11.properties.systemType.if, parentSchema: schema11.properties.systemType, data: data24 };
              if (vErrors === null) {
                vErrors = [err94];
              } else {
                vErrors.push(err94);
              }
              errors++;
            }
            if (data24 && typeof data24 == "object" && !Array.isArray(data24)) {
              if (data24.type === void 0) {
                const err95 = { instancePath: instancePath + "/systemType", schemaPath: "#/properties/systemType/required", keyword: "required", params: { missingProperty: "type" }, message: "must have required property 'type'", schema: schema11.properties.systemType.required, parentSchema: schema11.properties.systemType, data: data24 };
                if (vErrors === null) {
                  vErrors = [err95];
                } else {
                  vErrors.push(err95);
                }
                errors++;
              }
              for (const key3 in data24) {
                if (!func2.call(schema11.properties.systemType.properties, key3)) {
                  const err96 = { instancePath: instancePath + "/systemType", schemaPath: "#/properties/systemType/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key3 }, message: "must NOT have additional properties", schema: false, parentSchema: schema11.properties.systemType, data: data24 };
                  if (vErrors === null) {
                    vErrors = [err96];
                  } else {
                    vErrors.push(err96);
                  }
                  errors++;
                }
              }
              if (data24.agentChoice !== void 0) {
                let data26 = data24.agentChoice;
                if (typeof data26 !== "boolean") {
                  const err97 = { instancePath: instancePath + "/systemType/agentChoice", schemaPath: "#/properties/systemType/properties/agentChoice/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean", schema: schema11.properties.systemType.properties.agentChoice.type, parentSchema: schema11.properties.systemType.properties.agentChoice, data: data26 };
                  if (vErrors === null) {
                    vErrors = [err97];
                  } else {
                    vErrors.push(err97);
                  }
                  errors++;
                }
              }
              if (data24.id !== void 0) {
                let data27 = data24.id;
                if (typeof data27 === "string") {
                  if (func4(data27) < 1) {
                    const err98 = { instancePath: instancePath + "/systemType/id", schemaPath: "#/properties/systemType/properties/id/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters", schema: 1, parentSchema: schema11.properties.systemType.properties.id, data: data27 };
                    if (vErrors === null) {
                      vErrors = [err98];
                    } else {
                      vErrors.push(err98);
                    }
                    errors++;
                  }
                } else {
                  const err99 = { instancePath: instancePath + "/systemType/id", schemaPath: "#/properties/systemType/properties/id/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: schema11.properties.systemType.properties.id.type, parentSchema: schema11.properties.systemType.properties.id, data: data27 };
                  if (vErrors === null) {
                    vErrors = [err99];
                  } else {
                    vErrors.push(err99);
                  }
                  errors++;
                }
              }
              if (data24.name !== void 0) {
                let data28 = data24.name;
                if (typeof data28 === "string") {
                  if (func4(data28) < 1) {
                    const err100 = { instancePath: instancePath + "/systemType/name", schemaPath: "#/properties/systemType/properties/name/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters", schema: 1, parentSchema: schema11.properties.systemType.properties.name, data: data28 };
                    if (vErrors === null) {
                      vErrors = [err100];
                    } else {
                      vErrors.push(err100);
                    }
                    errors++;
                  }
                } else {
                  const err101 = { instancePath: instancePath + "/systemType/name", schemaPath: "#/properties/systemType/properties/name/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: schema11.properties.systemType.properties.name.type, parentSchema: schema11.properties.systemType.properties.name, data: data28 };
                  if (vErrors === null) {
                    vErrors = [err101];
                  } else {
                    vErrors.push(err101);
                  }
                  errors++;
                }
              }
              if (data24.type !== void 0) {
                let data29 = data24.type;
                if ("MEPSystemType" !== data29) {
                  const err102 = { instancePath: instancePath + "/systemType/type", schemaPath: "#/properties/systemType/properties/type/const", keyword: "const", params: { allowedValue: "MEPSystemType" }, message: "must be equal to constant", schema: "MEPSystemType", parentSchema: schema11.properties.systemType.properties.type, data: data29 };
                  if (vErrors === null) {
                    vErrors = [err102];
                  } else {
                    vErrors.push(err102);
                  }
                  errors++;
                }
              }
              if (data24.documentId !== void 0) {
                let data30 = data24.documentId;
                if (typeof data30 === "string") {
                  if (func4(data30) < 1) {
                    const err103 = { instancePath: instancePath + "/systemType/documentId", schemaPath: "#/properties/systemType/properties/documentId/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters", schema: 1, parentSchema: schema11.properties.systemType.properties.documentId, data: data30 };
                    if (vErrors === null) {
                      vErrors = [err103];
                    } else {
                      vErrors.push(err103);
                    }
                    errors++;
                  }
                } else {
                  const err104 = { instancePath: instancePath + "/systemType/documentId", schemaPath: "#/properties/systemType/properties/documentId/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: schema11.properties.systemType.properties.documentId.type, parentSchema: schema11.properties.systemType.properties.documentId, data: data30 };
                  if (vErrors === null) {
                    vErrors = [err104];
                  } else {
                    vErrors.push(err104);
                  }
                  errors++;
                }
              }
              if (data24.documentName !== void 0) {
                let data31 = data24.documentName;
                if (typeof data31 !== "string") {
                  const err105 = { instancePath: instancePath + "/systemType/documentName", schemaPath: "#/properties/systemType/properties/documentName/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: schema11.properties.systemType.properties.documentName.type, parentSchema: schema11.properties.systemType.properties.documentName, data: data31 };
                  if (vErrors === null) {
                    vErrors = [err105];
                  } else {
                    vErrors.push(err105);
                  }
                  errors++;
                }
              }
              if (data24.documentPath !== void 0) {
                let data32 = data24.documentPath;
                if (typeof data32 !== "string") {
                  const err106 = { instancePath: instancePath + "/systemType/documentPath", schemaPath: "#/properties/systemType/properties/documentPath/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: schema11.properties.systemType.properties.documentPath.type, parentSchema: schema11.properties.systemType.properties.documentPath, data: data32 };
                  if (vErrors === null) {
                    vErrors = [err106];
                  } else {
                    vErrors.push(err106);
                  }
                  errors++;
                }
              }
              if (data24.sessionId !== void 0) {
                let data33 = data24.sessionId;
                if (typeof data33 === "string") {
                  if (func4(data33) < 1) {
                    const err107 = { instancePath: instancePath + "/systemType/sessionId", schemaPath: "#/properties/systemType/properties/sessionId/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters", schema: 1, parentSchema: schema11.properties.systemType.properties.sessionId, data: data33 };
                    if (vErrors === null) {
                      vErrors = [err107];
                    } else {
                      vErrors.push(err107);
                    }
                    errors++;
                  }
                } else {
                  const err108 = { instancePath: instancePath + "/systemType/sessionId", schemaPath: "#/properties/systemType/properties/sessionId/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: schema11.properties.systemType.properties.sessionId.type, parentSchema: schema11.properties.systemType.properties.sessionId, data: data33 };
                  if (vErrors === null) {
                    vErrors = [err108];
                  } else {
                    vErrors.push(err108);
                  }
                  errors++;
                }
              }
              if (data24.revitVersion !== void 0) {
                let data34 = data24.revitVersion;
                if (typeof data34 === "string") {
                  if (!pattern0.test(data34)) {
                    const err109 = { instancePath: instancePath + "/systemType/revitVersion", schemaPath: "#/properties/systemType/properties/revitVersion/pattern", keyword: "pattern", params: { pattern: "^[0-9]{4}$" }, message: 'must match pattern "^[0-9]{4}$"', schema: "^[0-9]{4}$", parentSchema: schema11.properties.systemType.properties.revitVersion, data: data34 };
                    if (vErrors === null) {
                      vErrors = [err109];
                    } else {
                      vErrors.push(err109);
                    }
                    errors++;
                  }
                } else {
                  const err110 = { instancePath: instancePath + "/systemType/revitVersion", schemaPath: "#/properties/systemType/properties/revitVersion/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: schema11.properties.systemType.properties.revitVersion.type, parentSchema: schema11.properties.systemType.properties.revitVersion, data: data34 };
                  if (vErrors === null) {
                    vErrors = [err110];
                  } else {
                    vErrors.push(err110);
                  }
                  errors++;
                }
              }
              if (data24.lastUpdated !== void 0) {
                let data35 = data24.lastUpdated;
                if (typeof data35 === "string") {
                  if (func4(data35) < 1) {
                    const err111 = { instancePath: instancePath + "/systemType/lastUpdated", schemaPath: "#/properties/systemType/properties/lastUpdated/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters", schema: 1, parentSchema: schema11.properties.systemType.properties.lastUpdated, data: data35 };
                    if (vErrors === null) {
                      vErrors = [err111];
                    } else {
                      vErrors.push(err111);
                    }
                    errors++;
                  }
                } else {
                  const err112 = { instancePath: instancePath + "/systemType/lastUpdated", schemaPath: "#/properties/systemType/properties/lastUpdated/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: schema11.properties.systemType.properties.lastUpdated.type, parentSchema: schema11.properties.systemType.properties.lastUpdated, data: data35 };
                  if (vErrors === null) {
                    vErrors = [err112];
                  } else {
                    vErrors.push(err112);
                  }
                  errors++;
                }
              }
            } else {
              const err113 = { instancePath: instancePath + "/systemType", schemaPath: "#/properties/systemType/type", keyword: "type", params: { type: "object" }, message: "must be object", schema: schema11.properties.systemType.type, parentSchema: schema11.properties.systemType, data: data24 };
              if (vErrors === null) {
                vErrors = [err113];
              } else {
                vErrors.push(err113);
              }
              errors++;
            }
          }
          if (data.pipeHeightCm !== void 0) {
            let data36 = data.pipeHeightCm;
            if (typeof data36 == "number" && isFinite(data36)) {
              if (data36 < 0 || isNaN(data36)) {
                const err114 = { instancePath: instancePath + "/pipeHeightCm", schemaPath: "#/properties/pipeHeightCm/minimum", keyword: "minimum", params: { comparison: ">=", limit: 0 }, message: "must be >= 0", schema: 0, parentSchema: schema11.properties.pipeHeightCm, data: data36 };
                if (vErrors === null) {
                  vErrors = [err114];
                } else {
                  vErrors.push(err114);
                }
                errors++;
              }
            } else {
              const err115 = { instancePath: instancePath + "/pipeHeightCm", schemaPath: "#/properties/pipeHeightCm/type", keyword: "type", params: { type: "number" }, message: "must be number", schema: schema11.properties.pipeHeightCm.type, parentSchema: schema11.properties.pipeHeightCm, data: data36 };
              if (vErrors === null) {
                vErrors = [err115];
              } else {
                vErrors.push(err115);
              }
              errors++;
            }
          }
          if (data.sprinklerHeightCm !== void 0) {
            let data37 = data.sprinklerHeightCm;
            if (typeof data37 == "number" && isFinite(data37)) {
              if (data37 < 0 || isNaN(data37)) {
                const err116 = { instancePath: instancePath + "/sprinklerHeightCm", schemaPath: "#/properties/sprinklerHeightCm/minimum", keyword: "minimum", params: { comparison: ">=", limit: 0 }, message: "must be >= 0", schema: 0, parentSchema: schema11.properties.sprinklerHeightCm, data: data37 };
                if (vErrors === null) {
                  vErrors = [err116];
                } else {
                  vErrors.push(err116);
                }
                errors++;
              }
            } else {
              const err117 = { instancePath: instancePath + "/sprinklerHeightCm", schemaPath: "#/properties/sprinklerHeightCm/type", keyword: "type", params: { type: "number" }, message: "must be number", schema: schema11.properties.sprinklerHeightCm.type, parentSchema: schema11.properties.sprinklerHeightCm, data: data37 };
              if (vErrors === null) {
                vErrors = [err117];
              } else {
                vErrors.push(err117);
              }
              errors++;
            }
          }
          if (data.crossingOffsetCm !== void 0) {
            let data38 = data.crossingOffsetCm;
            if (typeof data38 == "number" && isFinite(data38)) {
              if (data38 <= 0 || isNaN(data38)) {
                const err118 = { instancePath: instancePath + "/crossingOffsetCm", schemaPath: "#/properties/crossingOffsetCm/exclusiveMinimum", keyword: "exclusiveMinimum", params: { comparison: ">", limit: 0 }, message: "must be > 0", schema: 0, parentSchema: schema11.properties.crossingOffsetCm, data: data38 };
                if (vErrors === null) {
                  vErrors = [err118];
                } else {
                  vErrors.push(err118);
                }
                errors++;
              }
            } else {
              const err119 = { instancePath: instancePath + "/crossingOffsetCm", schemaPath: "#/properties/crossingOffsetCm/type", keyword: "type", params: { type: "number" }, message: "must be number", schema: schema11.properties.crossingOffsetCm.type, parentSchema: schema11.properties.crossingOffsetCm, data: data38 };
              if (vErrors === null) {
                vErrors = [err119];
              } else {
                vErrors.push(err119);
              }
              errors++;
            }
          }
          if (data.executionMode !== void 0) {
            let data39 = data.executionMode;
            if (typeof data39 !== "string") {
              const err120 = { instancePath: instancePath + "/executionMode", schemaPath: "#/properties/executionMode/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: schema11.properties.executionMode.type, parentSchema: schema11.properties.executionMode, data: data39 };
              if (vErrors === null) {
                vErrors = [err120];
              } else {
                vErrors.push(err120);
              }
              errors++;
            }
            const _errs98 = errors;
            let valid9 = false;
            let passing1 = null;
            const _errs99 = errors;
            if ("complete" !== data39) {
              const err121 = { instancePath: instancePath + "/executionMode", schemaPath: "#/properties/executionMode/oneOf/0/const", keyword: "const", params: { allowedValue: "complete" }, message: "must be equal to constant", schema: "complete", parentSchema: schema11.properties.executionMode.oneOf[0], data: data39 };
              if (vErrors === null) {
                vErrors = [err121];
              } else {
                vErrors.push(err121);
              }
              errors++;
            }
            var _valid3 = _errs99 === errors;
            if (_valid3) {
              valid9 = true;
              passing1 = 0;
            }
            const _errs100 = errors;
            if ("investigate" !== data39) {
              const err122 = { instancePath: instancePath + "/executionMode", schemaPath: "#/properties/executionMode/oneOf/1/const", keyword: "const", params: { allowedValue: "investigate" }, message: "must be equal to constant", schema: "investigate", parentSchema: schema11.properties.executionMode.oneOf[1], data: data39 };
              if (vErrors === null) {
                vErrors = [err122];
              } else {
                vErrors.push(err122);
              }
              errors++;
            }
            var _valid3 = _errs100 === errors;
            if (_valid3 && valid9) {
              valid9 = false;
              passing1 = [passing1, 1];
            } else {
              if (_valid3) {
                valid9 = true;
                passing1 = 1;
              }
            }
            if (!valid9) {
              const err123 = { instancePath: instancePath + "/executionMode", schemaPath: "#/properties/executionMode/oneOf", keyword: "oneOf", params: { passingSchemas: passing1 }, message: "must match exactly one schema in oneOf", schema: schema11.properties.executionMode.oneOf, parentSchema: schema11.properties.executionMode, data: data39 };
              if (vErrors === null) {
                vErrors = [err123];
              } else {
                vErrors.push(err123);
              }
              errors++;
            } else {
              errors = _errs98;
              if (vErrors !== null) {
                if (_errs98) {
                  vErrors.length = _errs98;
                } else {
                  vErrors = null;
                }
              }
            }
          }
          if (data.drawingQuality !== void 0) {
            let data40 = data.drawingQuality;
            if (typeof data40 !== "string") {
              const err124 = { instancePath: instancePath + "/drawingQuality", schemaPath: "#/properties/drawingQuality/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: schema11.properties.drawingQuality.type, parentSchema: schema11.properties.drawingQuality, data: data40 };
              if (vErrors === null) {
                vErrors = [err124];
              } else {
                vErrors.push(err124);
              }
              errors++;
            }
            const _errs103 = errors;
            let valid10 = false;
            let passing2 = null;
            const _errs104 = errors;
            if ("unknown" !== data40) {
              const err125 = { instancePath: instancePath + "/drawingQuality", schemaPath: "#/properties/drawingQuality/oneOf/0/const", keyword: "const", params: { allowedValue: "unknown" }, message: "must be equal to constant", schema: "unknown", parentSchema: schema11.properties.drawingQuality.oneOf[0], data: data40 };
              if (vErrors === null) {
                vErrors = [err125];
              } else {
                vErrors.push(err125);
              }
              errors++;
            }
            var _valid4 = _errs104 === errors;
            if (_valid4) {
              valid10 = true;
              passing2 = 0;
            }
            const _errs105 = errors;
            if ("cleaned" !== data40) {
              const err126 = { instancePath: instancePath + "/drawingQuality", schemaPath: "#/properties/drawingQuality/oneOf/1/const", keyword: "const", params: { allowedValue: "cleaned" }, message: "must be equal to constant", schema: "cleaned", parentSchema: schema11.properties.drawingQuality.oneOf[1], data: data40 };
              if (vErrors === null) {
                vErrors = [err126];
              } else {
                vErrors.push(err126);
              }
              errors++;
            }
            var _valid4 = _errs105 === errors;
            if (_valid4 && valid10) {
              valid10 = false;
              passing2 = [passing2, 1];
            } else {
              if (_valid4) {
                valid10 = true;
                passing2 = 1;
              }
            }
            if (!valid10) {
              const err127 = { instancePath: instancePath + "/drawingQuality", schemaPath: "#/properties/drawingQuality/oneOf", keyword: "oneOf", params: { passingSchemas: passing2 }, message: "must match exactly one schema in oneOf", schema: schema11.properties.drawingQuality.oneOf, parentSchema: schema11.properties.drawingQuality, data: data40 };
              if (vErrors === null) {
                vErrors = [err127];
              } else {
                vErrors.push(err127);
              }
              errors++;
            } else {
              errors = _errs103;
              if (vErrors !== null) {
                if (_errs103) {
                  vErrors.length = _errs103;
                } else {
                  vErrors = null;
                }
              }
            }
          }
          if (data.cadOverlay !== void 0) {
            let data41 = data.cadOverlay;
            if (typeof data41 !== "string") {
              const err128 = { instancePath: instancePath + "/cadOverlay", schemaPath: "#/properties/cadOverlay/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: schema11.properties.cadOverlay.type, parentSchema: schema11.properties.cadOverlay, data: data41 };
              if (vErrors === null) {
                vErrors = [err128];
              } else {
                vErrors.push(err128);
              }
              errors++;
            }
            const _errs108 = errors;
            let valid11 = false;
            let passing3 = null;
            const _errs109 = errors;
            if ("include" !== data41) {
              const err129 = { instancePath: instancePath + "/cadOverlay", schemaPath: "#/properties/cadOverlay/oneOf/0/const", keyword: "const", params: { allowedValue: "include" }, message: "must be equal to constant", schema: "include", parentSchema: schema11.properties.cadOverlay.oneOf[0], data: data41 };
              if (vErrors === null) {
                vErrors = [err129];
              } else {
                vErrors.push(err129);
              }
              errors++;
            }
            var _valid5 = _errs109 === errors;
            if (_valid5) {
              valid11 = true;
              passing3 = 0;
            }
            const _errs110 = errors;
            if ("existing" !== data41) {
              const err130 = { instancePath: instancePath + "/cadOverlay", schemaPath: "#/properties/cadOverlay/oneOf/1/const", keyword: "const", params: { allowedValue: "existing" }, message: "must be equal to constant", schema: "existing", parentSchema: schema11.properties.cadOverlay.oneOf[1], data: data41 };
              if (vErrors === null) {
                vErrors = [err130];
              } else {
                vErrors.push(err130);
              }
              errors++;
            }
            var _valid5 = _errs110 === errors;
            if (_valid5 && valid11) {
              valid11 = false;
              passing3 = [passing3, 1];
            } else {
              if (_valid5) {
                valid11 = true;
                passing3 = 1;
              }
              const _errs111 = errors;
              if ("skip" !== data41) {
                const err131 = { instancePath: instancePath + "/cadOverlay", schemaPath: "#/properties/cadOverlay/oneOf/2/const", keyword: "const", params: { allowedValue: "skip" }, message: "must be equal to constant", schema: "skip", parentSchema: schema11.properties.cadOverlay.oneOf[2], data: data41 };
                if (vErrors === null) {
                  vErrors = [err131];
                } else {
                  vErrors.push(err131);
                }
                errors++;
              }
              var _valid5 = _errs111 === errors;
              if (_valid5 && valid11) {
                valid11 = false;
                passing3 = [passing3, 2];
              } else {
                if (_valid5) {
                  valid11 = true;
                  passing3 = 2;
                }
              }
            }
            if (!valid11) {
              const err132 = { instancePath: instancePath + "/cadOverlay", schemaPath: "#/properties/cadOverlay/oneOf", keyword: "oneOf", params: { passingSchemas: passing3 }, message: "must match exactly one schema in oneOf", schema: schema11.properties.cadOverlay.oneOf, parentSchema: schema11.properties.cadOverlay, data: data41 };
              if (vErrors === null) {
                vErrors = [err132];
              } else {
                vErrors.push(err132);
              }
              errors++;
            } else {
              errors = _errs108;
              if (vErrors !== null) {
                if (_errs108) {
                  vErrors.length = _errs108;
                } else {
                  vErrors = null;
                }
              }
            }
          }
          if (data.jointType !== void 0) {
            let data42 = data.jointType;
            if (typeof data42 !== "string") {
              const err133 = { instancePath: instancePath + "/jointType", schemaPath: "#/properties/jointType/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: schema11.properties.jointType.type, parentSchema: schema11.properties.jointType, data: data42 };
              if (vErrors === null) {
                vErrors = [err133];
              } else {
                vErrors.push(err133);
              }
              errors++;
            }
            const _errs114 = errors;
            let valid12 = false;
            let passing4 = null;
            const _errs115 = errors;
            if ("routing" !== data42) {
              const err134 = { instancePath: instancePath + "/jointType", schemaPath: "#/properties/jointType/oneOf/0/const", keyword: "const", params: { allowedValue: "routing" }, message: "must be equal to constant", schema: "routing", parentSchema: schema11.properties.jointType.oneOf[0], data: data42 };
              if (vErrors === null) {
                vErrors = [err134];
              } else {
                vErrors.push(err134);
              }
              errors++;
            }
            var _valid6 = _errs115 === errors;
            if (_valid6) {
              valid12 = true;
              passing4 = 0;
            }
            const _errs116 = errors;
            if ("mechanical" !== data42) {
              const err135 = { instancePath: instancePath + "/jointType", schemaPath: "#/properties/jointType/oneOf/1/const", keyword: "const", params: { allowedValue: "mechanical" }, message: "must be equal to constant", schema: "mechanical", parentSchema: schema11.properties.jointType.oneOf[1], data: data42 };
              if (vErrors === null) {
                vErrors = [err135];
              } else {
                vErrors.push(err135);
              }
              errors++;
            }
            var _valid6 = _errs116 === errors;
            if (_valid6 && valid12) {
              valid12 = false;
              passing4 = [passing4, 1];
            } else {
              if (_valid6) {
                valid12 = true;
                passing4 = 1;
              }
              const _errs117 = errors;
              if ("threaded" !== data42) {
                const err136 = { instancePath: instancePath + "/jointType", schemaPath: "#/properties/jointType/oneOf/2/const", keyword: "const", params: { allowedValue: "threaded" }, message: "must be equal to constant", schema: "threaded", parentSchema: schema11.properties.jointType.oneOf[2], data: data42 };
                if (vErrors === null) {
                  vErrors = [err136];
                } else {
                  vErrors.push(err136);
                }
                errors++;
              }
              var _valid6 = _errs117 === errors;
              if (_valid6 && valid12) {
                valid12 = false;
                passing4 = [passing4, 2];
              } else {
                if (_valid6) {
                  valid12 = true;
                  passing4 = 2;
                }
                const _errs118 = errors;
                if ("agent" !== data42) {
                  const err137 = { instancePath: instancePath + "/jointType", schemaPath: "#/properties/jointType/oneOf/3/const", keyword: "const", params: { allowedValue: "agent" }, message: "must be equal to constant", schema: "agent", parentSchema: schema11.properties.jointType.oneOf[3], data: data42 };
                  if (vErrors === null) {
                    vErrors = [err137];
                  } else {
                    vErrors.push(err137);
                  }
                  errors++;
                }
                var _valid6 = _errs118 === errors;
                if (_valid6 && valid12) {
                  valid12 = false;
                  passing4 = [passing4, 3];
                } else {
                  if (_valid6) {
                    valid12 = true;
                    passing4 = 3;
                  }
                }
              }
            }
            if (!valid12) {
              const err138 = { instancePath: instancePath + "/jointType", schemaPath: "#/properties/jointType/oneOf", keyword: "oneOf", params: { passingSchemas: passing4 }, message: "must match exactly one schema in oneOf", schema: schema11.properties.jointType.oneOf, parentSchema: schema11.properties.jointType, data: data42 };
              if (vErrors === null) {
                vErrors = [err138];
              } else {
                vErrors.push(err138);
              }
              errors++;
            } else {
              errors = _errs114;
              if (vErrors !== null) {
                if (_errs114) {
                  vErrors.length = _errs114;
                } else {
                  vErrors = null;
                }
              }
            }
          }
          if (data.missingComponents !== void 0) {
            let data43 = data.missingComponents;
            if (typeof data43 !== "string") {
              const err139 = { instancePath: instancePath + "/missingComponents", schemaPath: "#/properties/missingComponents/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: schema11.properties.missingComponents.type, parentSchema: schema11.properties.missingComponents, data: data43 };
              if (vErrors === null) {
                vErrors = [err139];
              } else {
                vErrors.push(err139);
              }
              errors++;
            }
            const _errs121 = errors;
            let valid13 = false;
            let passing5 = null;
            const _errs122 = errors;
            if ("create" !== data43) {
              const err140 = { instancePath: instancePath + "/missingComponents", schemaPath: "#/properties/missingComponents/oneOf/0/const", keyword: "const", params: { allowedValue: "create" }, message: "must be equal to constant", schema: "create", parentSchema: schema11.properties.missingComponents.oneOf[0], data: data43 };
              if (vErrors === null) {
                vErrors = [err140];
              } else {
                vErrors.push(err140);
              }
              errors++;
            }
            var _valid7 = _errs122 === errors;
            if (_valid7) {
              valid13 = true;
              passing5 = 0;
            }
            const _errs123 = errors;
            if ("substitute" !== data43) {
              const err141 = { instancePath: instancePath + "/missingComponents", schemaPath: "#/properties/missingComponents/oneOf/1/const", keyword: "const", params: { allowedValue: "substitute" }, message: "must be equal to constant", schema: "substitute", parentSchema: schema11.properties.missingComponents.oneOf[1], data: data43 };
              if (vErrors === null) {
                vErrors = [err141];
              } else {
                vErrors.push(err141);
              }
              errors++;
            }
            var _valid7 = _errs123 === errors;
            if (_valid7 && valid13) {
              valid13 = false;
              passing5 = [passing5, 1];
            } else {
              if (_valid7) {
                valid13 = true;
                passing5 = 1;
              }
              const _errs124 = errors;
              if ("list" !== data43) {
                const err142 = { instancePath: instancePath + "/missingComponents", schemaPath: "#/properties/missingComponents/oneOf/2/const", keyword: "const", params: { allowedValue: "list" }, message: "must be equal to constant", schema: "list", parentSchema: schema11.properties.missingComponents.oneOf[2], data: data43 };
                if (vErrors === null) {
                  vErrors = [err142];
                } else {
                  vErrors.push(err142);
                }
                errors++;
              }
              var _valid7 = _errs124 === errors;
              if (_valid7 && valid13) {
                valid13 = false;
                passing5 = [passing5, 2];
              } else {
                if (_valid7) {
                  valid13 = true;
                  passing5 = 2;
                }
              }
            }
            if (!valid13) {
              const err143 = { instancePath: instancePath + "/missingComponents", schemaPath: "#/properties/missingComponents/oneOf", keyword: "oneOf", params: { passingSchemas: passing5 }, message: "must match exactly one schema in oneOf", schema: schema11.properties.missingComponents.oneOf, parentSchema: schema11.properties.missingComponents, data: data43 };
              if (vErrors === null) {
                vErrors = [err143];
              } else {
                vErrors.push(err143);
              }
              errors++;
            } else {
              errors = _errs121;
              if (vErrors !== null) {
                if (_errs121) {
                  vErrors.length = _errs121;
                } else {
                  vErrors = null;
                }
              }
            }
          }
          if (data.notes !== void 0) {
            let data44 = data.notes;
            if (typeof data44 === "string") {
              if (func4(data44) > 1e4) {
                const err144 = { instancePath: instancePath + "/notes", schemaPath: "#/properties/notes/maxLength", keyword: "maxLength", params: { limit: 1e4 }, message: "must NOT have more than 10000 characters", schema: 1e4, parentSchema: schema11.properties.notes, data: data44 };
                if (vErrors === null) {
                  vErrors = [err144];
                } else {
                  vErrors.push(err144);
                }
                errors++;
              }
            } else {
              const err145 = { instancePath: instancePath + "/notes", schemaPath: "#/properties/notes/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: schema11.properties.notes.type, parentSchema: schema11.properties.notes, data: data44 };
              if (vErrors === null) {
                vErrors = [err145];
              } else {
                vErrors.push(err145);
              }
              errors++;
            }
          }
        } else {
          const err146 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object", schema: schema11.type, parentSchema: schema11, data };
          if (vErrors === null) {
            vErrors = [err146];
          } else {
            vErrors.push(err146);
          }
          errors++;
        }
        validate10.errors = vErrors;
        return errors === 0;
      }
      exports["-524876b9"] = validate11;
      var schema12 = { "const": "cm", "title": "\u516C\u5206", "$id": "-524876b9" };
      function validate11(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
        ;
        let vErrors = null;
        let errors = 0;
        if ("cm" !== data) {
          const err0 = { instancePath, schemaPath: "#/const", keyword: "const", params: { allowedValue: "cm" }, message: "must be equal to constant", schema: "cm", parentSchema: schema12, data };
          if (vErrors === null) {
            vErrors = [err0];
          } else {
            vErrors.push(err0);
          }
          errors++;
        }
        validate11.errors = vErrors;
        return errors === 0;
      }
      exports["-1efb2661"] = validate12;
      var schema13 = { "const": "mm", "title": "\u6BEB\u7C73", "$id": "-1efb2661" };
      function validate12(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
        ;
        let vErrors = null;
        let errors = 0;
        if ("mm" !== data) {
          const err0 = { instancePath, schemaPath: "#/const", keyword: "const", params: { allowedValue: "mm" }, message: "must be equal to constant", schema: "mm", parentSchema: schema13, data };
          if (vErrors === null) {
            vErrors = [err0];
          } else {
            vErrors.push(err0);
          }
          errors++;
        }
        validate12.errors = vErrors;
        return errors === 0;
      }
      exports["-1e783c8c"] = validate13;
      var schema14 = { "const": "m", "title": "\u516C\u5C3A", "$id": "-1e783c8c" };
      function validate13(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
        ;
        let vErrors = null;
        let errors = 0;
        if ("m" !== data) {
          const err0 = { instancePath, schemaPath: "#/const", keyword: "const", params: { allowedValue: "m" }, message: "must be equal to constant", schema: "m", parentSchema: schema14, data };
          if (vErrors === null) {
            vErrors = [err0];
          } else {
            vErrors.push(err0);
          }
          errors++;
        }
        validate13.errors = vErrors;
        return errors === 0;
      }
      exports["-2437a79c"] = validate14;
      var schema15 = { "type": "object", "properties": { "agentChoice": { "const": true } }, "required": ["agentChoice"], "$id": "-2437a79c" };
      function validate14(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
        ;
        let vErrors = null;
        let errors = 0;
        if (data && typeof data == "object" && !Array.isArray(data)) {
          if (data.agentChoice === void 0) {
            const err0 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "agentChoice" }, message: "must have required property 'agentChoice'", schema: schema15.required, parentSchema: schema15, data };
            if (vErrors === null) {
              vErrors = [err0];
            } else {
              vErrors.push(err0);
            }
            errors++;
          }
          if (data.agentChoice !== void 0) {
            let data0 = data.agentChoice;
            if (true !== data0) {
              const err1 = { instancePath: instancePath + "/agentChoice", schemaPath: "#/properties/agentChoice/const", keyword: "const", params: { allowedValue: true }, message: "must be equal to constant", schema: true, parentSchema: schema15.properties.agentChoice, data: data0 };
              if (vErrors === null) {
                vErrors = [err1];
              } else {
                vErrors.push(err1);
              }
              errors++;
            }
          }
        } else {
          const err2 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object", schema: schema15.type, parentSchema: schema15, data };
          if (vErrors === null) {
            vErrors = [err2];
          } else {
            vErrors.push(err2);
          }
          errors++;
        }
        validate14.errors = vErrors;
        return errors === 0;
      }
      exports["-3224223d"] = validate15;
      var schema16 = { "const": "complete", "title": "\u5B8C\u6210\u5EFA\u6A21", "description": "\u5224\u8B80\u5716\u9762\u3001\u8655\u7406\u5EFA\u6A21\u554F\u984C\uFF0C\u4E26\u5B8C\u6210\u6574\u500B\u7BA1\u7DB2\u3002", "$id": "-3224223d" };
      function validate15(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
        ;
        let vErrors = null;
        let errors = 0;
        if ("complete" !== data) {
          const err0 = { instancePath, schemaPath: "#/const", keyword: "const", params: { allowedValue: "complete" }, message: "must be equal to constant", schema: "complete", parentSchema: schema16, data };
          if (vErrors === null) {
            vErrors = [err0];
          } else {
            vErrors.push(err0);
          }
          errors++;
        }
        validate15.errors = vErrors;
        return errors === 0;
      }
      exports["1e02e55c"] = validate16;
      var schema17 = { "const": "investigate", "title": "\u5148\u78BA\u8A8D\u65B9\u6848", "description": "\u5224\u8B80\u5716\u9762\u4E26\u63D0\u51FA\u5EFA\u6A21\u65B9\u6848\uFF0C\u65B9\u6848\u78BA\u8A8D\u5F8C\u518D\u5EFA\u7ACB\u6A21\u578B\u3002", "$id": "1e02e55c" };
      function validate16(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
        ;
        let vErrors = null;
        let errors = 0;
        if ("investigate" !== data) {
          const err0 = { instancePath, schemaPath: "#/const", keyword: "const", params: { allowedValue: "investigate" }, message: "must be equal to constant", schema: "investigate", parentSchema: schema17, data };
          if (vErrors === null) {
            vErrors = [err0];
          } else {
            vErrors.push(err0);
          }
          errors++;
        }
        validate16.errors = vErrors;
        return errors === 0;
      }
      exports["44ed36de"] = validate17;
      var schema18 = { "const": "unknown", "title": "\u5C1A\u672A\u78BA\u8A8D", "description": "\u5143\u4EF6\u53EF\u80FD\u653E\u932F\u5716\u5C64\u3002\u7D9C\u5408\u7DDA\u6BB5\u3001\u7B26\u865F\u8207\u6A19\u8A3B\u5224\u8B80\u7528\u9014\u53CA\u9023\u63A5\u95DC\u4FC2\uFF0C\u4FEE\u6B63\u6709\u4F9D\u64DA\u7684\u932F\u8AA4\u3002", "$id": "44ed36de" };
      function validate17(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
        ;
        let vErrors = null;
        let errors = 0;
        if ("unknown" !== data) {
          const err0 = { instancePath, schemaPath: "#/const", keyword: "const", params: { allowedValue: "unknown" }, message: "must be equal to constant", schema: "unknown", parentSchema: schema18, data };
          if (vErrors === null) {
            vErrors = [err0];
          } else {
            vErrors.push(err0);
          }
          errors++;
        }
        validate17.errors = vErrors;
        return errors === 0;
      }
      exports.bedaea9 = validate18;
      var schema19 = { "const": "cleaned", "title": "\u5DF2\u6E05\u7406", "description": "\u4F9D\u5716\u9762\u5224\u8B80\uFF0C\u50C5\u4FEE\u6B63\u660E\u986F\u932F\u8AA4\u3002", "$id": "bedaea9" };
      function validate18(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
        ;
        let vErrors = null;
        let errors = 0;
        if ("cleaned" !== data) {
          const err0 = { instancePath, schemaPath: "#/const", keyword: "const", params: { allowedValue: "cleaned" }, message: "must be equal to constant", schema: "cleaned", parentSchema: schema19, data };
          if (vErrors === null) {
            vErrors = [err0];
          } else {
            vErrors.push(err0);
          }
          errors++;
        }
        validate18.errors = vErrors;
        return errors === 0;
      }
      exports["2122e7dc"] = validate19;
      var schema20 = { "const": "include", "title": "\u532F\u5165 Revit \u5C0D\u7167", "description": "\u5C07 CAD \u5716\u653E\u5728\u76EE\u6A19\u6A13\u5C64\uFF0C\u4F9B\u6A21\u578B\u8207\u539F\u5716\u758A\u5716\u6BD4\u5C0D\u3002", "$id": "2122e7dc" };
      function validate19(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
        ;
        let vErrors = null;
        let errors = 0;
        if ("include" !== data) {
          const err0 = { instancePath, schemaPath: "#/const", keyword: "const", params: { allowedValue: "include" }, message: "must be equal to constant", schema: "include", parentSchema: schema20, data };
          if (vErrors === null) {
            vErrors = [err0];
          } else {
            vErrors.push(err0);
          }
          errors++;
        }
        validate19.errors = vErrors;
        return errors === 0;
      }
      exports["3bea4926"] = validate20;
      var schema21 = { "const": "existing", "title": "\u5DF2\u532F\u5165 Revit", "description": "\u4F7F\u7528 Revit \u4E2D\u65E2\u6709\u7684 CAD \u5E95\u5716\u6BD4\u5C0D\u6A21\u578B\uFF0C\u4E0D\u91CD\u8907\u532F\u5165\u3002", "$id": "3bea4926" };
      function validate20(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
        ;
        let vErrors = null;
        let errors = 0;
        if ("existing" !== data) {
          const err0 = { instancePath, schemaPath: "#/const", keyword: "const", params: { allowedValue: "existing" }, message: "must be equal to constant", schema: "existing", parentSchema: schema21, data };
          if (vErrors === null) {
            vErrors = [err0];
          } else {
            vErrors.push(err0);
          }
          errors++;
        }
        validate20.errors = vErrors;
        return errors === 0;
      }
      exports["-4d4cc22c"] = validate21;
      var schema22 = { "const": "skip", "title": "\u4E0D\u532F\u5165", "description": "\u4E0D\u5C07 CAD \u5716\u532F\u5165 Revit\uFF0C\u6539\u7528\u5716\u7247\u6BD4\u5C0D\u6A21\u578B\u8207\u539F\u5716\u3002", "$id": "-4d4cc22c" };
      function validate21(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
        ;
        let vErrors = null;
        let errors = 0;
        if ("skip" !== data) {
          const err0 = { instancePath, schemaPath: "#/const", keyword: "const", params: { allowedValue: "skip" }, message: "must be equal to constant", schema: "skip", parentSchema: schema22, data };
          if (vErrors === null) {
            vErrors = [err0];
          } else {
            vErrors.push(err0);
          }
          errors++;
        }
        validate21.errors = vErrors;
        return errors === 0;
      }
      exports["13e15a65"] = validate22;
      var schema23 = { "const": "routing", "title": "\u4F9D\u7BA1\u985E\u578B\u4F48\u7BA1\u504F\u597D", "$id": "13e15a65" };
      function validate22(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
        ;
        let vErrors = null;
        let errors = 0;
        if ("routing" !== data) {
          const err0 = { instancePath, schemaPath: "#/const", keyword: "const", params: { allowedValue: "routing" }, message: "must be equal to constant", schema: "routing", parentSchema: schema23, data };
          if (vErrors === null) {
            vErrors = [err0];
          } else {
            vErrors.push(err0);
          }
          errors++;
        }
        validate22.errors = vErrors;
        return errors === 0;
      }
      exports["72bd6861"] = validate23;
      var schema24 = { "const": "mechanical", "title": "\u6A5F\u68B0\u63A5\u982D", "$id": "72bd6861" };
      function validate23(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
        ;
        let vErrors = null;
        let errors = 0;
        if ("mechanical" !== data) {
          const err0 = { instancePath, schemaPath: "#/const", keyword: "const", params: { allowedValue: "mechanical" }, message: "must be equal to constant", schema: "mechanical", parentSchema: schema24, data };
          if (vErrors === null) {
            vErrors = [err0];
          } else {
            vErrors.push(err0);
          }
          errors++;
        }
        validate23.errors = vErrors;
        return errors === 0;
      }
      exports["3d204d07"] = validate24;
      var schema25 = { "const": "threaded", "title": "\u87BA\u7D0B\u63A5\u982D", "$id": "3d204d07" };
      function validate24(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
        ;
        let vErrors = null;
        let errors = 0;
        if ("threaded" !== data) {
          const err0 = { instancePath, schemaPath: "#/const", keyword: "const", params: { allowedValue: "threaded" }, message: "must be equal to constant", schema: "threaded", parentSchema: schema25, data };
          if (vErrors === null) {
            vErrors = [err0];
          } else {
            vErrors.push(err0);
          }
          errors++;
        }
        validate24.errors = vErrors;
        return errors === 0;
      }
      exports["-170ccb3c"] = validate25;
      var schema26 = { "const": "agent", "title": "\u8ABF\u67E5\u5F8C\u5EFA\u8B70", "$id": "-170ccb3c" };
      function validate25(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
        ;
        let vErrors = null;
        let errors = 0;
        if ("agent" !== data) {
          const err0 = { instancePath, schemaPath: "#/const", keyword: "const", params: { allowedValue: "agent" }, message: "must be equal to constant", schema: "agent", parentSchema: schema26, data };
          if (vErrors === null) {
            vErrors = [err0];
          } else {
            vErrors.push(err0);
          }
          errors++;
        }
        validate25.errors = vErrors;
        return errors === 0;
      }
      exports["-6e6021de"] = validate26;
      var schema27 = { "const": "create", "title": "\u5EFA\u7ACB\u6240\u9700\u5143\u4EF6", "description": "\u5EFA\u7ACB\u7F3A\u5C11\u7684\u65CF\u7FA4\uFF0C\u4F7F\u5916\u5F62\u8207\u5C3A\u5BF8\u7B26\u5408\u6240\u9700\u5143\u4EF6\uFF0C\u4E26\u9023\u63A5\u7BA1\u7DDA\u3002", "$id": "-6e6021de" };
      function validate26(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
        ;
        let vErrors = null;
        let errors = 0;
        if ("create" !== data) {
          const err0 = { instancePath, schemaPath: "#/const", keyword: "const", params: { allowedValue: "create" }, message: "must be equal to constant", schema: "create", parentSchema: schema27, data };
          if (vErrors === null) {
            vErrors = [err0];
          } else {
            vErrors.push(err0);
          }
          errors++;
        }
        validate26.errors = vErrors;
        return errors === 0;
      }
      exports["5384f8fa"] = validate27;
      var schema28 = { "const": "substitute", "title": "\u4F7F\u7528\u66FF\u4EE3\u5143\u4EF6", "description": "\u4F7F\u7528\u73FE\u6709\u7684\u76F8\u8FD1\u5143\u4EF6\u66FF\u4EE3\uFF0C\u4E26\u9023\u63A5\u7BA1\u7DDA\u3002", "$id": "5384f8fa" };
      function validate27(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
        ;
        let vErrors = null;
        let errors = 0;
        if ("substitute" !== data) {
          const err0 = { instancePath, schemaPath: "#/const", keyword: "const", params: { allowedValue: "substitute" }, message: "must be equal to constant", schema: "substitute", parentSchema: schema28, data };
          if (vErrors === null) {
            vErrors = [err0];
          } else {
            vErrors.push(err0);
          }
          errors++;
        }
        validate27.errors = vErrors;
        return errors === 0;
      }
      exports["14e2235"] = validate28;
      var schema29 = { "const": "list", "title": "\u5217\u51FA\u7F3A\u5C11\u9805\u76EE", "description": "\u5217\u51FA\u7F3A\u5C11\u7684\u5143\u4EF6\u53CA\u4F4D\u7F6E\uFF0C\u4E0D\u5EFA\u7ACB\u9019\u4E9B\u5143\u4EF6\u3002", "$id": "14e2235" };
      function validate28(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
        ;
        let vErrors = null;
        let errors = 0;
        if ("list" !== data) {
          const err0 = { instancePath, schemaPath: "#/const", keyword: "const", params: { allowedValue: "list" }, message: "must be equal to constant", schema: "list", parentSchema: schema29, data };
          if (vErrors === null) {
            vErrors = [err0];
          } else {
            vErrors.push(err0);
          }
          errors++;
        }
        validate28.errors = vErrors;
        return errors === 0;
      }
    }
  });
  return require_validator_5();
})();

"use strict";
var compiled6 = (() => {
  var __getOwnPropNames = Object.getOwnPropertyNames;
  var __commonJS = (cb, mod) => function __require() {
    return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
  };

  // src/web/node_modules/ajv/dist/runtime/ucs2length.js
  var require_ucs2length = __commonJS({
    "src/web/node_modules/ajv/dist/runtime/ucs2length.js"(exports) {
      "use strict";
      Object.defineProperty(exports, "__esModule", { value: true });
      function ucs2length(str) {
        const len = str.length;
        let length = 0;
        let pos = 0;
        let value;
        while (pos < len) {
          length++;
          value = str.charCodeAt(pos++);
          if (value >= 55296 && value <= 56319 && pos < len) {
            value = str.charCodeAt(pos);
            if ((value & 64512) === 56320)
              pos++;
          }
        }
        return length;
      }
      exports.default = ucs2length;
      ucs2length.code = 'require("ajv/dist/runtime/ucs2length").default';
    }
  });

  // src/web/validator-6.cjs
  var require_validator_6 = __commonJS({
    "src/web/validator-6.cjs"(exports) {
      exports["-21b784c5"] = validate10;
      var schema11 = { "$schema": "http://json-schema.org/draft-07/schema#", "type": "object", "additionalProperties": false, "required": ["goal"], "properties": { "goal": { "type": "string", "title": "What would you like to do?", "pattern": "\\S", "maxLength": 1e4 }, "deliverables": { "type": "string", "title": "Expected deliverables", "maxLength": 1e4 }, "notes": { "type": "string", "title": "Additional details", "maxLength": 1e4 } }, "$id": "-21b784c5" };
      var func2 = require_ucs2length().default;
      var pattern0 = new RegExp("\\S", "u");
      function validate10(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
        ;
        let vErrors = null;
        let errors = 0;
        if (data && typeof data == "object" && !Array.isArray(data)) {
          if (data.goal === void 0) {
            const err0 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "goal" }, message: "must have required property 'goal'", schema: schema11.required, parentSchema: schema11, data };
            if (vErrors === null) {
              vErrors = [err0];
            } else {
              vErrors.push(err0);
            }
            errors++;
          }
          for (const key0 in data) {
            if (!(key0 === "goal" || key0 === "deliverables" || key0 === "notes")) {
              const err1 = { instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties", schema: false, parentSchema: schema11, data };
              if (vErrors === null) {
                vErrors = [err1];
              } else {
                vErrors.push(err1);
              }
              errors++;
            }
          }
          if (data.goal !== void 0) {
            let data0 = data.goal;
            if (typeof data0 === "string") {
              if (func2(data0) > 1e4) {
                const err2 = { instancePath: instancePath + "/goal", schemaPath: "#/properties/goal/maxLength", keyword: "maxLength", params: { limit: 1e4 }, message: "must NOT have more than 10000 characters", schema: 1e4, parentSchema: schema11.properties.goal, data: data0 };
                if (vErrors === null) {
                  vErrors = [err2];
                } else {
                  vErrors.push(err2);
                }
                errors++;
              }
              if (!pattern0.test(data0)) {
                const err3 = { instancePath: instancePath + "/goal", schemaPath: "#/properties/goal/pattern", keyword: "pattern", params: { pattern: "\\S" }, message: 'must match pattern "\\S"', schema: "\\S", parentSchema: schema11.properties.goal, data: data0 };
                if (vErrors === null) {
                  vErrors = [err3];
                } else {
                  vErrors.push(err3);
                }
                errors++;
              }
            } else {
              const err4 = { instancePath: instancePath + "/goal", schemaPath: "#/properties/goal/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: schema11.properties.goal.type, parentSchema: schema11.properties.goal, data: data0 };
              if (vErrors === null) {
                vErrors = [err4];
              } else {
                vErrors.push(err4);
              }
              errors++;
            }
          }
          if (data.deliverables !== void 0) {
            let data1 = data.deliverables;
            if (typeof data1 === "string") {
              if (func2(data1) > 1e4) {
                const err5 = { instancePath: instancePath + "/deliverables", schemaPath: "#/properties/deliverables/maxLength", keyword: "maxLength", params: { limit: 1e4 }, message: "must NOT have more than 10000 characters", schema: 1e4, parentSchema: schema11.properties.deliverables, data: data1 };
                if (vErrors === null) {
                  vErrors = [err5];
                } else {
                  vErrors.push(err5);
                }
                errors++;
              }
            } else {
              const err6 = { instancePath: instancePath + "/deliverables", schemaPath: "#/properties/deliverables/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: schema11.properties.deliverables.type, parentSchema: schema11.properties.deliverables, data: data1 };
              if (vErrors === null) {
                vErrors = [err6];
              } else {
                vErrors.push(err6);
              }
              errors++;
            }
          }
          if (data.notes !== void 0) {
            let data2 = data.notes;
            if (typeof data2 === "string") {
              if (func2(data2) > 1e4) {
                const err7 = { instancePath: instancePath + "/notes", schemaPath: "#/properties/notes/maxLength", keyword: "maxLength", params: { limit: 1e4 }, message: "must NOT have more than 10000 characters", schema: 1e4, parentSchema: schema11.properties.notes, data: data2 };
                if (vErrors === null) {
                  vErrors = [err7];
                } else {
                  vErrors.push(err7);
                }
                errors++;
              }
            } else {
              const err8 = { instancePath: instancePath + "/notes", schemaPath: "#/properties/notes/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: schema11.properties.notes.type, parentSchema: schema11.properties.notes, data: data2 };
              if (vErrors === null) {
                vErrors = [err8];
              } else {
                vErrors.push(err8);
              }
              errors++;
            }
          }
        } else {
          const err9 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object", schema: schema11.type, parentSchema: schema11, data };
          if (vErrors === null) {
            vErrors = [err9];
          } else {
            vErrors.push(err9);
          }
          errors++;
        }
        validate10.errors = vErrors;
        return errors === 0;
      }
    }
  });
  return require_validator_6();
})();

"use strict";
var compiled7 = (() => {
  var __getOwnPropNames = Object.getOwnPropertyNames;
  var __commonJS = (cb, mod) => function __require() {
    return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
  };

  // src/web/node_modules/ajv/dist/runtime/ucs2length.js
  var require_ucs2length = __commonJS({
    "src/web/node_modules/ajv/dist/runtime/ucs2length.js"(exports) {
      "use strict";
      Object.defineProperty(exports, "__esModule", { value: true });
      function ucs2length(str) {
        const len = str.length;
        let length = 0;
        let pos = 0;
        let value;
        while (pos < len) {
          length++;
          value = str.charCodeAt(pos++);
          if (value >= 55296 && value <= 56319 && pos < len) {
            value = str.charCodeAt(pos);
            if ((value & 64512) === 56320)
              pos++;
          }
        }
        return length;
      }
      exports.default = ucs2length;
      ucs2length.code = 'require("ajv/dist/runtime/ucs2length").default';
    }
  });

  // src/web/validator-7.cjs
  var require_validator_7 = __commonJS({
    "src/web/validator-7.cjs"(exports) {
      exports["-6a46ec88"] = validate10;
      var schema11 = { "$schema": "http://json-schema.org/draft-07/schema#", "type": "object", "additionalProperties": false, "required": ["goal"], "properties": { "goal": { "type": "string", "title": "\u60F3\u5B8C\u6210\u7684\u5DE5\u4F5C", "pattern": "\\S", "maxLength": 1e4 }, "deliverables": { "type": "string", "title": "\u9810\u671F\u6210\u679C", "maxLength": 1e4 }, "notes": { "type": "string", "title": "\u88DC\u5145\u8AAA\u660E", "maxLength": 1e4 } }, "$id": "-6a46ec88" };
      var func2 = require_ucs2length().default;
      var pattern0 = new RegExp("\\S", "u");
      function validate10(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
        ;
        let vErrors = null;
        let errors = 0;
        if (data && typeof data == "object" && !Array.isArray(data)) {
          if (data.goal === void 0) {
            const err0 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "goal" }, message: "must have required property 'goal'", schema: schema11.required, parentSchema: schema11, data };
            if (vErrors === null) {
              vErrors = [err0];
            } else {
              vErrors.push(err0);
            }
            errors++;
          }
          for (const key0 in data) {
            if (!(key0 === "goal" || key0 === "deliverables" || key0 === "notes")) {
              const err1 = { instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties", schema: false, parentSchema: schema11, data };
              if (vErrors === null) {
                vErrors = [err1];
              } else {
                vErrors.push(err1);
              }
              errors++;
            }
          }
          if (data.goal !== void 0) {
            let data0 = data.goal;
            if (typeof data0 === "string") {
              if (func2(data0) > 1e4) {
                const err2 = { instancePath: instancePath + "/goal", schemaPath: "#/properties/goal/maxLength", keyword: "maxLength", params: { limit: 1e4 }, message: "must NOT have more than 10000 characters", schema: 1e4, parentSchema: schema11.properties.goal, data: data0 };
                if (vErrors === null) {
                  vErrors = [err2];
                } else {
                  vErrors.push(err2);
                }
                errors++;
              }
              if (!pattern0.test(data0)) {
                const err3 = { instancePath: instancePath + "/goal", schemaPath: "#/properties/goal/pattern", keyword: "pattern", params: { pattern: "\\S" }, message: 'must match pattern "\\S"', schema: "\\S", parentSchema: schema11.properties.goal, data: data0 };
                if (vErrors === null) {
                  vErrors = [err3];
                } else {
                  vErrors.push(err3);
                }
                errors++;
              }
            } else {
              const err4 = { instancePath: instancePath + "/goal", schemaPath: "#/properties/goal/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: schema11.properties.goal.type, parentSchema: schema11.properties.goal, data: data0 };
              if (vErrors === null) {
                vErrors = [err4];
              } else {
                vErrors.push(err4);
              }
              errors++;
            }
          }
          if (data.deliverables !== void 0) {
            let data1 = data.deliverables;
            if (typeof data1 === "string") {
              if (func2(data1) > 1e4) {
                const err5 = { instancePath: instancePath + "/deliverables", schemaPath: "#/properties/deliverables/maxLength", keyword: "maxLength", params: { limit: 1e4 }, message: "must NOT have more than 10000 characters", schema: 1e4, parentSchema: schema11.properties.deliverables, data: data1 };
                if (vErrors === null) {
                  vErrors = [err5];
                } else {
                  vErrors.push(err5);
                }
                errors++;
              }
            } else {
              const err6 = { instancePath: instancePath + "/deliverables", schemaPath: "#/properties/deliverables/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: schema11.properties.deliverables.type, parentSchema: schema11.properties.deliverables, data: data1 };
              if (vErrors === null) {
                vErrors = [err6];
              } else {
                vErrors.push(err6);
              }
              errors++;
            }
          }
          if (data.notes !== void 0) {
            let data2 = data.notes;
            if (typeof data2 === "string") {
              if (func2(data2) > 1e4) {
                const err7 = { instancePath: instancePath + "/notes", schemaPath: "#/properties/notes/maxLength", keyword: "maxLength", params: { limit: 1e4 }, message: "must NOT have more than 10000 characters", schema: 1e4, parentSchema: schema11.properties.notes, data: data2 };
                if (vErrors === null) {
                  vErrors = [err7];
                } else {
                  vErrors.push(err7);
                }
                errors++;
              }
            } else {
              const err8 = { instancePath: instancePath + "/notes", schemaPath: "#/properties/notes/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: schema11.properties.notes.type, parentSchema: schema11.properties.notes, data: data2 };
              if (vErrors === null) {
                vErrors = [err8];
              } else {
                vErrors.push(err8);
              }
              errors++;
            }
          }
        } else {
          const err9 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object", schema: schema11.type, parentSchema: schema11, data };
          if (vErrors === null) {
            vErrors = [err9];
          } else {
            vErrors.push(err9);
          }
          errors++;
        }
        validate10.errors = vErrors;
        return errors === 0;
      }
    }
  });
  return require_validator_7();
})();

const entries = [
{id:"1943475d498e2de827fac59d8c417463f63fd4ec93d1d0af7e5d8178fc8b1cb7", schema:{"$schema":"http://json-schema.org/draft-07/schema#","type":"object","additionalProperties":false,"required":["cobieFile"],"properties":{"toolCallLimit":{"type":"integer","title":"Tool call limit per execution","default":40,"minimum":1,"maximum":80,"description":"Set 1–80 calls; default 40. Each execution or continuation has its own allowance. The final report is excluded. Estimates vary with model size and the size of the delivery; they are neither a completion guarantee nor a timeout."},"cobieFile":{"type":"string","title":"COBie Excel","minLength":1,"maxLength":4096,"description":"The COBie workbook (.xlsx) to check. Use the folder button to pick it, or paste its full path. The check report is saved in the same folder."},"formFile":{"type":"string","title":"Input form Excel","default":"","maxLength":4096,"description":"The input form (.xlsx) this COBie was made from: the same one COBie-maker used. What the form supplies in the delivery (contacts, the facility's name and units, each type's manufacturer, model number and warranty, and the installation and warranty dates) is compared with it row by row. Leave blank to skip verification against it. If there is none yet, \"Get a blank form\" saves one; it must list the delivered types and be filled in before it can be compared, and is normally made from the model by COBie-maker."},"categories":{"type":"array","title":"Categories to check","description":"The categories this COBie delivery covers. Only the selected categories are compared with the model; an unselected category is not reported as missing from the delivery even when the model flags it for COBie. All are selected by default. Adjust to the delivery scope and keep at least one.","default":["OST_MechanicalEquipment","OST_DuctTerminal","OST_DuctAccessory","OST_PlumbingFixtures","OST_PlumbingEquipment","OST_PipeAccessory","OST_Sprinklers","OST_FireAlarmDevices","OST_ElectricalEquipment","OST_ElectricalFixtures","OST_LightingFixtures","OST_LightingDevices","OST_CommunicationDevices","OST_DataDevices","OST_SecurityDevices","OST_NurseCallDevices","OST_TelephoneDevices","OST_AudioVisualDevices","OST_SpecialityEquipment","OST_MedicalEquipment","OST_FoodServiceEquipment","OST_Furniture","OST_FurnitureSystems","OST_Casework","OST_Doors","OST_Windows"],"uniqueItems":true,"minItems":1,"items":{"type":"string","oneOf":[{"const":"OST_MechanicalEquipment","title":"Mechanical equipment"},{"const":"OST_DuctTerminal","title":"Air terminals"},{"const":"OST_DuctAccessory","title":"Duct accessories"},{"const":"OST_PlumbingFixtures","title":"Plumbing fixtures"},{"const":"OST_PlumbingEquipment","title":"Plumbing equipment"},{"const":"OST_PipeAccessory","title":"Pipe accessories"},{"const":"OST_Sprinklers","title":"Sprinklers"},{"const":"OST_FireAlarmDevices","title":"Fire alarm devices"},{"const":"OST_ElectricalEquipment","title":"Electrical equipment"},{"const":"OST_ElectricalFixtures","title":"Electrical fixtures"},{"const":"OST_LightingFixtures","title":"Lighting fixtures"},{"const":"OST_LightingDevices","title":"Lighting devices"},{"const":"OST_CommunicationDevices","title":"Communication devices"},{"const":"OST_DataDevices","title":"Data devices"},{"const":"OST_SecurityDevices","title":"Security devices"},{"const":"OST_NurseCallDevices","title":"Nurse call devices"},{"const":"OST_TelephoneDevices","title":"Telephone devices"},{"const":"OST_AudioVisualDevices","title":"Audio visual devices"},{"const":"OST_SpecialityEquipment","title":"Specialty equipment"},{"const":"OST_MedicalEquipment","title":"Medical equipment"},{"const":"OST_FoodServiceEquipment","title":"Food service equipment"},{"const":"OST_Furniture","title":"Furniture"},{"const":"OST_FurnitureSystems","title":"Furniture systems"},{"const":"OST_Casework","title":"Casework"},{"const":"OST_Doors","title":"Doors"},{"const":"OST_Windows","title":"Windows"}]}},"notes":{"type":"string","title":"Requests and notes for this run","default":"","maxLength":10000,"description":"Optional. The model is the project currently open in Revit."}}}, functions:compiled0},
{id:"e643a86d276571d01ba365dfea3b2f5c916b030855fb555a2364dac5cc9936d4", schema:{"$schema":"http://json-schema.org/draft-07/schema#","type":"object","additionalProperties":false,"required":["cobieFile"],"properties":{"toolCallLimit":{"type":"integer","title":"每次執行工具上限（次）","default":40,"minimum":1,"maximum":80,"description":"可設定 1–80 次，預設 40 次。執行或續跑各自計算；結案報告不計入。預估會隨模型規模與交付檔大小變動，並非完成保證或逾時限制。"},"cobieFile":{"type":"string","title":"COBie Excel","minLength":1,"maxLength":4096,"description":"要檢核的 COBie 活頁簿（.xlsx）。按右側的資料夾圖示選檔，或直接貼上完整路徑。檢核報表會放在同一個資料夾。"},"formFile":{"type":"string","title":"填寫表 Excel","default":"","maxLength":4096,"description":"製作這份 COBie 時用的填寫表（.xlsx），也就是 COBie 製作的那一張。交付資料中由填寫表提供的內容（聯絡人、設施名稱與單位、各設備型式的製造商、型號、保固，以及安裝與保固日期）會逐筆與它比對。還沒有填寫表時，按「取得空白表單」可拿到一份；它要列出交付的設備型式並填好內容才能用來比對，一般由 COBie 製作依模型產生。留空則不做與填寫表的資料驗證。"},"categories":{"type":"array","title":"檢核品類","description":"這份 COBie 交付涵蓋哪些品類。與模型比對時只看勾選的品類；沒勾選的品類即使模型中有標記 COBie，也不會被列為交付檔缺漏。預設全選，請依交付範圍調整，至少保留一項。","default":["OST_MechanicalEquipment","OST_DuctTerminal","OST_DuctAccessory","OST_PlumbingFixtures","OST_PlumbingEquipment","OST_PipeAccessory","OST_Sprinklers","OST_FireAlarmDevices","OST_ElectricalEquipment","OST_ElectricalFixtures","OST_LightingFixtures","OST_LightingDevices","OST_CommunicationDevices","OST_DataDevices","OST_SecurityDevices","OST_NurseCallDevices","OST_TelephoneDevices","OST_AudioVisualDevices","OST_SpecialityEquipment","OST_MedicalEquipment","OST_FoodServiceEquipment","OST_Furniture","OST_FurnitureSystems","OST_Casework","OST_Doors","OST_Windows"],"uniqueItems":true,"minItems":1,"items":{"type":"string","oneOf":[{"const":"OST_MechanicalEquipment","title":"機械設備"},{"const":"OST_DuctTerminal","title":"風管終端"},{"const":"OST_DuctAccessory","title":"風管附件"},{"const":"OST_PlumbingFixtures","title":"衛工設備"},{"const":"OST_PlumbingEquipment","title":"給排水設備"},{"const":"OST_PipeAccessory","title":"管附件"},{"const":"OST_Sprinklers","title":"灑水頭"},{"const":"OST_FireAlarmDevices","title":"火警裝置"},{"const":"OST_ElectricalEquipment","title":"電氣設備"},{"const":"OST_ElectricalFixtures","title":"電氣裝置"},{"const":"OST_LightingFixtures","title":"照明設備"},{"const":"OST_LightingDevices","title":"照明裝置"},{"const":"OST_CommunicationDevices","title":"通訊裝置"},{"const":"OST_DataDevices","title":"資料裝置"},{"const":"OST_SecurityDevices","title":"保全裝置"},{"const":"OST_NurseCallDevices","title":"護理呼叫裝置"},{"const":"OST_TelephoneDevices","title":"電話裝置"},{"const":"OST_AudioVisualDevices","title":"視聽設備"},{"const":"OST_SpecialityEquipment","title":"專用設備"},{"const":"OST_MedicalEquipment","title":"醫療設備"},{"const":"OST_FoodServiceEquipment","title":"餐飲設備"},{"const":"OST_Furniture","title":"家具"},{"const":"OST_FurnitureSystems","title":"家具系統"},{"const":"OST_Casework","title":"櫥櫃"},{"const":"OST_Doors","title":"門"},{"const":"OST_Windows","title":"窗"}]}},"notes":{"type":"string","title":"本次要求與說明","default":"","maxLength":10000,"description":"可留空。模型以目前在 Revit 開啟的專案為準。"}}}, functions:compiled1},
{id:"58e24c69763ed61a994f00f1414997bd6ce8c527132ba44228345cce0d24d29b", schema:{"$schema":"http://json-schema.org/draft-07/schema#","type":"object","additionalProperties":false,"properties":{"toolCallLimit":{"type":"integer","title":"Tool call limit per execution","default":80,"minimum":1,"maximum":80,"description":"Set 1–80 calls; default 80. Each execution or continuation has its own allowance. The final report is excluded. Limits below 50 may require continuation. Estimates vary with model size and data completeness; they are neither a completion guarantee nor a timeout."},"formFile":{"type":"string","title":"Input form (Excel)","default":"","maxLength":4096,"description":"Provides project, contact and equipment type data not available in the model. For a new form, confirm the delivery categories and generate a form from the current Revit model to list its types and quantities. Complete and save the form, then select it to create the delivery. Regenerating with a form selected saves an updated copy and preserves existing entries."},"outputFolder":{"type":"string","title":"Delivery folder","default":"","maxLength":4096,"description":"Sets the output location; defaults to the Desktop. A separate subfolder contains the COBie workbook, delivery notes and final input form, plus the model copy when that option is selected. Use the final input form for subsequent checks and deliveries."},"categories":{"type":"array","title":"Categories to deliver","description":"Defines the delivery categories for form generation and model updates. All categories are selected by default; at least one is required. Set whether each type is included in the input form.","default":["OST_MechanicalEquipment","OST_DuctTerminal","OST_DuctAccessory","OST_PlumbingFixtures","OST_PlumbingEquipment","OST_PipeAccessory","OST_Sprinklers","OST_FireAlarmDevices","OST_ElectricalEquipment","OST_ElectricalFixtures","OST_LightingFixtures","OST_LightingDevices","OST_CommunicationDevices","OST_DataDevices","OST_SecurityDevices","OST_NurseCallDevices","OST_TelephoneDevices","OST_AudioVisualDevices","OST_SpecialityEquipment","OST_MedicalEquipment","OST_FoodServiceEquipment","OST_Furniture","OST_FurnitureSystems","OST_Casework","OST_Doors","OST_Windows"],"uniqueItems":true,"minItems":1,"items":{"type":"string","oneOf":[{"const":"OST_MechanicalEquipment","title":"Mechanical equipment"},{"const":"OST_DuctTerminal","title":"Air terminals"},{"const":"OST_DuctAccessory","title":"Duct accessories"},{"const":"OST_PlumbingFixtures","title":"Plumbing fixtures"},{"const":"OST_PlumbingEquipment","title":"Plumbing equipment"},{"const":"OST_PipeAccessory","title":"Pipe accessories"},{"const":"OST_Sprinklers","title":"Sprinklers"},{"const":"OST_FireAlarmDevices","title":"Fire alarm devices"},{"const":"OST_ElectricalEquipment","title":"Electrical equipment"},{"const":"OST_ElectricalFixtures","title":"Electrical fixtures"},{"const":"OST_LightingFixtures","title":"Lighting fixtures"},{"const":"OST_LightingDevices","title":"Lighting devices"},{"const":"OST_CommunicationDevices","title":"Communication devices"},{"const":"OST_DataDevices","title":"Data devices"},{"const":"OST_SecurityDevices","title":"Security devices"},{"const":"OST_NurseCallDevices","title":"Nurse call devices"},{"const":"OST_TelephoneDevices","title":"Telephone devices"},{"const":"OST_AudioVisualDevices","title":"Audio visual devices"},{"const":"OST_SpecialityEquipment","title":"Specialty equipment"},{"const":"OST_MedicalEquipment","title":"Medical equipment"},{"const":"OST_FoodServiceEquipment","title":"Food service equipment"},{"const":"OST_Furniture","title":"Furniture"},{"const":"OST_FurnitureSystems","title":"Furniture systems"},{"const":"OST_Casework","title":"Casework"},{"const":"OST_Doors","title":"Doors"},{"const":"OST_Windows","title":"Windows"}]}},"modelHandling":{"type":"string","title":"Model handling","default":"copy","description":"Writes the delivery scope and COBie data into the model. Saving a copy preserves the original, saves the copy in the delivery folder and opens it in Revit. Changing the open model updates and saves the current document.","oneOf":[{"const":"copy","title":"Save a copy, then change the copy"},{"const":"in-place","title":"Change the open model"}]},"existingValues":{"type":"string","title":"Existing data handling","default":"overwrite","description":"Controls how differences between model COBie parameters and the input form are handled. Overwrite and record uses form values and records the originals for restoration. Keeping model values preserves the originals and uses them in the COBie workbook. Both options report data differences.","oneOf":[{"const":"overwrite","title":"Overwrite and record"},{"const":"keep","title":"Keep the model's values"}]},"coordinates":{"type":"string","title":"Coordinates","default":"shared","description":"The origin of the Coordinate sheet's positions. Shared coordinates match the survey point, other disciplines' models and GIS; without shared coordinates set up they are the internal origin. The project base point gives smaller numbers relative to the project. Lengths are in the form's length unit.","oneOf":[{"const":"shared","title":"Shared coordinates"},{"const":"project-base","title":"Project base point"},{"const":"internal","title":"Revit internal origin"}]},"notes":{"type":"string","title":"Requirements and notes","default":"","maxLength":10000,"description":"Optional delivery scope, data requirements or special handling instructions. Applies to the project currently open in Revit."}}}, functions:compiled2},
{id:"64020b22f8064bd1ef2e4a0f5c6b5c17ab273754c66f18125c2adafe15731dfb", schema:{"$schema":"http://json-schema.org/draft-07/schema#","type":"object","additionalProperties":false,"properties":{"toolCallLimit":{"type":"integer","title":"每次執行工具上限（次）","default":80,"minimum":1,"maximum":80,"description":"可設定 1–80 次，預設 80 次。執行或續跑各自計算；結案報告不計入。低於 50 次可能需要續跑。預估會隨模型規模與資料完整度變動，並非完成保證或逾時限制。"},"formFile":{"type":"string","title":"填寫表 Excel","default":"","maxLength":4096,"description":"用於補充模型未提供的專案、聯絡人及設備類型資料。首次使用時，請先確認輸出品類，再選擇「依模型產生填寫表」，依目前 Revit 模型列出類型與數量。完成填寫並儲存後，選取該檔案開始製作。若已選取填寫表，重新產生時會保留既有填寫內容，另存更新版本。"},"outputFolder":{"type":"string","title":"成果資料夾","default":"","maxLength":4096,"description":"指定成果儲存位置，未指定時使用桌面。系統會建立獨立子資料夾，存放 COBie Excel、製作說明及最終填寫表；採用另存新檔時，也會包含模型副本。後續檢核與再次製作請使用最終填寫表。"},"categories":{"type":"array","title":"輸出品類","description":"設定交付涵蓋的品類，適用於填寫表產生與模型資料寫入。預設全選，至少須選擇一項。各類型是否納入交付，請於填寫表的「納入COBie」欄設定。","default":["OST_MechanicalEquipment","OST_DuctTerminal","OST_DuctAccessory","OST_PlumbingFixtures","OST_PlumbingEquipment","OST_PipeAccessory","OST_Sprinklers","OST_FireAlarmDevices","OST_ElectricalEquipment","OST_ElectricalFixtures","OST_LightingFixtures","OST_LightingDevices","OST_CommunicationDevices","OST_DataDevices","OST_SecurityDevices","OST_NurseCallDevices","OST_TelephoneDevices","OST_AudioVisualDevices","OST_SpecialityEquipment","OST_MedicalEquipment","OST_FoodServiceEquipment","OST_Furniture","OST_FurnitureSystems","OST_Casework","OST_Doors","OST_Windows"],"uniqueItems":true,"minItems":1,"items":{"type":"string","oneOf":[{"const":"OST_MechanicalEquipment","title":"機械設備"},{"const":"OST_DuctTerminal","title":"風管終端"},{"const":"OST_DuctAccessory","title":"風管附件"},{"const":"OST_PlumbingFixtures","title":"衛工設備"},{"const":"OST_PlumbingEquipment","title":"給排水設備"},{"const":"OST_PipeAccessory","title":"管附件"},{"const":"OST_Sprinklers","title":"灑水頭"},{"const":"OST_FireAlarmDevices","title":"火警裝置"},{"const":"OST_ElectricalEquipment","title":"電氣設備"},{"const":"OST_ElectricalFixtures","title":"電氣裝置"},{"const":"OST_LightingFixtures","title":"照明設備"},{"const":"OST_LightingDevices","title":"照明裝置"},{"const":"OST_CommunicationDevices","title":"通訊裝置"},{"const":"OST_DataDevices","title":"資料裝置"},{"const":"OST_SecurityDevices","title":"保全裝置"},{"const":"OST_NurseCallDevices","title":"護理呼叫裝置"},{"const":"OST_TelephoneDevices","title":"電話裝置"},{"const":"OST_AudioVisualDevices","title":"視聽設備"},{"const":"OST_SpecialityEquipment","title":"專用設備"},{"const":"OST_MedicalEquipment","title":"醫療設備"},{"const":"OST_FoodServiceEquipment","title":"餐飲設備"},{"const":"OST_Furniture","title":"家具"},{"const":"OST_FurnitureSystems","title":"家具系統"},{"const":"OST_Casework","title":"櫥櫃"},{"const":"OST_Doors","title":"門"},{"const":"OST_Windows","title":"窗"}]}},"modelHandling":{"type":"string","title":"模型處理","default":"copy","description":"製作時會將交付範圍與 COBie 資料寫入模型。選擇「另存新檔後修改」會保留原模型，將副本儲存於成果資料夾，並在 Revit 開啟該副本。選擇「直接修改目前的模型」則會更新並儲存目前開啟的模型。","oneOf":[{"const":"copy","title":"另存新檔後修改"},{"const":"in-place","title":"直接修改目前的模型"}]},"existingValues":{"type":"string","title":"既有資料處理","default":"overwrite","description":"設定模型 COBie 參數與填寫表不一致時的處理方式。「覆寫並記錄」採用填寫表資料，並記錄原值供後續還原；「保留模型既有的值」保留原值，COBie Excel 也採用該值。兩種方式均會列出資料差異。","oneOf":[{"const":"overwrite","title":"覆寫並記錄"},{"const":"keep","title":"保留模型既有的值"}]},"coordinates":{"type":"string","title":"座標基準","default":"shared","description":"Coordinate 頁的位置以哪個原點為準。共用座標與測量點、其他專業的模型及 GIS 一致；模型沒有設定共用座標時，等同內部原點。專案基準點的數字較小，以專案為準。長度採用填寫表的長度單位。","oneOf":[{"const":"shared","title":"共用座標"},{"const":"project-base","title":"專案基準點"},{"const":"internal","title":"Revit 內部原點"}]},"notes":{"type":"string","title":"要求與說明","default":"","maxLength":10000,"description":"補充交付範圍、資料要求或特殊處理事項，可留空。作業對象為目前在 Revit 開啟的專案。"}}}, functions:compiled3},
{id:"d54908e8897613e0d9dc956a5e3e8be3ff99a8c48e5c8534c7faf80a8c954e62", schema:{"$schema":"http://json-schema.org/draft-07/schema#","type":"object","additionalProperties":false,"required":["drawingUnit","level","pipeType","pipeHeightCm","sprinklerHeightCm","crossingOffsetCm","executionMode","drawingQuality","cadOverlay","jointType","missingComponents"],"properties":{"toolCallLimit":{"type":"integer","title":"Tool call limit per execution","description":"Choose 1–80 calls; default 40. Each execution or continuation has its own allowance. The final report is excluded.","minimum":1,"maximum":80,"default":40},"drawingUnit":{"type":"string","title":"Actual drawing units","description":"The actual unit used in the CAD drawing. Use this setting for unit conversion.","default":"cm","oneOf":[{"const":"cm","title":"Centimeters"},{"const":"mm","title":"Millimeters"},{"const":"m","title":"Meters"}]},"level":{"type":"object","title":"Target Revit level","description":"The Revit level for the network. Measure pipe and sprinkler heights from this level.","additionalProperties":false,"required":["id","name","type","documentId","documentName","documentPath","sessionId","revitVersion","lastUpdated"],"properties":{"id":{"type":"string","minLength":1},"name":{"type":"string","minLength":1},"type":{"const":"Level"},"documentId":{"type":"string","minLength":1},"documentName":{"type":"string"},"documentPath":{"type":"string"},"sessionId":{"type":"string","minLength":1},"revitVersion":{"type":"string","pattern":"^[0-9]{4}$"},"lastUpdated":{"type":"string","minLength":1}}},"pipeType":{"type":"object","title":"Revit pipe type","description":"The Revit pipe type for the model, including material, available diameters, and fitting settings.","additionalProperties":false,"default":{"type":"PipeType","agentChoice":true},"required":["type"],"if":{"type":"object","properties":{"agentChoice":{"const":true}},"required":["agentChoice"]},"then":{"type":"object","maxProperties":2},"else":{"type":"object","properties":{"id":true,"name":true,"documentId":true,"documentName":true,"documentPath":true,"sessionId":true,"revitVersion":true,"lastUpdated":true},"required":["id","name","documentId","documentName","documentPath","sessionId","revitVersion","lastUpdated"]},"properties":{"agentChoice":{"type":"boolean"},"id":{"type":"string","minLength":1},"name":{"type":"string","minLength":1},"type":{"const":"PipeType"},"documentId":{"type":"string","minLength":1},"documentName":{"type":"string"},"documentPath":{"type":"string"},"sessionId":{"type":"string","minLength":1},"revitVersion":{"type":"string","pattern":"^[0-9]{4}$"},"lastUpdated":{"type":"string","minLength":1}}},"systemType":{"type":"object","title":"Revit system type","description":"Choose a piping system type from the project, or let the agent select one for the sprinkler network.","additionalProperties":false,"default":{"type":"MEPSystemType","agentChoice":true},"required":["type"],"if":{"type":"object","properties":{"agentChoice":{"const":true}},"required":["agentChoice"]},"then":{"type":"object","maxProperties":2},"else":{"type":"object","properties":{"id":true,"name":true,"documentId":true,"documentName":true,"documentPath":true,"sessionId":true,"revitVersion":true,"lastUpdated":true},"required":["id","name","documentId","documentName","documentPath","sessionId","revitVersion","lastUpdated"]},"properties":{"agentChoice":{"type":"boolean"},"id":{"type":"string","minLength":1},"name":{"type":"string","minLength":1},"type":{"const":"MEPSystemType"},"documentId":{"type":"string","minLength":1},"documentName":{"type":"string"},"documentPath":{"type":"string"},"sessionId":{"type":"string","minLength":1},"revitVersion":{"type":"string","pattern":"^[0-9]{4}$"},"lastUpdated":{"type":"string","minLength":1}}},"pipeHeightCm":{"type":"number","title":"Pipe centerline height (cm)","description":"Height of the pipe centerline above the target level.","minimum":0,"default":280},"sprinklerHeightCm":{"type":"number","title":"Sprinkler outlet above level (cm)","description":"Height of the sprinkler outlet above the target level.","minimum":0,"default":260},"crossingOffsetCm":{"type":"number","title":"Rise at unconnected crossings (cm)","description":"The distance to raise one pipe where two pipes cross without a connection.","exclusiveMinimum":0,"default":20},"executionMode":{"type":"string","title":"Execution mode","description":"Choose to complete the model or confirm the modeling plan first.","default":"complete","oneOf":[{"const":"complete","title":"Complete the model","description":"Interpret the drawing. Resolve modeling problems. Complete the entire network."},{"const":"investigate","title":"Confirm the plan first","description":"Interpret the drawing. Propose a modeling plan. Build the model only after confirmation of the plan."}]},"drawingQuality":{"type":"string","title":"Drawing quality","description":"Select the current cleanup status of the CAD drawing.","default":"unknown","oneOf":[{"const":"unknown","title":"Not checked","description":"Components can be on incorrect layers. Use lines, symbols, and annotations to identify component functions and pipe connections. Correct errors when drawing evidence supports the change."},{"const":"cleaned","title":"Cleaned","description":"Interpret the drawing as shown. Correct only obvious errors."}]},"cadOverlay":{"type":"string","title":"CAD overlay","description":"Choose to import a CAD overlay, use an existing overlay, or skip the import.","default":"include","oneOf":[{"const":"include","title":"Import into Revit","description":"Place the CAD drawing on the target level for comparison with the model."},{"const":"existing","title":"Already imported into Revit","description":"Compare the model with the existing CAD overlay in Revit. Do not import the drawing again."},{"const":"skip","title":"Do not import","description":"Do not import the CAD drawing into Revit. Use images to compare the model with the drawing."}]},"jointType":{"type":"string","title":"Joint type","description":"Select the joint type for pipe fittings. The default uses the selected pipe type's routing preferences.","default":"routing","oneOf":[{"const":"routing","title":"Follow the pipe type's routing preferences"},{"const":"mechanical","title":"Mechanical joints"},{"const":"threaded","title":"Threaded joints"},{"const":"agent","title":"Inspect and recommend"}]},"missingComponents":{"type":"string","title":"Missing components","description":"Select how to handle required families that the Revit project does not contain, such as valve families.","default":"create","oneOf":[{"const":"create","title":"Create required components","description":"Create the missing families with the required component shapes and dimensions. Connect the components to the pipes."},{"const":"substitute","title":"Use substitute components","description":"Use similar existing components as substitutes. Connect the substitutes to the pipes."},{"const":"list","title":"List missing components","description":"List missing components and their locations. Do not create these components."}]},"notes":{"type":"string","title":"Additional instructions","description":"Specify the scope, priorities, or special requirements.","maxLength":10000}}}, functions:compiled4},
{id:"21c15872394e3e48ae40281772f8cac3d927c3c95adad3c9eefe54d791726fb0", schema:{"$schema":"http://json-schema.org/draft-07/schema#","type":"object","additionalProperties":false,"required":["drawingUnit","level","pipeType","pipeHeightCm","sprinklerHeightCm","crossingOffsetCm","executionMode","drawingQuality","cadOverlay","jointType","missingComponents"],"properties":{"toolCallLimit":{"type":"integer","title":"每次執行工具上限（次）","description":"可設定 1–80 次，預設 40 次。每次執行或續跑各自計算，結案報告不計入。","minimum":1,"maximum":80,"default":40},"drawingUnit":{"type":"string","title":"圖面實際單位","description":"CAD 圖實際使用的繪圖單位。換算時以此設定為準。","default":"cm","oneOf":[{"const":"cm","title":"公分"},{"const":"mm","title":"毫米"},{"const":"m","title":"公尺"}]},"level":{"type":"object","title":"Revit 目標樓層","description":"管網所在的 Revit 樓層。管線與灑水頭的高度以此樓層為基準。","additionalProperties":false,"required":["id","name","type","documentId","documentName","documentPath","sessionId","revitVersion","lastUpdated"],"properties":{"id":{"type":"string","minLength":1},"name":{"type":"string","minLength":1},"type":{"const":"Level"},"documentId":{"type":"string","minLength":1},"documentName":{"type":"string"},"documentPath":{"type":"string"},"sessionId":{"type":"string","minLength":1},"revitVersion":{"type":"string","pattern":"^[0-9]{4}$"},"lastUpdated":{"type":"string","minLength":1}}},"pipeType":{"type":"object","title":"Revit 管類型","description":"建模使用的 Revit 管類型，包含管材、可用管徑與接頭設定。","additionalProperties":false,"default":{"type":"PipeType","agentChoice":true},"required":["type"],"if":{"type":"object","properties":{"agentChoice":{"const":true}},"required":["agentChoice"]},"then":{"type":"object","maxProperties":2},"else":{"type":"object","properties":{"id":true,"name":true,"documentId":true,"documentName":true,"documentPath":true,"sessionId":true,"revitVersion":true,"lastUpdated":true},"required":["id","name","documentId","documentName","documentPath","sessionId","revitVersion","lastUpdated"]},"properties":{"agentChoice":{"type":"boolean"},"id":{"type":"string","minLength":1},"name":{"type":"string","minLength":1},"type":{"const":"PipeType"},"documentId":{"type":"string","minLength":1},"documentName":{"type":"string"},"documentPath":{"type":"string"},"sessionId":{"type":"string","minLength":1},"revitVersion":{"type":"string","pattern":"^[0-9]{4}$"},"lastUpdated":{"type":"string","minLength":1}}},"systemType":{"type":"object","title":"Revit 系統類型","description":"從專案選擇配管系統類型，或由 Agent 選擇適合灑水管網的類型。","additionalProperties":false,"default":{"type":"MEPSystemType","agentChoice":true},"required":["type"],"if":{"type":"object","properties":{"agentChoice":{"const":true}},"required":["agentChoice"]},"then":{"type":"object","maxProperties":2},"else":{"type":"object","properties":{"id":true,"name":true,"documentId":true,"documentName":true,"documentPath":true,"sessionId":true,"revitVersion":true,"lastUpdated":true},"required":["id","name","documentId","documentName","documentPath","sessionId","revitVersion","lastUpdated"]},"properties":{"agentChoice":{"type":"boolean"},"id":{"type":"string","minLength":1},"name":{"type":"string","minLength":1},"type":{"const":"MEPSystemType"},"documentId":{"type":"string","minLength":1},"documentName":{"type":"string"},"documentPath":{"type":"string"},"sessionId":{"type":"string","minLength":1},"revitVersion":{"type":"string","pattern":"^[0-9]{4}$"},"lastUpdated":{"type":"string","minLength":1}}},"pipeHeightCm":{"type":"number","title":"管線中心距樓層高度（cm）","description":"管線中心線距離目標樓層的高度。","minimum":0,"default":280},"sprinklerHeightCm":{"type":"number","title":"灑水頭出水口距樓層高度（cm）","description":"灑水頭出水口距離目標樓層的高度。","minimum":0,"default":260},"crossingOffsetCm":{"type":"number","title":"不連通交叉的抬升量（cm）","description":"兩條管線交叉但不相連時，其中一條管線向上抬升的距離。","exclusiveMinimum":0,"default":20},"executionMode":{"type":"string","title":"執行方式","description":"選擇完成建模，或先確認建模方案。","default":"complete","oneOf":[{"const":"complete","title":"完成建模","description":"判讀圖面、處理建模問題，並完成整個管網。"},{"const":"investigate","title":"先確認方案","description":"判讀圖面並提出建模方案，方案確認後再建立模型。"}]},"drawingQuality":{"type":"string","title":"圖面品質","description":"選擇目前 CAD 圖面的整理狀態。","default":"unknown","oneOf":[{"const":"unknown","title":"尚未確認","description":"元件可能放錯圖層。綜合線段、符號與標註判讀用途及連接關係，修正有依據的錯誤。"},{"const":"cleaned","title":"已清理","description":"依圖面判讀，僅修正明顯錯誤。"}]},"cadOverlay":{"type":"string","title":"CAD 底圖對照","description":"選擇匯入 CAD 底圖、使用既有底圖，或不匯入。","default":"include","oneOf":[{"const":"include","title":"匯入 Revit 對照","description":"將 CAD 圖放在目標樓層，供模型與原圖疊圖比對。"},{"const":"existing","title":"已匯入 Revit","description":"使用 Revit 中既有的 CAD 底圖比對模型，不重複匯入。"},{"const":"skip","title":"不匯入","description":"不將 CAD 圖匯入 Revit，改用圖片比對模型與原圖。"}]},"jointType":{"type":"string","title":"接頭形式","description":"選擇管件的接頭形式。預設沿用所選管類型的佈管偏好。","default":"routing","oneOf":[{"const":"routing","title":"依管類型佈管偏好"},{"const":"mechanical","title":"機械接頭"},{"const":"threaded","title":"螺紋接頭"},{"const":"agent","title":"調查後建議"}]},"missingComponents":{"type":"string","title":"缺元件處理","description":"選擇 Revit 專案缺少閥件等所需族群時的處理方式。","default":"create","oneOf":[{"const":"create","title":"建立所需元件","description":"建立缺少的族群，使外形與尺寸符合所需元件，並連接管線。"},{"const":"substitute","title":"使用替代元件","description":"使用現有的相近元件替代，並連接管線。"},{"const":"list","title":"列出缺少項目","description":"列出缺少的元件及位置，不建立這些元件。"}]},"notes":{"type":"string","title":"補充說明","description":"補充處理範圍、優先順序或特殊要求。","maxLength":10000}}}, functions:compiled5},
{id:"b78c4d3f374ae4c156210dfa05e326a6c071c98276f97aa4c0f791e712a02ef5", schema:{"$schema":"http://json-schema.org/draft-07/schema#","type":"object","additionalProperties":false,"required":["goal"],"properties":{"goal":{"type":"string","title":"What would you like to do?","pattern":"\\S","maxLength":10000},"deliverables":{"type":"string","title":"Expected deliverables","maxLength":10000},"notes":{"type":"string","title":"Additional details","maxLength":10000}}}, functions:compiled6},
{id:"14e81c84e482f8bd4bfb60c5f8df5cea7069a0c97f2fbf1a087a445d1335feac", schema:{"$schema":"http://json-schema.org/draft-07/schema#","type":"object","additionalProperties":false,"required":["goal"],"properties":{"goal":{"type":"string","title":"想完成的工作","pattern":"\\S","maxLength":10000},"deliverables":{"type":"string","title":"預期成果","maxLength":10000},"notes":{"type":"string","title":"補充說明","maxLength":10000}}}, functions:compiled7}
];
const validators = new Map(entries.map(entry => [entry.id, {schema:entry.schema, validator:createPrecompiledValidator(entry.functions, entry.schema)}]));
function canonical(value) { if (Array.isArray(value)) return value.map(canonical); if (value && typeof value === "object") return Object.fromEntries(Object.keys(value).sort().map(key => [key,canonical(value[key])])); return value; }
export function getWorkSettingsValidator(variant: WorkSettingsVariant): ValidatorType<WorkSettingsData> | null {
  const entry = validators.get(variant.validatorId);
  return entry && JSON.stringify(canonical(entry.schema)) === JSON.stringify(canonical(variant.schema)) ? entry.validator : null;
}
